const translation = {
    common: {
        utilityMenuLandmark: 'Benutzermenü',
        back: 'Zurück',
        cancel: 'Abbrechen',
        expand: 'Ausklappen',
        create: 'Erstellen',
        save: 'Speichern',
        saveChanges: 'Änderungen speichern',
        apply: 'Anwenden',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        close: 'Schließen',
        clear: 'Leeren',
        clearFilter: 'Filter zurücksetzen',
        clearSearch: 'Suche zurücksetzen',
        select: 'Auswählen',
        confirm: 'Bestätigen',
        approve: 'Genehmigen',
        reject: 'Ablehnen',
        more: 'Mehr',
        less: 'Weniger',
        showMoreCount: 'Alle {{count}} anzeigen',
        showLess: 'Weniger anzeigen',
        showTree: 'Baum anzeigen',
        hideTree: 'Baum ausblenden',
        submit: 'Absenden',
        reset: 'Zurücksetzen',
        loading: 'Wird geladen...',
        saving: 'Wird gespeichert...',
        required: 'Pflichtfeld',
        maxValues: 'Max. Werte',
        defaultValue: 'Standard',
        creating: 'Wird erstellt...',
        deleting: 'Wird gelöscht...',
        submitting: 'Wird abgesendet...',
        name: 'Name',
        description: 'Beschreibung',
        actions: 'Aktionen',
        status: 'Status',
        type: '$t(appConfig.domainEntityTypes.TYPE)',
        search: 'Suchen...',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
        active: 'Aktiv',
        inactive: 'Inaktiv',
        static: 'Statisch',
        dynamic: 'Dynamisch',
        testdata: 'Testdaten',
        yes: 'Ja',
        no: 'Nein',
        none: 'Keine',
        all: 'Alle',
        noResults: 'Keine Ergebnisse gefunden.',
        noData: 'Keine Daten verfügbar.',
        filterByResource: 'Nach $t(appConfig.domainEntityTypes.RESOURCE) filtern...',
        viewFailureDetails: 'Vollständige Fehlerdetails mit Stack-Trace anzeigen',
        errorLoading: 'Fehler beim Laden der Daten. Bitte versuchen Sie es erneut.',
        comingSoon: 'Demnächst verfügbar...',
        pageNotFound: 'Diese Seite existiert nicht.',
        notFound: '{{entity}} nicht gefunden.',
        didYouMean: 'Meinten Sie eine dieser Seiten?',
        backToDashboard: 'Zurück zum Dashboard',
        showingRange: '{{start}} bis {{end}} von {{total}} Einträgen',
        rowsPerPage: 'Zeilen pro Seite:',
        pageOf: 'Seite {{page}} von {{totalPages}}',
        firstPage: 'Erste Seite',
        previousPage: 'Vorherige Seite',
        nextPage: 'Nächste Seite',
        lastPage: 'Letzte Seite',
        allTypes: 'Alle $t(appConfig.domainEntityTypes.TYPES)',
        allStatus: 'Alle Status',
        allStates: 'Alle Zustände',
        matchingFilter: 'passend zum Filter',
        matchingFilters: 'passend zu Filtern',
        version: 'Version',
        createdAt: 'Erstellt',
        updatedAt: 'Aktualisiert',
        lastUpdated: 'Zuletzt aktualisiert',
        id: 'ID',
        details: 'Details',
        overview: 'Übersicht',
        configuration: 'Konfiguration',
        permissions: 'Berechtigungen',
        settings: 'Einstellungen',
        noRoles: 'Keine $t(appConfig.domainEntityTypes.ROLES)',
        set: 'Festlegen',
        view: 'Anzeigen',
        switchToDarkMode: 'Zum Dunkelmodus wechseln',
        switchToLightMode: 'Zum Hellmodus wechseln',
        logout: 'Abmelden',
        never: 'Nie',
        justNow: 'gerade eben',
        durationDaysAgo: 'vor {{count}} Tag',
        durationDaysAgo_other: 'vor {{count}} Tagen',
        durationHoursAgo: 'vor {{count}} Stunde',
        durationHoursAgo_other: 'vor {{count}} Stunden',
        durationMinutesAgo: 'vor {{count}} Minute',
        durationMinutesAgo_other: 'vor {{count}} Minuten',
        durationSecondsAgo: 'vor {{count}}s',
        durationMinutesShortAgo: 'vor {{count}}m',
        durationHoursShortAgo: 'vor {{count}}h',
        durationDaysFromNow: 'in {{count}} Tag',
        durationDaysFromNow_other: 'in {{count}} Tagen',
        durationHoursFromNow: 'in {{count}} Stunde',
        durationHoursFromNow_other: 'in {{count}} Stunden',
        durationMinutesFromNow: 'in {{count}} Minute',
        durationMinutesFromNow_other: 'in {{count}} Minuten',
        inAMoment: 'gleich',
        selectedCount: '{{count}} ausgewählt',
        unknown: 'Unbekannt',
        unknownError: 'Unbekannter Fehler',
        errorTitle: 'Fehler',
        viewErrorLog: '$t(appConfig.domainEntityTypes.ERROR_LOG) anzeigen',
        sessionExpired: 'Sitzung abgelaufen',
        cancelledByUser: 'Vom Benutzer abgebrochen',
        optional: 'Optional',
        noRolesAssigned: 'Keine $t(appConfig.domainEntityTypes.ROLES) zugewiesen',
        primary: 'Primär',
        permanent: 'Permanent',
        resource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        entitlement: 'Berechtigung',
        operation: 'Vorgang',
        validUntil: 'Gültig bis',
        value: 'Wert',
        observed: 'Beobachtet',
        validFrom: 'Gültig ab',
        from: 'Von:',
        to: 'Bis:',
        add: 'Hinzufügen',
        remove: 'Entfernen',
        unchanged: 'Unverändert',
        priorityValue: 'Priorität: {{value}}',
        versionPrefix: 'v{{version}}',
        valueWithMs: '{{value}}ms',
        emDash: '\u2014',
        completedTask_one: '{{count}} abgeschlossene Aufgabe',
        completedTask_other: '{{count}} abgeschlossene Aufgaben',
        task_one: '{{count}} Aufgabe',
        task_other: '{{count}} Aufgaben',
        identity_one: '{{count}} $t(appConfig.domainEntityTypes.IDENTITY)',
        identity_other: '{{count}} $t(appConfig.domainEntityTypes.IDENTITIES)',
        system_one: '{{count}} System',
        system_other: '{{count}} Systeme',
        byUser: 'von {{user}}',
        atPosition: '(Position {{position}})',
        viewAllExecutions: 'Alle {{count}} $t(appConfig.domainEntityTypes.EXECUTIONS) anzeigen \u2192',
        viewErrors: 'Fehler anzeigen',
        matched: 'Zugetroffen:',
        rfc7644: 'RFC 7644 (Standard)',
        salesforce: 'Salesforce',
        microsoft: 'Microsoft',
        iamCore: 'ID Pulse',
        swissAdmin: 'Swiss Admin',
        percentValue: '{{value}}%',
        connectionLostReconnecting: 'Verbindung verloren. Erneuter Verbindungsversuch in {{seconds}}s...',
        connectionLostMaxAttempts: 'Verbindung verloren. Maximale Anzahl an Verbindungsversuchen erreicht.',
        failedToConnectRetrying: 'Verbindung fehlgeschlagen. Erneuter Versuch in {{seconds}}s...',
        failedToConnectLiveUpdates: 'Verbindung zu Live-Updates fehlgeschlagen.',
        retry: 'Erneut versuchen',
        attributes: 'Attribute',
        attributeCount: '{{count}} Attribute definiert',
        attributeCount_one: '{{count}} Attribut definiert',
        attributeCount_other: '{{count}} Attribute definiert',
        noAttributes: 'Keine Attribute definiert.',
        addAttribute: 'Attribut hinzufügen',
        editAttribute: 'Attribut bearbeiten',
        deleteAttribute: 'Attribut löschen',
        attributeName: 'Attributname',
        attributeValue: 'Attributwert',
        authority: 'Autorität',
        confirmDeleteAttribute: 'Möchten Sie dieses Attribut wirklich löschen?',
        attributeSaved: 'Attribut erfolgreich gespeichert.',
        attributeDeleted: 'Attribut erfolgreich gelöscht.',
        addValue: 'Hinzufügen',
        removeValue: 'Wert entfernen',
        maxValuesReached: 'Maximale Anzahl an Werten erreicht',
        copyFailed: 'Kopieren in die Zwischenablage fehlgeschlagen.',
        next: 'Weiter',
    },
    typeScopeFilter: {
        all: 'Alle',
        global: 'Global',
    },
    accessibility: {
        skipToContent: 'Zum Hauptinhalt springen',
    },
    dashboard: {
        title: 'Dashboard',
        subtitle: 'Identity- & Access-Management-System',
        sectionsNav: 'Hauptbereiche',
        myIam: 'Mein IAM',
        myIamDesc: 'Zugriff anfordern und $t(appConfig.domainEntityTypes.APPROVALS) verwalten',
        iamAdmin: 'IAM-Administration',
        iamAdminDesc: '$t(appConfig.domainEntityTypes.ROLES), Berechtigungen und Systemeinstellungen verwalten',
        connectors: 'Konnektoren',
        connectorsDesc: 'Eingehende und ausgehende Systemkonnektoren verwalten',
        identityManagement: 'Identity-Management',
        identityManagementDesc: '$t(appConfig.domainEntityTypes.PARTIES), $t(appConfig.domainEntityTypes.IDENTITIES) und deren Lebenszyklus verwalten',
        targetSystems: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS) & $t(appConfig.domainEntityTypes.RESOURCES)',
        targetSystemsDesc: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS), $t(appConfig.domainEntityTypes.RESOURCES) und Berechtigungen anzeigen',
        accessGovernance: '$t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        accessGovernanceDesc: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES), Regeln und $t(appConfig.domainEntityTypes.ACCESS_REQUESTS) verwalten',
        effectiveAccess: 'Effektiver Zugriff',
        effectiveAccessDesc: 'Effektiven Zugriff anzeigen und Identitätszugriffe vergleichen',
        accessProvisioning: 'Access Provisioning',
        accessProvisioningDesc: 'Provisionierungsaufgaben und Zugriffszuweisung überwachen',
        backgroundJobs: 'Hintergrund-Jobs',
        backgroundJobsDesc: 'Geplante Jobs und Cluster verwalten',
        auditLog: 'Audit-Log',
        auditLogDesc: 'Systemaktivitäten und Zugriffsverlauf prüfen',
        reporting: 'Reporting & Audit',
        reportingDesc: 'SQL-basierte Berichte und Compliance-Berichte',
        schema: 'Schema',
        schemaDesc: 'Datenmodell definieren — $t(appConfig.domainEntityTypes.TYPES), Attribute, $t(appConfig.domainEntityTypes.FORM_LAYOUTS) und Beziehungen',
    },
    schema: {
        title: 'Schema',
        pageTitle: 'Schema',
        subtitle: 'Datenmodell für Ihr IAM-System definieren und verwalten',
        welcome: 'Willkommen im Schema-Bereich',
        selectOption: 'Wählen Sie eine Option aus dem Menü, um das Datenmodell zu konfigurieren.',
        typeValues: '$t(appConfig.domainEntityTypes.TYPE_VALUES)',
        typeValuesDescription: '$t(appConfig.domainEntityTypes.TYPE_VALUES) und Übersetzungen verwalten',
        attributeDefinitions: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS)',
        attributeDefinitionsDescription: 'Benutzerdefinierte $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) verwalten',
        formLayouts: '$t(appConfig.domainEntityTypes.FORM_LAYOUTS)',
        formLayoutsDescription: '$t(appConfig.domainEntityTypes.FORM_LAYOUTS) für Eingabefelder konfigurieren',
        relationshipSchema: 'Beziehungsschema',
        relationshipSchemaDescription: 'Erlaubte Beziehungstypen zwischen $t(appConfig.domainEntityTypes.PARTIES) definieren',
        schemaPolicies: 'Schema-Policies',
        schemaPoliciesDescription: 'Domänenregeln definieren und überwachen',
        schemaViolations: 'Schema-Verstöße',
        schemaViolationsDescription: 'Erkannte Schema-Policy-Verstöße',
        valueLists: '$t(appConfig.domainEntityTypes.VALUE_LISTS)',
        valueListsDescription: 'Benutzerdefinierte $t(appConfig.domainEntityTypes.VALUE_LISTS) für Attribute verwalten',
    },
    connectorsHub: {
        pageTitle: 'Konnektoren',
        welcome: 'Willkommen bei den Konnektoren',
        selectOption: 'Wählen Sie Eingehend oder Ausgehend, um Konnektoren zu verwalten.',
        inboundTitle: '$t(appConfig.domainEntityTypes.INBOUND_CONNECTORS)',
        inboundDescription: 'Verwalten Sie eingehende Datenimport-Konnektoren',
        outboundTitle: '$t(appConfig.domainEntityTypes.OUTBOUND_CONNECTORS)',
        outboundDescription: 'Verwalten Sie ausgehende Systemkonnektoren für das Provisioning',
    },
    admin: {
        title: 'IAM-Administration',
        pageTitle: 'IAM-Administration',
        subtitle: '$t(appConfig.domainEntityTypes.ROLES), Berechtigungen, Konnektoren und Systemeinstellungen verwalten',
        welcome: 'Willkommen in der IAM-Administration',
        selectOption: 'Wählen Sie eine Option aus dem Menü, um zu beginnen.',
        adminRoles: '$t(appConfig.domainEntityTypes.ROLES)',
        adminRolesDescription: '$t(appConfig.domainEntityTypes.ROLES) und Berechtigungen verwalten',
        roleAssignments: '$t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS)',
        roleAssignmentsDescription: 'Benutzern $t(appConfig.domainEntityTypes.ROLES) zuweisen',
        connectors: '$t(appConfig.domainEntityTypes.OUTBOUND_CONNECTORS)',
        connectorsDescription: 'Ausgehende Systemkonnektoren verwalten',
        typeValues: '$t(appConfig.domainEntityTypes.TYPE_VALUES)',
        typesDescription: '$t(appConfig.domainEntityTypes.TYPE_VALUES) und Übersetzungen verwalten',
        notificationLog: 'Benachrichtigungsprotokoll',
        notificationLogDescription: 'Zustellstatus der $t(appConfig.domainEntityTypes.NOTIFICATIONS) überwachen',
        attributeDefinitions: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS)',
        attributeDefinitionsDescription: 'Benutzerdefinierte $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) verwalten',
        relationshipSchema: 'Beziehungsschema',
        relationshipSchemaDescription: 'Erlaubte Beziehungstypen zwischen $t(appConfig.domainEntityTypes.PARTIES) definieren',
        errorLogs: '$t(appConfig.domainEntityTypes.ERROR_LOG)',
        errorLogsDescription: 'Fehlermuster und Systemfehler anzeigen',
        scriptExecuteLog: 'Skript-Ausführungsprotokoll',
        scriptExecuteLogDescription: 'DDL-Audit-Spur aus sql.execute()-Aufrufen',
        llmPrompts: 'LLM-Prompts',
        llmPromptsDescription: 'KI-Prompt-Vorlagen konfigurieren',
        caches: 'Caches',
        cachesDescription: 'In-Process-Caches — Größe, letzte Ladezeit, TTL, manuelles Neuladen',
        notificationTemplates: 'Benachrichtigungsvorlagen',
        notificationTemplatesDescription: 'Benachrichtigungs-E-Mail-Vorlagen anpassen',
        testData: 'Testdaten',
        testDataDescription: 'Massentestdaten generieren',
        formLayouts: '$t(appConfig.domainEntityTypes.FORM_LAYOUTS)',
        formLayoutsDescription: '$t(appConfig.domainEntityTypes.FORM_LAYOUTS) für Onboarding konfigurieren',
        inboundConnectors: '$t(appConfig.domainEntityTypes.INBOUND_CONNECTORS)',
        inboundConnectorsDescription: 'Eingehende Datenimport-Konnektoren verwalten',
        valueLists: '$t(appConfig.domainEntityTypes.VALUE_LISTS)',
        valueListsDescription: 'Benutzerdefinierte $t(appConfig.domainEntityTypes.VALUE_LISTS) für Attribute verwalten',
        requestInspector: 'Request Inspector',
        requestInspectorDescription: 'HTTP-Traces und Session-Timelines inspizieren',
        rehireReview: 'Wiedereinstellungs-Prüfung',
        rehireReviewDescription: 'Offene Wiedereinstellungen prüfen',
        serviceAccounts: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNTS)',
        serviceAccountsDescription: 'Nicht-menschliche $t(appConfig.domainEntityTypes.IDENTITIES) und API-Schlüssel verwalten',
        sectionIdpulseAccess: 'idPulse-Zugriff',
        sectionActivity: 'Aktivität',
        sectionDiagnostics: 'Diagnose',
        sectionConfigurationTooling: 'Konfiguration & Werkzeuge',
    },
    testData: {
        pageTitle: 'Testdaten-Generator | Administration',
        title: 'Testdaten-Generator',
        subtitle: 'Massentestdaten fuer Entwicklung und Tests generieren',
        generateEntities: 'Entitaeten generieren',
        generateAttributeValues: 'Attributwerte generieren',
        generateErrorLogs: '$t(appConfig.domainEntityTypes.ERROR_LOGS) generieren',
        generateErrorLogsDescription: 'Beispiel-Fehlereintraege fuer alle Module erstellen',
        errorLogs: '$t(appConfig.domainEntityTypes.ERROR_LOGS)',
        generatorType: 'Generator-$t(appConfig.domainEntityTypes.TYPE)',
        parties: '$t(appConfig.domainEntityTypes.PARTIES)',
        identities: 'Identitaeten',
        count: 'Anzahl',
        partyType: 'Parteityp',
        identityType: 'Identitaetstyp',
        entityType: 'Entitaetstyp',
        definition: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION)',
        valueTemplate: 'Wertevorlage',
        valueTemplatePlaceholder: 'z.B. CC-ENG-{seq}',
        valueTemplateHelp: '{seq} fuer laufende Nummer, {random} fuer Zufallstext, {uuid} fuer UUID',
        generate: 'Generieren',
        generating: 'Wird generiert...',
        generatingProgress: 'Batch {{current}} von {{total}} wird generiert...',
        success: '{{count}} {{type}} erfolgreich erstellt',
        error: 'Testdaten konnten nicht generiert werden',
        noDefinitions: 'Keine $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) fuer diesen Entitaetstyp gefunden',
        selectDefinition: 'Definition auswaehlen',
        selectEntityType: 'Entitaetstyp auswaehlen',
        attributeValues: 'Attributwerte',
    },
    attributeDefinitions: {
        pageTitle: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) | Administration',
        title: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS)',
        subtitle: 'Benutzerdefinierte $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) über Entitätstypen verwalten',
        noPermission: 'Sie haben keine Berechtigung, $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) anzuzeigen.',
        tabs: {
            parties: '$t(appConfig.domainEntityTypes.PARTIES)',
            identities: '$t(appConfig.domainEntityTypes.IDENTITIES)',
            resources: '$t(appConfig.domainEntityTypes.RESOURCES)',
            functionGroups: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
            targetSystems: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS)',
            connectors: 'Konnektoren',
            reports: 'Berichte',
        },
        reorder: {
            failedToast: 'Reihenfolge konnte nicht gespeichert werden. Die ursprüngliche Reihenfolge wurde wiederhergestellt.',
            disabledTooltip: "Wechseln Sie zu 'Alle', um die Reihenfolge zu ändern",
            banner: 'Drag-and-Drop-Sortierung ist nur in der Ansicht "Alle" verfügbar.',
            announcement: 'Zeile von Position {{from}} nach Position {{to}} verschoben',
        },
        dragToType: {
            successToast: 'Typzuordnung aktualisiert',
            failedToast: 'Typzuordnung konnte nicht aktualisiert werden.',
        },
        nameDuplicate: 'Eine Definition mit diesem Namen existiert bereits.',
        nameInvalid: 'Name darf nur Buchstaben, Zahlen und Unterstriche enthalten.',
        managedBy: 'Verwaltet von {{authority}}',
        sqlEditor: 'SQL-Wertquellen-Editor',
        sqlTooManyColumns: 'SQL-Wertquelle muss genau eine Spalte zurückgeben, aber {{count}} zurückgegeben: {{columns}}. Bitte verwenden Sie SELECT DISTINCT spaltenname FROM tabelle.',
        sqlLabeledColumnCount: 'SQL_LABELED-Wertquelle muss genau zwei Spalten zurückgeben (Code, Label), aber {{count}} zurückgegeben: {{columns}}.',
        sqlHintOneColumn: 'Erwartetes Ergebnis: 1 Spalte (Code). Verfügbare Parameter: ${lang} — aktuelle Benutzersprache (z.B. en, de)',
        sqlHintTwoColumns: 'Erwartetes Ergebnis: 2 Spalten (Code, Label). Verfügbare Parameter: ${lang} — aktuelle Benutzersprache (z.B. en, de)',
        columns: {
            name: 'Name',
            displayName: 'Anzeigename',
            valueType: 'Werttyp',
            authority: 'Autorität',
            required: 'Erforderlich',
            active: 'Aktiv',
            searchable: 'Suchbar',
            filterable: 'Filterbar',
            sortOrder: 'Sortierung',
            typeScope: 'Typbereich',
            valueSource: 'Wertquelle',
        },
        flags: {
            enableSearchable: 'Volltextsuche aktivieren',
            disableSearchable: 'Volltextsuche deaktivieren',
            enableFilterable: 'Im Filter-Panel anzeigen',
            disableFilterable: 'Aus Filter-Panel ausblenden',
            updateSuccess: 'Schalter aktualisiert.',
            updateFailed: 'Schalter konnte nicht aktualisiert werden.',
        },
        valueSourceTypes: {
            LIST: 'Statische Liste',
            ENUM: 'Typtabelle',
            SQL: 'SQL-Abfrage',
            SQL_LABELED: 'SQL-Abfrage (Code + Label)',
            CUSTOM_LIST: 'Benutzerdefinierte Liste',
        },
        typeScopeAllTypes: 'Alle',
        typeScopeSpecificTypes: 'Bestimmte',
        typeScopeAddType: '$t(appConfig.domainEntityTypes.TYPE) hinzufügen',
        typeScopeSelectTypes: '$t(appConfig.domainEntityTypes.TYPES) auswählen',
        typeScopeAll: 'Alle $t(appConfig.domainEntityTypes.TYPES)',
        empty: 'Keine $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) gefunden.',
        loading: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) werden geladen...',
        count: '{{count}} Definition',
        count_other: '{{count}} Definitionen',
        required: 'Erforderlich',
        optional: 'Optional',
        createDefinition: 'Definition erstellen',
        editDefinition: 'Definition bearbeiten',
        deleteDefinition: 'Definition löschen',
        deleteConfirmTitle: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) löschen',
        deleteConfirmDescription: 'Sind Sie sicher, dass Sie diese $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        deleteInUse: 'Diese $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) wird verwendet und kann nicht gelöscht werden.',
        createSuccess: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) erfolgreich erstellt.',
        updateSuccess: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) erfolgreich aktualisiert.',
        deleteSuccess: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) erfolgreich gelöscht.',
        removeFromType: 'Von diesem $t(appConfig.domainEntityTypes.TYPE) entfernen',
        removeFromTypeSuccess: 'Erfolgreich vom $t(appConfig.domainEntityTypes.TYPE) entfernt.',
        removeFromTypeImpact: '"{{name}}" vom $t(appConfig.domainEntityTypes.TYPE) {{type}} entfernen betrifft {{count}} Attributwerte.',
        optimisticLockConflict: 'Diese Definition wurde von einem anderen Benutzer geändert. Bitte schließen und erneut öffnen.',
        deleteImpactMessage: 'Definition "{{name}}" hat {{valueCount}} Werte über {{entityCount}} Entitäten. Alle Werte werden dauerhaft gelöscht.',
        deleteConfirmButton: 'Definition und {{count}} Werte löschen',
        deleteConfirmButton_one: 'Definition und 1 Wert löschen',
        sections: {
            basic: 'Grundlagen',
            behavior: 'Verhalten',
            validation: 'Validierung',
        },
        fields: {
            name: 'Name',
            namePlaceholder: 'z.B. abteilung',
            displayName: 'Anzeigename',
            displayNameLocale: 'Anzeigename ({{locale}})',
            displayNamePlaceholder: 'z.B. Abteilung',
            valueType: 'Werttyp',
            required: 'Erforderlich',
            unique: 'Eindeutig',
            active: 'Aktiv',
            sortOrder: 'Sortierung',
            typeScope: 'Typbereich',
        },
        translations: {
            title: 'Übersetzungen',
            saveFirstHint: 'Speichern Sie die Definition zuerst, dann bearbeiten Sie sie, um Übersetzungen hinzuzufügen.',
            label: 'Bezeichnung',
            description: 'Beschreibung',
            saveFailed: 'Definition gespeichert, aber Übersetzungen konnten nicht gespeichert werden. Bitte erneut versuchen.',
        },
        validationRules: {
            title: 'Validierungsregeln',
            titleWithCount: 'Validierungsregeln ({{count}})',
            noRulesForType: 'Für diesen Werttyp sind keine Validierungsregeln verfügbar.',
            notApplicableWithAllowedValues: 'Nicht anwendbar, wenn erlaubte Werte definiert sind.',
            minLength: 'Mindestlänge',
            minLengthDescription: 'Erforderliche Mindestanzahl an Zeichen',
            minLengthPlaceholder: 'z.B. 2',
            maxLength: 'Maximallänge',
            maxLengthDescription: 'Maximal zulässige Anzahl an Zeichen',
            maxLengthPlaceholder: 'z.B. 100',
            pattern: 'Muster (Regulärer Ausdruck)',
            patternDescription: 'Java-kompatibler Regex. Beispiele: ^[A-Z]{2}$ (ISO-Land), ^CC-[A-Z]+-\\d{3}$ (Kostenstelle)',
            patternPlaceholder: 'z.B. ^[A-Z]{2}$',
            patternInvalid: 'Ungültiger regulärer Ausdruck: {{error}}',
            allowedValues: 'Erlaubte Werte',
            allowedValuesDescription: 'Eingabe auf eine festgelegte Menge von Werten beschränken.',
            allowedValuesPlaceholder: 'Wert eingeben und Enter drücken',
            allowedValuesDuplicate: 'Wert existiert bereits',
            listEditor: {
                title: 'Listeneinträge',
                codePlaceholder: 'z.B. AT',
                labelPlaceholder: 'z.B. Österreich',
                codeHeader: 'Code',
                labelHeader: 'Bezeichnung',
                addEntry: 'Eintrag hinzufügen',
                removeEntry: 'Entfernen',
                errorBlankCode: 'Code ist erforderlich',
                errorBlankLabel: 'Bezeichnung ist erforderlich',
                errorDuplicateCode: 'Doppelter Code',
            },
            min: 'Minimalwert',
            minDescription: 'Kleinster akzeptabler Wert (inklusiv)',
            minPlaceholder: 'z.B. 0',
            max: 'Maximalwert',
            maxDescription: 'Größter akzeptabler Wert (inklusiv)',
            maxPlaceholder: 'z.B. 100',
            minMaxError: 'Minimum muss kleiner oder gleich Maximum sein',
            minLengthMaxLengthError: 'Mindestlänge muss kleiner oder gleich Maximallänge sein',
            mustBeAtLeastOne: 'Muss mindestens 1 sein',
        },
        patternSuggest: {
            title: 'Muster vorschlagen',
            description: 'Geben Sie Beispielwerte ein und das System leitet ein Regex-Muster ab.',
            addSample: 'Beispiel hinzufügen',
            samplePlaceholder: 'Beispielwert eingeben',
            samplesLabel: 'Beispiele',
            samples: 'Beispiele',
            addSampleHint: 'Fügen Sie mindestens 2 Beispielwerte hinzu, um ein Muster abzuleiten',
            analyzing: 'Muster werden analysiert...',
            inferredPattern: 'Abgeleitetes Muster',
            accept: 'Dieses Muster verwenden',
            noSamples: 'Bitte geben Sie mindestens einen Beispielwert ein',
            minSamples: 'Bitte fügen Sie mindestens 2 Beispielwerte hinzu',
            duplicateSample: 'Dieses Beispiel existiert bereits',
            error: 'Muster konnte nicht abgeleitet werden',
        },
        noPermissionToEdit: 'Sie haben keine Berechtigung, diese $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) zu bearbeiten.',
        impact: {
            checkingImpact: 'Auswirkungen werden geprüft...',
            checkingProgress: 'Auswirkungen werden geprüft... {{checked}} / {{total}} Werte',
            warningTitle: 'Kritische Änderungen erkannt',
            affectedCount: '{{valueCount}} Werte von {{entityCount}} Entitäten werden betroffen sein.',
            affectedEntitiesOnly: '{{entityCount}} Entitäten benötigen einen Initialwert.',
            breakingChanges: 'Kritische Änderungen:',
            affectedEntities: 'Betroffene Entitäten',
            currentValue: 'Aktueller Wert: {{value}}',
            andMore: 'und {{count}} weitere...',
            confirmationLabel: 'Ich bestätige, dass {{valueCount}} Werte von {{entityCount}} Entitäten geändert werden',
            confirmationLabelEntitiesOnly: 'Ich bestätige, dass {{entityCount}} Entitäten einen Initialwert erhalten',
            saveWithMigration: 'Mit Migration speichern',
            suggestMigrationSql: 'Migrations-SQL vorschlagen',
            suggestingMigrationSql: 'Wird generiert...',
        },
        migration: {
            migrate: 'Migrieren',
            sqlEditorTitle: 'SQL-Migrations-Editor',
            submitWithSql: 'Mit Migration einreichen',
            sqlError: 'SQL-Migrationsfehler: {{error}}',
            jobStarted: 'Definitionsaktualisierung eingereicht. Migrationsjob gestartet.',
            createWithMigration: 'Definition erstellt. Migrationsjob gestartet.',
            createRequiredImpact: '{{count}} bestehende Entitäten haben keinen Wert für dieses Pflichtattribut.',
            viewJobDashboard: 'Im Job-Dashboard anzeigen',
            inProgress: 'Migration wird ausgeführt...',
            completedWithErrors: 'Migration mit Fehlern abgeschlossen',
            failed: 'Migration fehlgeschlagen',
            editDisabledDuringMigration: 'Bearbeitung während Migration deaktiviert',
            deleteDisabledDuringMigration: 'Löschen während Migration deaktiviert',
        },
    },
    partyRelationshipSchema: {
        pageTitle: 'Beziehungsschema | Admin',
        title: 'Beziehungsschema',
        subtitle: 'Definieren Sie, welche Parteitypen über welche Beziehungstypen verbunden werden können',
        noPermission: 'Sie haben keine Berechtigung, das Beziehungsschema anzuzeigen.',
        tabs: {
            schemaEntries: 'Schemaeinträge',
            violations: 'Verstöße',
        },
        columns: {
            fromType: 'Von-$t(appConfig.domainEntityTypes.TYPE)',
            relationshipType: 'Beziehungstyp',
            toType: 'Zu-$t(appConfig.domainEntityTypes.TYPE)',
            cardinality: 'Kardinalität',
            display: 'Anzeige',
            status: 'Status',
        },
        form: {
            createTitle: 'Schemaeintrag erstellen',
            createDescription: 'Einen neuen erlaubten Beziehungstyp definieren.',
            editTitle: 'Schemaeintrag bearbeiten',
            editDescription: 'Kardinalität, Anzeigeeinstellungen und Beschriftungen anpassen.',
            detailTitle: 'Schemaeintrag Details',
            fromPartyType: 'Von-Parteityp',
            relationshipType: 'Beziehungstyp',
            toPartyType: 'Zu-Parteityp',
            maxFromCount: 'Max. Von-Anzahl',
            maxFromCountHint: '0 = unbegrenzt',
            maxToCount: 'Max. Zu-Anzahl',
            maxToCountHint: '0 = unbegrenzt',
            fromSideDisplay: 'Von-Seite anzeigen',
            toSideDisplay: 'Zu-Seite anzeigen',
            fromSideTree: 'Baum Von-Seite',
            toSideTree: 'Baum Zu-Seite',
            fromSideLabel: 'Von-Seite Bezeichnung',
            toSideLabel: 'Zu-Seite Bezeichnung',
            iconFrom: 'Symbol (Von-Seite)',
            iconTo: 'Symbol (Zu-Seite)',
            aliasNameFrom: 'Aliasname (Von-Seite)',
            aliasNameTo: 'Aliasname (Zu-Seite)',
            aliasNameHint: 'Optionaler camelCase-Bezeichner für CEL-Ausdrücke (z.\u00a0B. memberOf, hasMembers).',
            aliasNameInvalid: 'Aliasname muss camelCase sein: mit Kleinbuchstaben beginnen, dann nur Buchstaben und Ziffern.',
            aliasNamePlaceholder: 'z.\u00a0B. memberOf',
            sortOrder: 'Sortierreihenfolge',
            active: 'Aktiv',
            labelRequired: 'Bezeichnung ist erforderlich, wenn Anzeige aktiviert ist.',
            minZero: 'Muss 0 oder größer sein.',
            required: 'Erforderlich.',
            unlimited: 'Unbegrenzt',
            searchIcon: 'Symbole suchen...',
        },
        actions: {
            create: 'Schemaeintrag erstellen',
            save: 'Speichern',
            deactivate: 'Deaktivieren',
        },
        messages: {
            createSuccess: 'Schemaeintrag erstellt.',
            updateSuccess: 'Schemaeintrag aktualisiert.',
            deactivateSuccess: 'Schemaeintrag deaktiviert.',
            deactivateTitle: 'Schemaeintrag deaktivieren',
            deactivateDescription: 'Der Schemaeintrag für {{from}} → {{rel}} → {{to}} wird deaktiviert. Bestehende Beziehungen werden nicht gelöscht.',
            duplicateTriple: 'Ein Schemaeintrag für diese Kombination existiert bereits.',
            unsavedChanges: 'Sie haben ungespeicherte Änderungen. Verwerfen?',
            discard: 'Verwerfen',
            keepEditing: 'Weiter bearbeiten',
        },
        violations: {
            title: 'Schemaverstöße',
            empty: 'Keine Schemaverstöße aufgezeichnet.',
            emptyDescription: 'Im WARN-Modus werden Beziehungen, die gegen das Schema verstoßen, hier protokolliert.',
            violationType: 'Verstoßtyp',
            detail: 'Details',
            createdAt: 'Erstellt am',
            allTypes: 'Alle $t(appConfig.domainEntityTypes.TYPES)',
            noSchemaEntry: 'Kein Schemaeintrag',
            cardinalityExceeded: 'Kardinalität überschritten',
            createdAfter: 'Erstellt nach',
            createdBefore: 'Erstellt vor',
            runValidation: 'Validierung starten',
            validationStarted: 'Schema-Validierungsjob gestartet. Ergebnisse erscheinen in Kürze.',
        },
        enforcement: {
            strict: 'Durchsetzung: STRICT — ungültige Beziehungen werden abgelehnt.',
            warn: 'Durchsetzung: WARN — ungültige Beziehungen werden protokolliert, aber zugelassen.',
            off: 'Durchsetzung: OFF — Schemavalidierung ist deaktiviert.',
            modeOff: 'OFF',
            modeWarn: 'WARN',
            modeStrict: 'STRICT',
            updated: 'Durchsetzungsmodus aktualisiert.',
            changeMode: 'Modus ändern',
            changeModeTitle: 'Durchsetzungsmodus ändern',
            changeModeDescription: 'Wählen Sie den neuen Durchsetzungsmodus. Dies beeinflusst, wie das System mit Beziehungen umgeht, die das Schema verletzen.',
            changeModeWarning: 'Die Änderung des Durchsetzungsmodus wirkt sich systemweit auf alle Beziehungsoperationen aus. Der Wechsel zu STRICT lehnt alle neuen Beziehungen ab, die das Schema verletzen.',
            newMode: 'Neuer Modus',
            offDescription: 'Schemavalidierung ist deaktiviert. Es werden keine Prüfungen durchgeführt.',
            warnDescription: 'Ungültige Beziehungen werden als Verstöße protokolliert, aber trotzdem zugelassen.',
            strictDescription: 'Ungültige Beziehungen werden abgelehnt. Nur schemakonforme Beziehungen können erstellt werden.',
            confirm: 'Änderung bestätigen',
        },
    },
    roles: {
        title: '$t(appConfig.domainEntityTypes.ROLES)',
        pageTitle: '$t(appConfig.domainEntityTypes.ROLES) | Administration',
        detailPageTitle: 'Rollendetails | Administration',
        subtitle: '$t(appConfig.domainEntityTypes.ROLES) und ihre Berechtigungen verwalten',
        allRoles: 'Alle $t(appConfig.domainEntityTypes.ROLES)',
        createRole: '$t(appConfig.domainEntityTypes.ROLE) erstellen',
        editRole: '$t(appConfig.domainEntityTypes.ROLE) bearbeiten',
        deleteRole: '$t(appConfig.domainEntityTypes.ROLE) löschen',
        filterPlaceholder: '$t(appConfig.domainEntityTypes.ROLES) filtern...',
        roleCount: '{{count}} $t(appConfig.domainEntityTypes.ROLE)',
        roleCount_other: '{{count}} $t(appConfig.domainEntityTypes.ROLES)',
        count: '{{count}} $t(appConfig.domainEntityTypes.ROLE)(n)',
        system: 'System',
        custom: 'Benutzerdefiniert',
        createDescription: 'Erstellen Sie eine neue $t(appConfig.domainEntityTypes.ROLE) mit Name und Beschreibung.',
        editDescription: 'Aktualisieren Sie den Rollennamen und die Beschreibung.',
        deleteConfirm: 'Möchten Sie die $t(appConfig.domainEntityTypes.ROLE) "{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        namePlaceholder: 'Rollenname eingeben',
        descriptionPlaceholder: 'Rollenbeschreibung eingeben (optional)',
        keyColumn: 'Schlüssel',
        keyLabel: 'OAuth-Claim-Schlüssel',
        keyPlaceholder: 'iam-admin',
        keyValidationError: 'Schlüssel muss in Kebab-Case (ASCII) sein (z. B. iam-admin), maximal 64 Zeichen',
        keyHint: 'Stabiler Bezeichner, der vorgelagerte [[OIDC-Rollen-Claims]] auf diese Rolle abbildet. Nach dem Anlegen schreibgeschützt.',
        noRolesMatch: 'Keine $t(appConfig.domainEntityTypes.ROLES) entsprechen Ihrem Filter.',
        noRolesFound: 'Keine $t(appConfig.domainEntityTypes.ROLES) gefunden. Erstellen Sie Ihre erste $t(appConfig.domainEntityTypes.ROLE), um zu beginnen.',
        loadingRoles: '$t(appConfig.domainEntityTypes.ROLES) werden geladen...',
        loadingRole: '$t(appConfig.domainEntityTypes.ROLE) wird geladen...',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.ROLES). Bitte versuchen Sie es erneut.',
        errorLoadingRole: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.ROLE). Bitte versuchen Sie es erneut.',
        noDescription: 'Keine Beschreibung',
        permissionsForRole: 'Berechtigungen für {{name}}',
        permissionsDescription: 'Diese $t(appConfig.domainEntityTypes.ROLE) hat folgende Berechtigungen zugewiesen:',
        permissionsAssigned: '{{selected}} von {{total}} Berechtigung(en) zugewiesen',
        noPermissions: 'Keine Berechtigungen dieser $t(appConfig.domainEntityTypes.ROLE) zugewiesen.',
        permissionCount: '{{count}} Berechtigung(en)',
        category: 'Kategorie',
        assignPermissions: 'Berechtigungen zuweisen',
        editPermissions: 'Berechtigungen bearbeiten',
        savePermissions: 'Berechtigungen speichern',
        removePermission: 'Entfernen',
        addPermissions: 'Berechtigungen hinzufügen',
        availablePermissions: 'Verfügbare Berechtigungen',
        searchPermissions: 'Berechtigungen suchen...',
        addSelected: 'Ausgewählte hinzufügen',
        removeSelected: 'Ausgewählte entfernen',
        editing: 'Bearbeitung',
        resource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        roleCreated: '$t(appConfig.domainEntityTypes.ROLE) erfolgreich erstellt.',
        roleUpdated: '$t(appConfig.domainEntityTypes.ROLE) erfolgreich aktualisiert.',
        roleDeleted: '$t(appConfig.domainEntityTypes.ROLE) erfolgreich gelöscht.',
        permissionsSaved: 'Berechtigungen erfolgreich gespeichert.',
    },
    roleAssignments: {
        title: '$t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS)',
        pageTitle: '$t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS) | Administration',
        subtitle: '$t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS) für $t(appConfig.domainEntityTypes.IDENTITIES) anzeigen und verwalten',
        oauthSubtitle: '$t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS) anzeigen (über OAuth verwaltet)',
        allAssignments: 'Alle $t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS)',
        identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        role: '$t(appConfig.domainEntityTypes.ROLE)',
        assignedAt: 'Zugewiesen am',
        assignRole: '$t(appConfig.domainEntityTypes.ROLE) zuweisen',
        removeAssignment: 'Zuweisung entfernen',
        removeConfirm: 'Möchten Sie die $t(appConfig.domainEntityTypes.ROLE) "{{role}}" wirklich von "{{identity}}" entfernen? Diese Aktion kann nicht rückgängig gemacht werden.',
        filterPlaceholder: 'Zuweisungen filtern...',
        assignmentCount: '{{count}} Zuweisung(en)',
        noAssignmentsMatch: 'Keine Zuweisungen entsprechen Ihrem Filter.',
        noAssignmentsFound: 'Keine $t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS) gefunden.',
        loadingAssignments: '$t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS) werden geladen...',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS). Bitte versuchen Sie es erneut.',
        selectIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) auswählen',
        selectRole: '$t(appConfig.domainEntityTypes.ROLE) auswählen',
        searchIdentities: '$t(appConfig.domainEntityTypes.IDENTITIES) suchen...',
        searchRoles: '$t(appConfig.domainEntityTypes.ROLES) suchen...',
        assignDescription: 'Weisen Sie einer $t(appConfig.domainEntityTypes.IDENTITY) eine $t(appConfig.domainEntityTypes.ROLE) zu.',
        assigning: 'Wird zugewiesen...',
        removing: 'Wird entfernt...',
        usersWithRoles: 'Benutzer mit $t(appConfig.domainEntityTypes.ROLES)',
        email: 'E-Mail',
        userCount: '{{count}} Benutzer',
        filterUsersPlaceholder: 'Benutzer filtern...',
        assignedRoles: 'Zugewiesene $t(appConfig.domainEntityTypes.ROLES)',
        oauthNote: 'Benutzer­$t(appConfig.domainEntityTypes.ROLES) werden automatisch basierend auf OAuth-Claims zugewiesen; Service­konto-$t(appConfig.domainEntityTypes.ROLES) werden auf der $t(appConfig.domainEntityTypes.SERVICE_ACCOUNT)-Detailseite verwaltet.',
        noUsersMatch: 'Keine Benutzer entsprechen Ihrem Filter.',
        noUsersFound: 'Keine Benutzer gefunden. Benutzer werden bei der Anmeldung über OAuth erstellt.',
        type: '$t(appConfig.domainEntityTypes.TYPE)',
        typeUser: 'Benutzer',
        typeServiceAccount: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNT)',
        typeFilterAll: 'Alle',
        typeFilterUsers: 'Nur Benutzer',
        typeFilterServiceAccounts: 'Nur $t(appConfig.domainEntityTypes.SERVICE_ACCOUNTS)',
    },
    connectors: {
        title: '$t(appConfig.domainEntityTypes.OUTBOUND_CONNECTORS)',
        pageTitle: '$t(appConfig.domainEntityTypes.OUTBOUND_CONNECTORS) | Administration',
        detailPageTitle: 'Ausgehende Konnektordetails | Administration',
        subtitle: 'Ausgehende Systemkonnektoren für die Provisionierung verwalten',
        allConnectors: 'Alle ausgehenden Konnektoren',
        createConnector: 'Konnektor erstellen',
        deleteConnector: 'Konnektor löschen',
        connectorCount: '{{count}} Konnektor(en)',
        filterPlaceholder: 'Konnektoren filtern...',
        targetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
        connectorType: 'Konnektortyp',
        lastUpdated: 'Zuletzt aktualisiert',
        scim20: 'SCIM 2.0',
        ldap: 'LDAP',
        sapAbap: {
            connectionSection: 'SAP-ABAP-Verbindung',
            connectionDescription: 'Ausgehende Provisionierung in SAP ABAP über OData V2 (Konfiguration und $t(appConfig.domainEntityTypes.ROLES)) sowie optional RFC/BAPI (Benutzeranlage und $t(appConfig.domainEntityTypes.ROLE_ASSIGNMENT)).',
            odataBaseUrl: 'OData-Basis-URL',
            rfcBaseUrl: 'RFC-Basis-URL',
            mandant: 'Mandant',
            userTypeDefault: 'Standard-Benutzertyp',
            roleAssignmentMode: 'Rollenzuweisungsmodus',
            compositeRoleExpansion: 'Sammelrollenauflösung',
            bnameTemplate: 'BNAME-Vorlage',
            passwordPolicy: 'Passwortrichtlinie',
            lockReason: 'Sperrgrund',
            etagRetryLimit: 'ETag-Wiederholungslimit',
            allowedActions: 'Erlaubte Aktionen',
            actionCreate: 'CREATE',
            actionUpdate: 'UPDATE',
            actionDelete: 'DELETE',
            actionEnable: 'ENABLE',
            actionDisable: 'DISABLE',
            actionGrant: 'GRANT',
            actionRevoke: 'REVOKE',
            warnCreateWithoutGrant: 'CREATE ist deaktiviert, GRANT aber aktiv — $t(appConfig.domainEntityTypes.ROLE_ASSIGNMENTS) schlagen fehl, weil der Benutzer in SAP nie angelegt wird.',
            warnDisableWithoutDelete: 'DISABLE ist deaktiviert, DELETE aber aktiv — beendete $t(appConfig.domainEntityTypes.IDENTITIES) werden gelöscht statt gesperrt; die Audit-Historie geht verloren.',
            bapiAllowlist: 'BAPI-Allowlist',
            bapiAllowlistPlaceholder: 'Ein BAPI-Funktionsbaustein pro Zeile. Leer = uneingeschränkt; nicht leer = strikte Allowlist.',
            editDialogTitle: 'SAP-ABAP-Konfiguration bearbeiten',
            editDialogDescription: 'Aktualisieren Sie Verbindung, Authentifizierung, Provisionierungssteuerung, erlaubte Aktionen und BAPI-Allowlist für diesen SAP-ABAP-Konnektor. Die Standardrollen werden separat verwaltet.',
            sectionConnection: 'Verbindung',
            sectionAuthentication: 'Authentifizierung',
            sectionProvisioning: 'Provisionierung',
            sectionTimeouts: 'Zeitüberschreitungen',
            clientId: 'Client-ID',
            clientSecretRef: 'Client-Secret-Referenz',
            tokenUrl: 'Token-URL',
            scope: 'OAuth-Scope',
            username: 'Benutzername',
            passwordSecretRef: 'Passwort-Secret-Referenz',
            clientCertSecretRef: 'Client-Zertifikatreferenz',
            clientKeySecretRef: 'Client-Schlüsselreferenz',
            truststoreSecretRef: 'Truststore-Referenz',
            connectTimeoutMs: 'Verbindungs-Timeout (ms)',
            readTimeoutMs: 'Lese-Timeout (ms)',
            maxRetries: 'Max. Wiederholungen',
            saveSuccess: 'SAP-ABAP-Konfiguration gespeichert.',
        },
        createDescription: 'Erstellen Sie einen neuen Konnektor für ein $t(appConfig.domainEntityTypes.TARGET_SYSTEM).',
        deleteConfirm: 'Möchten Sie den Konnektor für "{{name}}" wirklich löschen? Dadurch wird auch seine Konfiguration gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
        selectSystem: 'System auswählen',
        selectOutboundConnectorType: 'Konnektortyp auswählen',
        noConnectorsMatch: 'Keine Konnektoren entsprechen Ihrem Filter.',
        noConnectorsFound: 'Keine Konnektoren gefunden. Erstellen Sie einen Konnektor, um zu beginnen.',
        loadingConnectors: 'Konnektoren werden geladen...',
        loadingConnector: 'Konnektor wird geladen...',
        errorLoading: 'Fehler beim Laden der Konnektoren. Bitte versuchen Sie es erneut.',
        errorLoadingConnector: 'Fehler beim Laden des Konnektors. Bitte versuchen Sie es erneut.',
        allSystemsHaveConnectors: 'Alle Systeme haben bereits Konnektoren konfiguriert.',
        connectorDetails: 'Konnektordetails',
        connectorConfiguration: 'Konnektorkonfiguration',
        baseUrl: 'Basis-URL',
        authToken: 'Auth-Token',
        authTokenPlaceholder: 'Authentifizierungs-Token eingeben',
        baseUrlPlaceholder: 'SCIM-Basis-URL eingeben',
        saveConfiguration: 'Konfiguration speichern',
        testConnection: 'Verbindung testen',
        testingConnection: 'Wird getestet...',
        connectionSuccess: 'Verbindung erfolgreich',
        connectionFailed: 'Verbindung fehlgeschlagen',
        connectionSuccessMessage: 'Der SCIM-Server hat mit Status {{statusCode}} geantwortet.',
        syncNow: 'Jetzt synchronisieren',
        syncing: 'Synchronisierung...',
        lastSyncAt: 'Zuletzt synchronisiert',
        neverSynced: 'Noch nie synchronisiert',
        system: 'System',
        disable: 'Deaktivieren',
        enable: 'Aktivieren',
        overview: 'Übersicht',
        basicInfo: 'Grundlegende Konnektorinformationen',
        scimConfiguration: 'SCIM-Konfiguration',
        scimDescription: 'SCIM 2.0-Endpunkt- und Authentifizierungseinstellungen',
        configure: 'Konfigurieren',
        configureScimConnection: 'SCIM-Verbindung konfigurieren',
        configureScimDescription: 'Richten Sie den SCIM 2.0-Endpunkt und die Authentifizierung ein.',
        editScimConfiguration: 'SCIM-Konfiguration bearbeiten',
        editScimDescription: 'SCIM 2.0-Endpunkt- und Authentifizierungseinstellungen aktualisieren.',
        scimNotConfigured: 'Die SCIM-Konfiguration wurde noch nicht eingerichtet.',
        recentActivity: 'Letzte Aktivitäten',
        last20Calls: 'Letzte 20 Konnektor-Operationen',
        noActivity: 'Noch keine Aktivitäten aufgezeichnet.',
        testResultTitle: 'Verbindungstest-Ergebnis',
        endpoint: 'Endpunkt',
        authentication: 'Authentifizierung',
        authType: 'Auth-$t(appConfig.domainEntityTypes.TYPE)',
        authTypeLabels: {
            bearerToken: 'Bearer-Token',
            basicAuth: 'Basic-Auth',
            oauth2Client: 'OAuth2-Client-Credentials',
            token: 'Token',
            certificate: 'Zertifikat',
            kubeconfig: 'Kubeconfig',
            none: 'Keine',
        },
        bearerToken: 'Bearer-Token',
        oauth2Client: 'OAuth2-Client-Credentials',
        basicAuth: 'Basic-Authentifizierung',
        tokenSecretRef: 'Token-Geheimnis-Referenz',
        tokenSecretRefHint: 'Referenz auf das Geheimnis, das den Bearer-Token enthält.',
        tokenUrl: 'Token-URL',
        clientId: 'Client-ID',
        clientSecretRef: 'Client-Geheimnis-Referenz',
        scope: 'Scope',
        username: 'Benutzername',
        passwordSecretRef: 'Passwort-Geheimnis-Referenz',
        leaveEmptyToKeep: 'Leer lassen, um aktuellen Wert beizubehalten',
        leaveEmptyToKeepHint: 'Leer lassen, um den aktuellen Token beizubehalten. Neue Referenz eingeben, um zu aktualisieren.',
        httpSettings: 'HTTP-Einstellungen',
        connectTimeout: 'Verbindungs-Timeout',
        connectTimeoutMs: 'Verbindungs-Timeout (ms)',
        readTimeout: 'Lese-Timeout',
        readTimeoutMs: 'Lese-Timeout (ms)',
        maxRetries: 'Max. Wiederholungen',
        retryBackoff: 'Retry-Backoff',
        retryBackoffMs: 'Retry-Backoff (ms)',
        features: 'Funktionen',
        supportsBulk: 'Unterstützt Massenoperationen',
        supportsEtag: 'Unterstützt ETag',
        patchStyle: 'Patch-Stil',
        userEndpoint: 'Benutzer-Endpunkt',
        groupEndpoint: 'Gruppen-Endpunkt',
        timestamp: 'Zeitstempel',
        operation: 'Vorgang',
        resource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        duration: 'Dauer',
        statusCode: 'Statuscode: {{code}}',
        pending: 'Ausstehend',
        batch: 'Batch',
        // LDAP-Konfiguration
        ldapConfiguration: 'LDAP-Konfiguration',
        ldapDescription: 'LDAP-Serververbindung und Verzeichniseinstellungen',
        configureLdapConnection: 'LDAP-Verbindung konfigurieren',
        configureLdapDescription: 'Richten Sie die LDAP-Serververbindung und Verzeichnis-Sucheinstellungen ein.',
        editLdapConfiguration: 'LDAP-Konfiguration bearbeiten',
        editLdapDescription: 'LDAP-Serververbindung und Verzeichnis-Sucheinstellungen aktualisieren.',
        ldapNotConfigured: 'Die LDAP-Konfiguration wurde noch nicht eingerichtet.',
        serverSettings: 'Server',
        host: 'Host',
        hostPlaceholder: 'ldap.example.com',
        port: 'Port',
        useSsl: 'SSL verwenden (LDAPS)',
        useStarttls: 'StartTLS verwenden',
        bindDn: 'Bind-DN',
        bindDnPlaceholder: 'cn=admin,dc=example,dc=com',
        bindPasswordRef: 'Bind-Passwort-Referenz',
        bindPasswordRefPlaceholder: 'vault:secret/ldap/bind-password',
        bindPasswordRefHint: 'Referenz auf das Geheimnis, das das Bind-Passwort enthält.',
        directorySettings: 'Verzeichnis',
        directoryDialect: 'Verzeichnis-Dialekt',
        directoryDialectHint: 'Wählen Sie den Verzeichnistyp, der die DISABLE/ENABLE_ACCOUNT-Drahtdarstellung steuert.',
        dialectActiveDirectory: 'Active Directory',
        dialectOpenLdap: 'OpenLDAP / 389-DS',
        baseDn: 'Basis-DN',
        baseDnPlaceholder: 'dc=example,dc=com',
        userSearchBase: 'Benutzer-Suchbasis',
        userSearchBasePlaceholder: 'ou=Users,dc=example,dc=com',
        userSearchFilter: 'Benutzer-Suchfilter',
        userSearchFilterPlaceholder: '(sAMAccountName={0})',
        groupSearchBase: 'Gruppen-Suchbasis',
        groupSearchBasePlaceholder: 'ou=Groups,dc=example,dc=com',
        groupMemberAttribute: 'Gruppenmitglied-Attribut',
        userDnAttribute: 'Benutzer-DN-Attribut',
        connectionSettings: 'Verbindung',
        responseTimeoutMs: 'Antwort-Timeout (ms)',
        poolSize: 'Pool-Größe',
        connectionSuccessMessageGeneric: 'Der Server hat erfolgreich geantwortet.',
        // REST-Konfiguration
        restConfiguration: 'REST-Konfiguration',
        restDescription: 'REST-API-Endpunkt-Vorlagen für GRANT- und REVOKE-Operationen',
        configureRestConnection: 'REST-Verbindung konfigurieren',
        configureRestDescription: 'Konfigurieren Sie die REST-API-Basis-URL und Vorlagen pro Aktion.',
        editRestConfiguration: 'REST-Konfiguration bearbeiten',
        editRestDescription: 'REST-API-Verbindung und Vorlagen aktualisieren.',
        restNotConfigured: 'REST-Konfiguration wurde noch nicht eingerichtet.',
        restBaseUrlPlaceholder: 'https://api.example.com/v1',
        authSecretRef: 'Auth-Secret-Referenz',
        authSecretRefPlaceholder: 'vault:secret/rest/token',
        grantAction: 'Grant-Aktion',
        revokeAction: 'Revoke-Aktion',
        httpMethod: 'HTTP-Methode',
        urlTemplate: 'URL-Vorlage',
        urlTemplatePlaceholder: '${baseUrl}/repos/${repoId}/collaborators/${userId}',
        bodyTemplate: 'Body-Vorlage',
        bodyTemplatePlaceholder: '{"permission": "${roleName}"}',
        headers: 'Header',
        headersPlaceholder: '{"X-Custom-Header": "value"}',
        addHeader: 'Header hinzufügen',
        noHeaders: 'Keine Header konfiguriert',
        headerName: 'Header-Name',
        headerNamePlaceholder: 'Authorization',
        headerValue: 'Header-Wert',
        headerValuePlaceholder: 'Bearer ${token}',
        successStatusCodes: 'Erfolgs-Statuscodes',
        successStatusCodesPlaceholder: '200,201,204',
        contentType: 'Content-Type',
        // Datenbank-Konfiguration
        databaseConfiguration: 'Datenbank-Konfiguration',
        databaseDescription: 'JDBC-Datenbankverbindung und SQL-Vorlagen für GRANT- und REVOKE-Operationen',
        configureDatabaseConnection: 'Datenbankverbindung konfigurieren',
        configureDatabaseDescription: 'Konfigurieren Sie die JDBC-Datenbankverbindung und SQL-Vorlagen.',
        editDatabaseConfiguration: 'Datenbank-Konfiguration bearbeiten',
        editDatabaseDescription: 'JDBC-Datenbankverbindung und SQL-Vorlagen aktualisieren.',
        databaseNotConfigured: 'Datenbank-Konfiguration wurde noch nicht eingerichtet.',
        databaseType: 'Datenbanktyp',
        jdbcUrl: 'JDBC-URL',
        jdbcUrlPlaceholder: 'jdbc:postgresql://localhost:5432/mydb',
        driverClass: 'Treiberklasse',
        driverClassPlaceholder: 'org.postgresql.Driver',
        dbUsername: 'Benutzername',
        dbUsernamePlaceholder: 'db_connector_user',
        passwordRef: 'Passwort-Referenz',
        passwordRefPlaceholder: 'plain:secret oder vault:secret/db/password',
        passwordRefHint: 'Referenz auf das Geheimnis, das das Datenbankpasswort enthält.',
        grantSqlTemplate: 'Grant-SQL-Vorlage',
        grantSqlTemplatePlaceholder: 'GRANT ${enforcementObjectExternalId} TO "${accountExternalId}"',
        revokeSqlTemplate: 'Revoke-SQL-Vorlage',
        revokeSqlTemplatePlaceholder: 'REVOKE ${enforcementObjectExternalId} FROM "${accountExternalId}"',
        testSql: 'Test-SQL',
        testSqlPlaceholder: 'SELECT 1',
        testSqlHint: 'SQL-Anweisung zur Überprüfung der Konnektivität. Leer lassen für Standard.',
        queryTimeoutMs: 'Abfrage-Timeout (ms)',
        sqlTemplates: 'SQL-Vorlagen',
        // Kubernetes configuration
        k8sConfiguration: 'Kubernetes-Konfiguration',
        k8sDescription: 'Kubernetes API-Server-Verbindung und RBAC-Binding-Einstellungen',
        configureK8sConnection: 'Kubernetes-Verbindung konfigurieren',
        configureK8sDescription: 'Kubernetes API-Server-Verbindung einrichten.',
        editK8sConfiguration: 'Kubernetes-Konfiguration bearbeiten',
        editK8sDescription: 'Kubernetes API-Server-Verbindungseinstellungen aktualisieren.',
        k8sNotConfigured: 'Kubernetes-Konfiguration wurde noch nicht eingerichtet.',
        apiServerUrl: 'API-Server-URL',
        apiServerUrlPlaceholder: 'https://k8s.example.com:6443',
        tokenRef: 'Token-Geheimnis-Referenz',
        tokenRefPlaceholder: 'vault:secret/k8s/token oder plain:my-token',
        caCertRef: 'CA-Zertifikat-Referenz',
        caCertRefPlaceholder: 'vault:secret/k8s/ca-cert',
        defaultNamespace: 'Standard-Namespace',
        defaultNamespacePlaceholder: 'default',
        skipTlsVerify: 'TLS-Verifizierung überspringen',
        requestTimeoutMs: 'Anfrage-Timeout (ms)',
        // E-Mail-Konfiguration
        emailConfiguration: 'E-Mail-Konfiguration',
        emailDescription: 'SMTP-Verbindung und Benachrichtigungsvorlagen',
        configureEmailConnection: 'E-Mail-Verbindung konfigurieren',
        configureEmailDescription: 'SMTP-Server, Empfänger und Benachrichtigungsvorlagen einrichten.',
        editEmailConfiguration: 'E-Mail-Konfiguration bearbeiten',
        editEmailDescription: 'SMTP-Verbindung und Benachrichtigungsvorlagen aktualisieren.',
        emailNotConfigured: 'E-Mail-Konfiguration wurde noch nicht eingerichtet.',
        smtpSettings: 'SMTP-Einstellungen',
        smtpHost: 'SMTP-Host',
        smtpPort: 'SMTP-Port',
        smtpUsername: 'SMTP-Benutzername',
        smtpPasswordRef: 'SMTP-Passwort-Referenz',
        useTls: 'TLS verwenden',
        recipients: 'Empfänger',
        fromAddress: 'Absenderadresse',
        toAddresses: 'Empfängeradressen',
        ccAddresses: 'CC-Adressen',
        grantTemplate: 'Vorlage für Berechtigungsvergabe',
        revokeTemplate: 'Vorlage für Berechtigungsentzug',
        subjectTemplate: 'Betreff-Vorlage',
        bodyContentType: 'Inhaltstyp',
        advancedSettings: 'Erweiterte Einstellungen',
        optionalPlaceholder: 'Optional',
        connectorCreated: 'Connector erfolgreich erstellt.',
        connectorUpdated: 'Connector erfolgreich aktualisiert.',
        connectorDeleted: 'Connector erfolgreich gelöscht.',
        connectorToggled: 'Connector-Status erfolgreich aktualisiert.',
        configurationSaved: 'Konfiguration erfolgreich gespeichert.',
        // Auth type labels
        tokenAuth: 'Service-Account-Token',
        certificateAuth: 'Client-Zertifikat',
        kubeconfigAuth: 'Kubeconfig-Datei',
        noneAuth: 'Keine Authentifizierung',
        // Placeholder texts
        tokenSecretRefPlaceholder: 'vault:secret/api/token oder plain:mein-token',
        tokenUrlPlaceholder: 'https://auth.example.com/oauth/token',
        clientSecretRefPlaceholder: 'vault:secret/oauth/client-secret',
        scopePlaceholder: 'openid profile email',
        passwordSecretRefPlaceholder: 'vault:secret/api/password',
        scimBaseUrlPlaceholder: 'https://scim.example.com/v2',
        smtpHostPlaceholder: 'smtp.example.com',
        smtpPasswordRefPlaceholder: 'vault:secret/smtp/password',
        fromAddressPlaceholder: 'noreply@example.com',
        toAddressesPlaceholder: 'empfaenger@example.com',
        grantSubjectTemplatePlaceholder: 'Zugriff gewährt: ${accessProfileName}',
        grantBodyTemplatePlaceholder: 'Hallo ${identity.displayName}, der Zugriff wurde gewährt.',
        revokeSubjectTemplatePlaceholder: 'Zugriff entzogen: ${accessProfileName}',
        revokeBodyTemplatePlaceholder: 'Hallo ${identity.displayName}, der Zugriff wurde entzogen.',
        // Database type labels
        databaseTypePostgresql: 'PostgreSQL',
        databaseTypeMysql: 'MySQL',
        databaseTypeOracle: 'Oracle',
        databaseTypeSqlserver: 'SQL Server',
        databaseTypeOther: 'Sonstige',
        // Tabs
        tabs: {
            overview: 'Übersicht',
            configuration: 'Konfiguration',
            attributes: 'Attribute',
            provisioningTasks: 'Provisionierungsaufgaben',
        },
        // Attributes tab
        attributes: {
            title: 'Connector-Attribute',
            description: 'Benutzerdefinierte Attribute, die diesem Connector zugewiesen sind.',
        },
        // Attribute Mappings card
        attributeMappings: {
            title: 'Attributzuordnungen',
            description: 'Legt fest, wie Identitätsattribute bei der Kontobereitstellung auf Felder des Zielsystems abgebildet werden.',
            descriptionDetail: 'Jede Zeile ordnet eine Quelle (Direkt, Berechnet oder Statisch) einem Zielfeldnamen zu.',
            emptyState: 'Noch keine Attributzuordnungen konfiguriert.',
            addMapping: 'Zuordnung hinzufügen',
            source: 'Quelle',
            target: 'Ziel',
            type: '$t(appConfig.domainEntityTypes.TYPE)',
            transform: 'Transformation',
            transformNone: 'Keine',
            required: 'Erforderlich',
            typeDirect: 'Direkt',
            typeComputed: 'Berechnet',
            typeStatic: 'Statisch',
            sourceHintDirect: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) auswählen',
            sourceHintComputed: '{firstName} {lastName}',
            sourceHintStatic: 'Literalwert (z.B. 512)',
            targetHint: 'Zielsystemattribut (z.B. mail)',
            duplicateTarget: 'Doppeltes Ziel: {{name}}',
            unknownSource: 'Unbekannte $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION)',
            saved: 'Attributzuordnungen gespeichert',
            cleared: 'Attributzuordnungen geleert',
            confirmDelete: 'Diese Zuordnung entfernen?',
            noMappings: 'Keine Attributzuordnungen konfiguriert',
            noMappingsWarning: 'Die Kontobereitstellung (CREATE_ACCOUNT, UPDATE_ACCOUNT) schlägt fehl, bis Attributzuordnungen konfiguriert sind.',
            invalidTemplateSyntax: 'Ungültige Vorlagensyntax (nicht geschlossene oder verschachtelte geschweifte Klammern)',
            unknownScimTarget: 'Unbekannter SCIM-Zielpfad',
            sourceRequired: 'Quelle ist erforderlich',
            targetExceedsMaxLength: 'Ziel überschreitet 100 Zeichen',
            sourceExceedsMaxLength: 'Quelle überschreitet 500 Zeichen',
            invalidRfc4512Target: 'Muss mit einem Buchstaben beginnen, gefolgt von Buchstaben, Ziffern, Bindestrichen oder Punkten',
            maxMappingsReached: 'Maximal 50 Attributzuordnungen',
            maxMappingsTooltip: 'Maximal 50 Attributzuordnungen erreicht',
            unknownVariable: 'Unbekannte Variable: {{name}}',
            addMappingAction: '+ Hinzufügen',
        },
        // Navigation guard dialog
        unsavedChangesTitle: 'Ohne Speichern verlassen?',
        unsavedChangesBody: 'Sie haben nicht gespeicherte Änderungen. Wenn Sie jetzt verlassen, gehen Ihre Änderungen verloren.',
        unsavedChangesStay: 'Bleiben',
        unsavedChangesLeave: 'Ohne Speichern verlassen',
        // Per-connector Provisioning Tasks tab (issue 601)
        provisioningTasks: {
            title: 'Provisionierungsaufgaben',
            active: 'Aktive Aufgaben',
            history: 'Letzter Verlauf',
            viewAll: 'Alle im Provisionierungsverlauf anzeigen →',
            activeEmpty: 'Keine aktiven Provisionierungsaufgaben für diesen Konnektor.',
            historyEmpty: 'Noch kein Provisionierungsverlauf für diesen Konnektor.',
            loading: 'Provisionierungsaufgaben werden geladen...',
            errorLoading: 'Fehler beim Laden der Provisionierungsaufgaben. Bitte erneut versuchen.',
            columns: {
                identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
                entitlement: 'Berechtigung',
                account: 'Konto',
                action: 'Aktion',
                status: 'Status',
                retries: 'Wiederholungen',
                created: 'Erstellt',
                completed: 'Abgeschlossen',
            },
        },
        // LDAP Provisioning Config card
        ldapProvisioningConfig: {
            title: 'LDAP-Bereitstellungskonfiguration',
            description: 'LDAP-spezifische Bereitstellungskonfiguration einschließlich OU-Routing-Regeln und Objektklassen.',
            emptyState: 'Keine LDAP-Bereitstellungskonfiguration gesetzt. Standardwerte gelten: objectClass=inetOrgPerson, DN-Vorlage=cn=${accountName},${ou}.',
            objectClasses: 'Objektklassen',
            objectClassesHint: 'z.B. top, person, inetOrgPerson',
            objectClassesEmpty: 'Keine Objektklassen konfiguriert',
            dnTemplate: 'DN-Vorlage',
            dnTemplateHint: 'Muss {ou} enthalten. Beispiel: cn={cn},{ou}',
            noConfig: 'Keine LDAP-Bereitstellungskonfiguration',
            noConfigWarning: 'Die Kontobereitstellung erfordert Objektklassen und eine DN-Vorlage.',
            ouRouting: 'OU-Routing',
            ouRoutingDescription: 'Regeln werden von oben nach unten ausgewertet. Erste Übereinstimmung gewinnt.',
            defaultOu: 'Standard-OU',
            addRule: 'Regel hinzufügen',
            attribute: 'Attribut',
            operator: 'Operator',
            value: 'Wert',
            targetOu: 'Ziel-OU',
            saved: 'LDAP-Bereitstellungskonfiguration gespeichert',
            defaultOuRequired: 'Standard-OU ist erforderlich, wenn Regeln vorhanden sind',
            defaultOuMaxLength: 'Maximal 500 Zeichen',
        },
    },
    types: {
        title: '$t(appConfig.domainEntityTypes.TYPE_VALUES)',
        pageTitle: '$t(appConfig.domainEntityTypes.TYPE_VALUES) | Administration',
        subtitle: 'Typwerttabellen und deren Einträge verwalten',
        allTypeTables: 'Alle Typwerttabellen',
        filterPlaceholder: 'Typwerttabellen filtern...',
        searchPlaceholder: 'Typtabellen suchen...',
        entityTypesOnly: 'Nur Entitätstypen',
        tableName: 'Tabellenname',
        entryCount: 'Einträge',
        noTablesMatch: 'Keine Typwerttabellen entsprechen Ihrem Filter.',
        noTablesFound: 'Keine Typwerttabellen gefunden.',
        loadingTables: 'Typwerttabellen werden geladen...',
        errorLoading: 'Fehler beim Laden der Typwerttabellen. Bitte versuchen Sie es erneut.',
        tableCount: '{{count}} Typwerttabelle(n)',
        values: 'Werte',
        code: 'Code',
        label: 'Bezeichnung',
        sortOrder: 'Sortierung',
        addValue: 'Wert hinzufügen',
        editValue: 'Wert bearbeiten',
        deleteValue: 'Wert löschen',
        deleteValueConfirm: 'Möchten Sie den Wert "{{code}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        codePlaceholder: 'Code eingeben',
        labelPlaceholder: 'Bezeichnung eingeben',
        sortOrderPlaceholder: 'Sortierung eingeben',
        noValuesFound: 'Keine Werte in dieser Typwerttabelle gefunden.',
        noValuesMatch: 'Keine Werte entsprechen Ihrem Filter.',
        filterValuesPlaceholder: 'Werte filtern...',
        valueCount: '{{count}} Wert(e)',
        loadingValues: '$t(appConfig.domainEntityTypes.TYPE_VALUES) werden geladen...',
        errorLoadingValues: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.TYPE_VALUES). Bitte versuchen Sie es erneut.',
        typesTitle: '$t(appConfig.domainEntityTypes.TYPES)',
        detailPageTitle: 'Typdetails | Administration',
        typesSubtitle: '$t(appConfig.domainEntityTypes.TYPE_VALUES) und deren Übersetzungen für Auswahlfelder in der gesamten Anwendung verwalten.',
        loadingTypes: '$t(appConfig.domainEntityTypes.TYPES) werden geladen...',
        errorLoadingTypes: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.TYPES). Bitte versuchen Sie es erneut.',
        addTypeValue: '$t(appConfig.domainEntityTypes.TYPE_VALUE) hinzufügen',
        createValueDescription: 'Erstellen Sie einen neuen Wert für {{name}}.',
        deleteTypeValue: '$t(appConfig.domainEntityTypes.TYPE_VALUE) löschen',
        cannotDelete: '{{code}} kann nicht gelöscht werden, da es von {{count}} Datensätzen verwendet wird.',
        setInactiveHint: 'Sie können es stattdessen auf inaktiv setzen, um es bei neuen Auswahlen auszublenden.',
        codeFormatHint: 'GROSSBUCHSTABEN_MIT_UNTERSTRICHEN',
        noPermission: 'Sie haben keine Berechtigung, $t(appConfig.domainEntityTypes.TYPES) anzuzeigen.',
        usage: 'Verwendung',
        translations: 'Übersetzungen',
        translationsFor: 'Übersetzungen für {{code}}',
        editTranslations: 'Übersetzungen bearbeiten',
        editTranslationsFor: 'Übersetzungen für {{code}} aktualisieren',
        viewTranslations: 'Übersetzungen anzeigen',
        language: 'Sprache',
        descriptionOptional: 'Beschreibung (optional)',
        setInactive: 'Inaktiv setzen',
        setActive: 'Aktiv setzen',
        inUse: '({{count}} in Verwendung)',
        activeCount: '{{count}} aktiv',
        translationLabel: '{{locale}}-Übersetzung',
        entityTypeBadge: 'Entity-$t(appConfig.domainEntityTypes.TYPE)',
        valueDetailPageTitle: '$t(appConfig.domainEntityTypes.TYPE_VALUE) | Admin',
        backToTable: 'Zurück zu {{tableName}}',
        settingsCard: 'Einstellungen',
        settingsCardEmpty: 'Keine Einstellungen konfiguriert. Füllen Sie die Felder oben aus und klicken Sie auf Speichern.',
        settingsIconLabel: 'Symbol',
        settingsIconNone: 'Kein Symbol ausgewählt',
        settingsIconSearch: 'Symbole suchen...',
        settingsIconNoResults: 'Keine Symbole gefunden',
        iconCategories: {
            people: 'Personen & Teams',
            business: 'Geschäft & Gebäude',
            technology: 'Technologie',
            security: 'Sicherheit & Zugang',
            communication: 'Kommunikation',
            organization: 'Organisation',
            files: 'Dateien & Daten',
            status: 'Status & Indikatoren',
            objects: 'Objekte & Orte',
            tools: 'Werkzeuge & Aktionen',
        },
        settingsColorLabel: 'Farbe',
        settingsTemplateLabel: 'Anzeigename-Vorlage',
        settingsTemplatePlaceholder: 'z.B. {firstName} {lastName}',
        settingsTemplateChipsHint: 'Klicken Sie auf einen Chip, um den Platzhalter zur Vorlage hinzuzufügen.',
        settingsTemplateNoAttributes: 'Diesem $t(appConfig.domainEntityTypes.TYPE) sind noch keine Attribute zugeordnet.',
        settingsTemplateStalePlaceholders: 'Einige Platzhalter in dieser Vorlage ({{placeholders}}) sind diesem $t(appConfig.domainEntityTypes.TYPE) nicht zugeordnet und werden als leere Zeichenfolge aufgelöst.',
        settingsSaveSuccess: 'Einstellungen gespeichert.',
        settingsSaveSuccessRederivation: 'Anzeigenamen werden für alle $t(appConfig.domainEntityTypes.IDENTITIES) dieses Typs neu abgeleitet. Dies kann einen Moment dauern.',
        settingsSaveError: 'Einstellungen konnten nicht gespeichert werden. Bitte erneut versuchen.',
        settingsConflict: 'Einstellungen wurden von einer anderen Person geändert. Bitte laden Sie die Seite neu, um die aktuelle Version zu erhalten.',
        scopedAttributesCard: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) (zugeordnet)',
        scopedAttributesEmpty: 'Diesem $t(appConfig.domainEntityTypes.TYPE) sind keine $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) zugeordnet.',
        scopedAttributesViewLink: '$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) anzeigen',
        scopedAttributesName: 'Name',
        scopedAttributesDisplayName: 'Anzeigename',
        scopedAttributesValueType: 'Werttyp',
        scopedAttributesRequired: 'Pflichtfeld',
        unsavedChangesTitle: 'Nicht gespeicherte Änderungen verwerfen?',
        unsavedChangesBody: 'Ihre Einstellungsänderungen wurden nicht gespeichert. Trotzdem verlassen?',
        unsavedChangesDiscard: 'Verwerfen',
        retryButton: 'Erneut versuchen',
        errorLoadingValue: 'Dieser $t(appConfig.domainEntityTypes.TYPE_VALUE) konnte nicht geladen werden. Die Tabelle oder der Code existiert möglicherweise nicht oder ist keine Entity-$t(appConfig.domainEntityTypes.TYPE)-Tabelle.',
        groupedView: {
            searchPlaceholder: 'Zeilen nach Code oder Bezeichnung suchen...',
            noResults: 'Keine Zeilen entsprechen Ihrer Suche.',
            ungroupedLabel: 'Ohne Gruppe',
            rowCountAria: '{{count}} Zeilen in Gruppe {{group}}',
        },
    },
    parties: {
        title: '$t(appConfig.domainEntityTypes.PARTIES)',
        pageTitle: '$t(appConfig.domainEntityTypes.PARTIES) | Identity-Management',
        detailPageTitle: 'Parteidetails | Identity-Management',
        subtitle: '$t(appConfig.domainEntityTypes.PARTIES) (Personen und Organisationen) verwalten',
        subtitleExtended: '$t(appConfig.domainEntityTypes.PARTIES) (Personen, Organisationen und Agenten) anzeigen und verwalten',
        allParties: 'Alle $t(appConfig.domainEntityTypes.PARTIES)',
        filterPlaceholder: 'Nach Name, externer ID oder Parteiattributen suchen...',
        searchByName: 'Nach Name suchen...',
        partyCount: '{{count}} $t(appConfig.domainEntityTypes.PARTY)(en)',
        partyCount_one: '{{count}} $t(appConfig.domainEntityTypes.PARTY)',
        partyCount_other: '{{count}} $t(appConfig.domainEntityTypes.PARTIES)',
        createSuccess: '$t(appConfig.domainEntityTypes.PARTY) erfolgreich erstellt.',
        displayName: 'Anzeigename',
        email: 'E-Mail',
        partyType: 'Parteityp',
        noPartiesMatch: 'Keine $t(appConfig.domainEntityTypes.PARTIES) entsprechen Ihren Filtern.',
        noPartiesFound: 'Keine $t(appConfig.domainEntityTypes.PARTIES) gefunden.',
        loadingParties: '$t(appConfig.domainEntityTypes.PARTIES) werden geladen...',
        loadingParty: '$t(appConfig.domainEntityTypes.PARTY) wird geladen...',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.PARTIES). Bitte versuchen Sie es erneut.',
        errorLoadingParty: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.PARTY). Bitte versuchen Sie es erneut.',
        partyDetails: 'Parteidetails',
        firstName: 'Vorname',
        lastName: 'Nachname',
        identities: '$t(appConfig.domainEntityTypes.IDENTITIES)',
        noIdentities: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) für diese $t(appConfig.domainEntityTypes.PARTY) gefunden.',
        identityCount: '{{count}} $t(appConfig.domainEntityTypes.IDENTITIES) mit dieser $t(appConfig.domainEntityTypes.PARTY) verknüpft',
        identityCount_one: '{{count}} $t(appConfig.domainEntityTypes.IDENTITY) mit dieser $t(appConfig.domainEntityTypes.PARTY) verknüpft',
        identityCount_other: '{{count}} $t(appConfig.domainEntityTypes.IDENTITIES) mit dieser $t(appConfig.domainEntityTypes.PARTY) verknüpft',
        noIdentitiesLinked: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) mit dieser $t(appConfig.domainEntityTypes.PARTY) verknüpft.',
        relationships: 'Beziehungen',
        partyHierarchy: 'Organisation',
        organizationalStructure: 'Organisationsstruktur und Beziehungen',
        noRelationshipsForCard: 'Keine {{label}} zugewiesen.',
        noRelationships: 'Keine Parteibeziehungen definiert.',
        addRelationship: '{{label}} hinzufügen',
        addRelationshipMaxReached: 'Maximale Anzahl für {{label}} erreicht.',
        removeRelationship: '{{name}} entfernen',
        removeRelationshipTitle: 'Beziehung entfernen',
        removeRelationshipConfirm: 'Beziehung zu {{name}} entfernen? Damit wird das Gültig-bis-Datum gesetzt; die Zeile ist nicht mehr aktiv, bleibt aber für die Audit-Historie erhalten.',
        relationshipPickerPlaceholder: 'Nach einer $t(appConfig.domainEntityTypes.PARTY) suchen...',
        relationshipCreateSuccess: 'Beziehung erstellt.',
        relationshipEndedSuccess: 'Beziehung entfernt.',
        created: 'Erstellt',
        menuDescription: 'Personen, Organisationen und Agenten',
    },
    identities: {
        title: '$t(appConfig.domainEntityTypes.IDENTITIES)',
        pageTitle: '$t(appConfig.domainEntityTypes.IDENTITIES) | Identity-Management',
        subtitle: 'Digitale $t(appConfig.domainEntityTypes.IDENTITIES) anzeigen und verwalten',
        allIdentities: 'Alle $t(appConfig.domainEntityTypes.IDENTITIES)',
        searchPlaceholder: 'Nach Parteiname, externer ID oder Attributen suchen...',
        identityCount: '{{count}} $t(appConfig.domainEntityTypes.IDENTITIES)',
        identityCount_one: '{{count}} $t(appConfig.domainEntityTypes.IDENTITY)',
        identityCount_other: '{{count}} $t(appConfig.domainEntityTypes.IDENTITIES)',
        party: '$t(appConfig.domainEntityTypes.PARTY)',
        identityType: '$t(appConfig.domainEntityTypes.TYPE)',
        lifecycleState: 'Zustand',
        noIdentitiesMatch: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) entsprechen Ihren Filtern.',
        noIdentitiesFound: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) gefunden.',
        loadingIdentities: '$t(appConfig.domainEntityTypes.IDENTITIES) werden geladen...',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.IDENTITIES). Bitte versuchen Sie es erneut.',
        identityDetails: 'Identitätsdetails',
        detailPageTitle: 'Identitätsdetails | Identity-Management',
        loadingIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) wird geladen...',
        errorLoadingIdentity: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.IDENTITY). Bitte versuchen Sie es erneut.',
        identityInfo: 'Kernidentitätsinformationen und Lebenszyklusstatus',
        lifecycleChanged: 'Lebenszyklus geändert',
        attributes: 'Attribute',
        attributeCount: '{{count}} Attribute für diese $t(appConfig.domainEntityTypes.IDENTITY) definiert',
        attributeCount_one: '{{count}} Attribut für diese $t(appConfig.domainEntityTypes.IDENTITY) definiert',
        attributeCount_other: '{{count}} Attribute für diese $t(appConfig.domainEntityTypes.IDENTITY) definiert',
        noAttributes: 'Keine Attribute für diese $t(appConfig.domainEntityTypes.IDENTITY) gefunden.',
        authority: 'Autorität',
        addAttribute: 'Attribut hinzufügen',
        editAttribute: 'Attribut bearbeiten',
        deleteAttribute: 'Attribut löschen',
        confirmDeleteAttribute: 'Möchten Sie dieses Attribut wirklich löschen?',
        attributeSaved: 'Attribut erfolgreich gespeichert.',
        attributeDeleted: 'Attribut erfolgreich gelöscht.',
        accountCount: '{{count}} Konten mit dieser $t(appConfig.domainEntityTypes.IDENTITY) verknüpft',
        accountCount_one: '{{count}} Konto mit dieser $t(appConfig.domainEntityTypes.IDENTITY) verknüpft',
        accountCount_other: '{{count}} Konten mit dieser $t(appConfig.domainEntityTypes.IDENTITY) verknüpft',
        noAccountsLinked: 'Keine Konten mit dieser $t(appConfig.domainEntityTypes.IDENTITY) verknüpft.',
        identifiersSection: 'Identifikatoren',
        identifierCount: '{{count}} Identifikatoren für diese $t(appConfig.domainEntityTypes.IDENTITY) erfasst',
        identifierCount_one: '{{count}} Identifikator für diese $t(appConfig.domainEntityTypes.IDENTITY) erfasst',
        identifierCount_other: '{{count}} Identifikatoren für diese $t(appConfig.domainEntityTypes.IDENTITY) erfasst',
        noIdentifiersRecorded: 'Keine Identifikatoren für diese $t(appConfig.domainEntityTypes.IDENTITY) erfasst.',
        identifierTypeColumn: 'Typ',
        identifierValueColumn: 'Wert',
        identifierPrimaryColumn: 'Primär',
        identifierValidFromColumn: 'Gültig ab',
        identifierValidToColumn: 'Gültig bis',
        identifierPrimaryBadge: 'Primär',
        activeAssignmentCount: '{{count}} aktive Zuweisungen',
        activeAssignmentCount_one: '{{count}} aktive Zuweisung',
        activeAssignmentCount_other: '{{count}} aktive Zuweisungen',
        noAssignments: 'Keine $t(appConfig.domainEntityTypes.ACCESS_PROFILE_ASSIGNMENTS).',
        byAssignment: 'Nach Zuweisung',
        assignmentHistory: 'Zuweisungsverlauf',
        noHistoryEvents: 'Keine Verlaufsereignisse.',
        partyBelongsTo: 'Die $t(appConfig.domainEntityTypes.PARTY), zu der diese $t(appConfig.domainEntityTypes.IDENTITY) gehört',
        viewPartyDetails: 'Parteidetails anzeigen',
        managerSection: 'Vorgesetzte:r',
        managerSection_other: 'Verantwortliche Personen',
        managerSectionDescription: 'Der/die direkte Vorgesetzte dieser $t(appConfig.domainEntityTypes.IDENTITY)',
        managerSectionDescription_other: 'Personen, die für diese $t(appConfig.domainEntityTypes.IDENTITY) verantwortlich sind',
        managerEmptyState: 'Kein/e Vorgesetzte:r zugewiesen',
        managerLoadError: 'Verantwortliche Personen konnten nicht geladen werden',
        managerRetry: 'Wiederholen',
        viewIdentityDetails: 'Identitätsdetails anzeigen',
        sources: 'Quellen',
        activeSources: '{{count}} aktiv',
        request: '$t(appConfig.domainEntityTypes.REQUEST)',
        expiresAt: 'Läuft ab',
        externalIdentifier: 'Externe Kennung',
        revokeAssignment: 'Zuweisung widerrufen',
        revokeAssignmentConfirm: 'Möchten Sie diese Zuweisung wirklich widerrufen? Diese Aktion kann nicht rückgängig gemacht werden.',
        revoking: 'Wird widerrufen...',
        revoke: 'Widerrufen',
        activateIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) aktivieren',
        suspendIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) sperren',
        terminateIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) beenden',
        activateDescription: 'Dadurch wird die $t(appConfig.domainEntityTypes.IDENTITY) aktiviert und der Zugriff ermöglicht.',
        suspendDescription: 'Dadurch wird die $t(appConfig.domainEntityTypes.IDENTITY) gesperrt und der Zugriff vorübergehend deaktiviert.',
        terminateDescription: 'Dadurch wird die $t(appConfig.domainEntityTypes.IDENTITY) dauerhaft beendet. Diese Aktion kann nicht rückgängig gemacht werden.',
        activate: 'Aktivieren',
        suspend: 'Sperren',
        terminate: 'Beenden',
        rehire: 'Wiedereinstellen',
        rehireIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) wiedereinstellen',
        rehireDescription: 'Eine beendete $t(appConfig.domainEntityTypes.IDENTITY) mit einem neuen Eintrittsdatum wiedereinstellen. Sie wird sofort aktiv, wenn das Eintrittsdatum heute ist, oder bleibt bis zum Eintrittsdatum gesperrt. Berechtigungen werden bei Aktivierung neu vergeben.',
        rehireNewEntryDate: 'Neues Eintrittsdatum',
        rehireNewEntryDateHelper: 'Heute oder in der Zukunft, innerhalb von 2 Jahren.',
        rehireReason: 'Grund',
        rehireReasonHelper: 'Pflichtfeld. Wird im Audit-Log erfasst.',
        rehireSubmitted: 'Wiedereinstellung übermittelt — $t(appConfig.domainEntityTypes.IDENTITY) ist bis zum Eintrittsdatum gesperrt.',
        processing: 'Wird verarbeitet...',
        menuDescription: 'Digitale $t(appConfig.domainEntityTypes.IDENTITIES) und Lebenszyklus',
        accounts: 'Konten',
        accessProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        effectiveAccess: 'Effektiver Zugriff',
        timeline: 'Zeitverlauf',
        snapshot: 'Momentaufnahme',
        lifecycleUpdated: 'Identitäts-Lebenszyklus erfolgreich aktualisiert.',
        activationSubmitted: 'Aktivierung eingereicht — wird im Hintergrund verarbeitet.',
        terminationSubmitted: 'Beendigung eingereicht — wird im Hintergrund verarbeitet.',
        assignmentRevoked: 'Zuweisung erfolgreich widerrufen.',
        entryDate: 'Eintrittsdatum',
        exitDate: 'Austrittsdatum',
        reactivationDate: 'Geplante Reaktivierung',
        reactivationDateNone: 'Nicht geplant',
        plannedReactivationDate: 'Geplantes Reaktivierungsdatum',
        plannedReactivationDateHelper: 'Optionales zukünftiges Datum. Die $t(appConfig.domainEntityTypes.IDENTITY) wird an diesem Tag automatisch reaktiviert.',
        reactivationDateUpdated: 'Geplantes Reaktivierungsdatum aktualisiert.',
        editReactivationDate: 'Geplantes Reaktivierungsdatum bearbeiten',
        editReactivationDateDescription: 'Legen Sie ein neues geplantes Reaktivierungsdatum fest oder entfernen Sie es, um die Sperre unbefristet zu belassen.',
        derivedDisplayName: 'Anzeigename',
        upcomingEvents: 'Anstehende Ereignisse',
        upcomingEventsDescription: 'Geplante Eintritte und Austritte',
        noUpcomingEvents: 'Keine anstehenden $t(appConfig.domainEntityTypes.LIFECYCLE_EVENTS).',
        eventTypeActivation: 'Aktivierung',
        eventTypeTermination: 'Beendigung',
        joiner: 'Eintritt',
        leaver: 'Austritt',
        evaluateRules: 'Regeln neu auswerten',
        evaluateRulesDescription: 'Alle Auto-Assign-Regeln für diese $t(appConfig.domainEntityTypes.IDENTITY) werden neu ausgewertet. Verwenden, wenn sich Attribute geändert haben (Mover-Szenario).',
        evaluateRulesSubmitted: 'Regelauswertung erfolgreich eingereicht.',
    },
    lifecycleEvents: {
        triggerSource: {
            USER_ACTION: 'Benutzeraktion',
            JML_JOINER: 'Eintritt',
            JML_LEAVER: 'Austritt',
            JML_MOVER: 'Versetzung',
            EXIT_DATE_JOB: 'Austrittsdatum-Job',
            REACTIVATION_SWEEPER: 'Reaktivierungs-Job',
            INBOUND_SYNC: 'Eingehende Synchronisierung',
            OUTBOUND_PROVISIONING: 'Ausgehende Bereitstellung',
            ACCESS_REQUEST: '$t(appConfig.domainEntityTypes.ACCESS_REQUEST)',
            CERTIFICATION_REVOKE: 'Zertifizierungswiderruf',
            INITIAL_LOAD: 'Erstbefüllung',
            SYSTEM: 'System',
        },
        tab: {
            identity: 'Lebenszyklus',
            account: 'Statusereignisse',
        },
        header: {
            viewTimeline: 'Vollständigen Verlauf anzeigen →',
            createdAs: 'Erstellt als {{state}}',
            unavailable: 'Lebenszyklus-Verlauf nicht verfügbar',
            loading: 'Lebenszyklus-Verlauf wird geladen…',
            by: 'von',
            reasonLabel: 'Begründung',
        },
        timeline: {
            system: 'System',
            createdLabel: 'Erstellt',
            cascadedFromIdentity: 'Ausgelöst durch $t(appConfig.domainEntityTypes.IDENTITY) →',
            viewJobExecution: 'Job-$t(appConfig.domainEntityTypes.EXECUTION) anzeigen →',
            viewAccessRequest: '$t(appConfig.domainEntityTypes.ACCESS_REQUEST) anzeigen →',
            loading: 'Verlauf wird geladen…',
            errorBanner: '$t(appConfig.domainEntityTypes.LIFECYCLE_EVENTS) konnten nicht geladen werden.',
        },
        empty: {
            noEvents: 'Keine $t(appConfig.domainEntityTypes.LIFECYCLE_EVENTS) für diese $t(appConfig.domainEntityTypes.IDENTITY) erfasst.',
            noEventsAccount: 'Keine Statusereignisse für dieses Konto erfasst.',
            cutoverNote: 'Ereignisse werden ab dem Auslieferungsdatum erfasst.',
            noResultsForFilters: 'Keine $t(appConfig.domainEntityTypes.LIFECYCLE_EVENTS) entsprechen den aktuellen Filtern.',
            clearFilters: 'Filter zurücksetzen',
        },
        filter: {
            triggerSource: 'Auslöser',
            stateTransition: 'Status',
            dateRange: 'Zeitraum',
            from: 'Von',
            to: 'Bis',
            toggleFilters: 'Filter',
            clearFilters: 'Filter zurücksetzen',
        },
        dialog: {
            reasonLabel: 'Begründung',
            reasonHelp: 'Optional — im Lebenszyklus-Verlauf sichtbar',
            reasonCounter: '{{count}} / 1000',
            reasonPlaceholder: 'Warum erfolgt diese Statusänderung?',
        },
        toast: {
            updated: 'Lebenszyklus-Status aktualisiert',
            accountUpdated: 'Kontostatus aktualisiert',
        },
        dashboard: {
            title: '$t(appConfig.domainEntityTypes.LIFECYCLE_EVENTS)',
            pageTitle: '$t(appConfig.domainEntityTypes.LIFECYCLE_EVENTS) | Verwaltung',
            menuDescription: 'Übergreifende Zeitleiste der Identitäts- und Kontostatusänderungen',
            cardTitle: 'Alle $t(appConfig.domainEntityTypes.LIFECYCLE_EVENTS)',
            count: '{{count}} Ereignis(se)',
            count_one: '{{count}} Ereignis',
            count_other: '{{count}} Ereignisse',
            errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.LIFECYCLE_EVENTS). Bitte erneut versuchen.',
            loading: '$t(appConfig.domainEntityTypes.LIFECYCLE_EVENTS) werden geladen…',
            entityTypeFilter: 'Entitätstyp',
            allEntities: 'Alle Entitäten',
            allTriggerSources: 'Alle Auslöser',
            triggerSourceCount: '{{count}} Auslöser',
            entityType: {
                IDENTITY: '$t(appConfig.domainEntityTypes.IDENTITY)',
                ACCOUNT: 'Konto',
            },
            columns: {
                changedAt: 'Geändert am',
                entity: 'Entität',
                fromTo: 'Von → Nach',
                triggerSource: 'Auslöser',
                actor: 'Akteur',
                reason: 'Begründung',
            },
            actorSystem: 'System',
            actorSystemWithSource: 'System ({{source}})',
            createdLabel: 'Erstellt',
            createdSeparator: 'Erstellt · {{state}}',
            fromToSeparator: '{{from}} → {{to}}',
            none: '—',
        },
    },
    accounts: {
        title: 'Konten',
        pageTitle: 'Konten | Identity-Management',
        detailPageTitle: 'Konto-Details',
        accountDetails: 'Konto-Details',
        accountConfig: 'Konto-Konfiguration',
        notFound: 'Konto nicht gefunden',
        subtitle: 'Konten über alle $t(appConfig.domainEntityTypes.TARGET_SYSTEMS) hinweg anzeigen',
        allAccounts: 'Alle Konten',
        filterPlaceholder: 'Konten suchen...',
        accountCount: '{{count}} Konto/Konten',
        accountName: 'Kontoname',
        targetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
        identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        subtitleExtended: 'Konten über alle $t(appConfig.domainEntityTypes.TARGET_SYSTEMS) hinweg anzeigen und verwalten',
        searchByExternalId: 'Nach externer ID suchen...',
        accountCount_one: '{{count}} Konto',
        accountCount_other: '{{count}} Konten',
        externalId: 'Externe ID',
        allStatuses: 'Alle Status',
        allSystems: 'Alle Systeme',
        allEnvs: 'Alle Umgebungen',
        filterBySystem: 'Nach System filtern...',
        noSystemsFound: 'Keine Systeme gefunden.',
        menuDescription: 'Konten über $t(appConfig.domainEntityTypes.TARGET_SYSTEMS) hinweg',
        noAccountsMatch: 'Keine Konten entsprechen Ihren Filtern.',
        noAccountsFound: 'Keine Konten gefunden.',
        loadingAccounts: 'Konten werden geladen...',
        errorLoading: 'Fehler beim Laden der Konten. Bitte versuchen Sie es erneut.',
        pendingCreation: 'Erstellung ausstehend...',
        creationInProgress: 'Kontoerstellung wird durchgeführt',
        disableInProgress: 'Kontodeaktivierung wird durchgeführt',
        enableInProgress: 'Kontoaktivierung wird durchgeführt',
        deleteInProgress: 'Kontolöschung wird durchgeführt',
        lockedTooltip: 'Konto aufgrund eines Sicherheitsvorfalls gesperrt. Kontaktieren Sie das Sicherheitsteam.',
        createAccount: 'Konto erstellen',
        provisionNow: 'Jetzt bereitstellen',
        disableAccount: 'Konto deaktivieren',
        enableAccount: 'Konto aktivieren',
        deleteAccount: 'Konto löschen',
        cancelAccountCreation: 'Kontoerstellung abbrechen',
        revokeGrantsFirst: 'Alle Berechtigungen widerrufen, bevor dieses Konto gelöscht wird',
        createAccountTitle: 'Konto erstellen',
        createAccountMessage: 'Konto auf {{systemName}} erstellen?',
        selectTargetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM) auswählen',
        disableAccountTitle: 'Konto deaktivieren',
        disableAccountMessage: 'Konto auf {{systemName}} deaktivieren? Das Konto wird im $t(appConfig.domainEntityTypes.TARGET_SYSTEM) deaktiviert.',
        enableAccountTitle: 'Konto aktivieren',
        enableAccountMessage: 'Konto auf {{systemName}} aktivieren?',
        deleteAccountTitle: 'Konto löschen',
        deleteAccountMessage: 'Konto auf {{systemName}} löschen? Das Konto wird dauerhaft aus dem $t(appConfig.domainEntityTypes.TARGET_SYSTEM) entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
        cancelCreationTitle: 'Kontoerstellung abbrechen',
        cancelCreationMessage: 'Die ausstehende Kontoerstellung auf {{systemName}} abbrechen? Das Konto wird nicht erstellt.',
        operationQueued: 'Kontooperation eingereiht \u2014 wird im Hintergrund verarbeitet',
        provisionNowQueued: 'Bereitstellung eingereiht \u2014 das Konto wird auf dem $t(appConfig.domainEntityTypes.TARGET_SYSTEM) (erneut) bereitgestellt.',
        noAccountsLinked: 'Keine Konten mit dieser $t(appConfig.domainEntityTypes.IDENTITY) verknüpft.',
        environment: 'Umgebung',
        systemType: 'Systemtyp',
        disabledAt: 'Deaktiviert am',
        externalIdentifier: 'Externe Kennung',
    },
    systems: {
        title: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS)',
        pageTitle: 'Systeme | $t(appConfig.domainEntityTypes.TARGET_SYSTEMS)',
        subtitle: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS) und deren Konfiguration verwalten',
        allSystems: 'Alle Systeme',
        filterPlaceholder: 'Systeme filtern...',
        systemCount: '{{count}} System(e)',
        systemName: 'Systemname',
        systemType: 'Systemtyp',
        noSystemsMatch: 'Keine Systeme entsprechen Ihrem Filter.',
        noSystemsFound: 'Keine Systeme gefunden.',
        loadingSystems: 'Systeme werden geladen...',
        errorLoading: 'Fehler beim Laden der Systeme. Bitte versuchen Sie es erneut.',
        detailPageTitle: 'Systemdetails | $t(appConfig.domainEntityTypes.TARGET_SYSTEMS)',
        subtitleView: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS) und deren Konfiguration anzeigen und verwalten',
        searchByName: 'Nach Name suchen...',
        environment: 'Umgebung',
        allEnvironments: 'Alle Umgebungen',
        lastSync: 'Letzte Synchronisierung',
        loadingSystem: 'System wird geladen...',
        errorLoadingSystem: 'Fehler beim Laden des Systems. Bitte versuchen Sie es erneut.',
        configDescription: 'Systemkonfiguration und Metadaten',
        authoritativeForIdentities: 'Autoritativ für $t(appConfig.domainEntityTypes.IDENTITIES)',
        authoritativeForAttributes: 'Autoritativ für Attribute',
        authoritativeForAccounts: 'Autoritativ für Konten',
        resourceCount_one: '{{count}} $t(appConfig.domainEntityTypes.RESOURCE) in diesem System',
        resourceCount_other: '{{count}} $t(appConfig.domainEntityTypes.RESOURCES) in diesem System',
        noResources: 'Keine $t(appConfig.domainEntityTypes.RESOURCES) für dieses System gefunden.',
        enforcementObjectCount_one: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT) in diesem System',
        enforcementObjectCount_other: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) in diesem System',
        noEnforcementObjects: 'Keine $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) für dieses System gefunden.',
        connector: 'Konnektor',
        connectorDescription: 'Konnektorkonfiguration für dieses System',
        noConnector: 'Kein Konnektor für dieses System konfiguriert.',
        noConnectorConfigured: 'Kein Konnektor wurde konfiguriert',
        addConnector: 'Konnektor hinzufügen',
        loadingConnector: 'Konnektor wird geladen...',
        viewConnector: 'Konnektordetails anzeigen',
        classification: 'Klassifizierung',
        menuDescription: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS) und Konfiguration',
        systemDetails: 'Systemdetails',
        resources: '$t(appConfig.domainEntityTypes.RESOURCES)',
        connectors: 'Konnektoren',
        resourceCount: '{{count}} $t(appConfig.domainEntityTypes.RESOURCE)(n)',
        enforcementObjectCount: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT)(e)',
        terminationAction: 'Terminierungsaktion',
        terminationActionHelper: 'Bestimmt, ob Konten gelöscht oder deaktiviert werden, wenn eine $t(appConfig.domainEntityTypes.IDENTITY) terminiert wird',
        terminationActionDelete: 'LÖSCHEN',
        terminationActionDisable: 'DEAKTIVIEREN',
        connectorCapabilityBanner: 'Dieser Konnektortyp ({{type}}) unterstützt keine automatisierten Kontolebenszyklus-Operationen. Konten müssen im $t(appConfig.domainEntityTypes.TARGET_SYSTEM) manuell erstellt, deaktiviert und gelöscht werden.',
        createSystem: 'System anlegen',
        createSuccess: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM) angelegt.',
        editName: 'Name bearbeiten',
        editNameTitle: 'Systemname bearbeiten',
        editNameDescription: 'Anzeigename dieses Zielsystems aktualisieren.',
        nameLabel: 'Name',
        nameUpdated: 'Systemname aktualisiert.',
        ownersTitle: 'Eigentümer',
        ownersDescription: 'Verantwortliche $t(appConfig.domainEntityTypes.PARTIES) für dieses $t(appConfig.domainEntityTypes.TARGET_SYSTEM).',
        noOwners: 'Diesem $t(appConfig.domainEntityTypes.TARGET_SYSTEM) sind keine Eigentümer zugewiesen.',
        deleteSystem: 'System löschen',
        deleteConfirmTitle: 'System wirklich löschen?',
        deleteConfirmDescription: '"{{name}}" wird endgültig entfernt. Das System kann nur gelöscht werden, wenn keine $t(appConfig.domainEntityTypes.RESOURCES), $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) oder Konten mehr darauf verweisen.',
        deleteSuccess: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM) gelöscht.',
        pickType: 'Systemtyp auswählen',
        pickTypePrompt: 'Wählen Sie den Systemtyp aus, den Sie anlegen möchten.',
    },
    resources: {
        title: '$t(appConfig.domainEntityTypes.RESOURCES)',
        pageTitle: '$t(appConfig.domainEntityTypes.RESOURCES) | $t(appConfig.domainEntityTypes.TARGET_SYSTEMS)',
        subtitle: 'Geschützte $t(appConfig.domainEntityTypes.RESOURCES) anzeigen und verwalten',
        allResources: 'Alle $t(appConfig.domainEntityTypes.RESOURCES)',
        filterPlaceholder: '$t(appConfig.domainEntityTypes.RESOURCES) filtern...',
        resourceCount: '{{count}} $t(appConfig.domainEntityTypes.RESOURCE)(n)',
        resourceName: 'Ressourcenname',
        resourceType: 'Ressourcentyp',
        targetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
        noResourcesMatch: 'Keine $t(appConfig.domainEntityTypes.RESOURCES) entsprechen Ihrem Filter.',
        noResourcesFound: 'Keine $t(appConfig.domainEntityTypes.RESOURCES) gefunden.',
        loadingResources: '$t(appConfig.domainEntityTypes.RESOURCES) werden geladen...',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.RESOURCES). Bitte versuchen Sie es erneut.',
        detailPageTitle: 'Ressourcendetails | $t(appConfig.domainEntityTypes.TARGET_SYSTEMS)',
        subtitleView: 'Geschützte $t(appConfig.domainEntityTypes.RESOURCES) anzeigen und verwalten',
        searchByName: 'Nach Name suchen...',
        filterBySystem: 'Nach System filtern...',
        allClassifications: 'Alle Klassifizierungen',
        resourceCount_one: '{{count}} $t(appConfig.domainEntityTypes.RESOURCE)',
        resourceCount_other: '{{count}} $t(appConfig.domainEntityTypes.RESOURCES)',
        system: 'System',
        loadingResource: '$t(appConfig.domainEntityTypes.RESOURCE) wird geladen...',
        errorLoadingResource: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.RESOURCE). Bitte versuchen Sie es erneut.',
        configAndMetadata: 'Konfiguration und Metadaten',
        nativeKey: 'Nativer Schlüssel',
        dataClassification: 'Datenklassifizierung',
        createResource: '$t(appConfig.domainEntityTypes.RESOURCE) anlegen',
        createSuccess: '$t(appConfig.domainEntityTypes.RESOURCE) angelegt.',
        editDisplayName: 'Name bearbeiten',
        editDisplayNameTitle: '$t(appConfig.domainEntityTypes.RESOURCE)-Namen bearbeiten',
        editDisplayNameDescription: 'Anzeigename dieser $t(appConfig.domainEntityTypes.RESOURCE) aktualisieren.',
        displayNameLabel: 'Anzeigename',
        displayNameUpdated: '$t(appConfig.domainEntityTypes.RESOURCE)-Namen aktualisiert.',
        deleteResource: '$t(appConfig.domainEntityTypes.RESOURCE) löschen',
        deleteConfirmTitle: '$t(appConfig.domainEntityTypes.RESOURCE) wirklich löschen?',
        deleteConfirmDescription: '"{{name}}" wird endgültig entfernt. Die $t(appConfig.domainEntityTypes.RESOURCE) kann nur gelöscht werden, wenn keine untergeordneten $t(appConfig.domainEntityTypes.RESOURCES) oder $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) mehr darauf verweisen.',
        deleteSuccess: '$t(appConfig.domainEntityTypes.RESOURCE) gelöscht.',
        pickType: 'Ressourcentyp auswählen',
        pickTypePrompt: 'Wählen Sie den Ressourcentyp aus, den Sie anlegen möchten.',
        enforcementObjectCount: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) in dieser $t(appConfig.domainEntityTypes.RESOURCE)',
        enforcementObjectCount_one: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT) in dieser $t(appConfig.domainEntityTypes.RESOURCE)',
        enforcementObjectCount_other: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) in dieser $t(appConfig.domainEntityTypes.RESOURCE)',
        noEnforcementObjects: 'Keine $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) für diese $t(appConfig.domainEntityTypes.RESOURCE) gefunden.',
        owners: 'Eigentümer',
        ownerCount: '{{count}} Eigentümer dieser $t(appConfig.domainEntityTypes.RESOURCE) zugewiesen',
        ownerCount_one: '{{count}} Eigentümer dieser $t(appConfig.domainEntityTypes.RESOURCE) zugewiesen',
        ownerCount_other: '{{count}} Eigentümer dieser $t(appConfig.domainEntityTypes.RESOURCE) zugewiesen',
        noOwners: 'Keine Eigentümer dieser $t(appConfig.domainEntityTypes.RESOURCE) zugewiesen.',
        responsibility: 'Verantwortlichkeit',
        validTo: 'Gültig bis',
        menuDescription: 'Geschützte $t(appConfig.domainEntityTypes.RESOURCES) und Berechtigungen',
        resourceDetails: 'Ressourcendetails',
        enforcementObjects: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS)',
        parentResource: 'Übergeordnete $t(appConfig.domainEntityTypes.RESOURCE)',
        children: 'Untergeordnete $t(appConfig.domainEntityTypes.RESOURCES)',
        childCount: '{{count}} untergeordnete $t(appConfig.domainEntityTypes.RESOURCES)',
        childCount_one: '{{count}} untergeordnete $t(appConfig.domainEntityTypes.RESOURCE)',
        childCount_other: '{{count}} untergeordnete $t(appConfig.domainEntityTypes.RESOURCES)',
        noChildren: 'Keine untergeordneten $t(appConfig.domainEntityTypes.RESOURCES).',
        ancestors: 'Übergeordnete Kette',
        setParent: 'Übergeordnete setzen',
        removeParent: 'Übergeordnete entfernen',
        inheritedAccess: 'Vererbter Zugriff',
        inheritedFrom: 'Vererbt von',
        treeView: 'Baumansicht',
        rootResources: 'Stammressourcen',
    },
    enforcementObjects: {
        title: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS)',
        pageTitle: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) | $t(appConfig.domainEntityTypes.TARGET_SYSTEMS)',
        subtitle: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) (Berechtigungen) anzeigen',
        allEnforcementObjects: 'Alle $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS)',
        filterPlaceholder: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) filtern...',
        enforcementObjectCount: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT)(e)',
        objectName: 'Name',
        objectType: '$t(appConfig.domainEntityTypes.TYPE)',
        resource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        targetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
        noObjectsMatch: 'Keine $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) entsprechen Ihrem Filter.',
        noObjectsFound: 'Keine $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) gefunden.',
        loadingObjects: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) werden geladen...',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS). Bitte versuchen Sie es erneut.',
        detailPageTitle: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT)-Details | $t(appConfig.domainEntityTypes.TARGET_SYSTEMS)',
        subtitleExtended: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) (Berechtigungen, $t(appConfig.domainEntityTypes.ROLES), Zugriffsrechte) anzeigen und verwalten',
        searchByName: 'Nach Name suchen...',
        filterBySystem: 'Nach System filtern...',
        filterByResource: 'Nach $t(appConfig.domainEntityTypes.RESOURCE) filtern...',
        enforcementObjectCount_one: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT)',
        enforcementObjectCount_other: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS)',
        externalId: 'Externe ID',
        externalIdentifier: 'Externe Kennung',
        enforcementType: 'Enforcement-$t(appConfig.domainEntityTypes.TYPE)',
        loadingObject: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT) wird geladen...',
        errorLoadingObject: 'Fehler beim Laden des Enforcement-Objekts. Bitte versuchen Sie es erneut.',
        technicalConfig: 'Technische Konfiguration und Kennungen',
        relatedEntities: 'Verknüpfte Entitäten',
        systemAndResourceAssociations: 'System- und Ressourcenzuordnungen',
        notLinkedToResource: 'Nicht mit einer $t(appConfig.domainEntityTypes.RESOURCE) verknüpft',
        accessProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        accessProfilesDesc: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES), die dieses $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT) enthalten',
        noAccessProfiles: 'Keine $t(appConfig.domainEntityTypes.ACCESS_PROFILES) mit diesem $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT) verknüpft.',
        noSystemsFound: 'Keine Systeme gefunden.',
        noResourcesFound: 'Keine $t(appConfig.domainEntityTypes.RESOURCES) gefunden.',
        menuDescription: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) und Berechtigungen',
        objectDetails: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT)-Details',
    },
    identityManagement: {
        title: 'Identity-Management',
        subtitle: '$t(appConfig.domainEntityTypes.PARTIES), $t(appConfig.domainEntityTypes.IDENTITIES) und deren Lebenszyklus verwalten',
        parties: '$t(appConfig.domainEntityTypes.PARTIES)',
        identities: '$t(appConfig.domainEntityTypes.IDENTITIES)',
        accounts: 'Konten',
        onboarding: 'Onboarding',
        selectOption: 'Wählen Sie eine Option aus dem Menü, um zu beginnen.',
    },
    targetSystemsResources: {
        title: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS) & $t(appConfig.domainEntityTypes.RESOURCES)',
        subtitle: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS), $t(appConfig.domainEntityTypes.RESOURCES) und Berechtigungen anzeigen und verwalten',
        systems: 'Systeme',
        resources: '$t(appConfig.domainEntityTypes.RESOURCES)',
        enforcementObjects: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS)',
        selectOption: 'Wählen Sie eine Option aus dem Menü, um zu beginnen.',
    },
    accessGovernance: {
        title: '$t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        pageTitle: '$t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        subtitle: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES), Regeln und $t(appConfig.domainEntityTypes.ACCESS_REQUESTS) verwalten',
        sectionAccess: 'Zugriff',
        sectionPolicies: 'Richtlinien & Regeln',
        sectionCertifications: 'Zertifizierungen',
        sectionRestrictions: 'Einschränkungen',
        accessProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        accessProfilesDesc: 'Beantragbare Zugriffspakete',
        functionGroups: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
        functionGroupsDesc: 'Bündel von Zugriffsprofilen, die als Einheit zugewiesen werden',
        autoAssignRules: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES)',
        autoAssignRulesDesc: 'Automatische Zugriffsregeln',
        autoAssignRuleRequests: 'Auto-Assign-Regelanträge',
        autoAssignRuleRequestsDesc: 'Regeländerungen beantragen',
        accessRequests: '$t(appConfig.domainEntityTypes.ACCESS_REQUESTS)',
        accessRequestsDesc: '$t(appConfig.domainEntityTypes.ACCESS_REQUESTS) verwalten',
        approvalPolicies: '$t(appConfig.domainEntityTypes.APPROVAL_POLICIES)',
        approvalPoliciesDesc: 'Genehmigungs-Routing-Regeln',
        certificationCampaigns: 'Zertifizierungskampagnen',
        certificationCampaignsDesc: 'Zugriffszertifizierungskampagnen',
        certificationReviews: 'Meine Reviews',
        certificationReviewsDesc: 'Zugewiesene Zertifizierungen prüfen',
        certificationPolicies: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICIES)',
        certificationPoliciesDesc: 'Konfiguration der Prüfrichtlinien',
        restrictionRules: '$t(appConfig.domainEntityTypes.RESTRICTION_RULES)',
        restrictionRulesDesc: 'Funktionstrennung (SoD)',
        restrictionRuleRequests: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUESTS)',
        restrictionRuleRequestsDesc: 'Governance-$t(appConfig.domainEntityTypes.REQUESTS) für $t(appConfig.domainEntityTypes.RESTRICTION_RULES)',
        violationsDashboard: 'Verstöße-Dashboard',
        violationsDashboardDesc: 'Regelübergreifende Verstöße',
        certificationDashboard: 'Zertifizierungs-Dashboard',
        certificationDashboardDesc: 'Zertifizierungsübersicht',
        functionGroupRequests: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        functionGroupRequestsDesc: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        delegations: 'Stellvertretungen',
        delegationsDesc: 'Stellvertretungsverwaltung',
        selectOption: 'Wählen Sie eine Option aus dem Menü, um zu beginnen.',
    },
    approvalPolicies: {
        title: '$t(appConfig.domainEntityTypes.APPROVAL_POLICIES)',
        pageTitle: '$t(appConfig.domainEntityTypes.APPROVAL_POLICIES) | Access Governance',
        createPageTitle: '$t(appConfig.domainEntityTypes.APPROVAL_POLICY) erstellen | Access Governance',
        detailPageTitle: '$t(appConfig.domainEntityTypes.APPROVAL_POLICY) Details | Access Governance',
        editPageTitle: '$t(appConfig.domainEntityTypes.APPROVAL_POLICY) bearbeiten | Access Governance',
        subtitle: 'Genehmigungs-Routing-Richtlinien für $t(appConfig.domainEntityTypes.ACCESS_REQUESTS) verwalten',
        allPolicies: 'Alle $t(appConfig.domainEntityTypes.APPROVAL_POLICIES)',
        policiesCount: '{{count}} Richtlinie(n)',
        noPoliciesFound: 'Keine $t(appConfig.domainEntityTypes.APPROVAL_POLICIES) gefunden.',
        createPolicy: 'Richtlinie erstellen',
        createDescription: 'Neue Genehmigungs-Routing-Richtlinie definieren',
        createCardTitle: 'Richtliniendetails',
        createCardDesc: 'Richtlinie, Bedingungen und $t(appConfig.domainEntityTypes.APPROVAL_STEPS) konfigurieren',
        editPolicy: 'Richtlinie bearbeiten',
        editDescription: 'Genehmigungs-Routing-Richtlinie ändern',
        deletePolicy: 'Richtlinie löschen',
        deleteConfirm: 'Möchten Sie die Richtlinie "{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        cannotDeleteDefault: 'Standardrichtlinien können nicht gelöscht werden.',
        loadingPolicy: 'Richtlinie wird geladen...',
        loadingPolicies: 'Richtlinien werden geladen...',
        errorLoadingPolicy: 'Fehler beim Laden der Richtlinie. Bitte versuchen Sie es erneut.',
        errorLoading: 'Fehler beim Laden der Richtlinien. Bitte versuchen Sie es erneut.',
        name: 'Name',
        namePlaceholder: 'z.B. Hochrisiko-$t(appConfig.domainEntityTypes.APPROVAL)',
        description: 'Beschreibung',
        descriptionPlaceholder: 'Beschreiben Sie, wann diese Richtlinie gilt...',
        priority: 'Priorität',
        priorityPlaceholder: 'z.B. 10',
        priorityHelp: 'Niedrigere Zahl = höhere Priorität. Die erste passende Richtlinie gewinnt.',
        active: 'Aktiv',
        activeDesc: 'Inaktive Richtlinien werden nicht ausgewertet',
        validFrom: 'Gültig ab',
        validTo: 'Gültig bis',
        isDefault: 'Standard',
        defaultBadge: 'Standard',
        conditions: 'Bedingungen',
        conditionsDesc: 'Wann gilt diese Richtlinie? Leere Bedingungen passen auf alle $t(appConfig.domainEntityTypes.REQUESTS).',
        conditionsCount: '{{count}} Bedingung(en)',
        noConditions: 'Keine Bedingungen (passt auf alle $t(appConfig.domainEntityTypes.REQUESTS))',
        addCondition: 'Bedingung hinzufügen',
        field: 'Feld',
        operator: 'Operator',
        value: 'Wert',
        conditionValuePlaceholder: 'z.B. HIGH',
        defaultResolverParam: 'APPLICATION_OWNER',
        steps: '$t(appConfig.domainEntityTypes.APPROVAL_STEPS)',
        stepsDesc: 'Wer genehmigt? Schritte werden der Reihe nach ausgewertet.',
        stepsCount: '{{count}} Schritt(e)',
        addStep: 'Schritt hinzufügen',
        stepOrder: 'Reihenfolge',
        resolverType: 'Resolver',
        resolverParam: 'Parameter',
        approvalStrategy: 'Strategie',
        required: 'Erforderlich',
        requiredDesc: 'Fehlschlagen, wenn keine Genehmiger gefunden',
        moveUp: 'Nach oben',
        moveDown: 'Nach unten',
        removeStep: 'Schritt entfernen',
        removeCondition: 'Bedingung entfernen',
        atLeastOneStep: 'Mindestens ein $t(appConfig.domainEntityTypes.APPROVAL_STEP) ist erforderlich.',
        policyType: 'Richtlinientyp',
        policyTypeLabels: {
            ACCESS_PROFILE: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE)',
            FUNCTION_GROUP: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP)',
            AUTO_ASSIGN_RULE: 'Automatische Zuweisungsregel',
            RESTRICTION_RULE: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE)',
        },
        allPolicyTypes: 'Alle Richtlinientypen',
        incompatibleConditionsRemoved: 'Inkompatible Bedingungen und Schritte entfernt',
        fieldLabels: {
            RISK_LEVEL: 'Risikostufe',
            RESOURCE_TYPE: 'Ressourcentyp',
            DATA_CLASSIFICATION: 'Datenklassifizierung',
            FUNCTION_GROUP_TYPE: 'Funktionsgruppentyp',
            OWNER_PARTY: 'Eigentümerpartei',
        },
        operatorLabels: {
            EQUALS: 'Gleich',
            NOT_EQUALS: 'Ungleich',
            IN: 'In (kommagetrennt)',
        },
        resolverTypeLabels: {
            RESOURCE_OWNER: '$t(appConfig.domainEntityTypes.RESOURCES)-Eigentümer',
            PROFILE_OWNER: 'Profil-Eigentümer',
            MANAGER: 'Vorgesetzter',
            SPECIFIC_IDENTITY: 'Bestimmte $t(appConfig.domainEntityTypes.IDENTITY)',
            TEAM_MEMBER: 'Teammitglied',
            FUNCTION_GROUP_OWNER: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Eigentümer',
            RULE_OWNER: 'Regel-Eigentümer',
        },
        resolverParamPlaceholder: {
            RESOURCE_OWNER: 'z.B. APPLICATION_OWNER',
            PROFILE_OWNER: 'z.B. BUSINESS_OWNER',
            SPECIFIC_IDENTITY: 'Identitäts-UUID',
            TEAM_MEMBER: 'Team suchen...',
        },
        strategyLabels: {
            ANY: 'Beliebiger (1 von N)',
            ALL: 'Alle müssen genehmigen',
        },
        createdAt: 'Erstellt',
        updatedAt: 'Zuletzt aktualisiert',
        version: 'Version',
        policyDetails: 'Richtliniendetails',
        policyDetailsDesc: 'Allgemeine Richtlinienkonfiguration',
        policyCreated: '$t(appConfig.domainEntityTypes.APPROVAL_POLICY) erfolgreich erstellt.',
        policyUpdated: '$t(appConfig.domainEntityTypes.APPROVAL_POLICY) erfolgreich aktualisiert.',
        policyDeleted: '$t(appConfig.domainEntityTypes.APPROVAL_POLICY) erfolgreich gelöscht.',
    },
    accessProfiles: {
        title: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        pageTitle: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) | Access Governance',
        createPageTitle: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) erstellen | Access Governance',
        detailPageTitle: 'Zugriffsprofildetails | Access Governance',
        editPageTitle: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) bearbeiten | Access Governance',
        subtitle: 'Beantragbare Zugriffspakete (Berechtigungspakete) verwalten',
        allProfiles: 'Alle $t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        createProfile: 'Profil erstellen',
        editProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) bearbeiten',
        deleteProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) löschen',
        filterPlaceholder: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) filtern...',
        searchByName: 'Nach Name suchen...',
        filterByResource: 'Nach $t(appConfig.domainEntityTypes.RESOURCE) filtern...',
        allStatuses: 'Alle Status',
        allEnvironments: 'Alle Umgebungen',
        allRisks: 'Alle Risikostufen',
        profileCount: '{{count}} $t(appConfig.domainEntityTypes.ACCESS_PROFILE)(e)',
        profilesCount: '{{count}} Profil(e)',
        profileName: 'Profilname',
        noProfilesMatch: 'Keine $t(appConfig.domainEntityTypes.ACCESS_PROFILES) entsprechen Ihren Filtern.',
        noProfilesFound: 'Keine $t(appConfig.domainEntityTypes.ACCESS_PROFILES) gefunden.',
        loadingProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) werden geladen...',
        loadingProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) wird geladen...',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.ACCESS_PROFILES). Bitte versuchen Sie es erneut.',
        errorLoadingProfile: 'Fehler beim Laden des Zugriffsprofils. Bitte versuchen Sie es erneut.',
        profileDetails: 'Profildetails',
        profileDetailsDesc: 'Zugriffsprofilkonfiguration und Governance-Einstellungen',
        enforcementObjects: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS)',
        noEnforcementObjects: 'Keine $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) zugewiesen.',
        deleteConfirm: 'Möchten Sie "{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        createDescription: 'Neues $t(appConfig.domainEntityTypes.ACCESS_PROFILE) für den Ressourcenschutz definieren',
        createCardTitle: 'Profildetails',
        createCardDesc: 'Zugriffsprofileinstellungen und Governance-Regeln konfigurieren',
        editDescription: 'Zugriffsprofileinstellungen und Governance-Regeln aktualisieren',
        code: 'Code',
        codePlaceholder: 'z.B. mdr-mitarbeiter-zugang',
        codeDesc: 'Eindeutiger Bezeichner: Kleinbuchstaben, Zahlen und Bindestriche (3-100 Zeichen). Ein Vorschlag wird automatisch vom Namen abgeleitet.',
        namePlaceholder: 'Profilname eingeben',
        descriptionPlaceholder: 'Profilbeschreibung eingeben',
        selectEnforcementObjects: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) auswählen',
        riskLevel: 'Risikostufe',
        owner: 'Eigentümer',
        ownerPartyDesc: 'Die für dieses $t(appConfig.domainEntityTypes.ACCESS_PROFILE) verantwortliche $t(appConfig.domainEntityTypes.PARTY)',
        searchOwnerParty: 'Eigentümer-$t(appConfig.domainEntityTypes.PARTY) suchen...',
        noPartiesFound: 'Keine $t(appConfig.domainEntityTypes.PARTIES) gefunden. Tippen Sie, um zu suchen.',
        approvalRequired: '$t(appConfig.domainEntityTypes.APPROVAL) erforderlich',
        step: 'Schritt {{number}}',
        basicInfo: 'Grundinformationen',
        selectItems: 'Elemente auswählen',
        review: 'Überprüfung',
        next: 'Weiter',
        previous: 'Zurück',
        resource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        environment: 'Umgebung',
        selectResourceEnv: 'Wählen Sie eine $t(appConfig.domainEntityTypes.RESOURCE), um die Umgebung anzuzeigen',
        risk: 'Risiko',
        requestable: 'Beantragbar',
        requestableDesc: 'Benutzer können dieses $t(appConfig.domainEntityTypes.ACCESS_PROFILE) beantragen',
        autoAssignable: 'Automatisch zuweisbar',
        autoAssignableDesc: 'Kann durch Regeln automatisch zugewiesen werden',
        expiryRequired: 'Ablaufdatum erforderlich',
        expiryRequiredDesc: 'Zuweisungen müssen ein Ablaufdatum haben',
        maxDuration: 'Maximale Dauer',
        maxDurationDays: '{{days}} Tage',
        maxDurationLabel: 'Maximale Dauer (Tage) *',
        maxDurationPlaceholder: 'Maximale Dauer in Tagen eingeben',
        reviewFrequencyDays: 'Überprüfungshäufigkeit',
        reviewFrequencyMonthly: 'Monatlich (30 Tage)',
        reviewFrequencyBimonthly: 'Zweimonatlich (60 Tage)',
        reviewFrequencyQuarterly: 'Vierteljährlich (90 Tage)',
        reviewFrequencySemiAnnual: 'Halbjährlich (180 Tage)',
        reviewFrequencyAnnual: 'Jährlich (365 Tage)',
        selectRiskLevel: 'Risikostufe auswählen',
        selectReviewFrequency: 'Überprüfungshäufigkeit auswählen',
        searchResource: '$t(appConfig.domainEntityTypes.RESOURCE) suchen...',
        noResourcesFound: 'Keine $t(appConfig.domainEntityTypes.RESOURCES) gefunden.',
        owners: 'Eigentümer',
        ownersCount: '{{count}} Eigentümer für dieses Profil verantwortlich',
        party: '$t(appConfig.domainEntityTypes.PARTY)',
        responsibility: 'Verantwortlichkeit',
        noOwners: 'Keine Eigentümer diesem Profil zugewiesen.',
        boundCount: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT)(e) an dieses Profil gebunden',
        addEnforcementObject: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT) hinzufügen',
        addBindings: 'Bindungen hinzufügen',
        addBindingsDesc: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) auswählen, die an dieses $t(appConfig.domainEntityTypes.ACCESS_PROFILE) gebunden werden sollen.',
        filterEnforcementObjects: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) filtern...',
        loadingEnforcementObjects: '$t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) werden geladen...',
        noAvailableEnforcementObjects: 'Keine verfügbaren $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) für diese $t(appConfig.domainEntityTypes.RESOURCE).',
        noEnforcementObjectsMatch: 'Keine $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECTS) entsprechen Ihrem Filter.',
        selectedCount: '{{count}} $t(appConfig.domainEntityTypes.ENFORCEMENT_OBJECT)(e) ausgewählt',
        operationLabel: 'Vorgang (wird auf alle ausgewählten angewendet)',
        selectOperation: 'Vorgang auswählen',
        addBindingsButton: '{{count}} Bindung(en) hinzufügen',
        adding: 'Wird hinzugefügt...',
        removeBinding: 'Bindung entfernen',
        removeBindingConfirm: 'Möchten Sie diese Bindung wirklich entfernen? Diese Aktion kann nicht rückgängig gemacht werden.',
        removing: 'Wird entfernt...',
        remove: 'Entfernen',
        activateProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) aktivieren',
        activateConfirm: 'Möchten Sie "{{name}}" wirklich aktivieren? Dadurch wird das Profil für Zuweisungen verfügbar.',
        activating: 'Wird aktiviert...',
        activate: 'Aktivieren',
        deprecateProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) als veraltet markieren',
        deprecateConfirm: 'Möchten Sie "{{name}}" wirklich als veraltet markieren? Veraltete Profile können nicht neu zugewiesen werden, bestehende Zuweisungen bleiben jedoch aktiv.',
        deprecating: 'Wird als veraltet markiert...',
        deprecate: 'Als veraltet markieren',
        system: 'System',
        createError: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) konnte nicht erstellt werden',
        updateError: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) konnte nicht aktualisiert werden',
        profileCreated: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) erfolgreich erstellt.',
        profileUpdated: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) erfolgreich aktualisiert.',
        profileDeleted: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) erfolgreich gelöscht.',
        profileActivated: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) erfolgreich aktiviert.',
        profileDeprecated: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) erfolgreich als veraltet markiert.',
        bindingAdded: 'Bindung erfolgreich hinzugefügt.',
        bindingRemoved: 'Bindung erfolgreich entfernt.',
    },
    autoAssignRules: {
        title: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES)',
        pageTitle: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES) | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        detailPageTitle: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE)-Details | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        executionsPageTitle: 'Regelausführungen | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        subtitle: 'Regeln, die $t(appConfig.domainEntityTypes.ACCESS_PROFILES) automatisch basierend auf Bedingungen an $t(appConfig.domainEntityTypes.IDENTITIES) zuweisen',
        allRules: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES)',
        createRule: 'Regel erstellen',
        editRule: 'Regel bearbeiten',
        deleteRule: 'Regel löschen',
        filterPlaceholder: 'Regeln filtern...',
        searchByName: 'Nach Name suchen...',
        ruleCount: '{{count}} Regel(n)',
        ruleName: 'Regelname',
        accessProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE)',
        functionGroupLabel: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP)',
        condition: 'Bedingung',
        priority: 'Priorität',
        profiles: 'Profile',
        columnType: 'Typ',
        columnTarget: 'Ziel',
        targetProfileCount: '{{count}} $t(appConfig.domainEntityTypes.ACCESS_PROFILE)',
        targetProfileCount_other: '{{count}} $t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        owner: 'Eigentümer',
        risk: 'Risiko',
        version: 'Version',
        activeOnly: 'Nur aktive',
        allStatus: 'Alle Status',
        activeRulesOnly: 'Nur aktive Regeln',
        noRulesMatch: 'Keine $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES) entsprechen Ihren Filtern.',
        noRulesFound: 'Keine $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES) gefunden.',
        loadingRules: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES) werden geladen...',
        loadingRule: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE) wird geladen...',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES). Bitte versuchen Sie es erneut.',
        errorLoadingRule: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE). Bitte versuchen Sie es erneut.',
        ruleDetails: 'Regeldetails',
        ruleDetailsDesc: 'Konfiguration der $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE)',
        conditionExpression: 'Bedingungsausdruck',
        conditionExpressionDesc: 'Regel, die bestimmt, welche $t(appConfig.domainEntityTypes.IDENTITIES) Zugriff erhalten',
        accessProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        accessProfilesCount: '{{count}} $t(appConfig.domainEntityTypes.ACCESS_PROFILE)(e) werden durch diese Regel zugewiesen',
        noAccessProfiles: 'Keine $t(appConfig.domainEntityTypes.ACCESS_PROFILES) mit dieser Regel verknüpft.',
        deleteConfirm: 'Möchten Sie die Regel "{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        testRule: 'Regel testen',
        testing: 'Wird getestet...',
        testResults: 'Testergebnisse',
        testResultsDesc: 'Vorschau, wie diese Regel $t(appConfig.domainEntityTypes.IDENTITIES) betreffen würde',
        testFailed: 'Test fehlgeschlagen',
        evaluated: 'Ausgewertet',
        matched: 'Übereinstimmend',
        toAdd: 'Hinzuzufügen',
        toRemove: 'Zu entfernen',
        viewAffectedIdentities: 'Betroffene $t(appConfig.domainEntityTypes.IDENTITIES) anzeigen ({{count}})',
        ruleInformation: 'Regelinformationen',
        ruleId: 'Regel-ID',
        removalGraceDays: 'Karenzzeit für Entzug',
        removalGraceDaysValue: '{{days}} Tage',
        userRiskScore: 'Benutzer-Risikobewertung',
        profileCount: 'Profilanzahl',
        versionHistory: 'Versionshistorie',
        versionByAuthor: ' von {{name}}',
        createRequestError: 'Anfrage konnte nicht erstellt werden',
        noVersionHistory: 'Keine Versionshistorie verfügbar.',
        current: 'Aktuell',
        executions: '$t(appConfig.domainEntityTypes.EXECUTIONS)',
        executionHistory: 'Ausführungshistorie',
        noExecutionsYet: 'Noch keine $t(appConfig.domainEntityTypes.EXECUTIONS).',
        viewAllExecutions: 'Alle {{count}} $t(appConfig.domainEntityTypes.EXECUTIONS) anzeigen',
        lastExecution: 'Letzte $t(appConfig.domainEntityTypes.EXECUTION)',
        nextExecution: 'Nächste $t(appConfig.domainEntityTypes.EXECUTION)',
        runNow: 'Jetzt ausführen',
        running: 'Wird ausgeführt...',
        expression: 'Ausdruck',
        allExecutions: 'Alle $t(appConfig.domainEntityTypes.EXECUTIONS)',
        executionCount: '{{count}} $t(appConfig.domainEntityTypes.EXECUTION)(en)',
        executionId: 'Ausführungs-ID',
        startedAt: 'Gestartet am',
        completedAt: 'Abgeschlossen am',
        duration: 'Dauer',
        assignmentsCreated: 'Erstellte Zuweisungen',
        noExecutionsFound: 'Keine $t(appConfig.domainEntityTypes.EXECUTIONS) gefunden.',
        loadingExecutions: '$t(appConfig.domainEntityTypes.EXECUTIONS) werden geladen...',
        errorLoadingExecutions: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.EXECUTIONS). Bitte versuchen Sie es erneut.',
        triggerExecution: '$t(appConfig.domainEntityTypes.EXECUTION) auslösen',
        triggerDescription: 'Diese Regel jetzt ausführen, um Zuweisungen auszuwerten und zu erstellen.',
        triggering: 'Wird ausgelöst...',
        affectedIdentities: 'Betroffene $t(appConfig.domainEntityTypes.IDENTITIES)',
        affectedIdentitiesDesc: 'Vorschau, welche $t(appConfig.domainEntityTypes.IDENTITIES) von dieser Regel betroffen wären',
        searchIdentities: '$t(appConfig.domainEntityTypes.IDENTITIES) suchen...',
        noIdentitiesMatch: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) entsprechen Ihren Filtern.',
        identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        party: '$t(appConfig.domainEntityTypes.PARTY)',
        action: 'Aktion',
        activateRule: 'Regel aktivieren',
        activateRuleDesc: 'Erstellen Sie eine Anfrage zur Aktivierung der Regel "{{name}}". Die Anfrage muss genehmigt werden, bevor die Regel aktiv wird.',
        createActivateRequest: 'Aktivierungsanfrage erstellen',
        deactivateRule: 'Regel deaktivieren',
        deactivateRuleDesc: 'Erstellen Sie eine Anfrage zur Deaktivierung der Regel "{{name}}". Die Anfrage muss genehmigt werden, bevor die Regel inaktiv wird. $t(appConfig.domainEntityTypes.IDENTITIES) erhalten nach der Deaktivierung keinen Zugriff mehr über diese Regel.',
        createDeactivateRequest: 'Deaktivierungsanfrage erstellen',
        error: 'Fehler',
        creating: 'Wird erstellt...',
        ruleExecutionHistory: 'Regelausführungshistorie',
        executionsForRule: '$t(appConfig.domainEntityTypes.EXECUTIONS) für Regel: {{name}}',
        viewAllRuleExecutions: 'Alle $t(appConfig.domainEntityTypes.EXECUTIONS) der $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES) anzeigen',
        filters: 'Filter:',
        allStatuses: 'Alle Status',
        statusSelectedCount: '{{count}} ausgewählt',
        success: 'Erfolgreich',
        partial: 'Teilweise',
        failed: 'Fehlgeschlagen',
        rule: 'Regel',
        executedAt: 'Ausgeführt am',
        added: 'Hinzugefügt',
        removed: 'Entfernt',
        showingOfExecutions: '{{count}} von {{total}} $t(appConfig.domainEntityTypes.EXECUTIONS) angezeigt',
        noExecutions: 'Keine $t(appConfig.domainEntityTypes.EXECUTIONS) gefunden.',
        previous: 'Zurück',
        next: 'Weiter',
        requestCreated: 'Regelanfrage erfolgreich erstellt.',
        ruleNoOwner: 'Einreichung nicht möglich: Regel hat keinen Eigentümer. Weisen Sie der Regel eine Eigentümerpartei zu, bevor Sie einreichen.',
        impactAnalysis: {
            title: 'Auswirkungsanalyse',
            description: 'Vorschau der Hinzufügungen und Entfernungen, die diese Regel an einer Stichprobe von $t(appConfig.domainEntityTypes.IDENTITIES) erzeugen würde. Es werden keine Zuweisungen geschrieben.',
            runButton: 'Auswirkungsanalyse starten',
            opening: 'Auswirkungsanalyse öffnen',
            running: 'Analysiere...',
            filterTitle: 'Identitäts-Stichprobe',
            identityTypeCode: 'Identitätstyp-Code',
            identityTypeCodePlaceholder: 'z.B. WORKFORCE',
            lifecycleState: 'Lebenszyklus-Status',
            lifecycleStateAny: 'Beliebig',
            maxIdentities: 'Max. $t(appConfig.domainEntityTypes.IDENTITIES)',
            maxIdentitiesHint: '1 bis 10000 (Standard 1000)',
            counts: 'Ausgewertet {{evaluated}} • Hinzufügen {{add}} • Entfernen {{remove}} • Unverändert {{unchanged}}',
            truncatedWarning: 'Die Stichprobe wurde auf das Limit gekürzt. Erhöhen Sie Max. $t(appConfig.domainEntityTypes.IDENTITIES) oder verfeinern Sie den Filter, um mehr zu sehen.',
            empty: 'Keine Hinzufügungen oder Entfernungen — diese Regel hätte keine Auswirkung auf die Stichprobe.',
            errorTitle: 'Auswirkungsanalyse fehlgeschlagen',
            unknownError: 'Unbekannter Fehler',
            tableIdentity: '$t(appConfig.domainEntityTypes.IDENTITY)',
            tableProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE)',
            tableAction: 'Aktion',
            tableSourceRule: 'Quellregel',
            actionAdd: 'Hinzufügen',
            actionRemove: 'Entfernen',
            close: 'Schließen',
        },
        triggerFullEvaluation: {
            buttonLabel: 'Vollständige Auswertung auslösen',
            confirmTitle: 'Vollständige Auto-Assign-Auswertung auslösen',
            confirmBody: 'Den Start-of-Day-Job jetzt ausführen? Er wertet jede aktive Auto-Assign-Regel gegen jede aktive $t(appConfig.domainEntityTypes.IDENTITY) aus und schreibt die resultierenden Änderungen. Eine neue Ausführungsprotokoll-Zeile erscheint.',
            confirmButton: 'Auslösen',
            running: 'Wird ausgelöst...',
            successToast: 'Vollständige Auswertung ausgelöst. Verlauf im Tab "$t(appConfig.domainEntityTypes.EXECUTIONS)" prüfen.',
            errorToast: 'Auslösen der vollständigen Auswertung fehlgeschlagen.',
        },
    },
    autoAssignRuleRequests: {
        title: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULES)',
        openRequestExists: 'Für diese Regel ist bereits ein Änderungsantrag in Bearbeitung.',
        pageTitle: 'Regelanfragen | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        createPageTitle: 'Regelanfrage erstellen | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        editPageTitle: 'Regelanfrage bearbeiten | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        detailPageTitle: 'Regelanfrage-Details | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        subtitle: 'Automatische $t(appConfig.domainEntityTypes.ACCESS_PROFILE_ASSIGNMENTS) basierend auf Identitätsbedingungen verwalten',
        allRequests: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE)-Anfragen',
        createRequest: 'Anfrage erstellen',
        editRequest: 'Regelanfrage bearbeiten',
        filterPlaceholder: 'Regelanfragen filtern...',
        searchByName: 'Nach Name suchen...',
        requestCount: '{{count}} Anfrage(n)',
        requestCountWithFilter: '{{count}} Anfrage(n) entsprechend den Filtern',
        requestType: 'Anfragetyp',
        requestStatus: 'Anfragestatus',
        requestedBy: 'Angefragt von',
        requestedAt: 'Angefragt am',
        noRequestsMatch: 'Keine Regelanfragen entsprechen Ihren Filtern.',
        noRequestsFound: 'Keine Regelanfragen gefunden. Erstellen Sie eine, um zu beginnen.',
        loadingRequests: 'Regelanfragen werden geladen...',
        loadingRequest: 'Regelanfrage wird geladen...',
        errorLoading: 'Fehler beim Laden der Regelanfragen. Bitte versuchen Sie es erneut.',
        errorLoadingRequest: 'Fehler beim Laden der Regelanfrage. Bitte versuchen Sie es erneut.',
        requestDetails: 'Anfragedetails',
        requestDetailsDesc: 'Konfiguration der $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE)',
        createDescription: 'Definieren Sie eine neue $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE) für die automatische Zugriffsbereitstellung',
        updateDescription: 'Erstellen Sie eine Anfrage zur Aktualisierung von "{{name}}"',
        editDescription: 'Ändern Sie die Regelkonfiguration, bevor Sie sie zur $t(appConfig.domainEntityTypes.APPROVAL) einreichen',
        approveRequest: 'Anfrage genehmigen',
        approveDesc: 'Die $t(appConfig.domainEntityTypes.APPROVAL) dieser Anfrage erstellt/aktualisiert die $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE). Diese Aktion kann nicht rückgängig gemacht werden.',
        rejectRequest: 'Anfrage ablehnen',
        rejectDesc: 'Bitte geben Sie einen Grund für die Ablehnung dieser Anfrage an. Der Antragsteller wird benachrichtigt.',
        rejectionReason: 'Ablehnungsgrund *',
        rejectionReasonPlaceholder: 'Erklären Sie, warum diese Anfrage abgelehnt wird...',
        approving: 'Wird genehmigt...',
        rejecting: 'Wird abgelehnt...',
        selectAccessProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) auswählen',
        selectRuleType: 'Anfragetyp auswählen',
        wizardTitle: 'Regelanfrage erstellen',
        wizardUpdateTitle: 'Regelanfrage aktualisieren',
        wizardEditTitle: 'Bearbeiten: {{name}}',
        defaultName: 'Regelanfrage',
        theRule: 'die Regel',
        wizardStep1: 'Anfragetyp',
        wizardStep2: 'Regeldetails',
        wizardStep3: 'Überprüfen & Einreichen',
        newRule: 'Neue Regel',
        modifyRule: 'Regel ändern',
        activateRule: 'Regel aktivieren',
        deactivateRule: 'Regel deaktivieren',
        createNewRule: 'Neue Regel erstellen',
        modifyExistingRule: 'Bestehende Regel ändern',
        draft: 'Entwurf',
        pendingApproval: '$t(appConfig.domainEntityTypes.APPROVAL) ausstehend',
        approved: 'Genehmigt',
        rejected: 'Abgelehnt',
        submitForApproval: 'Zur $t(appConfig.domainEntityTypes.APPROVAL) einreichen',
        submitDesc: 'Dadurch wird die Regelanfrage zur $t(appConfig.domainEntityTypes.APPROVAL) eingereicht. Nach der Einreichung können Sie sie nicht mehr bearbeiten, bis sie genehmigt oder abgelehnt wurde.',
        deleteRequest: 'Anfrage löschen',
        deleteConfirm: 'Möchten Sie diese Regelanfrage wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        commentOptional: 'Kommentar (optional)',
        commentPlaceholder: 'Optionalen Kommentar hinzufügen...',
        workflow: 'Workflow',
        reviewedBy: 'Überprüft von',
        reviewedAt: 'Überprüft am',
        reviewComment: 'Überprüfungskommentar',
        targetRuleId: 'Zielregel-ID',
        expressionDesc: '$t(appConfig.domainEntityTypes.IDENTITIES), die dieser Bedingung entsprechen, erhalten die $t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        profilesAssignDesc: 'Profile, die zugewiesen werden, wenn die Regel übereinstimmt',
        noProfilesLinked: 'Keine $t(appConfig.domainEntityTypes.ACCESS_PROFILES) mit dieser Anfrage verknüpft.',
        wouldBeAdded: 'Würde hinzugefügt',
        wouldBeRemoved: 'Würde entfernt',
        unchanged: 'Unverändert',
        showingIdentities: '{{filtered}} von {{total}} $t(appConfig.domainEntityTypes.IDENTITIES) angezeigt',
        cannotEdit: 'Diese Anfrage kann nicht bearbeitet werden, da sie sich im Status {{status}} befindet.',
        loadingRuleData: 'Regeldaten werden geladen...',
        ruleNameLabel: 'Regelname *',
        ruleNamePlaceholder: 'z. B. Alle Mitarbeiter - Basiszugriff',
        descriptionPlaceholder: 'Beschreiben Sie, was diese Regel tut...',
        ownerPartyLabel: 'Eigentümer-$t(appConfig.domainEntityTypes.PARTY) *',
        ownerPartyDesc: 'Die für diese Regel verantwortliche $t(appConfig.domainEntityTypes.PARTY)',
        searchOwnerParty: 'Eigentümer-$t(appConfig.domainEntityTypes.PARTY) suchen...',
        noPartiesFound: 'Keine $t(appConfig.domainEntityTypes.PARTIES) gefunden. Tippen Sie, um zu suchen.',
        priorityLabel: 'Priorität',
        priorityPlaceholder: 'z.B. 10',
        priorityDesc: 'Niedrigere Werte werden zuerst ausgewertet (1 = höchste Priorität)',
        removalGraceDaysLabel: 'Karenzzeit für Entzug (Tage)',
        removalGraceDaysPlaceholder: 'z.B. 7',
        removalGraceDaysDesc: 'Tage bis zum Entzug des Zugriffs',
        userRiskLabel: 'Benutzer-Risikobewertung',
        userRiskDesc: 'Optional, 0–100',
        conditionExprLabel: 'Bedingungsausdruck *',
        conditionExprPlaceholder: "identity.type == 'WORKFORCE' && identity.lifecycleState == 'ACTIVE'",
        showHelp: 'Hilfe anzeigen',
        hideHelp: 'Hilfe ausblenden',
        expressionValid: 'Ausdruck ist gültig',
        errorAtPosition: ' (Position {{position}})',
        testYourExpression: 'Testen Sie Ihren Ausdruck, um zu sehen, welche $t(appConfig.domainEntityTypes.IDENTITIES) übereinstimmen, bevor Sie fortfahren.',
        runTest: 'Test ausführen',
        testCompleted: 'Test abgeschlossen',
        testCompletedDesc: '{{total}} $t(appConfig.domainEntityTypes.IDENTITIES) ausgewertet, {{matched}} stimmten mit Ihrem Ausdruck überein.',
        expressionBeingTested: 'Getesteter Ausdruck:',
        accessProfilesLabel: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) *',
        accessProfilesDesc: 'Wählen Sie die $t(appConfig.domainEntityTypes.ACCESS_PROFILES) aus, die zugewiesen werden, wenn $t(appConfig.domainEntityTypes.IDENTITIES) die Regelbedingung erfüllen. Es werden nur auto-zuweisbare Profile angezeigt.',
        searchProfilesToAdd: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) zum Hinzufügen suchen...',
        noAutoAssignableProfiles: 'Keine auto-zuweisbaren Profile gefunden',
        selectAtLeastOneProfile: 'Suchen und wählen Sie mindestens ein $t(appConfig.domainEntityTypes.ACCESS_PROFILE) aus',
        reviewRuleName: 'Regelname',
        reviewOwner: 'Eigentümer',
        notSelected: 'Nicht ausgewählt',
        reviewConditionExpression: 'Bedingungsausdruck',
        reviewAccessProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) ({{count}})',
        noProfilesFound: 'Keine Profile gefunden',
        ruleConfiguration: 'Regelkonfiguration',
        ruleConfigurationUpdateDesc: 'Ändern Sie die Regelkonfiguration. Änderungen erfordern eine $t(appConfig.domainEntityTypes.APPROVAL), bevor sie wirksam werden.',
        ruleConfigurationCreateDesc: 'Konfigurieren Sie die Regelbedingung und die zuzuweisenden $t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        viewCount: 'Anzeigen ({{count}})',
        allCount: 'Alle ({{count}})',
        addCount: 'Hinzufügen ({{count}})',
        removeCount: 'Entfernen ({{count}})',
        unchangedCount: 'Unverändert ({{count}})',
        reviewMatchedOfTotal: '{{matched}} von {{total}} $t(appConfig.domainEntityTypes.IDENTITIES) stimmten überein',
        reviewWouldBeAdded: '({{count}} würden hinzugefügt)',
        failedToCreateRequest: 'Regelanfrage konnte nicht erstellt werden',
        failedToUpdateRequest: 'Regelanfrage konnte nicht aktualisiert werden',
        requestCreated: 'Regelanfrage erfolgreich erstellt.',
        requestUpdated: 'Regelanfrage erfolgreich aktualisiert.',
        requestSubmitted: 'Regelanfrage zur $t(appConfig.domainEntityTypes.APPROVAL) eingereicht.',
        requestApproved: 'Regelanfrage erfolgreich genehmigt.',
        requestRejected: 'Regelanfrage abgelehnt.',
        requestDeleted: 'Regelanfrage erfolgreich gelöscht.',
        matchedPolicy: 'Zugeordnete Richtlinie: {{name}}',
        ruleTypeLabel: 'Regeltyp *',
        accessProfileRule: 'Zugangsprofil',
        functionGroupRule: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP)',
        ruleTypeDesc: 'Wählen Sie, ob diese Regel Zugangsprofile oder $t(appConfig.domainEntityTypes.FUNCTION_GROUPS) zuweist',
        functionGroupsLabel: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS) *',
        functionGroupsDesc: 'Wählen Sie die $t(appConfig.domainEntityTypes.FUNCTION_GROUPS) aus, die zugewiesen werden, wenn $t(appConfig.domainEntityTypes.IDENTITIES) die Regelbedingung erfüllen. Nur automatisch zuweisbare $t(appConfig.domainEntityTypes.FUNCTION_GROUPS) werden angezeigt.',
        searchFunctionGroupsToAdd: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS) zum Hinzufügen suchen...',
        noAutoAssignableFunctionGroups: 'Keine automatisch zuweisbaren $t(appConfig.domainEntityTypes.FUNCTION_GROUPS) gefunden',
        selectAtLeastOneFunctionGroup: 'Suchen und mindestens eine $t(appConfig.domainEntityTypes.FUNCTION_GROUP) auswählen',
        reviewFunctionGroups: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS) ({{count}})',
        stepBasicInfo: 'Grunddaten',
        stepBasicInfoDesc: 'Name und Konfiguration',
        stepExpression: 'Ausdruck',
        stepExpressionDesc: 'Bedingung definieren',
        stepTest: 'Test',
        stepTestDesc: 'Regel validieren',
        stepProfiles: 'Profile',
        stepProfilesDesc: 'Zugang auswählen',
        stepFunctionGroups: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
        stepFunctionGroupsDesc: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS) auswählen',
        stepReview: 'Überprüfung',
        stepReviewDesc: 'Bestätigen & erstellen',
        expressionDescFunctionGroup: '$t(appConfig.domainEntityTypes.IDENTITIES), die diese Bedingung erfüllen, erhalten die $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
        functionGroupsAssignDesc: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS), die zugewiesen werden, wenn die Regel zutrifft',
        noFunctionGroupsLinked: 'Keine $t(appConfig.domainEntityTypes.FUNCTION_GROUPS) mit dieser Anfrage verknüpft.',
    },
    accessRequests: {
        title: 'Zugriffsanfragen',
        pageTitle: 'Zugriffsanfragen | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        detailPageTitle: 'Zugriffsanfrage-Details | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        newPageTitle: 'Neue Zugriffsanfrage | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
        subtitle: 'Alle Zugriffsanfragen im System',
        allRequests: 'Alle Zugriffsanfragen',
        createRequest: 'Neue Anfrage',
        filterPlaceholder: 'Zugriffsanfragen filtern...',
        searchByBeneficiary: 'Nach Begünstigtem suchen...',
        requestCount: '{{count}} Zugriffsanfrage(n)',
        requester: 'Antragsteller',
        beneficiary: 'Begünstigter',
        requestedFor: 'Angefragt für',
        requestStatus: 'Status',
        requestedAt: 'Angefragt am',
        noRequestsMatch: 'Keine Zugriffsanfragen entsprechen Ihrem Filter.',
        noRequestsFound: 'Keine Zugriffsanfragen gefunden',
        loadingRequests: 'Wird geladen...',
        errorLoading: 'Fehler beim Laden der Zugriffsanfragen',
        requestDetails: 'Anfragedetails',
        items: 'Positionen',
        itemsPlusMore: '+{{count}} weitere',
        requestItems: 'Anfragepositionen ({{count}})',
        approvalHistory: 'Genehmigungshistorie',
        approvers: 'Genehmiger:',
        cancelRequest: 'Anfrage stornieren',
        cancelItem: 'Position stornieren',
        cancelEntireRequest: 'Gesamte Anfrage stornieren',
        cancelReason: 'Grund (erforderlich)',
        cancelReasonPlaceholder: 'Geben Sie einen Grund an...',
        cancelling: 'Wird storniert...',
        approveItem: 'Position genehmigen',
        rejectItem: 'Position ablehnen',
        commentOptional: 'Kommentar (optional)',
        commentPlaceholder: 'Kommentar hinzufügen...',
        reasonRequired: 'Grund (erforderlich)',
        rejectReasonPlaceholder: 'Geben Sie einen Grund für die Ablehnung an...',
        wizardTitle: 'Neue Zugriffsanfrage',
        wizardSelectIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) auswählen',
        wizardSelectProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) auswählen',
        wizardConfigure: 'Konfigurieren',
        wizardReviewSubmit: 'Überprüfen & Einreichen',
        whoNeedsAccess: 'Wer benötigt Zugriff?',
        myself: 'Ich selbst',
        someoneElse: 'Jemand anderes',
        searchForIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) suchen',
        searchByName: 'Nach Name suchen...',
        selected: 'Ausgewählt:',
        selectAccessProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) auswählen',
        searchAccessProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) suchen...',
        noProfilesFound: 'Keine Profile gefunden',
        selectedCount: 'Ausgewählt ({{count}})',
        expiryRequired: 'Ablaufdatum erforderlich',
        expiresAtLabel: 'Läuft ab am',
        maxDurationHint: 'Maximale Dauer: {{days}} Tage',
        reviewAndSubmit: 'Überprüfen & Einreichen',
        reviewBeneficiary: 'Begünstigter',
        reviewAccessProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) ({{count}})',
        justification: 'Begründung',
        justificationPlaceholder: 'Erklären Sie, warum dieser Zugriff benötigt wird...',
        noProfilesSelected: 'Keine $t(appConfig.domainEntityTypes.ACCESS_PROFILES) ausgewählt.',
        searchProfiles: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) suchen...',
        untilDate: '(bis {{date}})',
        submitting: 'Wird eingereicht...',
        submitRequest: 'Anfrage einreichen',
        failedToCreate: 'Anfrage konnte nicht erstellt werden: {{error}}',
        popularInDepartment: 'Beliebt in Ihrer Abteilung ({{count}})',
        peerRecommendations: 'Empfohlen basierend auf Ihren Kollegen',
        allProfiles: 'Alle $t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        setExpiration: 'Ablaufdatum festlegen',
        expirationDate: 'Ablaufdatum',
        expires: 'Läuft ab:',
        showingRange: '{{start}}-{{end}} von {{total}} angezeigt',
        cancelled: 'Storniert:',
        statusSubmitted: 'Eingereicht',
        statusInProgress: 'In Bearbeitung',
        statusCompleted: 'Abgeschlossen',
        statusCancelled: 'Storniert',
        statusPendingApproval: '$t(appConfig.domainEntityTypes.APPROVAL) ausstehend',
        statusApproved: 'Genehmigt',
        statusFulfilled: 'Erfüllt',
        statusRejected: 'Abgelehnt',
        approving: 'Wird genehmigt...',
        approve: 'Genehmigen',
        rejecting: 'Wird abgelehnt...',
        cancellingItem: 'Wird storniert...',
        cancellingRequest: 'Wird storniert...',
        itemApproved: 'Element erfolgreich genehmigt.',
        itemRejected: 'Element abgelehnt.',
        itemCancelled: 'Element erfolgreich storniert.',
        requestCancelled: 'Anfrage erfolgreich storniert.',
        requestSubmitted: 'Zugriffsanfrage erfolgreich eingereicht.',
        beneficiaries: 'Begünstigte',
        searchBeneficiariesPlaceholder: 'Begünstigte suchen…',
        beneficiariesCounter: '{{count}} / 50',
        beneficiariesMax: 'Maximale Anzahl von 50 Begünstigten erreicht.',
        pickerNoResults: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) gefunden.',
        pickerHintTypeMore: 'Bitte mindestens 2 Zeichen eingeben, um zu suchen.',
        reviewExpansion: '{{beneficiaries}} Begünstigte × {{items}} $t(appConfig.domainEntityTypes.ACCESS_PROFILES) = {{total}} Anfragen',
        bulkSuccess_one: '1 Zugriffsanfrage eingereicht.',
        bulkSuccess_other: '{{count}} Zugriffsanfragen eingereicht.',
        bulkValidationFailed: 'Einreichung fehlgeschlagen — es wurden keine Anfragen erstellt.',
        bulkErrorGeneric: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
    },
    approvalChain: {
        title: 'Genehmigungskette',
        stepLabel: 'Schritt {{step}}',
        strategy: 'Strategie',
        strategyAny: 'Ein Genehmiger genügt',
        strategyAll: 'Alle Genehmiger',
        statusPending: 'Ausstehend',
        statusActive: 'Entscheidung ausstehend',
        statusApproved: 'Genehmigt',
        statusRejected: 'Abgelehnt',
        statusSkipped: 'Übersprungen',
        pending: 'ausstehend',
        preliminary: 'vorläufig — kann sich bei Aktivierung ändern',
        matchedPolicy: 'Zugeordnete Richtlinie',
        resolverResourceOwner: 'Ressourceninhaber',
        resolverProfileOwner: 'Profilinhaber',
        resolverManager: 'Vorgesetzter',
        resolverSpecificIdentity: 'Bestimmte $t(appConfig.domainEntityTypes.IDENTITY)',
        resolverTeamMember: 'Teammitglied',
        approved: 'genehmigt',
        rejected: 'abgelehnt',
    },
    myRequests: {
        title: 'Meine Anfragen',
        pageTitle: 'Meine Anfragen',
        subtitle: 'Von Ihnen eingereichte Zugriffs- und $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        tabAccessRequests: 'Zugriffsanfragen',
        tabFunctionGroupRequests: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        myAccessRequests: 'Meine Zugriffsanfragen',
        accessRequestsSubmitted: 'Von Ihnen eingereichte Zugriffsanfragen',
        newRequest: 'Neue Anfrage',
        allRequests: 'Alle meine Anfragen',
        allAccessRequests: 'Alle Zugriffsanfragen',
        allFunctionGroupRequests: 'Alle $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        accessRequestsDescription: 'Von Ihnen eingereichte Zugriffsprofilanfragen',
        functionGroupRequestsDescription: 'Von Ihnen eingereichte $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        requestCount: '{{count}} Anfrage(n)',
        accessRequestCount: '{{count}} Zugriffsanfrage(n)',
        accessRequestCount_one: '{{count}} Zugriffsanfrage',
        accessRequestCount_other: '{{count}} Zugriffsanfragen',
        functionGroupRequestCount: '{{count}} $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUEST)/$t(appConfig.domainEntityTypes.REQUESTS)',
        functionGroupRequestCount_one: '{{count}} $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUEST)',
        functionGroupRequestCount_other: '{{count}} $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        filterStatus: 'Nach Status filtern',
        allStatuses: 'Alle Status',
        searchPlaceholder: 'Begünstigte oder Begründung suchen...',
        filterPlaceholder: 'Anfragen filtern...',
        noRequestsMatch: 'Keine Anfragen entsprechen Ihrem Filter.',
        noRequestsFound: 'Sie haben noch keine Zugriffsanfragen gestellt.',
        noAccessRequestsFound: 'Keine Zugriffsanfragen gefunden',
        statusSubmitted: 'Eingereicht',
        statusInProgress: 'In Bearbeitung',
        statusCompleted: 'Abgeschlossen',
        statusCancelled: 'Storniert',
        loadingRequests: 'Ihre Anfragen werden geladen...',
        failedToLoadRequests: 'Fehler beim Laden der Anfragen',
        errorLoading: 'Fehler beim Laden Ihrer Anfragen. Bitte versuchen Sie es erneut.',
        previous: 'Zurück',
        next: 'Weiter',
    },
    myApprovals: {
        title: 'Meine $t(appConfig.domainEntityTypes.APPROVALS)',
        pageTitle: 'Meine $t(appConfig.domainEntityTypes.APPROVALS)',
        subtitle: 'Zugriffsanfragen überprüfen und genehmigen',
        searchPlaceholder: 'Suche nach Begründung, Antragstellerin, Begünstigtem…',
        itemsPendingApproval: 'Positionen, die auf Ihre $t(appConfig.domainEntityTypes.APPROVAL) warten',
        allApprovals: 'Alle ausstehenden $t(appConfig.domainEntityTypes.APPROVALS)',
        approvalCount: '{{count}} $t(appConfig.domainEntityTypes.APPROVAL)(en)',
        filterPlaceholder: '$t(appConfig.domainEntityTypes.APPROVALS) filtern...',
        noApprovalsMatch: 'Keine $t(appConfig.domainEntityTypes.APPROVALS) entsprechen Ihrem Filter.',
        noApprovalsFound: 'Keine ausstehenden $t(appConfig.domainEntityTypes.APPROVALS).',
        noPendingApprovals: 'Keine ausstehenden $t(appConfig.domainEntityTypes.APPROVALS)',
        statusPending: 'Ausstehend',
        statusApproved: 'Genehmigt',
        statusFulfilled: 'Erfüllt',
        statusRejected: 'Abgelehnt',
        statusCancelled: 'Storniert',
        accessProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE)',
        loadingApprovals: '$t(appConfig.domainEntityTypes.APPROVALS) werden geladen...',
        failedToLoadApprovals: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.APPROVALS)',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.APPROVALS). Bitte versuchen Sie es erneut.',
        approveAccessRequest: 'Zugriffsanfrage genehmigen',
        rejectAccessRequest: 'Zugriffsanfrage ablehnen',
        batchApprove: 'Ausgewählte genehmigen',
        batchReject: 'Ausgewählte ablehnen',
        batchApproveTitle: '{{count}} Position(en) genehmigen',
        batchRejectTitle: '{{count}} Position(en) ablehnen',
        batchApproveConfirm: 'Möchten Sie wirklich {{count}} Position(en) genehmigen?',
        batchRejectConfirm: 'Möchten Sie wirklich {{count}} Position(en) ablehnen?',
        selectAll: 'Alle auswählen',
        selectedItemCount: '{{count}} ausgewählt',
        requestedBy: 'Angefragt von',
        requestedFor: 'Für',
        permanent: 'Dauerhaft',
        risk: 'Risiko:',
        previous: 'Zurück',
        next: 'Weiter',
        itemApproved: 'Element erfolgreich genehmigt.',
        itemRejected: 'Element abgelehnt.',
        batchApproved: 'Ausgewählte Elemente erfolgreich genehmigt.',
        batchRejected: 'Ausgewählte Elemente abgelehnt.',
        tabAccessRequests: 'Zugriffsanfragen',
        tabRuleRequests: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE_REQUESTS)',
        accessRequestsDescription: 'Zugriffsanfragen, die auf Ihre $t(appConfig.domainEntityTypes.APPROVAL) warten',
        ruleRequestsDescription: '$t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE_REQUESTS), die auf Ihre $t(appConfig.domainEntityTypes.APPROVAL) warten',
        functionGroupRequestsDescription: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS), die auf Ihre $t(appConfig.domainEntityTypes.APPROVAL) warten',
        restrictionRuleRequestsDescription: 'Aufgabentrennungs-$t(appConfig.domainEntityTypes.REQUESTS), die auf Ihre $t(appConfig.domainEntityTypes.APPROVAL) warten',
        noRuleRequestApprovals: 'Keine ausstehenden Regelantrag-$t(appConfig.domainEntityTypes.APPROVALS)',
        ruleRequestApproved: 'Regelantrag erfolgreich genehmigt.',
        ruleRequestRejected: 'Regelantrag abgelehnt.',
        approveRuleRequest: 'Regelantrag genehmigen',
        rejectRuleRequest: 'Regelantrag ablehnen',
    },
    my: {
        title: 'Mein IAM',
        pageTitle: 'Mein IAM',
        subtitle: 'Ihre Zugriffsanfragen und $t(appConfig.domainEntityTypes.APPROVALS) verwalten',
        welcome: 'Willkommen bei Mein IAM',
        selectOption: 'Wählen Sie eine Option aus dem Menü, um zu beginnen.',
        dashboard: 'Dashboard',
        dashboardDesc: 'Übersicht Ihrer IAM-Aktivitäten',
        myAccess: 'Mein Zugriff',
        myAccessDesc: 'Ihre $t(appConfig.domainEntityTypes.ACCESS_PROFILE)- und $t(appConfig.domainEntityTypes.FUNCTION_GROUP_ASSIGNMENTS)',
        myRequests: 'Meine Anfragen',
        myRequestsDesc: 'Von Ihnen eingereichte Zugriffs- und $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        myApprovals: 'Meine $t(appConfig.domainEntityTypes.APPROVALS)',
        myApprovalsDesc: 'Positionen, die auf Ihre $t(appConfig.domainEntityTypes.APPROVAL) warten',
        myNotifications: '$t(appConfig.domainEntityTypes.NOTIFICATIONS)',
        myNotificationsDesc: 'Ihre Benachrichtigungshistorie',
        myDelegations: 'Meine Stellvertretungen',
        myDelegationsDesc: 'Verwalten Sie Ihre Stellvertretungen',
        myRehires: 'Meine Wiedereinstellungen',
        myRehiresDesc: 'Wiedereinstellungs-Kandidaten unter Ihren direkten Mitarbeitern prüfen',
        myReviews: 'Meine Reviews',
        myReviewsDesc: 'Zugewiesene Zertifizierungen prüfen',
        myResponsibilities: 'Meine Verantwortlichkeiten',
        myResponsibilitiesDesc: 'Katalog-Entitäten, die Sie verantworten',
        sectionMyAccount: 'Mein Konto',
        sectionAsManager: 'Als Führungskraft',
    },
    myResponsibilities: {
        title: 'Meine Verantwortlichkeiten',
        pageTitle: 'Meine Verantwortlichkeiten | Mein IAM',
        subtitle: 'Katalog-Entitäten, für die Sie als Eigentümer oder Steward verantwortlich sind',
        noVisibleTabs: 'Sie haben keine Ansichtsberechtigungen für einen Katalogeintrag.',
        emptyAccessProfiles: 'Sie sind für kein $t(appConfig.domainEntityTypes.ACCESS_PROFILE) als Eigentümer eingetragen.',
        emptyFunctionGroups: 'Sie sind für keine $t(appConfig.domainEntityTypes.FUNCTION_GROUP) als Eigentümer eingetragen.',
        emptyResources: 'Sie sind für keine $t(appConfig.domainEntityTypes.RESOURCE) als Eigentümer eingetragen.',
        emptyTargetSystems: 'Sie sind für kein $t(appConfig.domainEntityTypes.TARGET_SYSTEM) als Eigentümer eingetragen.',
        emptyRestrictionRules: 'Sie sind für keine $t(appConfig.domainEntityTypes.RESTRICTION_RULE) als Eigentümer eingetragen.',
        emptyAutoAssignRules: 'Sie sind für keine $t(appConfig.domainEntityTypes.AUTO_ASSIGN_RULE) als Eigentümer eingetragen.',
        emptyCertificationPolicies: 'Sie sind für keine $t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) als Eigentümer eingetragen.',
        emptyCertificationCampaigns: 'Sie sind für keine $t(appConfig.domainEntityTypes.CERTIFICATION_CAMPAIGN) als Eigentümer eingetragen.',
    },
    myDashboard: {
        title: 'Mein Dashboard',
        pageTitle: 'Dashboard | Mein IAM',
        subtitle: 'Übersicht Ihrer IAM-Aktivitäten',
        myAccess: 'Mein Zugriff',
        myAccessDesc: 'Ihre $t(appConfig.domainEntityTypes.ACCESS_PROFILE)- und $t(appConfig.domainEntityTypes.FUNCTION_GROUP_ASSIGNMENTS)',
        pendingRequests: 'Offene Anfragen',
        pendingRequestsDesc: 'Ihre Zugriffs- und Funktionsgruppenanfragen, die noch genehmigt werden müssen',
        pendingApprovals: 'Ausstehende $t(appConfig.domainEntityTypes.APPROVALS)',
        pendingApprovalsDesc: 'Positionen, die auf Ihre $t(appConfig.domainEntityTypes.APPROVAL) warten',
        viewRequests: 'Alle Anfragen anzeigen',
        viewApprovals: 'Alle $t(appConfig.domainEntityTypes.APPROVALS) anzeigen',
        recentNotifications: 'Letzte $t(appConfig.domainEntityTypes.NOTIFICATIONS)',
        recentNotificationsEmpty: 'Noch keine $t(appConfig.domainEntityTypes.NOTIFICATIONS).',
        viewAllNotifications: 'Alle $t(appConfig.domainEntityTypes.NOTIFICATIONS) anzeigen',
        newAccessRequest: 'Neue Zugriffsanfrage',
        newFunctionGroupRequest: 'Neue Funktionsgruppenanfrage',
    },
    myAccess: {
        title: 'Mein Zugriff',
        pageTitle: 'Mein Zugriff | Mein IAM',
        subtitle: 'Ihre aktuellen $t(appConfig.domainEntityTypes.ACCESS_PROFILE)- und $t(appConfig.domainEntityTypes.FUNCTION_GROUP_ASSIGNMENTS) und Historie',
        byAssignment: 'Nach Zuweisung',
        timeline: 'Zeitachse',
        noAssignments: 'Sie haben keine $t(appConfig.domainEntityTypes.ACCESS_PROFILE_ASSIGNMENTS).',
        noAssignmentsMatch: 'Keine $t(appConfig.domainEntityTypes.ACCESS_PROFILE_ASSIGNMENTS) entsprechen Ihren Filtern.',
        assignmentHistory: 'Zuweisungshistorie',
        noHistoryEvents: 'Keine Historienereignisse.',
        accessProfilesTab: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        functionGroupsTab: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
        accessProfilesTabSection: 'Ihre aktuellen $t(appConfig.domainEntityTypes.ACCESS_PROFILE_ASSIGNMENTS).',
        functionGroupsTabSection: 'Ihre aktuellen $t(appConfig.domainEntityTypes.FUNCTION_GROUP_ASSIGNMENTS).',
        accessProfilesSearchPlaceholder: 'Nach Zugriffsprofilnamen suchen…',
        functionGroupsSearchPlaceholder: 'Nach Funktionsgruppennamen suchen…',
        noFgAssignments: 'Sie haben keine $t(appConfig.domainEntityTypes.FUNCTION_GROUP_ASSIGNMENTS).',
        noFgAssignmentsMatch: 'Keine $t(appConfig.domainEntityTypes.FUNCTION_GROUP_ASSIGNMENTS) entsprechen Ihren Filtern.',
        fgColumnName: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP)',
        fgColumnStatus: 'Status',
        fgColumnSources: 'Quellen',
        fgColumnExpiresAt: 'Läuft ab',
        effectiveAccessTab: 'Effektiver Zugriff',
        effectiveAccessTabSection: 'Alle aktuell wirksamen berechneten Berechtigungen Ihrer $t(appConfig.domainEntityTypes.IDENTITY) — über alle Systeme und $t(appConfig.domainEntityTypes.RESOURCES) hinweg.',
        effectiveAccessSearchPlaceholder: 'Nach System, Berechtigung, $t(appConfig.domainEntityTypes.RESOURCE) suchen…',
        effectiveAccessScopeHint: 'Sie sehen ausschließlich Ihre eigenen Berechtigungen — Suche und Filter sind auf Ihre $t(appConfig.domainEntityTypes.IDENTITY) beschränkt.',
        noEffectiveAccess: 'Sie haben aktuell keine effektiven Berechtigungen.',
        noEffectiveAccessMatch: 'Keine Berechtigungen entsprechen Ihrer Suche.',
        eaColumnSystem: 'System',
        eaColumnEnforcementObject: 'Berechtigung',
        eaColumnResource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        eaColumnOperation: 'Operation',
        eaColumnValidFrom: 'Gültig ab',
        eaColumnValidTo: 'Gültig bis',
        eaColumnSourcesCount: 'Quellen',
    },
    backgroundJobs: {
        title: 'Hintergrund-Jobs',
        pageTitle: 'Hintergrund-Jobs',
        dashboardPageTitle: 'Dashboard | Hintergrund-Jobs',
        subtitle: 'Geplante Jobs und Cluster verwalten',
        dashboard: 'Dashboard',
        dashboardDesc: 'Statistikübersicht',
        jobs: 'Jobs',
        jobsDesc: 'Geplante Job-Definitionen',
        executions: '$t(appConfig.domainEntityTypes.EXECUTIONS)',
        executionsDesc: 'Job-Ausführungshistorie',
cluster: 'Cluster',
        clusterDesc: 'Cluster-Nodes und Master',
        errorLogs: '$t(appConfig.domainEntityTypes.ERROR_LOG)',
        errorLogsDesc: '$t(appConfig.domainEntityTypes.ERROR_LOGS) aller Module',
        scripts: 'Skripte',
        scriptsDesc: 'Groovy-Skripte verwalten und testen',
        selectOption: 'Wählen Sie eine Option aus dem Menü...',
        jobsDashboard: 'Jobs-Dashboard',
        jobsDashboardDesc: 'Übersicht der Job-$t(appConfig.domainEntityTypes.EXECUTIONS) und Systemgesundheit',
        selectPeriod: 'Zeitraum auswählen',
        last24Hours: 'Letzte 24 Stunden',
        last7Days: 'Letzte 7 Tage',
        last30Days: 'Letzte 30 Tage',
        customRange: 'Benutzerdefinierter Zeitraum',
        allTime: 'Gesamter Zeitraum',
        jobExecutions: 'Job-$t(appConfig.domainEntityTypes.EXECUTIONS)',
        total: 'Gesamt',
        completed: 'Abgeschlossen',
        running: 'Laufend',
        pending: 'Ausstehend',
        failed: 'Fehlgeschlagen',
        cancelled: 'Abgebrochen',
        avgDuration: 'Durchschnittliche Dauer',
        successRate: 'Erfolgsrate',
        jobsOverview: 'Jobs-Übersicht',
        totalJobs: 'Jobs gesamt',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
        processing: 'In Verarbeitung',
        deadLetter: 'Dead Letter',
        totalNodes: 'Nodes gesamt',
        activeNodes: 'Aktive Nodes',
        masterNode: 'Master-Node',
        completedOfTotal: '{{completed}} von {{total}} $t(appConfig.domainEntityTypes.EXECUTIONS) erfolgreich abgeschlossen',
        failedCancelledStats: '{{failed}} fehlgeschlagen, {{cancelled}} abgebrochen',
        runningNow: 'Aktuell laufend',
        failed24h: 'Fehlgeschlagen (24h)',
        enabledOfTotal: '{{enabled}} aktiviert / {{total}} gesamt',
        needsAttention: 'Benötigt Aufmerksamkeit',
        allSystemsHealthy: 'Alles in Ordnung — keine Elemente benötigen Aufmerksamkeit.',
        recentExecutions: 'Letzte $t(appConfig.domainEntityTypes.EXECUTIONS)',
        viewAll: 'Alle anzeigen',
        sourceBreakdown: 'Quellenübersicht',
        sourceStatic: 'Statisch',
        sourceDynamic: 'Dynamisch',
        sourceTestdata: 'Testdaten',
        failedToLoadStats: 'Dashboard-Statistiken konnten nicht geladen werden.',
        retry: 'Wiederholen',
    },
    jobs: {
        title: 'Jobs',
        pageTitle: 'Jobs | Hintergrund-Jobs',
        detailPageTitle: 'Job-Details | Hintergrund-Jobs',
        subtitle: 'Geplante und manuelle Jobs verwalten',
        scheduledJobs: 'Geplante Jobs',
        scheduledJobsDesc: 'Geplante Hintergrund-Jobs verwalten',
        allJobs: 'Alle Jobs',
        createJob: 'Job erstellen',
        filterPlaceholder: 'Jobs filtern...',
        jobCount: '{{count}} Job(s)',
        jobName: 'Jobname',
        key: 'Schlüssel',
        schedule: 'Zeitplan',
        lastRun: 'Letzte $t(appConfig.domainEntityTypes.EXECUTION)',
        nextRun: 'Nächste $t(appConfig.domainEntityTypes.EXECUTION)',
        noJobsMatch: 'Keine Jobs entsprechen Ihrem Filter.',
        noJobsFound: 'Keine Jobs gefunden. Passen Sie die Filter an oder erstellen Sie einen neuen Job.',
        loadingJobs: 'Jobs werden geladen...',
        failedToLoadJobs: 'Jobs konnten nicht geladen werden.',
        errorLoading: 'Fehler beim Laden der Jobs. Bitte versuchen Sie es erneut.',
        source: 'Quelle',
        manual: 'Manuell',
        lastStatus: 'Letzter Status',
        jobDetails: 'Job-Details',
        trigger: 'Auslösen',
        triggering: 'Wird ausgelöst...',
        tasks: 'Aufgaben',
        tasksDesc: 'Aufgabendefinitionen und ihre Ausführungsreihenfolge',
        noTasksDefined: 'Keine Aufgaben definiert',
        taskCount: '{{count}} Aufgabe(n)',
        cronExpression: 'Cron-Ausdruck',
        timeout: 'Timeout',
        retries: 'Wiederholungen',
        maxConcurrent: 'Maximale Parallelität',
        allowOverlap: 'Überlappung erlauben',
        assignedNode: 'Zugewiesener Node',
        manualOnly: 'Nur manuell',
        builder: 'Job-Builder',
        runNow: 'Jetzt ausführen',
        disable: 'Deaktivieren',
        enable: 'Aktivieren',
        deleteJob: 'Job löschen',
        deleteConfirm: 'Möchten Sie "{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        deleteConfirmMessage: 'Dadurch wird der Job und alle seine Aufgabendefinitionen dauerhaft gelöscht. Aktive $t(appConfig.domainEntityTypes.EXECUTIONS) werden abgebrochen.',
        viewDetails: 'Details anzeigen',
        viewExecutions: '$t(appConfig.domainEntityTypes.EXECUTIONS) anzeigen',
        recentExecutions: 'Letzte $t(appConfig.domainEntityTypes.EXECUTIONS)',
        recentExecutionsDesc: 'Letzte 10 Job-$t(appConfig.domainEntityTypes.EXECUTIONS)',
        live: 'Live',
        progress: 'Fortschritt',
        started: 'Gestartet',
        duration: 'Dauer',
        node: 'Node',
        noExecutionsYet: 'Noch keine $t(appConfig.domainEntityTypes.EXECUTIONS)',
        neverRun: 'Nie ausgeführt',
        completed: 'Abgeschlossen',
        completedWithErrors: 'Mit Fehlern abgeschlossen',
        running: 'Laufend',
        cancelling: 'Wird abgebrochen',
        failed: 'Fehlgeschlagen',
        cancelled: 'Abgebrochen',
        pending: 'Ausstehend',
        parallelGroup: 'Parallele Gruppe',
        sequentialGroup: 'Sequenzielle Gruppe',
        skipOnFail: 'Bei Fehler überspringen',
        retryCount: '{{count}} Wiederholung',
        retryCountPlural: '{{count}} Wiederholungen',
        log: 'Log:',
        jobNotFound: 'Job nicht gefunden.',
        loadingJobDetails: 'Job-Details werden geladen...',
        timeoutDuration: 'Timeout: {{duration}}',
        jobEnabled: 'Job erfolgreich aktiviert.',
        jobDisabled: 'Job erfolgreich deaktiviert.',
        jobTriggered: 'Job erfolgreich ausgelöst.',
        jobCancelled: 'Job erfolgreich abgebrochen.',
        jobDeleted: 'Job erfolgreich gelöscht.',
        manageJobScripts: 'Job-Skripte verwalten',
    },
    jobBuilder: {
        title: 'Job-Builder',
        pageTitle: 'Job-Builder | Hintergrund-Jobs',
        editPageTitle: 'Aufgaben bearbeiten | Hintergrund-Jobs',
        newPageTitle: 'Neuer Job | Hintergrund-Jobs',
        editTasks: 'Aufgaben bearbeiten',
        newJob: 'Neuer Job',
        unsavedChanges: 'Sie haben ungespeicherte Änderungen.',
        // Palette
        taskPalette: 'Aufgabenpalette',
        registeredTasks: 'Registrierte Aufgaben',
        customTasks: 'Benutzerdefinierte Aufgaben',
        groovyScript: 'Groovy-Skript',
        delay: 'Verzögerung',
        searchTasks: 'Aufgaben suchen...',
        noRegisteredTasks: 'Keine registrierten Aufgaben verfügbar.',
        failedToLoadPalette: 'Palette konnte nicht geladen werden.',
        // Task chain
        taskChain: 'Aufgabenkette',
        noTasksYet: 'Noch keine Aufgaben hinzugefügt.',
        addTasksFromPalette: 'Ziehen Sie Aufgaben aus der Palette, um zu beginnen.',
        staticTask: 'Statische Aufgabe (gesperrt)',
        dragToReorder: 'Zum Umsortieren ziehen',
        // Config panel
        taskConfig: 'Aufgabenkonfiguration',
        beanMethod: 'Bean-Methode',
        beanName: 'Bean-Name',
        methodName: 'Methodenname',
        readOnlyConfig: 'Diese Aufgabe ist schreibgeschützt.',
        scriptBody: 'Skript-Inhalt',
        inputs: 'Eingaben',
        inputKey: 'Schlüssel',
        inputValue: 'Wert',
        addInput: 'Eingabe hinzufügen',
        sqlWriteAccess: 'SQL-Schreibzugriff',
        sqlWriteAccessWarning: 'Aktiviert INSERT/UPDATE/DELETE über context.sql. Mit Vorsicht verwenden.',
        testScript: 'Skript testen',
        testScriptRunning: 'Wird ausgeführt...',
        testScriptOutput: 'Testausgabe',
        testScriptError: 'Test fehlgeschlagen',
        durationSeconds: 'Dauer (Sekunden)',
        durationMin: 'Minimum: 1 Sekunde',
        durationMax: 'Maximum: 86400 Sekunden (24 Stunden)',
        durationOutOfRange: 'Dauer muss zwischen 1 und 86400 Sekunden liegen.',
        apply: 'Anwenden',
        // Save / Cancel
        saveJob: 'Speichern',
        savingJob: 'Wird gespeichert...',
        jobSaved: 'Job-Aufgaben gespeichert.',
        saveError: 'Job-Aufgaben konnten nicht gespeichert werden.',
        addTaskBeforeSaving: 'Fügen Sie mindestens eine Aufgabe hinzu, bevor Sie speichern.',
        discardChangesTitle: 'Ungespeicherte Änderungen verwerfen?',
        discardChangesDescription: 'Ihre Aufgabenänderungen gehen verloren.',
        keepEditing: 'Weiter bearbeiten',
        discard: 'Verwerfen',
        conflictTitle: 'Konflikt erkannt',
        conflictDescription: 'Dieser Job wurde von einem anderen Benutzer geändert. Bitte laden Sie die Seite neu.',
        reload: 'Neu laden',
        // Create job dialog
        createJob: 'Job erstellen',
        createJobDescription: 'Erstellen Sie einen neuen dynamischen Job mit einer benutzerdefinierten Aufgabenkette.',
        jobName: 'Jobname',
        jobNamePlaceholder: 'Jobname eingeben',
        jobKey: 'Job-Schlüssel',
        jobKeyPlaceholder: 'z. B. mein-hintergrund-job',
        jobDescription: 'Beschreibung',
        jobDescriptionPlaceholder: 'Beschreiben Sie, was dieser Job tut',
        cronExpression: 'Cron-Ausdruck',
        cronExpressionPlaceholder: 'z. B. 0 0 2 * * *',
        cronExpressionHint: 'Leer lassen für nur manuelle $t(appConfig.domainEntityTypes.EXECUTION).',
        cronPreview: 'Zeitplan: {{description}}',
        cronInvalid: 'Ungültiger Cron-Ausdruck.',
        timeoutSeconds: 'Timeout (Sekunden)',
        timeoutDefault: 'Standard: 3600 (1 Stunde)',
        priority: 'Priorität',
        priorityCritical: 'Kritisch',
        priorityHigh: 'Hoch',
        priorityNormal: 'Normal',
        priorityLow: 'Niedrig',
        next: 'Weiter',
        // Validation
        nameRequired: 'Name ist erforderlich.',
        nameMaxLength: 'Name darf maximal 100 Zeichen lang sein.',
        keyRequired: 'Job-Schlüssel ist erforderlich.',
        keyMaxLength: 'Job-Schlüssel darf maximal 100 Zeichen lang sein.',
        descriptionMaxLength: 'Beschreibung darf maximal 500 Zeichen lang sein.',
        taskName: 'Aufgabenname',
        taskNamePlaceholder: 'Aufgabenname eingeben',
        editScript: 'Skript bearbeiten',
    },
    scriptEditor: {
        pageTitle: 'Skript-Editor | Hintergrund-Jobs',
        title: 'KI-Skript-Assistent',
        placeholder: 'Beschreiben Sie, was das Skript tun soll...',
        suggest: 'Code vorschlagen',
        suggesting: 'Wird vorgeschlagen...',
        apply: 'Anwenden',
        insertAtCursor: 'An Cursorposition einfügen',
        insertAtCursorNoPosition: 'Klicken Sie zuerst in den Editor und versuchen Sie es erneut.',
        replaceConfirmTitle: 'Aktuelles Skript ersetzen?',
        replaceConfirmDescription: 'Dies ersetzt Ihr gesamtes Skript durch den KI-Vorschlag.',
        fixWithAi: 'Mit KI beheben',
        fixPrefix: 'Diesen Kompilierungsfehler beheben',
        validate: 'Syntax prüfen',
        validating: 'Wird geprüft...',
        syntaxOk: 'Syntax OK',
        syntaxError: 'Syntaxfehler gefunden',
        syntaxModifiedHint: 'Skript geändert \u2014 Syntax erneut prüfen',
        errorSummary: {
            showAll: 'Alle anzeigen ({{count}})',
            collapse: 'Weniger anzeigen',
            lineError: 'Zeile {{line}}: {{message}}',
        },
        rateLimited: 'Ratenlimit erreicht. Versuchen Sie es in {{seconds}} Sekunden erneut.',
        llmUnavailable: 'KI-Unterstützung ist nicht verfügbar. Kein LLM-Modell konfiguriert.',
        llmUnavailableBadge: 'Nicht verfügbar',
        suggestFailed: 'Vorschlag konnte nicht generiert werden. Bitte versuchen Sie es erneut.',
        networkError: 'Skript konnte nicht validiert werden. Überprüfen Sie Ihre Verbindung.',
        saved: 'Skript gespeichert',
        unsavedChanges: 'Ungespeicherte Änderungen',
        discardTitle: 'Ungespeicherte Änderungen verwerfen?',
        discardDescription: 'Ihre Skriptänderungen wurden nicht gespeichert und gehen verloren.',
        schedule: {
            edit: 'Zeitplan bearbeiten',
            cron: 'Cron-Ausdruck',
            preview: 'Zeitplan: {{description}}',
            manual: 'Nur manuelle Auslösung',
            saved: 'Zeitplan aktualisiert',
            removeTitle: 'Zeitplan entfernen?',
            removeDescription: 'Dieser Job wird nur ausgeführt, wenn er manuell ausgelöst wird.',
            removeConfirm: 'Zeitplan entfernen',
            hint: '6-Feld-Cron (Sek Min Std Tag Monat Wochentag). Leer lassen für nur manuelle Auslösung.',
            cronFieldHint: 'z.B. 0 0 2 * * *',
            invalidCron: 'Ungültiger Cron-Ausdruck',
        },
        scriptTooLarge: 'Skript überschreitet 10.000 Zeichen. Nur die ersten 10.000 werden an die KI gesendet.',
        editInBuilder: 'Im Builder bearbeiten',
        scriptPreview: {
            showAll: 'Alle anzeigen',
            collapse: 'Weniger anzeigen',
        },
        taskNotFound: 'Aufgabe in diesem Job nicht gefunden.',
        newScriptPlaceholder: '// Schreiben Sie hier Ihr Groovy-Skript',
        save: 'Speichern',
        saving: 'Wird gespeichert...',
        replace: 'Ersetzen',
    },
    jobExecutions: {
        title: '$t(appConfig.domainEntityTypes.EXECUTIONS)',
        pageTitle: '$t(appConfig.domainEntityTypes.EXECUTIONS) | Hintergrund-Jobs',
        detailPageTitle: 'Ausführungsdetails | Hintergrund-Jobs',
        subtitle: 'Job-Ausführungshistorie anzeigen',
        viewExecutionHistory: 'Ausführungshistorie anzeigen',
        allExecutions: 'Alle $t(appConfig.domainEntityTypes.EXECUTIONS)',
        filterPlaceholder: 'Nach Jobname filtern...',
        executionCount: '{{count}} $t(appConfig.domainEntityTypes.EXECUTION)(en)',
        jobName: 'Job',
        startedAt: 'Gestartet',
        completedAt: 'Abgeschlossen',
        duration: 'Dauer',
        noExecutionsMatch: 'Keine $t(appConfig.domainEntityTypes.EXECUTIONS) entsprechen Ihren Filtern.',
        noExecutionsFound: 'Keine $t(appConfig.domainEntityTypes.EXECUTIONS) gefunden.',
        loadingExecutions: '$t(appConfig.domainEntityTypes.EXECUTIONS) werden geladen...',
        errorLoading: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.EXECUTIONS). Bitte versuchen Sie es erneut.',
        executionDetails: 'Ausführungsdetails',
        liveUpdates: 'Live-Aktualisierungen',
        connecting: 'Verbindung wird hergestellt...',
        taskResults: 'Aufgabenergebnisse',
        logs: 'Logs',
        output: 'Ausgabe',
        success: 'Erfolgreich',
        failed: 'Fehlgeschlagen',
        running: 'Laufend',
        pending: 'Ausstehend',
        cancelled: 'Abgebrochen',
        completed: 'Abgeschlossen',
        completedWithErrors: 'Mit Fehlern abgeschlossen',
        cancelling: 'Wird abgebrochen',
        noLogs: 'Keine Logs verfügbar.',
        viewLogs: 'Logs anzeigen',
        live: 'Live',
        timeRange: 'Zeitraum',
        task: 'Aufgabe',
        tasks: 'Aufgaben',
        node: 'Node',
        total: 'Gesamt',
        succeeded: 'Erfolgreich',
        loadingTasks: 'Aufgaben werden geladen...',
        noTasksForExecution: 'Keine Aufgaben für diese $t(appConfig.domainEntityTypes.EXECUTION)',
        parallelGroup: 'Parallele Gruppe',
        sequentialGroup: 'Sequenzielle Gruppe',
        executionInfo: 'Ausführungsinformationen',
        progress: 'Fortschritt',
        started: 'Gestartet',
        error: 'Fehler',
        statistics: 'Statistiken',
        taskExecutions: 'Aufgabenausführungen',
        clickLogIcon: 'Klicken Sie auf das Log-Symbol, um die Aufgabenausführungs-Logs anzuzeigen',
        noTaskExecutions: 'Keine Aufgabenausführungen',
        executionNotFound: '$t(appConfig.domainEntityTypes.EXECUTION) nicht gefunden.',
        loadingExecutionDetails: 'Ausführungsdetails werden geladen...',
        errorLoadingExecutions: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.EXECUTIONS). Bitte versuchen Sie es erneut.',
        waiting: 'Wartend',
        skipped: 'Übersprungen',
        skipOnFail: 'Bei Fehler überspringen',
        jobLabel: 'Job:',
        jobIdLabel: 'Job-ID: {{id}}',
        executionCancelled: '$t(appConfig.domainEntityTypes.EXECUTION) erfolgreich abgebrochen.',
        executionIdLabel: '$t(appConfig.domainEntityTypes.EXECUTION) #{{id}}',
        cancelExecutionTitle: '$t(appConfig.domainEntityTypes.EXECUTION) abbrechen',
        cancelExecutionConfirm: 'Möchten Sie diese $t(appConfig.domainEntityTypes.EXECUTION) wirklich abbrechen? Laufende Aufgaben werden unterbrochen.',
        keepRunning: 'Weiterlaufen lassen',
        cancelExecution: '$t(appConfig.domainEntityTypes.EXECUTION) abbrechen',
        backToExecutions: 'Zurück zu $t(appConfig.domainEntityTypes.EXECUTIONS)',
        failedToLoadExecution: 'Ausführungsdetails konnten nicht geladen werden.',
    },
clusterNodes: {
        title: 'Cluster-Nodes',
        pageTitle: 'Cluster | Hintergrund-Jobs',
        subtitle: 'Anwendungsinstanzen im Job-Cluster',
        allNodes: 'Alle Cluster-Nodes',
        nodeCount: '{{count}} Node(s)',
        nodeId: 'Node-ID',
        hostname: 'Hostname',
        ipAddress: 'IP-Adresse',
        lastHeartbeat: 'Letzter Heartbeat',
        registered: 'Registriert',
        searchPlaceholder: 'Suche nach Node-ID, Hostname oder IP...',
        noNodesFound: 'Keine Nodes registriert',
        noNodesMatch: 'Keine Nodes entsprechen Ihrer Suche.',
        loadingNodes: 'Cluster-Nodes werden geladen...',
        errorLoading: 'Fehler beim Laden der Cluster-Nodes.',
        totalNodes: 'Nodes gesamt',
        activeNodes: 'Aktive Nodes',
        masterNode: 'Master-Node',
        removeNode: 'Node entfernen',
        removeNodeConfirm: 'Möchten Sie diesen Node wirklich aus dem Cluster entfernen?',
        removeNodeDesc: 'Dieser Node wird abgemeldet und seine Jobs werden neu zugewiesen.',
        thisNode: 'Dieser Node',
        remove: 'Entfernen',
        master: 'Master',
        worker: 'Worker',
        active: 'Aktiv',
        starting: 'Wird gestartet',
        inactive: 'Inaktiv',
        stopped: 'Gestoppt',
        nodeRemoved: 'Knoten aus dem Cluster entfernt.',
        failedToLoadCluster: 'Cluster-Informationen konnten nicht geladen werden.',
    },
    scripts: {
        pageTitle: 'Skripte | Hintergrund-Jobs',
        editorPageTitle: 'Skript-Editor | Hintergrund-Jobs',
        newPageTitle: 'Neues Skript | Hintergrund-Jobs',
        backToJobs: 'Zurück zu Jobs',
        backToJobBuilder: 'Zurück zum Job-Builder',
        title: 'Skripte',
        allScripts: 'Alle Skripte',
        scriptCount: '{{count}} Skript(e)',
        newScript: 'Neues Skript',
        filterPlaceholder: 'Skripte filtern...',
        filterCategory: 'Kategorie',
        filterPublished: 'Status',
        allCategories: 'Alle Kategorien',
        allStatuses: 'Alle',
        publishedOnly: 'Veröffentlicht',
        draftsOnly: 'Entwürfe',
        noScriptsFound: 'Keine Skripte gefunden.',
        noScriptsMatch: 'Keine Skripte entsprechen Ihrem Filter.',
        scriptName: 'Skriptname',
        scriptNamePlaceholder: 'z.B. HR-Benutzer importieren',
        category: 'Kategorie',
        categoryPlaceholder: 'Kategorie wählen',
        tags: 'Tags',
        tagsPlaceholder: 'Kommagetrennte Tags',
        maxExecutionTime: 'Max. Ausführungszeit',
        description: 'Beschreibung',
        descriptionPlaceholder: 'Was macht dieses Skript?',
        metadata: 'Metadaten',
        save: 'Speichern',
        saveFirst: 'Zuerst speichern',
        saving: 'Wird gespeichert...',
        validate: 'Syntax prüfen',
        validating: 'Wird geprüft...',
        run: 'Testlauf',
        running: 'Wird ausgeführt...',
        publish: 'Veröffentlichen',
        unpublish: 'Zurückziehen',
        delete: 'Löschen',
        deleteConfirm: 'Skript löschen',
        deleteConfirmDescription: 'Möchten Sie dieses Skript wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        cannotDeletePublished: 'Ziehen Sie das Skript zuerst zurück, bevor Sie es löschen.',
        saved: 'Skript erfolgreich gespeichert.',
        created: 'Skript erfolgreich erstellt.',
        deleted: 'Skript erfolgreich gelöscht.',
        published: 'Skript veröffentlicht. Es kann jetzt in Jobs verwendet werden.',
        unpublished: 'Skript zurückgezogen. Es kann nicht mehr in neuen Jobs verwendet werden.',
        saveError: 'Fehler beim Speichern des Skripts.',
        deleteError: 'Fehler beim Löschen des Skripts.',
        publishError: 'Fehler beim Veröffentlichen des Skripts.',
        validationValid: 'Syntax OK — keine Kompilierungsfehler.',
        validationErrors: '{{count}} Syntaxfehler gefunden.',
        validationWarnings: '{{count}} Warnung(en).',
        codeEditor: 'Skriptcode',
        inputParameters: 'Eingabeparameter',
        addParameter: 'Parameter hinzufügen',
        parameterName: 'Name',
        parameterType: '$t(appConfig.domainEntityTypes.TYPE)',
        parameterRequired: 'Erforderlich',
        parameterDefault: 'Standard',
        parameterDescription: 'Beschreibung',
        removeParameter: 'Entfernen',
        noParameters: 'Keine Eingabeparameter definiert.',
        testRun: 'Testlauf',
        executeTest: 'Ausführen',
        testOutput: 'Ausgabe',
        testResult: 'Ergebnis',
        noTestRuns: 'Noch keine Testläufe. Klicken Sie auf Ausführen, um das Skript zu starten.',
        executionCompleted: 'Abgeschlossen in {{duration}}ms',
        executionFailed: 'Fehlgeschlagen: {{error}}',
        executionTimeout: '$t(appConfig.domainEntityTypes.EXECUTION) hat das Zeitlimit überschritten.',
        executionHistory: 'Ausführungshistorie',
        executionId: 'Ausführungs-ID',
        startedAt: 'Gestartet am',
        duration: 'Dauer',
        executedBy: 'Ausgeführt von',
        noExecutionHistory: 'Noch keine $t(appConfig.domainEntityTypes.EXECUTIONS) aufgezeichnet.',
        tabParameters: 'Parameter',
        tabTestRun: 'Testlauf',
        tabHistory: 'Historie',
        tabVersions: 'Versionen',

        // Versions
        noVersionHistory: 'Noch keine Versionshistorie. Versionen werden erstellt, wenn sich der Skript-Code ändert.',
        versionLabel: 'Version',
        versionStatus: 'Status',
        viewDiff: 'Änderungen anzeigen',
        currentVersion: 'Aktuell',
        superseded: 'Ersetzt',
        publishVersion: 'Veröffentlichen',
        republishConfirmTitle: 'Version veröffentlichen',
        republishConfirmDesc: 'Version v{{version}} wird die derzeit veröffentlichte Version ersetzen. Jobs werden diese Version verwenden.',
        publishDraftConfirmDesc: 'Version v{{version}} wird dieses Skript für die Verwendung in Jobs verfügbar machen.',
        versionPublished: 'Version v{{version}} erfolgreich veröffentlicht.',
        publishedBadge: 'Veröffentlicht',
        draft: 'Entwurf',
        deactivated: 'Deaktiviert',
        selectScript: 'Skript auswählen',
        chooseScript: 'Skript wählen',
        changeScript: 'Skript ändern',
        scriptPickerTitle: 'Skript auswählen',
        scriptPickerDescription: 'Wählen Sie ein Skript für diese Aufgabe.',
        noScriptsAvailable: 'Keine aktiven Skripte verfügbar.',
        scriptInputs: 'Skript-Eingaben',
        noPublishedScripts: 'Keine veröffentlichten Skripte verfügbar.',
        selectedScript: 'Ausgewähltes Skript',
        templateBadge: 'Vorlage',
        markAsTemplate: 'Als Vorlage markieren',
        unmarkAsTemplate: 'Vorlagenstatus entfernen',
        markAsTemplateDesc: 'Vorlagen stehen anderen zur Erstellung neuer Skripte zur Verfügung.',
        markedAsTemplate: 'Skript als Vorlage markiert.',
        unmarkedAsTemplate: 'Vorlagenstatus entfernt.',
        manageTemplates: 'Vorlagen verwalten',
        manageTemplatesDesc: 'Vorlagen, die zum Erstellen neuer Skripte verfügbar sind.',
        noTemplatesManage: 'Derzeit sind keine Skripte als Vorlagen markiert.',
        removeTemplateBtnTooltip: 'Vorlagenstatus von diesem Skript entfernen',
        removeTemplateConfirmTitle: 'Vorlage entfernen',
        removeTemplateConfirmDesc: 'Möchten Sie "{{name}}" wirklich als Vorlage entfernen? Es wird zu einem regulären Skript.',
        removeTemplateConfirmAction: 'Vorlage entfernen',
        fromTemplate: 'Aus Vorlage',
        templatePicker: 'Aus Vorlage erstellen',
        selectTemplate: 'Vorlage auswählen',
        templatePickerDescription: 'Wählen Sie eine Vorlage, um ein neues Skript mit vorgefertigtem Code zu erstellen.',
        noTemplates: 'Keine Vorlagen verfügbar.',
        creatingFromTemplate: 'Skript wird erstellt...',
        unsavedChanges: 'Sie haben ungespeicherte Änderungen.',
        backToList: 'Alle Skripte',

        // Testlauf-Dialog
        testRunTitle: 'Testlauf — Live-$t(appConfig.domainEntityTypes.EXECUTION)',
        testRunWarning: 'Das Skript wird gegen die Live-Datenbank ausgeführt. Änderungen können nicht rückgängig gemacht werden.',
        testRunBindings: 'Verfügbare Bindings: sql (Datenbank), http (externe Anfragen), csv (Verarbeitung)',
        testRunConfirm: 'Skript ausführen',

        // Entwurf-Toast
        savedAsDraft: 'Skript als Entwurf gespeichert.',
        savedAsDraftHint: 'Veröffentlichen, um es in Jobs verfügbar zu machen.',

        // Aktivieren/Deaktivieren
        activate: 'Aktivieren',
        deactivate: 'Deaktivieren',
        activated: 'Skript aktiviert.',
        deactivatedMsg: 'Skript deaktiviert. Es kann nicht mehr in Jobs ausgeführt werden.',
        deactivatedReadOnly: 'Dieses Skript ist deaktiviert. Aktivieren Sie es, um Änderungen vorzunehmen.',

        // Status-Toggle
        publishConfirm: 'Durch die Veröffentlichung wird das Skript für Jobs verfügbar.',
        unpublishWarning: 'Jobs, die dieses Skript verwenden, werden fehlschlagen.',

        // Erstellungsdialog
        newScriptDialog: 'Neues Skript',
        startBlank: 'Leer starten',
        startBlankDesc: 'Leeres Skript mit Standard-Vorlage',
        fromTemplateDesc: 'Code von einer vorgefertigten Vorlage kopieren',

        // Historie
        testBadge: 'Ausgeführt via Testlauf',
        viewLogs: 'Logs anzeigen',

        // SQL-Einfügen-Dialog
        sqlInsertTitle: 'SQL verfassen',
        sqlInsertDescription: 'Schreiben Sie Ihre SQL-Abfrage unten. Sie wird als Groovy-Binding-Aufruf in das Skript eingefügt.',
        sqlBinding: 'Binding-Methode',
        sqlPreview: 'Vorschau — wird eingefügt als:',
        sqlInsert: 'In Skript einfügen',
        sqlReplace: 'Im Skript ersetzen',
        insertSql: 'SQL einfügen',
        sqlBindingOptions: {
            query: 'sql.query — liefert Zeilen',
            queryForValue: 'sql.queryForValue — einzelner Wert',
            update: 'sql.update — UPDATE/DELETE',
            execute: 'sql.execute — DDL',
        },

        // Ad-hoc-Ausführung
        runNow: 'Ausführen',
        runNowTooltip: 'Dieses Skript jetzt ausführen',
        runSuccess: 'Skript erfolgreich ausgeführt.',
        runError: 'Skriptausführung fehlgeschlagen.',
        openInEditor: 'Im Editor öffnen',
        lastExecuted: 'Zuletzt ausgeführt',

    },
    scriptSqlV2: {
        fields: {
            parameters: 'Parameter',
            resultType: 'Ergebnistyp',
        },
        placeholders: {
            parameters: '[id: 1, status: "ACTIVE"]',
            groovyPreview: 'SQL-Anweisung oben eingeben, um den einzufügenden Groovy-Code zu sehen.',
        },
        captions: {
            executeRestriction: 'Nur DDL. Erlaubt: CREATE TABLE, DROP TABLE, TRUNCATE TABLE, ALTER TABLE, CREATE INDEX, DROP INDEX, ANALYZE. Auth-Tabellen und audit_logs können nicht als Ziel verwendet werden.',
            executeParamsIgnored: 'Parameter werden bei execute ignoriert — DDL-Anweisungen akzeptieren keine Parameterliste.',
            blocklist: 'Tabellen mit dem Präfix auth_ sowie audit_logs sind für Skripte schreibgeschützt und DDL-geschützt. Verwenden Sie http.iam(…), um über die API darauf zuzugreifen.',
            inlineLiteralAdvisory: 'Betten Sie keine Geheimnisse als Literale in SQL ein — verwenden Sie stattdessen benannte Parameter.',
            variableRefHint: 'Vorschau nicht verfügbar — Variablenreferenzen durch Literale ersetzen, um sie zu testen.',
            codeMirrorEscapeHint: 'Esc, um zu Parameter zu wechseln.',
        },
        actions: {
            insert: 'In Skript einfügen',
            replace: 'Im Skript ersetzen',
            trySql: 'SQL testen',
            running: 'Läuft…',
        },
        badges: {
            rolledBack: 'Zurückgerollt',
        },
        aria: {
            rollbackBadge: 'Die Vorschau-Transaktion wurde zurückgerollt; es wurden keine Änderungen an der Datenbank festgeschrieben',
        },
        errorBanners: {
            sqlError: {
                heading: 'SQL-Fehler',
                bodyNoMessage: 'SQL-Vorschau ohne diagnostische Meldung fehlgeschlagen. Prüfen Sie das [[Fehlerprotokoll]] für Details.',
            },
            typeConversionError: {
                heading: 'Typumwandlungsfehler',
                body: 'Das Abfrageergebnis konnte nicht in {{selectedType}} umgewandelt werden. Versuchen Sie einen anderen `Ergebnistyp` (z. B. akzeptiert String die meisten Werte).',
            },
            paramsInvalid: {
                heading: 'Parameter-Fehler',
                body: 'Parameter dürfen nur Literale sein — ersetzen Sie alle Variablenreferenzen durch Werte, um zu testen.',
            },
            limitRowsPerQuery: {
                heading: 'Ergebnis zu groß',
                body: 'Die Abfrage hat mehr als 100 Zeilen zurückgegeben. Fügen Sie eine LIMIT-Klausel hinzu, um die Vorschau-Ergebnismenge einzugrenzen.',
            },
            limitStatementTimeout: {
                heading: 'Abfrage-Zeitüberschreitung',
                body: 'Die Abfrage hat länger als 60 Sekunden gedauert. Fügen Sie Filter hinzu oder teilen Sie sie in kleinere Abfragen auf.',
            },
            limitResponsePayload: {
                heading: 'Ergebnis zu groß zur Anzeige',
                body: 'Die Ergebnismenge überschreitet 5 MB. Fügen Sie eine LIMIT-Klausel hinzu oder grenzen Sie Ihre Abfrage ein.',
            },
            limitGeneric: {
                heading: 'Vorschau-Limit überschritten',
                body: 'Die Abfrage hat ein Vorschau-Limit überschritten. Grenzen Sie die Abfrage ein (LIMIT, Filter) und versuchen Sie es erneut.',
            },
            rateLimit: {
                heading: 'Bitte langsamer',
                body: 'Sie haben zu viele Vorschauen ausgeführt. Versuchen Sie es in {{retryAfterSeconds}} Sekunden erneut.',
            },
            permissionDenied: {
                heading: 'Zugriff verweigert',
                body: 'Sie haben keine Berechtigung, die SQL-Vorschau auszuführen. Wenden Sie sich an Ihren Administrator.',
            },
            serverError: {
                heading: 'Vorschau nicht verfügbar',
                body: 'Der Vorschaudienst ist derzeit nicht verfügbar. Versuchen Sie es später erneut.',
            },
            networkFailure: {
                heading: '`SQL-Test` fehlgeschlagen',
                body: 'Der Vorschaudienst ist nicht erreichbar. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
            },
        },
    },
    analytics: {
        title: 'Effektiver Zugriff',
        pageTitle: 'Effektiver Zugriff',
        dashboardPageTitle: 'Dashboard | Effektiver Zugriff',
        byIdentityPageTitle: 'Nach $t(appConfig.domainEntityTypes.IDENTITY) | Effektiver Zugriff',
        bySystemPageTitle: 'Nach System | Effektiver Zugriff',
        identityGrantsPageTitle: 'Identitätszugriff | Effektiver Zugriff',
        systemGrantsPageTitle: 'Systemzugriff | Effektiver Zugriff',
        comparePageTitle: 'Zugriff vergleichen | Effektiver Zugriff',
        subtitle: 'Effektiven Zugriff anzeigen und Identitätszugriff vergleichen',
        dashboard: 'Dashboard',
        dashboardDesc: 'Übersicht und Kennzahlen',
        byIdentity: 'Nach $t(appConfig.domainEntityTypes.IDENTITY)',
        byIdentityDesc: 'Zugriff pro $t(appConfig.domainEntityTypes.IDENTITY) anzeigen',
        bySystem: 'Nach System',
        bySystemDesc: 'Zugriff pro $t(appConfig.domainEntityTypes.TARGET_SYSTEM) anzeigen',
        compare: 'Zugriff vergleichen',
        compareDesc: 'Identitätszugriff vergleichen',
        selectOption: 'Effektive Zugriffsanalysen anzeigen und Identitätszugriff systemübergreifend vergleichen.',
        identityGrants: 'Identitätsberechtigungen',
        systemGrants: 'Systemberechtigungen',
        totalGrants: 'Berechtigungen gesamt',
        directGrants: 'Direkte Berechtigungen',
        inheritedGrants: 'Vererbte Berechtigungen',
        searchIdentities: '$t(appConfig.domainEntityTypes.IDENTITIES) suchen...',
        searchSystems: 'Systeme suchen...',
        selectIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) auswählen',
        selectSystem: 'System auswählen',
        selectIdentities: '$t(appConfig.domainEntityTypes.IDENTITIES) zum Vergleich auswählen',
        noGrantsFound: 'Keine Berechtigungen gefunden.',
        loadingGrants: 'Berechtigungen werden geladen...',
        loadingIdentities: '$t(appConfig.domainEntityTypes.IDENTITIES) werden geladen...',
        loadingSystems: 'Systeme werden geladen...',
        errorLoading: 'Fehler beim Laden der Berechtigungen. Bitte versuchen Sie es erneut.',
        errorLoadingIdentities: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.IDENTITIES). Bitte versuchen Sie es erneut.',
        errorLoadingSystems: 'Fehler beim Laden der Systeme. Bitte versuchen Sie es erneut.',
        errorLoadingDashboard: 'Fehler beim Laden der Dashboard-Statistiken.',
        errorLoadingComparison: 'Fehler beim Laden des Vergleichs. Bitte versuchen Sie es erneut.',
        loadingComparison: 'Vergleich wird geladen...',
        grantSource: 'Quelle',
        grantType: 'Berechtigungstyp',
        enforcementObject: 'Durchsetzungsobjekt',
        resource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        system: 'System',
        compareSummary: 'Vergleichszusammenfassung',
        onlyIn: 'Nur in {{name}}',
        inBoth: 'In beiden',
        differences: 'Unterschiede',
        noDifferences: 'Keine Unterschiede gefunden.',
        accessAnalytics: 'Zugriffsanalyse-Dashboard',
        effectiveAccessDashboard: 'Dashboard für effektiven Zugriff',
        effectiveAccessDashboardDesc: 'Übersicht der effektiven Zugriffsberechtigungen über alle Systeme',
        identitiesWithAccess: '$t(appConfig.domainEntityTypes.IDENTITIES) mit Zugriff',
        identitiesWithGrants: '$t(appConfig.domainEntityTypes.IDENTITIES) mit Berechtigungen',
        systemsWithGrants: 'Systeme mit Berechtigungen',
        entitlementsGranted: 'Gewährte Berechtigungen',
        grantsOverTime: 'Berechtigungen im Zeitverlauf',
        topSystems: 'Top-Systeme nach Berechtigungen',
        topIdentities: 'Top-$t(appConfig.domainEntityTypes.IDENTITIES) nach Berechtigungen',
        selectPeriod: 'Zeitraum auswählen',
        last24Hours: 'Letzte 24 Stunden',
        last7Days: 'Letzte 7 Tage',
        last30Days: 'Letzte 30 Tage',
        allTimeTotals: 'Gesamtwerte aller Zeiten',
        activity: 'Aktivität',
        grantsCreated: 'Erstellte Berechtigungen',
        identitiesAffected: 'Betroffene $t(appConfig.domainEntityTypes.IDENTITIES)',
        systemsAffected: 'Betroffene Systeme',
        noGrantsYet: 'Noch keine Berechtigungen erfasst.',
        noActivityYet: 'Keine Aktivität in diesem Zeitraum.',
        effectiveAccessByIdentity: 'Effektiver Zugriff nach $t(appConfig.domainEntityTypes.IDENTITY)',
        effectiveAccessByIdentityDesc: 'Effektiven Zugriff für jede $t(appConfig.domainEntityTypes.IDENTITY) anzeigen',
        accessByIdentities: 'Zugriff nach $t(appConfig.domainEntityTypes.IDENTITIES)',
        party: '$t(appConfig.domainEntityTypes.PARTY)',
        viewAccess: 'Zugriff anzeigen',
        noIdentitiesMatch: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) entsprechen Ihrer Suche.',
        noIdentitiesFound: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) gefunden.',
        effectiveAccessBySystem: 'Effektiver Zugriff nach System',
        effectiveAccessBySystemDesc: 'Effektive Zugriffsberechtigungen für jedes $t(appConfig.domainEntityTypes.TARGET_SYSTEM) anzeigen',
        accessByTargetSystems: 'Zugriff nach Zielsystemen',
        environment: 'Umgebung',
        noSystemsMatch: 'Keine Systeme entsprechen Ihrer Suche.',
        noSystemsFound: 'Keine Systeme gefunden.',
        compareAccess: 'Zugriff vergleichen',
        compareAccessDesc: 'Effektiven Zugriff zwischen zwei $t(appConfig.domainEntityTypes.IDENTITIES) vergleichen',
        selectIdentitiesLabel: '$t(appConfig.domainEntityTypes.IDENTITIES) auswählen',
        selectIdentitiesDesc: 'Wählen Sie zwei $t(appConfig.domainEntityTypes.IDENTITIES), um deren effektiven Zugriff zu vergleichen',
        identityA: '$t(appConfig.domainEntityTypes.IDENTITY) A',
        identityB: '$t(appConfig.domainEntityTypes.IDENTITY) B',
        searchForIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) suchen...',
        noIdentitiesFoundSearch: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) gefunden.',
        commonGrants: 'Gemeinsame Berechtigungen',
        commonGrantsDesc: 'Berechtigungen, die beide $t(appConfig.domainEntityTypes.IDENTITIES) haben',
        onlyInDesc: 'Berechtigungen, die nur {{name}} hat',
        targetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
        neitherHasGrants: 'Keine der beiden $t(appConfig.domainEntityTypes.IDENTITIES) hat effektive Zugriffsberechtigungen.',
        selectTwoIdentities: 'Wählen Sie oben zwei $t(appConfig.domainEntityTypes.IDENTITIES) aus, um deren effektiven Zugriff zu vergleichen.',
        effectiveAccessLabel: 'Effektiver Zugriff:',
        recalculate: 'Neu berechnen',
        recalculateSuccess: 'Neuberechnung erfolgreich gestartet.',
        recalculateError: 'Neuberechnung konnte nicht gestartet werden.',
        recalculating: 'Wird neu berechnet...',
        activeGrants: 'Aktive Berechtigungen',
        lastCalculated: 'Zuletzt berechnet',
        never: 'Nie',
        effectiveAccessGrants: 'Effektive Zugriffsberechtigungen',
        grantsFiltered: 'von {{total}} Berechtigungen',
        filtered: '(gefiltert)',
        allEnvironments: 'Alle Umgebungen',
        allSystems: 'Alle Systeme',
        allIdentities: 'Alle $t(appConfig.domainEntityTypes.IDENTITIES)',
        allOperations: 'Alle Operationen',
        viewIdentityDetails: 'Identitätsdetails anzeigen',
        viewSystemDetails: 'Systemdetails anzeigen',
        validTo: 'Gültig bis',
        sources: 'Quellen',
        accessProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE)',
        assignmentStart: 'Zuweisungsbeginn',
        assignmentExpires: 'Zuweisung läuft ab',
        uniqueIdentities: 'Eindeutige $t(appConfig.domainEntityTypes.IDENTITIES)',
        grantsFor: 'Berechtigungen für:',
        identityNotFound: '$t(appConfig.domainEntityTypes.IDENTITY) nicht gefunden.',
        systemNotFound: 'System nicht gefunden.',
        topIdentitiesByGrants: 'Top-$t(appConfig.domainEntityTypes.IDENTITIES) nach Berechtigungen',
        topIdentitiesByGrantsDesc: '$t(appConfig.domainEntityTypes.IDENTITIES) mit den meisten effektiven Zugriffsberechtigungen',
        topSystemsByGrants: 'Top-Systeme nach Berechtigungen',
        topSystemsByGrantsDesc: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS) mit den meisten effektiven Zugriffsberechtigungen',
        noIdentitiesWithGrants: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) mit Berechtigungen gefunden.',
        noSystemsWithGrants: 'Keine Systeme mit Berechtigungen gefunden.',
        targetSystems: '$t(appConfig.domainEntityTypes.TARGET_SYSTEMS)',
        customRange: 'Benutzerdefinierter Zeitraum',
        identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        grants: 'Berechtigungen',
        searchIdentitiesPlaceholder: '$t(appConfig.domainEntityTypes.IDENTITIES) suchen...',
        searchSystemsPlaceholder: 'Systeme suchen...',
        noGrantsMatchFilters: 'Keine Berechtigungen entsprechen den ausgewählten Filtern.',
        noGrantsForIdentity: 'Keine effektiven Zugriffsberechtigungen für diese $t(appConfig.domainEntityTypes.IDENTITY) gefunden.',
        noGrantsForSystem: 'Keine effektiven Zugriffsberechtigungen für dieses System gefunden.',
        matchingSearch: 'entsprechend der Suche',
        identityCount: '{{count}} $t(appConfig.domainEntityTypes.IDENTITIES)',
        identityCount_one: '{{count}} $t(appConfig.domainEntityTypes.IDENTITY)',
        identityCount_other: '{{count}} $t(appConfig.domainEntityTypes.IDENTITIES)',
        systemCount: '{{count}} Systeme',
        systemCount_one: '{{count}} System',
        systemCount_other: '{{count}} Systeme',
        recalculateResult: 'Neuberechnung abgeschlossen. Hinzugefügt: {{added}}, Entfernt: {{removed}}, Geändert: {{modified}}',
        recalculateRequested: 'Neuberechnung angefordert. Ergebnisse erscheinen in Kürze.',
        recalculateFailed: 'Neuberechnung fehlgeschlagen. Bitte versuchen Sie es erneut.',
        effectiveAccessOverview: 'Übersicht der effektiven Zugriffsberechtigungen in der Organisation',
    },
    provisioning: {
        title: 'Zugriffsbereitstellung',
        pageTitle: 'Zugriffsbereitstellung',
        dashboardPageTitle: 'Dashboard | Zugriffsbereitstellung',
        tasksPageTitle: 'Aktive Aufgaben | Zugriffsbereitstellung',
        historyPageTitle: 'Aufgabenhistorie | Zugriffsbereitstellung',
        subtitle: '$t(appConfig.domainEntityTypes.PROVISIONING_TASKS) und Zugriffserledigung überwachen',
        dashboard: 'Dashboard',
        dashboardDesc: 'Übersicht und Statistiken',
        tasks: 'Aktive Aufgaben',
        tasksDesc: 'Ausstehende und laufende Aufgaben anzeigen',
        history: 'Aufgabenhistorie',
        historyDesc: 'Abgeschlossene Aufgaben anzeigen',
        selectOption: '$t(appConfig.domainEntityTypes.PROVISIONING_TASKS) und Status der Zugriffserledigung überwachen.',
        provisioningDashboard: 'Bereitstellungs-Dashboard',
        provisioningDashboardDesc: 'Zugriffsbereitstellungsaufgaben und Erledigungsstatus überwachen',
        processAll: 'Alle verarbeiten',
        processingAll: 'Wird verarbeitet...',
        requeueReady: 'Bereite erneut einreihen',
        requeueing: 'Wird erneut eingereiht...',
        archiveCompleted: 'Abgeschlossene archivieren',
        archiving: 'Wird archiviert...',
        queued: 'In Warteschlange',
        queuedDesc: 'Warten auf Verarbeitung',
        running: 'Laufend',
        runningDesc: 'Wird aktuell verarbeitet',
        failed: 'Fehlgeschlagen',
        failedDesc: 'Erfordert Aufmerksamkeit',
        completed: 'Abgeschlossen',
        completedDesc: 'Bereit zum Archivieren',
        aboutProvisioningTasks: 'Über $t(appConfig.domainEntityTypes.PROVISIONING_TASKS)',
        aboutDesc: 'Den Bereitstellungs-Workflow verstehen',
        taskLifecycle: 'Aufgabenlebenszyklus',
        taskLifecycleQueued: 'IN WARTESCHLANGE',
        taskLifecycleQueuedDesc: 'Aufgabe erstellt, wartet auf Connector',
        taskLifecycleRunning: 'LAUFEND',
        taskLifecycleRunningDesc: 'Connector verarbeitet die Aufgabe',
        taskLifecycleFailed: 'FEHLGESCHLAGEN',
        taskLifecycleFailedDesc: 'Aufgabe fehlgeschlagen, automatischer Neuversuch möglich',
        taskLifecycleDone: 'ERLEDIGT',
        taskLifecycleDoneDesc: 'Aufgabe erfolgreich abgeschlossen',
        actionsTitle: 'Aktionen',
        actionGrant: 'GEWÄHREN',
        actionGrantDesc: 'Zugriff auf $t(appConfig.domainEntityTypes.TARGET_SYSTEM) hinzufügen',
        actionRevoke: 'ENTZIEHEN',
        actionRevokeDesc: 'Zugriff vom $t(appConfig.domainEntityTypes.TARGET_SYSTEM) entfernen',
        actionCreateAccount: 'KONTO ERSTELLEN',
        actionDisableAccount: 'KONTO DEAKTIVIEREN',
        actionEnableAccount: 'KONTO AKTIVIEREN',
        actionDeleteAccount: 'KONTO LÖSCHEN',
        actionUpdateAccount: 'KONTO AKTUALISIEREN',
        actionUpdateAccountDesc: 'Attributänderungen in das $t(appConfig.domainEntityTypes.TARGET_SYSTEM) übertragen',
        dependsOn: 'Abhängig von',
        waitingFor: 'Wartet auf: {{actionType}}',
        blockedWaitingForDependency: 'Blockiert \u2014 wartet auf Abhängigkeit',
        failedToLoadStats: 'Fehler beim Laden der Bereitstellungsstatistiken',
        pendingTasks: 'Ausstehende Aufgaben',
        activeTasks: 'Aktive $t(appConfig.domainEntityTypes.PROVISIONING_TASKS)',
        completedTasks: 'Abgeschlossene Aufgaben',
        failedTasks: 'Fehlgeschlagene Aufgaben',
        totalTasks: 'Aufgaben gesamt',
        taskDetails: 'Aufgabendetails',
        retryTask: 'Wiederholen',
        retrying: 'Wird wiederholt...',
        cancelTask: 'Aufgabe abbrechen',
        cancelling: 'Wird abgebrochen...',
        allTasks: 'Alle $t(appConfig.domainEntityTypes.PROVISIONING_TASKS)',
        filterPlaceholder: '$t(appConfig.domainEntityTypes.IDENTITY) oder Konto suchen...',
        taskCount: '{{count}} Aufgabe(n)',
        taskCount_one: '{{count}} Aufgabe',
        taskCount_other: '{{count}} Aufgaben',
        identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        account: 'Konto',
        entitlement: 'Berechtigung',
        targetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
        action: 'Aktion',
        operation: 'Operation',
        retries: 'Wiederholungen',
        retryCount: 'Wiederholung: {{count}}',
        grant: 'Gewähren',
        revoke: 'Entziehen',
        done: 'Erledigt',
        canceled: 'Abgebrochen',
        allStatuses: 'Alle Status',
        allActions: 'Alle Aktionen',
        allSystems: 'Alle Systeme',
        filterBySystem: 'Nach System filtern...',
        noSystemsFound: 'Keine Systeme gefunden.',
        noTasksMatch: 'Keine Aufgaben entsprechen Ihrem Filter.',
        noTasksFound: 'Keine $t(appConfig.domainEntityTypes.PROVISIONING_TASKS) gefunden.',
        loadingTasks: 'Wird geladen...',
        errorLoading: 'Fehler beim Laden der Aufgaben',
        allHistory: '$t(appConfig.domainEntityTypes.PROVISIONING_TASKS)-Historie',
        historyCount: '{{count}} Historieneintrag/-einträge',
        noHistoryFound: 'Keine Bereitstellungshistorie gefunden.',
        noHistoryMatch: 'Keine Historieneinträge entsprechen Ihrem Filter.',
        loadingHistory: 'Wird geladen...',
        errorLoadingHistory: 'Fehler beim Laden der Historie',
        searchByIdentity: 'Nach Identitätsname suchen...',
        createdAt: 'Erstellt',
        completedAt: 'Abgeschlossen',
        noActiveProvisioningTasks: 'Keine aktiven $t(appConfig.domainEntityTypes.PROVISIONING_TASKS).',
        completedTaskCount: '{{count}} abgeschlossene Aufgabe(n)',
        completedTaskCount_one: '{{count}} abgeschlossene Aufgabe',
        completedTaskCount_other: '{{count}} abgeschlossene Aufgaben',
        matchingFilters: 'entsprechend den Filtern',
        retry: 'Wiederholung:',
        retryQueued: 'Aufgabe zur erneuten $t(appConfig.domainEntityTypes.EXECUTION) eingereiht.',
        retryTriggered: 'Wiederholung ausgelöst.',
        selectFailedTasks: 'Fehlgeschlagene Aufgaben auswählen',
        selectAll: 'Alle fehlgeschlagenen auswählen',
        bulkRetrySelected: '{{count}} ausgewählte wiederholen',
        bulkRetryConfirmTitle: '{{count}} fehlgeschlagene Aufgaben wiederholen?',
        bulkRetryConfirmBody: 'Dadurch werden {{count}} fehlgeschlagene Provisionierungsaufgaben in {{targetSystem}} erneut eingereiht. Jede Aufgabe wird auf QUEUED zurückgesetzt und beim nächsten Verarbeitungslauf aufgenommen.',
        bulkRetryConfirmBodyNoSystem: 'Dadurch werden {{count}} fehlgeschlagene Provisionierungsaufgaben erneut eingereiht. Jede Aufgabe wird auf QUEUED zurückgesetzt und beim nächsten Verarbeitungslauf aufgenommen.',
        bulkRetrySuccess: '{{retried}} Aufgabe(n) eingereiht, {{skipped}} übersprungen.',
        bulkRetrySkippedCount: '{{count}} übersprungen',
        nextRetryAt: 'Nächster Wiederholungszeitpunkt',
        retrySingle: 'Diese Aufgabe wiederholen',
        tasksProcessed: 'Alle Aufgaben erfolgreich verarbeitet.',
        tasksRequeued: 'Bereite Aufgaben erfolgreich erneut eingereiht.',
        tasksArchived: 'Abgeschlossene Aufgaben erfolgreich archiviert.',
        taskDetailPageTitle: 'Aufgabendetails | Zugangsbereitstellung',
        taskDetailTitle: '$t(appConfig.domainEntityTypes.PROVISIONING_TASK)',
        taskDetailSubtitle: 'Details zu diesem Bereitstellungsvorgang',
        taskDetailInfoCard: 'Aufgabeninformationen',
        taskDetailInfoCardDesc: 'Bereitstellungsaktion und Zieldetails',
        taskDetailErrorCard: 'Fehlerdetails',
        taskDetailErrorCardDesc: 'Fehlerinformationen für diese fehlgeschlagene Aufgabe',
        taskDetailTimelineCard: 'Aufgaben-Zeitachse',
        taskDetailTimelineCardDesc: 'Statusänderungen und Ereignisse für diese Aufgabe',
        taskDetailErrorMessage: 'Fehlermeldung',
        taskDetailErrorLog: '$t(appConfig.domainEntityTypes.ERROR_LOG)-Eintrag',
        taskDetailRetryInfo: 'Wiederholung {{count}} von {{max}}',
        taskDetailNotFound: '$t(appConfig.domainEntityTypes.PROVISIONING_TASK) nicht gefunden.',
        taskDetailLoadError: 'Fehler beim Laden der $t(appConfig.domainEntityTypes.PROVISIONING_TASK).',
        taskDetailBack: 'Zurück zu $t(appConfig.domainEntityTypes.PROVISIONING_TASKS)',
        timelineQueued: 'Aufgabe eingereiht',
        timelineStarted: 'Aufgabe gestartet',
        timelineFailed: 'Aufgabe fehlgeschlagen',
        timelineCompleted: 'Aufgabe abgeschlossen',
        timelineRetry: 'Wiederholungsversuch {{count}}',
        timelineCreatedAt: 'Erstellt',
        timelineUpdatedAt: 'Zuletzt aktualisiert',
        statusQueued: 'In Warteschlange',
        statusInProgress: 'In Bearbeitung',
        statusSuccess: 'Erfolgreich',
        statusFailed: 'Fehlgeschlagen',
        statusRunning: 'Läuft',
        historySearchPlaceholder: '$t(appConfig.domainEntityTypes.IDENTITY), System oder Berechtigung suchen ...',
        historyMinQHint: 'Geben Sie mindestens 3 Zeichen ein, um zu suchen.',
        historySearchScopeHint: 'Die Suche durchsucht nur Anzeigenamen \u2014 die diagnostische Fehlerspalte wird ausgeschlossen.',
    },
    profile: {
        title: 'Mein Profil',
        pageTitle: 'Profil',
        subtitle: 'Ihre Kontoinformationen und Einstellungen',
        personalInfo: 'Persönliche Informationen',
        email: 'E-Mail',
        fullName: 'Vollständiger Name',
        username: 'Benutzername',
        roles: '$t(appConfig.domainEntityTypes.ROLES)',
        permissions: 'Berechtigungen',
        noPermissions: 'Keine Berechtigungen zugewiesen.',
        userProfile: 'Benutzerprofil',
        accountInfo: 'Ihre Kontoinformationen von Keycloak',
        basicInfo: 'Grundlegende Informationen',
        accountDetails: 'Ihre Kontodetails',
        authUserId: 'Auth-Benutzer-ID',
        displayName: 'Anzeigename',
        notProvided: 'Nicht angegeben',
        iamIdentity: 'IAM-$t(appConfig.domainEntityTypes.IDENTITY)',
        linkedIdentity: 'Ihre verknüpfte IAM-$t(appConfig.domainEntityTypes.IDENTITY)',
        identityId: 'Identitäts-ID',
        linked: 'Verknüpft',
        viewIdentityDetails: 'Identitätsdetails anzeigen',
        noIdentityLinked: 'Keine IAM-$t(appConfig.domainEntityTypes.IDENTITY) mit diesem Konto verknüpft.',
        contactAdmin: 'Kontaktieren Sie Ihren Administrator, um eine $t(appConfig.domainEntityTypes.IDENTITY) für Ihre E-Mail-Adresse zu erstellen.',
        rolesAndPermissions: '$t(appConfig.domainEntityTypes.ROLES) & Berechtigungen',
        rolesAndPermissionsDesc: 'Ihre zugewiesenen $t(appConfig.domainEntityTypes.ROLES) und Berechtigungen',
        sessionInfo: 'Sitzungsinformationen',
        sessionDetails: 'Details der aktuellen Authentifizierungssitzung',
        sessionStatus: 'Sitzungsstatus',
        authMethod: 'Authentifizierungsmethode',
        authMethodDesc: 'HTTP-Sitzung mit HTTP-only Cookies (Keycloak OIDC)',
        showPermissions: 'Berechtigungen anzeigen',
        hidePermissions: 'Berechtigungen ausblenden',
        resource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        permissionCount: '{{count}} Berechtigung(en)',
    },
    impersonation: {
        impersonating: 'Identitätswechsel aktiv',
        originalUser: 'Ursprünglicher Benutzer:',
        switchBack: 'Zurückwechseln',
        switchUser: 'Benutzer wechseln',
        switchUserDescription: 'Wechseln Sie zu einem anderen Benutzer, um dessen Zugriff zu testen.',
        switchUserDialogDescription: 'Wählen Sie einen Benutzer zum Wechseln aus. Ihre Sitzung übernimmt dessen $t(appConfig.domainEntityTypes.IDENTITY) und Berechtigungen.',
        selectUser: 'Benutzer auswählen',
        searchPlaceholder: 'Nach Name oder E-Mail suchen...',
        searchUsers: 'Benutzer suchen...',
        switching: 'Wird gewechselt...',
        switch: 'Wechseln',
        noUsersFound: 'Keine Benutzer gefunden',
        switchToUser: 'Zu {{name}} wechseln?',
        switchConfirmDescription: 'Sie übernehmen die $t(appConfig.domainEntityTypes.IDENTITY) und Berechtigungen von {{name}} ({{email}}). Sie können jederzeit über das Banner oben auf der Seite zurückwechseln.',
        impersonatingSuffix: '({{email}}) \u2014 Ursprünglicher Benutzer: {{originalName}}',
    },
    timeSwitch: {
        serverTime: 'Serverzeit',
        clockOverridden: 'Uhr ist überschrieben',
        setTime: 'Zeit setzen',
        quickAdvance: 'Schnellvorlauf',
        plusOneDay: '+1 Tag',
        plusSevenDays: '+7 Tage',
        plusThirtyDays: '+30 Tage',
        resetToSystemTime: 'Auf Systemzeit zurücksetzen',
        timeSwitch: 'Zeitschalter',
    },
    auth: {
        loopBreak: {
            title: 'Authentifizierungsschleife erkannt',
            description: 'Die App leitet wiederholt zur Anmeldung weiter, ohne Erfolg. Dies bedeutet normalerweise, dass Ihre Sitzung nicht hergestellt werden konnte.',
            tryAgain: 'Erneut versuchen',
            logoutFully: 'Vollständig abmelden',
        },
    },
    serverStatus: {
        serverUnavailable: 'Server nicht verfügbar',
        serverUnavailableMessage: 'Der Backend-Server ist derzeit nicht verfügbar. Dies kann an einem Neustart oder einer Wartung liegen.',
        retrying: 'Wird erneut versucht...',
        retry: 'Jetzt erneut versuchen',
        lastChecked: 'Zuletzt geprüft:',
        checkingConnection: 'Verbindung wird geprüft...',
        waitingForServer: 'Warten auf Server...',
        autoReconnect: 'Die Seite wird automatisch neu verbunden, wenn der Server verfügbar ist.',
    },
    executionLog: {
        executionLogs: 'Ausführungs-Logs: {{name}}',
        executionLog: 'Ausführungs-Log',
        noLogs: 'Keine Logs verfügbar',
        logEntries: '{{count}} Log-Einträge',
        download: 'Herunterladen',
        timestamp: 'Zeitstempel',
        level: 'Stufe',
        message: 'Nachricht',
        filterLogs: 'Logs filtern...',
        showAll: 'Alle',
        showErrors: 'Fehler',
        showWarnings: 'Warnungen',
        autoScroll: 'Automatisches Scrollen',
    },
    accessTimeline: {
        timeline: 'Zugriffszeitachse',
        effectiveDate: 'Gültigkeitsdatum',
        change: 'Änderung',
        source: 'Quelle',
        noTimelineData: 'Keine Zeitachsendaten verfügbar.',
        loadingTimeline: 'Zeitachse wird geladen...',
        viewDetails: 'Details anzeigen',
        noAccessHistory: 'Keine Zugriffshistorie gefunden',
        by: 'von {{name}}',
        sourceLabel: 'Quelle: {{name}}',
    },
    expressionEditor: {
        expression: 'Ausdruck',
        placeholder: 'Ausdruck eingeben...',
        validate: 'Validieren',
        validating: 'Wird validiert...',
        valid: 'Gültiger Ausdruck',
        invalid: 'Ungültiger Ausdruck',
        field: 'Feld',
        operator: 'Operator',
        value: 'Wert',
        addCondition: 'Bedingung hinzufügen',
        removeCondition: 'Entfernen',
        and: 'UND',
        or: 'ODER',
        keyTab: 'Tab',
        keyEsc: 'Esc',
        keyCtrlZ: 'Strg+Z',
        keyCtrlShiftZ: 'Strg+Umschalt+Z',
        tabAccept: 'Vorschlag übernehmen',
        escDismiss: 'Verwerfen',
        ctrlZUndo: 'Rückgängig',
        ctrlShiftZRedo: 'Wiederherstellen',
        identityAttributeHint: 'Attributnamen eingeben (z. B. department)',
        partyAttributeHint: 'Attributnamen eingeben',
    },
    attributeValidation: {
        minLength: '{{name}} muss mindestens {{min}} Zeichen lang sein',
        maxLength: '{{name}} darf höchstens {{max}} Zeichen lang sein',
        pattern: '{{name}} entspricht nicht dem erforderlichen Format',
        minValue: '{{name}} muss mindestens {{min}} betragen',
        maxValue: '{{name}} darf höchstens {{max}} betragen',
        allowedValues: '{{name}} muss einer der folgenden Werte sein: {{values}}',
        invalidNumber: '{{name}} muss eine gültige Zahl sein',
        invalidPattern: '{{name}} kann nicht validiert werden (ungültige Musterkonfiguration)',
        hintCharRange: '{{min}}\u2013{{max}} Zeichen',
        hintCharExact: 'Genau {{n}} Zeichen',
        hintCharMin: 'Mindestens {{min}} Zeichen',
        hintCharMax: 'Höchstens {{max}} Zeichen',
        hintRange: 'Bereich: {{min}}\u2013{{max}}',
        hintMin: 'Minimum: {{min}}',
        hintMax: 'Maximum: {{max}}',
        hintPattern: 'Format: {{pattern}}',
        hintLabelLength: 'Länge',
        hintLabelRange: 'Bereich',
        hintLabelPattern: 'Muster',
        hintLabelMaxValues: 'Max. Werte',
        patternUppercaseLetter: 'Großbuchstabe',
        patternLowercaseLetter: 'Kleinbuchstabe',
        patternDigit: 'Ziffer',
        patternWordChar: 'Wortzeichen',
        patternSpace: 'Leerzeichen',
        patternLetter: 'Buchstabe',
        patternLetterOrDigit: 'Buchstabe oder Ziffer',
        patternUppercaseOrDigit: 'Großbuchstabe oder Ziffer',
        patternLetterDigitUnderscore: 'Buchstabe, Ziffer oder Unterstrich',
        patternLetterDigitUnderscoreDash: 'Buchstabe, Ziffer, Unterstrich oder Bindestrich',
        patternUppercaseDigitUnderscore: 'Großbuchstabe, Ziffer oder Unterstrich',
        patternUppercaseDigitUnderscoreDash: 'Großbuchstabe, Ziffer, Unterstrich oder Bindestrich',
        patternAnyChar: 'beliebiges Zeichen',
        patternOneOrMore: 'ein oder mehr',
        patternZeroOrMore: 'null oder mehr',
        patternOptional: 'optional',
        maxOccurrences: '{{name}} erlaubt höchstens {{max}} Werte',
        hintMultiValue: 'Bis zu {{max}} Werte',
    },
    durationInput: {
        days: 'Tage',
        hours: 'Stunden',
        minutes: 'Minuten',
        seconds: 'Sekunden',
        invalidFormat: 'Ungültiges Format. Verwenden Sie: 2h, 30m, 1h30m oder 45s',
        examples: 'Beispiele: 2h, 30m, 1h30m, 45s',
    },
    combobox: {
        searchPlaceholder: 'Suchen...',
        noResults: 'Keine Ergebnisse gefunden.',
        select: 'Auswählen...',
        typeToSearch: 'Zum Suchen tippen...',
    },
    accessSnapshot: {
        loadingAccessState: 'Zugriffsstatus wird geladen...',
        failedToLoad: 'Fehler beim Laden des Zugriffsstatus',
        noAccessGrants: 'Keine Zugriffsberechtigungen zu diesem Zeitpunkt',
        grantsActive: '{{count}} Berechtigung(en) zu diesem Zeitpunkt aktiv',
        grantCount: '{{count}} Berechtigung(en)',
    },
    identitySnapshot: {
        loadingIdentityState: 'Identitätsstatus wird geladen...',
        failedToLoad: 'Fehler beim Laden des Identitätsstatus',
        noIdentityState: 'Kein Identitätsstatus verfügbar',
        identityState: 'Identitätsstatus',
        identityType: 'Identitätstyp',
        lifecycleState: 'Lebenszyklus-Status',
        party: '$t(appConfig.domainEntityTypes.PARTY)',
        identifiers: 'Kennungen',
        attributes: 'Attribute',
        noIdentifiersOrAttributes: 'Keine Kennungen oder Attribute zu diesem Zeitpunkt',
    },
    timelineDetail: {
        stateAt: 'Status zum Zeitpunkt {{timestamp}}',
        accessState: 'Zugriffsstatus',
        identityState: 'Identitätsstatus',
    },
    brandTheme: {
        lumon: 'Lumon Industries',
        swiss: 'Swiss Admin',
        muenchenstift: 'MÜNCHENSTIFT',
        bundesdruckerei: 'Bundesdruckerei',
        aargau: 'Kanton Aargau',
        default: 'ID Pulse',
    },
    reporting: {
        title: 'Reporting & Audit',
        pageTitle: 'Reporting',
        subtitle: 'SQL-basierte Berichte und Compliance-Berichte',
        welcome: 'Willkommen im Reporting',
        selectOption: 'Wählen Sie eine Kategorie oder einen Bericht aus der Seitenleiste.',
        categories: 'Berichtskategorien',
        categoriesDesc: 'Berichtskategorien',
        newReport: 'Bericht erstellen',
        noCategories: 'Noch keine Kategorien.',
        noReports: 'Keine Berichte in dieser Kategorie.',
        resultRows: '{{count}} Zeile',
        resultRows_other: '{{count}} Zeilen',
        runReport: 'Bericht ausführen',
        saveReport: 'Bericht speichern',
        reportSaved: 'Bericht gespeichert',
        trySql: 'SQL testen',
        running: 'Wird ausgeführt...',
        runError: 'Berichtsausführung fehlgeschlagen',
        saveReportDialog: {
            title: 'Bericht speichern',
            name: 'Berichtsname',
            description: 'Beschreibung (optional)',
            category: 'Kategorie',
            save: 'Speichern',
        },
        createCategory: 'Kategorie erstellen',
        createCategoryDialog: {
            title: 'Kategorie erstellen',
            name: 'Kategoriename',
            description: 'Beschreibung (optional)',
            type: '$t(appConfig.domainEntityTypes.TYPE)',
            typeGlobal: 'Global (mit allen Benutzern geteilt)',
            typePersonal: 'Persönlich (nur für Sie sichtbar)',
        },
        exportSuccess: 'Export heruntergeladen',
        categoryCreated: 'Kategorie erstellt',
        categoryDeleted: 'Kategorie gelöscht',
        categoryUpdated: 'Kategorie aktualisiert',
        categoryTransferred: 'Kategorie übertragen',
        categoryMoved: 'Kategorie verschoben',
        reportDeleted: 'Bericht gelöscht',
        reportUpdated: 'Bericht aktualisiert',
        reportMoved: 'Bericht verschoben',
        reportsBulkDeleted: 'Berichte gelöscht',
        reportsBulkMoved: 'Berichte verschoben',
        reportCount: '{{count}} Bericht',
        reportCount_other: '{{count}} Berichte',
        reportsLabel: 'Berichte',
        categoryCount: '{{count}} Kategorie',
        categoryCount_other: '{{count}} Kategorien',
        allTypes: 'Alle',
        typeGlobal: 'Global',
        typePersonal: 'Persönlich',
        lastModified: 'Zuletzt geändert',
        author: 'Autor',
        noCategoriesMatch: 'Keine Kategorien entsprechen Ihrer Suche.',
        noReportsMatch: 'Keine Berichte entsprechen Ihrer Suche.',
        renameCategory: 'Umbenennen',
        transferCategory: 'Übertragen',
        moveCategory: 'Verschieben',
        deleteCategory: 'Kategorie löschen',
        deleteCategoryConfirm: '„{{name}}" und alle enthaltenen Berichte werden dauerhaft gelöscht.',
        transferCategoryDialog: {
            title: 'Kategorie übertragen',
            description: 'Ändern Sie die Sichtbarkeit dieser Kategorie.',
            toGlobal: 'Global machen (für alle Benutzer sichtbar)',
            toPersonal: 'Persönlich machen (nur für Sie sichtbar)',
        },
        renameDialog: {
            title: 'Kategorie umbenennen',
            description: 'Name und Beschreibung der Kategorie aktualisieren.',
        },
        moveCategoryDialog: {
            title: 'Kategorie verschieben',
            description: 'Diese Kategorie unter eine andere verschieben oder auf die Hauptebene.',
            targetParent: 'Übergeordnete Kategorie',
        },
        parentCategory: 'Übergeordnete Kategorie (optional)',
        noParent: 'Keine (Hauptebene)',
        editReportDialog: {
            title: 'Bericht bearbeiten',
            description: 'Name und Beschreibung des Berichts aktualisieren.',
        },
        moveReportDialog: {
            title: 'Bericht verschieben',
            description: 'Diesen Bericht in eine andere Kategorie verschieben.',
            targetCategory: 'Zielkategorie',
        },
        searchCategories: 'Kategorien',
        searchReports: 'Berichte',
        reportSearchResults: '{{count}} Berichtsergebnis',
        reportSearchResults_other: '{{count}} Berichtsergebnisse',
        reportSearchPlaceholder: 'Berichte in allen Kategorien suchen...',
        categorySearchPlaceholder: 'Kategorien nach Name suchen...',
        allSearchPlaceholder: 'Kategorien und Berichte suchen...',
        reportDetail: {
            pageTitle: 'Berichtsdetails | Reporting',
            category: 'Kategorie',
            lastRun: 'Letzter Lauf',
            neverRun: 'Noch nie ausgeführt',
            results: 'Ergebnisse',
            noResults: 'Führen Sie den Bericht aus, um Ergebnisse zu sehen.',
            editReport: 'Bericht bearbeiten',
            deleteReport: 'Löschen',
            deleteConfirm: 'Der Bericht „{{name}}" wird dauerhaft gelöscht.',
            loadingReport: 'Bericht wird geladen...',
            truncatedBanner: 'Weitere Zeilen vorhanden, zeige die ersten {{shown}}.',
            createTitle: 'Bericht erstellen',
            createParameterHintPrefix: 'Um den Report zu parametrisieren, bitte zuerst',
            createParameterHintLink: 'speichern',
            createParameterHintSuffix: '.',
        },
        parameters: {
            title: 'Parameter',
            add: 'Hinzufügen',
            addPlaceholder: 'Parametername (z.B. state)',
        },
        assist: {
            title: 'KI SQL-Assistent',
            suggestSql: 'SQL vorschlagen',
            suggesting: 'Wird vorgeschlagen...',
            apply: 'Vorschlag anwenden',
            placeholder: 'Beschreiben Sie, was Sie abfragen möchten...',
            fixPrefix: 'Diesen Fehler beheben',
            fixWithAi: 'Mit KI beheben',
            unsaved: 'Ungespeicherte Änderungen',
        },
        searchAll: 'Alle',
        collapseAll: 'Alle einklappen',
        schedule: {
            title: 'Zeitplan',
            description: 'Diesen Bericht wiederkehrend ausführen und die Ergebnisse an Empfänger zustellen.',
            preset: 'Voreinstellung',
            presetNone: 'Keiner',
            presetDaily: 'Täglich',
            presetWeekly: 'Wöchentlich',
            presetMonthly: 'Monatlich',
            presetCustom: 'Benutzerdefiniert',
            daysOfWeek: 'Wochentage',
            dayMon: 'Mo',
            dayTue: 'Di',
            dayWed: 'Mi',
            dayThu: 'Do',
            dayFri: 'Fr',
            daySat: 'Sa',
            daySun: 'So',
            dayOfMonth: 'Tag des Monats',
            rawCron: 'Cron-Ausdruck',
            rawCronHint: 'Sechs Felder: Sekunde Minute Stunde Tag-des-Monats Monat Wochentag',
            nextRun: 'Nächste [[Ausführung]]',
            nextRunUnset: '—',
            invalidCron: 'Ungültiger Cron-Ausdruck',
            recipients: 'Empfänger',
            recipientIdentities: 'Identitätsempfänger',
            recipientIdentitiesPlaceholder: '[[Identitäten]] nach Name suchen…',
            recipientIdentitiesEmpty: 'Keine Identitätsempfänger ausgewählt.',
            recipientEmails: 'E-Mail-Empfänger',
            emailPlaceholder: 'E-Mail-Adresse eingeben und Eingabetaste drücken',
            invalidEmail: 'Ungültige E-Mail-Adresse',
            emailRejectedSummary: '{{count}} Adresse als ungültig verworfen.',
            emailRejectedSummary_other: '{{count}} Adressen als ungültig verworfen.',
            notificationTemplate: 'Benachrichtigungsvorlage',
            defaultTemplate: 'Standard — Bericht zugestellt',
            removeRecipient: 'Entfernen',
            unsavedSchedule: 'Speichern, um Zeitplanänderungen zu übernehmen.',
            noSchedule: 'Kein Zeitplan konfiguriert.',
            noRecipients: 'Keine Empfänger konfiguriert.',
            identityRecipientCount: '{{count}} Identitätsempfänger',
            identityRecipientCount_other: '{{count}} Identitätsempfänger',
        },
    },
    notifications: {
        pageTitle: '$t(appConfig.domainEntityTypes.NOTIFICATIONS)',
        title: '$t(appConfig.domainEntityTypes.NOTIFICATIONS)',
        subtitle: 'Ihre Benachrichtigungshistorie',
        bellTooltip: '$t(appConfig.domainEntityTypes.NOTIFICATIONS)',
        markAllRead: 'Alle als gelesen markieren',
        viewAll: 'Alle $t(appConfig.domainEntityTypes.NOTIFICATIONS) anzeigen',
        noNotifications: 'Noch keine $t(appConfig.domainEntityTypes.NOTIFICATIONS).',
        noNotificationsMatch: 'Keine $t(appConfig.domainEntityTypes.NOTIFICATIONS) entsprechen den aktuellen Filtern.',
        notificationCount: '{{count}} $t(appConfig.domainEntityTypes.NOTIFICATION)',
        notificationCount_other: '{{count}} $t(appConfig.domainEntityTypes.NOTIFICATIONS)',
        unreadCount: '{{count}} ungelesen',
        matchingFilters: '(gefiltert)',
        // Column headers
        title_column: 'Titel',
        message: 'Nachricht',
        eventType: 'Ereignistyp',
        date: 'Datum',
        readStatus: 'Status',
        read: 'Gelesen',
        unread: 'Ungelesen',
        // Filters
        allEventTypes: 'Alle Ereignistypen',
        allReferenceTypes: 'Alle Referenztypen',
        allStatuses: 'Alle Status',
        filterPlaceholder: '$t(appConfig.domainEntityTypes.NOTIFICATIONS) suchen...',
        // Event types
        eventAccessRequestCreated: 'Zugriffsanfrage erstellt',
        eventAccessRequestApproved: 'Zugriffsanfrage genehmigt',
        eventAccessRequestRejected: 'Zugriffsanfrage abgelehnt',
        eventAccessRequestCancelled: 'Zugriffsanfrage storniert',
        eventAccessProfileAssignmentGranted: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) erteilt',
        eventAccessProfileAssignmentGrantedByRule: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) per Regel erteilt',
        eventAccessProfileAssignmentRevoked: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) entzogen',
        eventAccessProfileAssignmentRestored: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) wiederhergestellt',
        eventFunctionGroupRequestCreated: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Anfrage erstellt',
        eventFunctionGroupRequestApproved: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Anfrage genehmigt',
        eventFunctionGroupRequestRejected: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Anfrage abgelehnt',
        eventFunctionGroupRequestCancelled: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Anfrage storniert',
        eventFunctionGroupAssignmentGranted: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP) erteilt',
        eventFunctionGroupAssignmentGrantedByRule: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP) per Regel erteilt',
        eventFunctionGroupAssignmentRevoked: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP) entzogen',
        eventFunctionGroupAssignmentRestored: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP) wiederhergestellt',
        eventAccessProfileAssignmentExpiring: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE) läuft bald ab',
        eventFunctionGroupAssignmentExpiring: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP) läuft bald ab',
        eventIdentitySuspended: '$t(appConfig.domainEntityTypes.IDENTITY) gesperrt',
        eventIdentityTerminated: '$t(appConfig.domainEntityTypes.IDENTITY) beendet',
        eventProvisioningFailed: 'Provisionierung fehlgeschlagen',
        eventCertificationCampaignStarted: 'Rezertifizierungskampagne gestartet',
        eventCertificationItemPending: 'Rezertifizierungsprüfung ausstehend',
        eventCertificationItemOverdue: 'Rezertifizierungsprüfung überfällig',
        eventCertificationCampaignCompleted: 'Rezertifizierungskampagne abgeschlossen',
        eventReportDelivered: 'Bericht zugestellt',
        // Admin log
        adminLogTitle: 'Benachrichtigungsprotokoll',
        adminLogPageTitle: 'Benachrichtigungsprotokoll',
        adminLogSubtitle: 'Systemweites Protokoll der Benachrichtigungszustellung',
        adminLogDescription: 'Zustellstatus der $t(appConfig.domainEntityTypes.NOTIFICATIONS) überwachen',
        recipient: 'Empfänger',
        deliveryStatus: 'Zustellstatus',
        error: 'Fehler',
        sentAt: 'Gesendet am',
        statusSent: 'Gesendet',
        statusPending: 'Ausstehend',
        statusFailed: 'Fehlgeschlagen',
        // Detail page
        detailPageTitle: 'Benachrichtigungsdetails',
        detailTitle: 'Benachrichtigungsdetails',
        detailDescription: 'Vollständige Details dieser $t(appConfig.domainEntityTypes.NOTIFICATION)',
        referenceType: 'Referenztyp',
        referenceId: 'Referenz-ID',
        goToReference: 'Zur referenzierten Entität',
        loadingNotification: '$t(appConfig.domainEntityTypes.NOTIFICATION) wird geladen...',
        referenceTypeAccessRequest: 'Zugriffsanfrage',
        referenceTypeAccessProfileAssignment: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE)-Zuweisung',
        referenceTypeFunctionGroupRequest: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Anfrage',
        referenceTypeFunctionGroupAssignment: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuweisung',
        referenceTypeIdentity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        referenceTypeProvisioningTask: 'Provisionierungsaufgabe',
    },
    errorCodes: {
        GN0001: 'Diese $t(appConfig.domainEntityTypes.RESOURCE) wurde geändert. Bitte aktualisieren und erneut versuchen.',
        GN0002: '{{entity}} nicht gefunden.',
        GN0003: 'Zugriff verweigert.',
        SESSION_EXPIRED: 'Ihre Sitzung ist abgelaufen — bitte erneut anmelden.',
        SERVER_UNAVAILABLE: 'Server nicht erreichbar — bitte gleich erneut versuchen.',
        UNAUTHORIZED: 'Ihre Sitzung ist abgelaufen — bitte erneut anmelden.',
        GN0005: '{{entity}} existiert bereits.',
        GN0007: 'Berechtigung verweigert: {{action}} {{resource}} nicht erlaubt.',
        VS0001: 'Validierungsregel \'{{rule}}\' ist für den Wertetyp {{valueType}} nicht anwendbar.',
        VS0003: 'Validierungsregel \'{{rule}}\': {{detail}}.',
        VS0004: 'Validierungsregeln stehen in Konflikt: {{conflict}}.',
        VS0005: 'Validierungsregel \'{{rule}}\': muss eine positive Ganzzahl sein.',
        VS0006: 'Validierungsregel \'{{rule}}\': muss größer als 0 sein.',
        VS0007: 'Validierungsregel \'{{rule}}\': ungültiger regulärer Ausdruck: {{description}}.',
        VS0008: 'Validierungsregel \'{{rule}}\': LIST benötigt eine nicht-leere $t(appConfig.domainEntityTypes.VALUE_LIST).',
        VS0009: 'Validierungsregel \'{{rule}}\': LIST-Eintragscode darf nicht leer sein.',
        VS0010: 'Validierungsregel \'{{rule}}\': LIST-Eintragsbezeichnung darf nicht leer sein.',
        VS0011: 'Validierungsregel \'{{rule}}\': LIST-Eintragscodes müssen eindeutig sein, Duplikat: {{duplicate}}.',
        VS0012: 'Validierungsregel \'{{rule}}\': ENUM benötigt einen Typnamen.',
        VS0013: 'Validierungsregel \'{{rule}}\': unbekannter Typ \'{{typeName}}\'.',
        VS0014: 'Validierungsregel \'{{rule}}\': CUSTOM_LIST benötigt einen Listennamen.',
        VS0015: 'Validierungsregel \'{{rule}}\': Eindeutigkeitsbeschränkung wird nur für STRING-Attribute unterstützt.',
        VS0016: 'Validierungsregel \'{{rule}}\': Eindeutigkeitsbeschränkung ist für mehrwertige Attribute nicht erlaubt.',
        VS0017: 'Validierungsregel \'{{rule}}\': Eindeutigkeitsbeschränkung ist mit Wertequelle nicht erlaubt.',
        TM0001: 'Der Teamleiter muss eine Person sein.',
        TM0002: 'Ein Team kann nicht Mitglied seiner selbst sein.',
        TM0003: 'Diese $t(appConfig.domainEntityTypes.PARTY) ist bereits Mitglied dieses Teams.',
        TM0004: 'Die ausgewählte $t(appConfig.domainEntityTypes.PARTY) ist kein Team.',
        TM0005: 'Team mit aktiven Verantwortlichkeiten kann nicht gelöscht werden.',
        TM0006: 'Mitgliedschaft nicht gefunden.',
    },
    schemaPolicies: {
        title: 'Schema-Policies',
        pageTitle: 'Schema-Policies | Schema',
        detailPageTitle: 'Schema-Policy | Schema',
        createPageTitle: 'Schema-Policy anlegen | Schema',
        subtitle: 'Regeln für gültige IAM-Datenstrukturen',
        allPolicies: 'Alle Schema-Policies',
        policiesCount: '{{count}} Policies',
        policiesCount_one: '{{count}} Policy',
        policiesCount_other: '{{count}} Policies',
        loadingPolicies: 'Schema-Policies werden geladen...',
        noPoliciesFound: 'Noch keine Schema-Policies definiert.',
        noPoliciesMatch: 'Keine Schema-Policies entsprechen den Filtern.',
        searchPolicies: 'Schema-Policies suchen...',
        createPolicy: 'Schema-Policy anlegen',
        editPolicy: 'Schema-Policy bearbeiten',
        createFirstPolicy: 'Die erste Schema-Policy anlegen',
        name: 'Name',
        description: 'Beschreibung',
        type: '$t(appConfig.domainEntityTypes.TYPE)',
        typeDsl: 'DSL',
        typeNativeCode: 'Native Code',
        severity: 'Schweregrad',
        expression: 'Ausdruck',
        constraintCode: 'Producer-Code',
        messageTemplate: 'Meldungsvorlage',
        enabled: 'Aktiv',
        evalStatus: 'Status',
        evalStatusStale: 'Referenz fehlt',
        openViolations: 'Offene Verstöße',
        lastReviewed: 'Zuletzt geprüft',
        lastReviewedNever: 'Nie',
        owner: 'Verantwortlich',
        version: 'Version',
        actionEnable: 'Aktivieren',
        actionDisable: 'Deaktivieren',
        actionReview: 'Als geprüft markieren',
        actionTrigger: 'Bedarfsweise ausführen',
        severityInfo: 'INFO',
        severityWarn: 'WARNUNG',
        severityError: 'FEHLER',
        severityCritical: 'KRITISCH',
        messageTemplatePlaceholder: '{constraintName} verletzt durch {subjectId}',
    },
    schemaViolations: {
        title: 'Schema-Verstöße',
        pageTitle: 'Schema-Verstöße | Schema',
        detailPageTitle: 'Schema-Verstoß | Schema',
        allViolations: 'Alle Schema-Verstöße',
        violationsCount: '{{count}} Verstöße',
        violationsCount_one: '{{count}} Verstoß',
        violationsCount_other: '{{count}} Verstöße',
        loadingViolations: 'Schema-Verstöße werden geladen...',
        noViolationsFound: 'Keine Schema-Verstöße gefunden.',
        noViolationsMatch: 'Keine Schema-Verstöße entsprechen den Filtern.',
        searchViolations: 'Schema-Verstöße suchen...',
        policy: 'Policy',
        detectedAt: 'Erkannt am',
        severity: 'Schweregrad',
        status: 'Status',
        statusOpen: 'Offen',
        statusAcked: 'Bestätigt',
        statusResolved: 'Behoben',
        message: 'Meldung',
        ackedBy: 'Bestätigt durch',
        ackedAt: 'Bestätigt am',
        resolvedAt: 'Behoben am',
        actionAck: 'Bestätigen',
        bulkAck: 'Massenbestätigung',
        toggleAll: 'Alle Verstöße umschalten',
        selectRow: 'Verstoß auswählen',
        severityBadgeLabel: 'Schemaverletzungen',
        noOpenViolations: 'Keine Verletzungen',
        referenceBroken: 'Referenz gebrochen',
        viewViolations: 'Verletzungen anzeigen',
        severityCritical: 'KRITISCH',
        severityError: 'FEHLER',
        severityWarn: 'WARNUNG',
        severityInfo: 'INFO',
        severityCountCritical: '{{count}} KRITISCH',
        severityCountError: '{{count}} FEHLER',
        severityCountWarn: '{{count}} WARNUNG',
        ackSubmitError: 'Bestätigung fehlgeschlagen — bitte erneut versuchen.',
    },
    certificationPolicies: {
        title: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICIES)',
        pageTitle: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICIES) | Access Governance',
        detailPageTitle: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) Details | Access Governance',
        createPageTitle: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) erstellen | Access Governance',
        subtitle: 'Zertifizierungs-Review-Richtlinien verwalten',
        allPolicies: 'Alle $t(appConfig.domainEntityTypes.CERTIFICATION_POLICIES)',
        policiesCount: '{{count}} Richtlinien',
        loadingPolicies: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICIES) werden geladen...',
        loadingPolicy: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) wird geladen...',
        noPoliciesFound: 'Keine $t(appConfig.domainEntityTypes.CERTIFICATION_POLICIES) gefunden.',
        searchPolicies: 'Richtlinien suchen...',
        noPoliciesMatch: 'Keine Richtlinien entsprechen Ihren Filtern.',
        allStatuses: 'Alle Status',
        createPolicy: 'Richtlinie erstellen',
        editPolicy: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) bearbeiten',
        createNewPolicy: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) erstellen',
        name: 'Name',
        description: 'Beschreibung',
        priority: 'Priorität',
        priorityPlaceholder: 'z.B. 10',
        priorityHelp: 'Niedrigere Werte werden zuerst ausgewertet (1 = höchste Priorität)',
        reviewFrequencyDaysPlaceholder: 'z.B. 90',
        gracePeriodDaysPlaceholder: 'z.B. 14',
        conditions: 'Bedingungen',
        conditionsCount: '{{count}} Bedingung',
        conditionsCount_other: '{{count}} Bedingungen',
        frequency: 'Häufigkeit',
        frequencyDays: '{{days}} Tage',
        noFrequency: 'Profil-Standard',
        defaultBadge: 'Standard',
        active: 'Aktiv',
        policyDetails: 'Richtliniendetails',
        policyDetailsDesc: 'Grundkonfiguration dieser $t(appConfig.domainEntityTypes.CERTIFICATION_POLICY)',
        parameters: 'Parameter',
        parametersDesc: 'Review- und Antwortparameter',
        reviewFrequencyDays: 'Review-Häufigkeit (Tage)',
        overrideReviewFrequency: 'Review-Häufigkeit des Profils überschreiben',
        overrideReviewFrequencyDescription: 'Verwendet eine benutzerdefinierte Review-Häufigkeit anstelle des eigenen Review-Zyklus jedes Zugriffsprofils.',
        useProfileFrequency: 'Verwendet die eigene Review-Häufigkeit jedes Zugriffsprofils, um zu bestimmen, wann Zuweisungen fällig sind.',
        reviewerType: 'Prüfer-$t(appConfig.domainEntityTypes.TYPE)',
        gracePeriodDays: 'Nachfrist (Tage)',
        nonResponseAction: 'Aktion bei Nichtantwort',
        autoRevokeOnOverdue: 'Automatisch widerrufen bei Überfälligkeit',
        campaignOwner: 'Kampagneneigentümer',
        campaignOwnerDesc: 'Optionale $t(appConfig.domainEntityTypes.IDENTITY), die als Kampagneneigentümer verwendet wird, wenn $t(appConfig.domainEntityTypes.CAMPAIGNS) aus dieser Richtlinie generiert werden. Wenn nicht gesetzt, wird der globale Fallback verwendet.',
        searchOwner: 'Eigentümer-$t(appConfig.domainEntityTypes.IDENTITY) suchen...',
        noIdentitiesFound: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) gefunden',
        reviewerTypeProfileOwner: 'Profileigentümer',
        reviewerTypeResourceOwner: 'Ressourceneigentümer',
        reviewerTypeManager: 'Manager',
        nonResponseNoChange: 'Keine Änderung',
        nonResponseAutoRevoke: 'Automatisch widerrufen',
        nonResponseEscalate: 'Eskalieren',
        policySaved: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) gespeichert.',
        policyCreated: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) erstellt.',
        policyDeleted: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) gelöscht.',
        deletePolicy: 'Richtlinie löschen',
        deleteConfirm: 'Möchten Sie die $t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) "{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        saveError: 'Fehler beim Speichern der $t(appConfig.domainEntityTypes.CERTIFICATION_POLICY).',
        nameRequired: 'Name ist erforderlich.',
        priorityRequired: 'Priorität ist erforderlich.',
        conditionsDesc: 'Definieren Sie, wann diese Richtlinie basierend auf Kriterien angewendet wird',
        addCondition: 'Bedingung hinzufügen',
        noConditions: 'Keine Bedingungen definiert. Diese Richtlinie gilt für alle Zugriffszuweisungen.',
        conditionField: 'Feld',
        conditionOperator: 'Operator',
        conditionValue: 'Wert',
        conditionValuePlaceholder: 'Wert eingeben...',
        removeCondition: 'Bedingung entfernen',
        conditionFieldLabels: {
            RISK_LEVEL: 'Risikostufe',
            SOURCE_TYPE: 'Quelltyp',
            RESOURCE_TYPE: 'Ressourcentyp',
            ENVIRONMENT: 'Umgebung',
        } as Record<string, string>,
        conditionOperatorLabels: {
            EQUALS: 'Gleich',
            NOT_EQUALS: 'Ungleich',
            IN: 'Enthalten in',
        } as Record<string, string>,
        sourceTypeLabels: {
            RULE: 'Regel',
            REQUEST: 'Anfrage',
        } as Record<string, string>,
        createCampaign: '$t(appConfig.domainEntityTypes.CAMPAIGN) erstellen',
        createCampaignDesc: 'Neue Zertifizierungskampagne aus dieser Richtlinie erstellen',
        campaignCount: '{{count}} $t(appConfig.domainEntityTypes.CAMPAIGN)(n)',
        viewCampaigns: '$t(appConfig.domainEntityTypes.CAMPAIGNS) anzeigen',
        campaignRunning: 'Für diese Richtlinie läuft bereits eine $t(appConfig.domainEntityTypes.CAMPAIGN)',
        policyNotActive: 'Die Richtlinie muss aktiv sein, um eine $t(appConfig.domainEntityTypes.CAMPAIGN) zu erstellen',
        campaignCreatedFromPolicy: '$t(appConfig.domainEntityTypes.CAMPAIGN) aus Richtlinie erstellt.',
        scopeModeConditions: 'Bedingungen',
        scopeModeExpression: 'Ausdruck',
        switchModeConfirmTitle: 'Geltungsbereichsmodus wechseln',
        switchModeConfirmBody: 'Beim Moduswechsel wird die vorhandene Geltungsbereichsdefinition gelöscht. Fortfahren?',
        expressionLabel: 'Geltungsbereich-Ausdruck',
        expressionPlaceholder: "z. B. access.profile.riskLevel >= 'HIGH'",
        expressionInvalid: 'Ungültiger Ausdruck',
        expressionRequired: 'Ein Geltungsbereich-Ausdruck ist erforderlich.',
        previewMatchingAccess: 'Passende Zugriffe vorschauen',
        previewDialogTitle: 'Vorschau — Passende Zugriffe',
        previewDialogDesc: 'Probelauf-Ergebnis für den aktuellen Ausdruck.',
        previewStatTotal: 'Insgesamt ausgewertet',
        previewStatInScope: 'Im Geltungsbereich',
        previewStatOutOfScope: 'Außerhalb des Geltungsbereichs',
        previewNoMatches: 'Keine Zugriffszuweisungen entsprechen dem Ausdruck.',
        previewSampleCaption: 'Zeige {{count}} von {{matched}} passenden Zuweisungen.',
        previewColIdentity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        previewColProfile: 'Profil',
        previewColResource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        previewColTargetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
        previewColRiskLevel: 'Risikostufe',
        scopeModeExpressionBadge: 'Ausdruck',
        previewZeroMatchWarning: 'Dieser Ausdruck entspricht keinen aktiven Zuweisungen. Eine mit dieser Richtlinie gestartete $t(appConfig.domainEntityTypes.CAMPAIGN) hat keinen Geltungsbereich.',
        summary: {
            basicsSection: 'Grundlagen',
            scopeSection: 'Geltungsbereich',
            reviewSettingsSection: 'Prüfungseinstellungen',
            editBasics: 'Grundlagen bearbeiten',
            editScope: 'Geltungsbereich bearbeiten',
            editReviewSettings: 'Prüfungseinstellungen bearbeiten',
            defaultPolicyNotEditable: 'Dies ist die Standardrichtlinie und kann nicht bearbeitet werden.',
            openCampaignWarning: 'Diese Richtlinie hat bereits eine offene $t(appConfig.domainEntityTypes.CAMPAIGN). Das Vorbereiten einer weiteren $t(appConfig.domainEntityTypes.CAMPAIGN) ist zulässig, kann aber zu doppelter Prüfarbeit führen.',
            validFrom: 'Gültig ab',
            validTo: 'Gültig bis',
            scopeMode: 'Geltungsbereichsdefinition',
            scopeModeConditions: 'Strukturierte Bedingungen',
            scopeModeExpression: 'CEL-Ausdruck',
            conditions: '{{count}} Bedingung(en)',
            expression: 'CEL-Ausdruck',
            certifyEverything: 'Keine Bedingungen — zertifiziert alle aktiven Zuweisungen.',
            reviewFrequency: 'Prüfhäufigkeit',
            owner: '$t(appConfig.domainEntityTypes.CAMPAIGN)-Eigentümer',
            noOwner: 'Globaler Standard',
        },
        wizard: {
            createTitle: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) erstellen',
            editTitle: 'Richtlinie bearbeiten — {{name}}',
            createPageTitle: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) erstellen | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
            editPageTitle: 'Richtlinie bearbeiten — {{name}} | $t(appConfig.domainEntityTypes.ACCESS_GOVERNANCE)',
            stepBasics: 'Grundlagen',
            stepScope: 'Geltungsbereich',
            stepReviewSettings: 'Prüfeinstellungen',
            stepLaunch: 'Start',
            stepBasicsDesc: 'Name, Priorität und der optionale Gültigkeitszeitraum dieser Richtlinie.',
            stepScopeDesc: 'Legen Sie fest, welche Zuweisungen diese Richtlinie zertifiziert.',
            stepReviewSettingsDesc: 'Wer prüft, wie oft und was passiert, wenn niemand reagiert.',
            stepLaunchDesc: 'Überprüfen Sie die Richtlinie und wählen Sie, wie Sie fortfahren möchten.',
            nameLabel: 'Name',
            namePlaceholder: 'z. B. Vierteljährliche Prüfung hoher Risiken',
            descriptionPlaceholder: 'Optionale Beschreibung, was diese Richtlinie zertifiziert',
            priorityLabel: 'Priorität',
            activeLabel: 'Aktiv',
            validFromLabel: 'Gültig ab',
            validToLabel: 'Gültig bis',
            validFromHelp: 'Optional — vor diesem Datum ist die Richtlinie inaktiv.',
            validToHelp: 'Optional — nach diesem Datum ist die Richtlinie inaktiv.',
            validToAfterValidFrom: '„Gültig bis“ muss nach „Gültig ab“ liegen.',
            reviewerTypeLabel: 'Prüfertyp',
            reviewerTypeManagerDesc: 'Die Führungskraft der $t(appConfig.domainEntityTypes.IDENTITY) erhält die Prüfaufgaben.',
            reviewerTypeProfileOwnerDesc: 'Der Eigentümer jedes Zugriffsprofils erhält die Prüfaufgaben.',
            reviewerTypeResourceOwnerDesc: 'Der Eigentümer jeder zugrunde liegenden $t(appConfig.domainEntityTypes.RESOURCE) erhält die Prüfaufgaben.',
            reviewerTypeCampaignOwnerDesc: 'Der Kampagneneigentümer erhält die Prüfaufgaben.',
            useProfileFrequencyHint: 'Ausgeschaltet lassen, um die Prüfhäufigkeit jedes Profils zu verwenden.',
            gracePeriodHint: 'Tage nach dem Fälligkeitsdatum, bevor die Nichtreaktions-Aktion ausgelöst wird.',
            autoRevokeHint: 'Zugriff automatisch entziehen, sobald das Fälligkeitsdatum der $t(appConfig.domainEntityTypes.CAMPAIGN) überschritten ist, unabhängig von der Reaktion des Prüfers.',
            campaignOwnerLabel: '$t(appConfig.domainEntityTypes.CAMPAIGN)-Eigentümer',
            back: 'Zurück',
            next: 'Weiter',
            nextToLaunch: 'Weiter → Start',
            saveAndReturn: 'Speichern & zurück',
            scopeStub: 'Der Geltungsbereich wird im nächsten Schritt konfiguriert.',
            scopeModeConditions: 'Bedingungen',
            scopeModeExpression: 'Ausdruck',
            switchModeConfirmTitle: 'Geltungsbereich-Modus wechseln',
            switchToConditionsConfirmBody: 'Beim Wechsel in den Bedingungsmodus wird Ihr Ausdruck entfernt. Dies kann im Assistenten nicht rückgängig gemacht werden.',
            switchToExpressionConfirmBody: 'Beim Wechsel in den Ausdrucksmodus werden Ihre {{count}} Bedingungen entfernt. Dies kann im Assistenten nicht rückgängig gemacht werden.',
            noConditionsInfo: 'Keine Bedingungen festgelegt — diese Richtlinie zertifiziert alle aktiven Zuweisungen.',
            previewSectionTitle: 'Geltungsbereich-Vorschau',
            previewNoQuery: 'Legen Sie oben Bedingungen oder einen Ausdruck fest, um zu sehen, wer im Geltungsbereich liegt.',
            previewZeroMatch: '0 Zuweisungen entsprechen dem aktuellen Geltungsbereich — es würden keine Zertifizierungen erzeugt.',
            previewError: 'Die Geltungsbereich-Vorschau konnte nicht geladen werden.',
            previewRetry: 'Erneut versuchen',
            previewSampleCaption: 'Es werden die ersten {{count}} von {{matched}} Treffern angezeigt.',
            previewTooLarge: 'Die Geltungsbereich-Vorschau ist nicht verfügbar, wenn die aktive Zuweisungsmenge das Vorschaulimit überschreitet — Ihr Ausdruck wird bei der Kampagnenerzeugung validiert.',
            previewFrequencyDisclaimer: 'Die Vorschau zeigt alle passenden Zuweisungen unabhängig von der Zertifizierungsfrequenz. Bei der Erzeugung werden nur fällige Zuweisungen ausgewählt.',
            previewInScope: '{{matched}} von {{total}} im Geltungsbereich',
            previewColIdentity: '$t(appConfig.domainEntityTypes.IDENTITY)',
            previewColProfile: 'Profil',
            previewColResource: '$t(appConfig.domainEntityTypes.RESOURCE)',
            previewColRiskLevel: 'Risikostufe',
            launchStub: 'Die Richtlinie ist gespeichert. Staging und Aktivierung folgen in einem späteren Schritt.',
            finish: 'Fertigstellen',
            policySaved: 'Richtlinie gespeichert — wählen Sie unten, wie Sie fortfahren möchten.',
            policyUpdated: 'Richtlinie aktualisiert — wählen Sie unten, wie Sie fortfahren möchten.',
            persistError: 'Die Richtlinie konnte nicht gespeichert werden. Bitte überprüfen Sie die Felder und versuchen Sie es erneut.',
            defaultPolicyTitle: 'Standardrichtlinie',
            defaultPolicyInfo: 'Dies ist die Standardrichtlinie und kann nicht bearbeitet werden.',
            forbidden: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
            launch: {
                sectionTitle: 'Start',
                alreadySavedNote: 'Richtlinie bereits gespeichert — ein Zurückgehen macht dies nicht rückgängig.',
                summaryTitle: 'Richtlinienübersicht',
                summaryBasics: 'Grundlagen',
                summaryScope: 'Geltungsbereich',
                summaryReviewSettings: 'Prüfeinstellungen',
                scopeCountLabel: 'Im Geltungsbereich',
                scopeCountValue: '{{matched}} von {{total}} Zuweisungen',
                stage: '$t(appConfig.domainEntityTypes.CAMPAIGN) vorbereiten',
                stageAndActivate: 'Vorbereiten & aktivieren',
                openCampaignWarning: 'Diese Richtlinie hat bereits eine offene $t(appConfig.domainEntityTypes.CAMPAIGN). Eine weitere $t(appConfig.domainEntityTypes.CAMPAIGN) vorzubereiten ist erlaubt, kann aber zu doppelter Prüfarbeit führen.',
                partialFailure: '$t(appConfig.domainEntityTypes.CAMPAIGN) wurde vorbereitet, aber die Aktivierung ist fehlgeschlagen — Sie können sie über die $t(appConfig.domainEntityTypes.CAMPAIGN)-Detailseite aktivieren.',
                goToCampaign: 'Zur $t(appConfig.domainEntityTypes.CAMPAIGN)',
                stageError: 'Richtlinie gespeichert, aber die $t(appConfig.domainEntityTypes.CAMPAIGN) konnte nicht erstellt werden.',
                noCampaignPermission: 'Sie haben keine Berechtigung, $t(appConfig.domainEntityTypes.CAMPAIGNS) zu erstellen.',
                campaignNamePrefill: '{{policyName}} Zertifizierung',
                stagedToast: '$t(appConfig.domainEntityTypes.CAMPAIGN) vorbereitet.',
                stagedAndActivatedToast: '$t(appConfig.domainEntityTypes.CAMPAIGN) vorbereitet und aktiviert.',
                finishedToast: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) gespeichert.',
            },
        },
    },
    certificationCampaigns: {
        title: 'Zertifizierungskampagnen',
        pageTitle: 'Zertifizierungskampagnen | Access Governance',
        detailPageTitle: 'Kampagnendetails | Access Governance',
        subtitle: 'Zugriffszertifizierungskampagnen verwalten',
        allCampaigns: 'Alle $t(appConfig.domainEntityTypes.CAMPAIGNS)',
        campaignsCount: '{{count}} $t(appConfig.domainEntityTypes.CAMPAIGNS)',
        noCampaignsFound: 'Keine Zertifizierungs-$t(appConfig.domainEntityTypes.CAMPAIGNS) gefunden.',
        noReviewItemsFound: 'Keine Review-Elemente für diese $t(appConfig.domainEntityTypes.CAMPAIGN) gefunden.',
        createCampaign: '$t(appConfig.domainEntityTypes.CAMPAIGN) erstellen',
        createDescription: 'Neue Zertifizierungs-$t(appConfig.domainEntityTypes.CAMPAIGN) erstellen',
        createSuccess: '$t(appConfig.domainEntityTypes.CAMPAIGN) "{{name}}" wurde erstellt.',
        name: 'Name',
        description: 'Beschreibung',
        status: 'Status',
        dueDate: 'Fälligkeitsdatum',
        owner: 'Eigentümer',
        policy: 'Richtlinie',
        startedAt: 'Gestartet',
        completedAt: 'Abgeschlossen',
        progress: 'Fortschritt',
        totalReviewItems: 'Review-Elemente gesamt',
        completedReviewItems: 'Abgeschlossen',
        keepCount: 'Behalten',
        revokedCount: 'Widerrufen',
        autoRevokeCount: 'Automatisch widerrufen',
        reviewItemsProgress: 'Fortschritt Review-Elemente',
        decisionsBreakdown: 'Entscheidungen',
        assignments: 'Zuweisungen',
        pendingDecisions: 'Unentschieden',
        searchReviewItems: '$t(appConfig.domainEntityTypes.IDENTITY) oder Prüfer suchen...',
        noReviewItemsMatch: 'Keine Review-Elemente entsprechen Ihren Filtern.',
        allReviewStatuses: 'Alle Status',
        activate: 'Aktivieren',
        cancel: '$t(appConfig.domainEntityTypes.CAMPAIGN) abbrechen',
        activateConfirm: 'Möchten Sie diese $t(appConfig.domainEntityTypes.CAMPAIGN) wirklich aktivieren? Dies startet den Überprüfungsprozess.',
        cancelConfirm: 'Möchten Sie diese $t(appConfig.domainEntityTypes.CAMPAIGN) wirklich abbrechen? Diese Aktion kann nicht rückgängig gemacht werden.',
        generate: '$t(appConfig.domainEntityTypes.CAMPAIGNS) generieren',
        generateDescription: '$t(appConfig.domainEntityTypes.CAMPAIGNS) automatisch aus aktiven Richtlinien generieren',
        generateExplanation: 'Es werden alle aktiven $t(appConfig.domainEntityTypes.CERTIFICATION_POLICIES) ausgewertet und neue $t(appConfig.domainEntityTypes.CAMPAIGNS) für Zugriffsberechtigungen erstellt, die zur Überprüfung fällig sind. Jede $t(appConfig.domainEntityTypes.CAMPAIGN) wird im Status „Vorbereitung" erstellt, sodass Sie sie vor der Aktivierung prüfen können. Nur Berechtigungen, die nicht kürzlich zertifiziert wurden, werden berücksichtigt.',
        ownerIdentity: 'Eigentümer-$t(appConfig.domainEntityTypes.IDENTITY)',
        searchOwner: 'Eigentümer suchen...',
        noIdentitiesFound: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) gefunden.',
        selectPolicy: '$t(appConfig.domainEntityTypes.CERTIFICATION_POLICY) auswählen...',
        noPoliciesFound: 'Keine $t(appConfig.domainEntityTypes.CERTIFICATION_POLICIES) gefunden.',
        filterByStatus: 'Nach Status filtern',
        searchByName: 'Nach Kampagnenname suchen...',
        reviewItems: 'Review-Elemente',
        decisions: 'Entscheidungen',
        statistics: 'Statistiken',
        statusStaging: 'Vorbereitung',
        statusBeforeGeneration: 'Generierung ausstehend',
        statusInGeneration: 'Wird generiert...',
        statusStarted: 'Gestartet',
        statusCompleted: 'Abgeschlossen',
        statusCancelled: 'Abgebrochen',
        previewTitle: 'Voraussichtliche Auswirkung',
        previewIdentityCount: '$t(appConfig.domainEntityTypes.IDENTITIES)',
        previewAssignmentCount: 'Zuweisungen',
        previewExplanation: 'Diese Zahlen spiegeln den aktuellen Stand basierend auf aktiven Richtlinien wider und können sich noch ändern. Der endgültige Umfang wird erst bei der Aktivierung der $t(appConfig.domainEntityTypes.CAMPAIGN) festgelegt.',
        editCampaign: '$t(appConfig.domainEntityTypes.CAMPAIGN) bearbeiten',
        editDescription: 'Kampagnendetails aktualisieren',
        campaignUpdated: '$t(appConfig.domainEntityTypes.CAMPAIGN) aktualisiert.',
        generateSuccess: '{{count}} $t(appConfig.domainEntityTypes.CAMPAIGN)(n) im Status „Vorbereitung" generiert.',
        generateSkipped: '{{count}} Richtlinie(n) mit offenen $t(appConfig.domainEntityTypes.CAMPAIGNS) übersprungen: {{policies}}.',
        generateNoCampaigns: 'Alle Zugriffszuweisungen sind aktuell. Keine neuen $t(appConfig.domainEntityTypes.CAMPAIGNS) erforderlich.',
        deleteCampaign: '$t(appConfig.domainEntityTypes.CAMPAIGN) löschen',
        deleteConfirm: 'Möchten Sie die $t(appConfig.domainEntityTypes.CAMPAIGN) „{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        campaignDeleted: '$t(appConfig.domainEntityTypes.CAMPAIGN) gelöscht.',
        campaignActivated: '$t(appConfig.domainEntityTypes.CAMPAIGN) aktiviert.',
        campaignCancelled: '$t(appConfig.domainEntityTypes.CAMPAIGN) abgebrochen.',
        origin: 'Ursprung',
        originManual: 'Manuell',
        originPolicyGenerated: 'Aus Richtlinie generiert',
        originPolicyGeneratedWithPolicy: 'Aus Richtlinie generiert: {{policyName}}',
    },
    certificationReviews: {
        title: 'Meine Zertifizierungsreviews',
        pageTitle: 'Meine Reviews | Access Governance',
        subtitle: 'Zugriffszuweisungen überprüfen und zertifizieren',
        noReviewsFound: 'Keine Zertifizierungsreviews zugewiesen.',
        reviewItemsCount: '{{count}} Review-Elemente',
        identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        reviewer: 'Prüfer',
        status: 'Status',
        totalAssignments: 'Zuweisungen gesamt',
        decidedAssignments: 'Entschieden',
        selfCertification: 'Selbstzertifizierung',
        fallbackReviewer: 'Fallback',
        certify: 'Zertifizieren',
        certifySuccess: '{{name}} wurde erfolgreich zertifiziert.',
        certifyConfirmDescription: 'Möchten Sie wirklich alle Zugriffsberechtigungen für {{name}} zertifizieren?',
        revoke: 'Widerrufen',
        reassign: 'Neu zuweisen',
        bulkCertify: 'Sammelzertifizierung',
        bulkCertifyCount: 'Massenzertifizierung ({{count}})',
        bulkCertifyDescription: 'Sind Sie sicher, dass Sie {{count}} ausgewählte Prüfpunkte zertifizieren möchten?',
        bulkCertifySuccess: '{{count}} Prüfpunkte erfolgreich zertifiziert.',
        bulkDecide: 'Sammelentscheidung',
        comment: 'Kommentar',
        reassignTo: 'Neu zuweisen an',
        reassignDescription: 'Dieses Review-Element einem anderen Prüfer zuweisen',
        reassignSuccess: 'Review-Element neu zugewiesen.',
        searchIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) suchen...',
        decisionUndecided: 'Unentschieden',
        decisionKeep: 'Behalten',
        decisionRevoke: 'Widerrufen',
        decisionAutoRevoke: 'Automatisch widerrufen',
        accessProfile: '$t(appConfig.domainEntityTypes.ACCESS_PROFILE)',
        riskLevel: 'Risikostufe',
        decidedBy: 'Entschieden von',
        decidedAt: 'Entschieden am',
        statusPending: 'Ausstehend',
        statusInReview: 'In Prüfung',
        statusCompleted: 'Zertifiziert',
        searchPlaceholder: '$t(appConfig.domainEntityTypes.IDENTITIES) suchen...',
        allStatuses: 'Alle Status',
        startReview: 'Prüfung starten',
        continueReview: 'Prüfung fortsetzen',
        allAssignments: 'Alle Zuweisungen',
        allAssignmentsCount: 'Alle {{count}} Zuweisungen',
        bulkDecideTitle: 'Sammelentscheidung',
        bulkDecideDescription: 'Eine Entscheidung auf alle gefilterten Zuweisungen anwenden',
        bulkDecideAffected: 'Dies betrifft {{count}} Zuweisungen und überschreibt bereits getroffene Entscheidungen.',
        bulkDecideSummary: '{{count}} Einträge werden auf {{decision}} gesetzt',
        bulkDecideSuccess: '{{count}} Zuweisungen aktualisiert',
        filterByRiskLevel: 'Risikostufe',
        filterByDecision: 'Entscheidung',
        allRiskLevels: 'Alle Risikostufen',
        allDecisions: 'Alle Entscheidungen',
        undecided: 'Unentschieden',
        keep: 'Behalten',
        noRiskLevel: 'Keine Risikostufe',
        searchAssignments: 'Zuweisungen suchen...',
        decisionRecorded: 'Entscheidung erfasst',
        decisionKept: 'Zugriff beibehalten — Zuweisung wird fortgeführt.',
        decisionRevoked: 'Zugriff zum Widerruf vorgemerkt — wird bei Zertifizierung entfernt.',
        decisionReset: 'Entscheidung auf unentschieden zurückgesetzt.',
        campaign: '$t(appConfig.domainEntityTypes.CAMPAIGN)',
        dueDate: 'Fälligkeitsdatum',
        previousItem: 'Vorherige',
        nextItem: 'Nächste',
    },
    certificationDashboard: {
        title: 'Zertifizierungs-Dashboard',
        pageTitle: 'Zertifizierungs-Dashboard | Access Governance',
        subtitle: 'Übersicht über Zertifizierungskampagnen und Review-Fortschritt',
        activeCampaigns: 'Aktive $t(appConfig.domainEntityTypes.CAMPAIGNS)',
        activeCampaignsDesc: 'Derzeit laufende Zertifizierungskampagnen',
        overdueCampaigns: 'Überfällige $t(appConfig.domainEntityTypes.CAMPAIGNS)',
        overdueCampaignsDesc: '$t(appConfig.domainEntityTypes.CAMPAIGNS), die ihr Fälligkeitsdatum überschritten haben',
        completionPercent: 'Fortschritt',
        completionPercentDesc: 'Gesamtabschlussrate der Reviews',
        completionValue: '{{value}}%',
        totalKeep: 'Behalten',
        totalKeepDesc: 'Gesamtzahl behaltener Zugriffselemente',
        totalRevoked: 'Widerrufen',
        totalRevokedDesc: 'Gesamtzahl widerrufener Zugriffselemente',
        keepAndRevoked: '{{keep}} behalten / {{revoked}} widerrufen',
        reviewProgress: 'Review-Fortschritt',
        reviewProgressDesc: 'Gesamtfortschritt der Review-Elemente',
        decisionsOverview: 'Entscheidungs�bersicht',
        decisionsOverviewDesc: 'Aufschl�sselung der Zertifizierungsentscheidungen',
        undecided: 'Unentschieden',
        keep: 'Behalten',
        revoked: 'Widerrufen',
        pending: 'Ausstehend',
        activeCampaignsList: 'Aktive $t(appConfig.domainEntityTypes.CAMPAIGNS)',
        activeCampaignsListDesc: 'Laufende Zertifizierungskampagnen mit Fortschritt',
        campaign: '$t(appConfig.domainEntityTypes.CAMPAIGN)',
        dueDate: 'F�lligkeitsdatum',
        progress: 'Fortschritt',
        overdue: '�berf�llig',
        noCampaigns: 'Keine aktiven $t(appConfig.domainEntityTypes.CAMPAIGNS).',
        ofTotal: '{{completed}} von {{total}} Elementen',
        campaignManagement: '$t(appConfig.domainEntityTypes.CAMPAIGNS)-Verwaltung',
        campaignManagementDesc: '$t(appConfig.domainEntityTypes.CAMPAIGNS) in Staging-, Generierungs-, Abgeschlossen- oder Abgebrochen-Status',
        noManagementCampaigns: 'Keine $t(appConfig.domainEntityTypes.CAMPAIGNS) zu verwalten.',
    },
    restrictionRules: {
        title: '$t(appConfig.domainEntityTypes.RESTRICTION_RULES)',
        pageTitle: '$t(appConfig.domainEntityTypes.RESTRICTION_RULES) | Access Governance',
        detailPageTitle: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE)-Details | Access Governance',
        subtitle: 'Verwalten Sie Funktionstrennung (SoD) $t(appConfig.domainEntityTypes.RESTRICTION_RULES) zur Vermeidung konfligierender Zugriffe',
        allRules: 'Alle $t(appConfig.domainEntityTypes.RESTRICTION_RULES)',
        ruleCount: '{{count}} Regeln',
        searchByName: 'Nach Name suchen...',
        activeOnly: 'Nur Aktive',
        allStatus: 'Alle Status',
        activeRulesOnly: 'Nur aktive Regeln',
        noRulesFound: 'Keine $t(appConfig.domainEntityTypes.RESTRICTION_RULES) gefunden.',
        noRulesMatch: 'Keine $t(appConfig.domainEntityTypes.RESTRICTION_RULES) entsprechen Ihren Filtern.',
        loading: '$t(appConfig.domainEntityTypes.RESTRICTION_RULES) werden geladen...',
        deniedProfiles: 'Verweigerte Profile',
        deniedProfilesCount: '{{count}} verweigerte(s) Profil(e)',
        violations: 'Verstöße',
        openViolations: 'Offene Verstöße',
        openViolationsCount: '{{count}} offene(r) Verstoß/Verstöße',
        openViolationsForRule: 'Offene Verstöße für diese Regel erkannt',
        owner: 'Verantwortlicher',
        ruleDetails: 'Regeldetails',
        ruleInformation: 'Regelinformationen',
        conditionExpression: 'Bedingungsausdruck',
        conditionExpressionDesc: '$t(appConfig.domainEntityTypes.IDENTITIES), die dieser Bedingung entsprechen, werden von den verweigerten Profilen eingeschränkt',
        profileCode: 'Code',
        profileName: 'Profil',
        resource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        system: 'System',
        noConditionExpression: 'Kein Bedingungsausdruck gesetzt.',
        noProfiles: 'Keine verweigerten Profile konfiguriert.',
        identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        violatingProfile: 'Verletzendes Profil',
        detectedAt: 'Erkannt am',
        detectViolations: 'Verstöße erkennen',
        detecting: 'Erkennung läuft...',
        detectCompleted: 'Verstoßerkennung abgeschlossen.',
        testRule: 'Regel testen',
        testing: 'Teste...',
        testResults: 'Testergebnisse',
        testFailed: 'Test fehlgeschlagen',
        evaluated: 'Ausgewertet',
        matched: 'Übereinstimmend',
        edit: 'Bearbeiten',
        activateRule: 'Regel aktivieren',
        activateRuleDesc: 'Möchten Sie die Regel "{{name}}" wirklich aktivieren? Einschränkungen werden durchgesetzt.',
        createActivateRequest: 'Regel aktivieren',
        deactivateRule: 'Regel deaktivieren',
        deactivateRuleDesc: 'Möchten Sie die Regel "{{name}}" wirklich deaktivieren? Einschränkungen werden nicht mehr durchgesetzt.',
        createDeactivateRequest: 'Regel deaktivieren',
        deleteRule: 'Regel löschen',
        deleteConfirm: 'Möchten Sie die Regel "{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        ruleDeleted: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE) gelöscht.',
        ruleActivated: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE) aktiviert.',
        ruleDeactivated: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE) deaktiviert.',
        createPageTitle: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE) erstellen | Access Governance',
        createRule: 'Regel erstellen',
        createDescription: 'Neue $t(appConfig.domainEntityTypes.RESTRICTION_RULE) zur Durchsetzung von Zugriffsrichtlinien definieren',
        ruleNameLabel: 'Regelname',
        ruleNamePlaceholder: 'Regelnamen eingeben...',
        descriptionPlaceholder: 'Beschreiben Sie den Zweck dieser Regel...',
        conditionExprPlaceholder: "z.B. identity.type == 'CONTRACTOR'",
        ownerLabel: 'Verantwortliche $t(appConfig.domainEntityTypes.PARTY)',
        searchOwnerParty: 'Verantwortliche $t(appConfig.domainEntityTypes.PARTY) suchen...',
        searchProfilesToAdd: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) zum Hinzufügen suchen...',
        selectProfiles: 'Mindestens ein $t(appConfig.domainEntityTypes.ACCESS_PROFILE) auswählen',
        pickProfiles: 'Profile auswählen',
        writeCondition: 'Bedingung schreiben',
        profileConditionDesc: 'Schreiben Sie eine CEL-Bedingung um abgelehnte Profile dynamisch zu bestimmen (z.B. profile.riskLevel == \'CRITICAL\')',
        profileConditionPlaceholder: "z.B. profile.riskLevel == 'CRITICAL'",
        ruleCreated: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE) erstellt.',
        editPageTitle: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE) bearbeiten | Access Governance',
        editRule: 'Regel bearbeiten',
        editDescription: 'Bestehende $t(appConfig.domainEntityTypes.RESTRICTION_RULE) ändern',
        ruleUpdated: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE) aktualisiert.',
        detailsTab: 'Details',
        violationsTab: 'Verstöße',
        testTab: 'Regel testen',
        runTest: 'Test ausführen',
        testDescription: 'Regel gegen aktuelle $t(appConfig.domainEntityTypes.IDENTITIES) testen, um Übereinstimmungen zu sehen.',
        noViolationsOnRule: 'Keine Verstöße für diese Regel erkannt.',
        violationsDashboardTitle: 'Verstöße-Dashboard',
        violationsDashboardSubtitle: 'Regelübergreifende SoD-Verstöße',
        totalOpenViolations: 'Offene Verstöße',
        filterByRule: 'Nach Regel filtern...',
        searchByIdentity: 'Nach $t(appConfig.domainEntityTypes.IDENTITY) suchen...',
        noViolationsFound: 'Keine Verstöße gefunden.',
        ruleName: 'Regel',
        removalGraceDays: 'Übergangsfrist',
        removalGraceDaysDesc: 'Tage bis eine beanstandete Zuweisung nach Erkennung abläuft',
        days: 'Tage',
        detectionHistory: 'Erkennungs-Historie',
        detectionHistoryDesc: 'Letzte Verstoßerkennungs-Läufe für diese Regel.',
        noDetectionsYet: 'Noch keine Erkennungs-Läufe.',
        detectionLoadFailed: 'Erkennungs-Historie konnte nicht geladen werden.',
        detectionLoading: 'Erkennungs-Historie wird geladen...',
        detectionStatusSuccess: 'Erfolgreich',
        detectionStatusFailed: 'Fehlgeschlagen',
        detectionViewErrors: 'Fehler anzeigen',
        detectionViolationsFound: 'Gefunden',
        detectionViolationsResolved: 'Behoben',
        detectionIdentitiesEvaluated: 'Geprüft',
        viewAllDetections: 'Alle anzeigen ({{count}})',
        versionHistory: 'Versionshistorie',
        versionCurrent: 'Aktuell',
        versionLoading: 'Versionshistorie wird geladen...',
        versionLoadFailed: 'Versionshistorie konnte nicht geladen werden.',
        noVersionHistory: 'Noch keine Versionshistorie vorhanden.',
        versionByAuthor: ' von {{name}}',
        testRuleResults: 'Testergebnisse Regel',
        testViolations: 'Verstöße',
        testRuleLoading: 'Test wird ausgeführt...',
        testRuleError: 'Test fehlgeschlagen. Bitte erneut versuchen.',
        testRuleEmpty: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) ausgewertet.',
        viewAffectedIdentities: 'Betroffene $t(appConfig.domainEntityTypes.IDENTITIES) anzeigen',
        affectedIdentitiesTitle: 'Betroffene $t(appConfig.domainEntityTypes.IDENTITIES)',
        affectedIdentitiesDesc: '$t(appConfig.domainEntityTypes.IDENTITIES), die durch diese Regelbedingung übereinstimmen, und ihr Verstoßstatus.',
        party: '$t(appConfig.domainEntityTypes.PARTY)',
        violationIndicator: 'Verstoß',
        violationsPageTitle: '{{name}} — Verstöße',
        violationsPageSubtitle: 'Für diese $t(appConfig.domainEntityTypes.RESTRICTION_RULE) erfasste Verstöße',
        noViolationsForRule: 'Noch keine Verstöße für diese Regel erfasst.',
        resolvedAt: 'Behoben am',
        viewViolations: 'Verstöße',
        detectionHistoryPageTitle: 'Erkennungsverlauf | Zugriffssteuerung',
        ruleDetectionHistory: 'Erkennungsverlauf',
        noDetections: 'Keine Erkennungsläufe gefunden.',
        detectionStartedAt: 'Gestartet am',
        identitiesEvaluated: 'Ausgewertete $t(appConfig.domainEntityTypes.IDENTITIES)',
        detectionsPageSubtitle: 'Alle Verstöße-Erkennungsläufe über alle $t(appConfig.domainEntityTypes.RESTRICTION_RULES)',
        rule: 'Regel',
        detectionHistoryBtn: 'Erkennungsverlauf',
    },
    restrictionRuleRequests: {
        pageTitle: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUESTS) | Zugriffssteuerung',
        createPageTitle: '$t(appConfig.domainEntityTypes.REQUEST) erstellen | Zugriffssteuerung',
        editPageTitle: '$t(appConfig.domainEntityTypes.REQUEST) bearbeiten | Zugriffssteuerung',
        detailPageTitle: 'Antragsdetails | Zugriffssteuerung',
        title: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUESTS)',
        subtitle: 'Governance-$t(appConfig.domainEntityTypes.REQUESTS) für den Lebenszyklus von $t(appConfig.domainEntityTypes.RESTRICTION_RULES)',
        allRequests: 'Alle $t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUESTS)',
        requestCount: '{{count}} $t(appConfig.domainEntityTypes.REQUEST)/$t(appConfig.domainEntityTypes.REQUESTS)',
        newRequest: 'Neuer $t(appConfig.domainEntityTypes.REQUEST)',
        createRequest: '$t(appConfig.domainEntityTypes.REQUEST) erstellen',
        createTitle: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUEST) erstellen',
        editTitle: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUEST) bearbeiten',
        searchByName: 'Nach Name suchen...',
        noRequestsFound: 'Noch keine $t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUESTS) vorhanden.',
        noRequestsMatch: 'Keine $t(appConfig.domainEntityTypes.REQUESTS) entsprechen den aktuellen Filtern.',
        loadingRequests: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUESTS) werden geladen...',
        loadingRequest: '$t(appConfig.domainEntityTypes.REQUEST) wird geladen...',
        loadingRuleData: 'Regeldaten werden geladen...',
        allStatuses: 'Alle Status',
        statusSelectedCount: '{{count}} Status',
        statusDraft: 'Entwurf',
        statusPending: '$t(appConfig.domainEntityTypes.APPROVAL) ausstehend',
        statusApproved: 'Genehmigt',
        statusRejected: 'Abgelehnt',
        statusCancelled: 'Zurückgezogen',
        typeCreate: 'Regel erstellen',
        typeUpdate: 'Regel aktualisieren',
        typeActivate: 'Regel aktivieren',
        typeDeactivate: 'Regel deaktivieren',
        requestType: 'Antragstyp',
        requestTypeLabel: 'Antragstyp',
        linkedRule: 'Verknüpfte Regel',
        ownerParty: 'Eigentümer',
        ownerPartyLabel: 'Eigentümer',
        searchOwnerParty: 'Eigentümer suchen...',
        requestConfiguration: 'Antragskonfiguration',
        requestConfigurationCreateDesc: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE)-Änderungsantrag definieren.',
        requestConfigurationEditDesc: 'Antragskonfiguration vor erneuter Einreichung anpassen.',
        namePlaceholder: 'Antragsname eingeben...',
        descriptionPlaceholder: 'Zweck dieses Antrags beschreiben...',
        conditionExprLabel: 'Identitätsbedingung',
        conditionExprDesc: 'CEL-Ausdruck, der bestimmt, für welche $t(appConfig.domainEntityTypes.IDENTITIES) diese Regel gilt',
        conditionExprPlaceholder: "z.B. identity.type == 'CONTRACTOR'",
        deniedProfilesLabel: 'Verwehrte Profile',
        profileModeList: 'Profile auswählen',
        profileModeCondition: 'Bedingung schreiben',
        profileConditionLabel: 'Verwehrte-Profil-Bedingung',
        profileConditionPlaceholder: "z.B. profile.riskLevel == 'CRITICAL'",
        searchProfilesToAdd: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) hinzufügen...',
        removalGraceDaysLabel: 'Übergangsfrist (Tage)',
        days: 'Tage',
        nameRequired: 'Name ist erforderlich.',
        ownerRequired: 'Eigentümer ist erforderlich.',
        profileRequired: 'Mindestens ein verwehrtes Profil oder eine Bedingung ist erforderlich.',
        missingRuleId: 'Keine Zielregel angegeben. Bitte von einer $t(appConfig.domainEntityTypes.RESTRICTION_RULE) navigieren.',
        impactBannerActivateTitle: 'Regel aktivieren',
        impactBannerDeactivateTitle: 'Regel deaktivieren',
        impactBannerActivate: 'Dieser $t(appConfig.domainEntityTypes.REQUEST) aktiviert die $t(appConfig.domainEntityTypes.RESTRICTION_RULE) und beginnt mit der Durchsetzung für:',
        impactBannerDeactivate: 'Dieser $t(appConfig.domainEntityTypes.REQUEST) deaktiviert die $t(appConfig.domainEntityTypes.RESTRICTION_RULE) und stoppt die Durchsetzung für:',
        requestCreated: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUEST) erstellt.',
        requestUpdated: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUEST) aktualisiert.',
        requestSubmitted: '$t(appConfig.domainEntityTypes.REQUEST) zur $t(appConfig.domainEntityTypes.APPROVAL) eingereicht.',
        requestApproved: '$t(appConfig.domainEntityTypes.REQUEST) genehmigt.',
        requestRejected: '$t(appConfig.domainEntityTypes.REQUEST) abgelehnt.',
        requestDeleted: '$t(appConfig.domainEntityTypes.REQUEST) gelöscht.',
        requestCancelled: '$t(appConfig.domainEntityTypes.REQUEST) zurückgezogen.',
        requestInfoTitle: 'Antragsinformationen',
        requestInfoDesc: 'Details zum $t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUEST)',
        submittedAt: 'Eingereicht am',
        reviewedAt: 'Geprüft am',
        reviewComment: 'Prüfungskommentar',
        linkedRuleTitle: 'Verknüpfte Regel',
        linkedRuleDesc: 'Die von diesem $t(appConfig.domainEntityTypes.REQUEST) betroffene $t(appConfig.domainEntityTypes.RESTRICTION_RULE)',
        proposedConfigTitle: 'Vorgeschlagene Konfiguration',
        proposedConfigDesc: 'Die im $t(appConfig.domainEntityTypes.REQUEST) vorgeschlagene Regelkonfiguration',
        approvalChainEmpty: 'Noch nicht eingereicht — die Genehmigungskette wird beim Einreichen erstellt.',
        noApproversConfigured: 'Noch keine Genehmiger konfiguriert.',
        standaloneNotLinkedToRule: 'Eigenständiger $t(appConfig.domainEntityTypes.REQUEST) — nicht mit einer Regel verknüpft.',
        ruleNotFound: 'Regel nicht gefunden.',
        reviewInfoTitle: 'Prüfungsentscheidung',
        reviewedBy: 'Geprüft von',
        workflowTitle: 'Workflow',
        workflowDraftCreated: 'Entwurf erstellt',
        workflowSubmittedForApproval: 'Zur $t(appConfig.domainEntityTypes.APPROVAL) eingereicht',
        workflowApproved: 'Genehmigt',
        workflowRejected: 'Abgelehnt',
        workflowCancelled: 'Zurückgezogen',
        matchedPolicy: 'Zugewiesene Richtlinie: {{name}}',
        submitForApproval: 'Zur $t(appConfig.domainEntityTypes.APPROVAL) einreichen',
        cancelRequest: 'Zurückziehen',
        deleteDialogTitle: 'Entwurf löschen',
        deleteDialogDesc: 'Möchten Sie diesen Antragsentwurf wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        submitDialogTitle: 'Zur $t(appConfig.domainEntityTypes.APPROVAL) einreichen',
        submitDialogDesc: 'Diesen $t(appConfig.domainEntityTypes.REQUEST) zur $t(appConfig.domainEntityTypes.APPROVAL) einreichen? Nach der Einreichung kann er nicht mehr bearbeitet werden.',
        approveDialogTitle: '$t(appConfig.domainEntityTypes.REQUEST) genehmigen',
        approveDialogDesc: 'Die $t(appConfig.domainEntityTypes.APPROVAL) führt die beantragte Änderung der $t(appConfig.domainEntityTypes.RESTRICTION_RULE) aus.',
        rejectDialogTitle: '$t(appConfig.domainEntityTypes.REQUEST) ablehnen',
        rejectDialogDesc: 'Die Ablehnung schließt diesen $t(appConfig.domainEntityTypes.REQUEST). Der Antragsteller wird benachrichtigt.',
        cancelDialogTitle: '$t(appConfig.domainEntityTypes.REQUEST) zurückziehen',
        cancelDialogDesc: 'Möchten Sie diesen $t(appConfig.domainEntityTypes.REQUEST) wirklich zurückziehen? Der $t(appConfig.domainEntityTypes.REQUEST) wird storniert und die Regeländerung verworfen. Danach kann ein neuer $t(appConfig.domainEntityTypes.REQUEST) erstellt werden.',
        withdrawRequest: '$t(appConfig.domainEntityTypes.REQUEST) zurückziehen',
        withdrawing: 'Wird zurückgezogen...',
        commentOptional: 'Kommentar (optional)',
        commentPlaceholder: 'Optionalen Kommentar hinzufügen...',
        rejectionReason: 'Ablehnungsgrund',
        rejectionReasonPlaceholder: 'Begründen Sie die Ablehnung...',
        rejectCommentRequired: 'Ein Ablehnungsgrund ist erforderlich.',
        approving: 'Wird genehmigt...',
        rejecting: 'Wird abgelehnt...',
        testPanelTitle: 'Regelkonfiguration testen',
        testIdentitySearch: '$t(appConfig.domainEntityTypes.IDENTITIES) suchen...',
        runTest: 'Test ausführen',
        testing: 'Wird getestet...',
        testFailed: 'Test fehlgeschlagen',
        testEvaluated: 'Ausgewertet',
        testMatched: 'Treffer',
        testViolations: 'Verstöße',
        cannotEdit: 'Dieser $t(appConfig.domainEntityTypes.REQUEST) kann nicht bearbeitet werden, da er den Status {{status}} hat.',
        // Spec Section 6.6 alias keys
        wizardTitle: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUEST) erstellen',
        viewRequests: '$t(appConfig.domainEntityTypes.REQUESTS) anzeigen',
        draft: 'Entwurf',
        pendingApproval: '$t(appConfig.domainEntityTypes.APPROVAL) ausstehend',
        approved: 'Genehmigt',
        rejected: 'Abgelehnt',
        cancelled: 'Zurückgezogen',
        newRule: 'Regel erstellen',
        modifyRule: 'Regel aktualisieren',
        activateRule: 'Regel aktivieren',
        deactivateRule: 'Regel deaktivieren',
        openRequestExists: 'Für diese Regel ist bereits ein Änderungsantrag in Bearbeitung.',
        noRuleIdForType: 'Keine Zielregel angegeben. Bitte von einer $t(appConfig.domainEntityTypes.RESTRICTION_RULE) navigieren, um diesen Antragstyp zu erstellen.',
        cancelTitle: '$t(appConfig.domainEntityTypes.REQUEST) zurückziehen',
        cancelDescription: 'Möchten Sie diesen $t(appConfig.domainEntityTypes.REQUEST) wirklich zurückziehen? Der $t(appConfig.domainEntityTypes.REQUEST) wird storniert und die Regeländerung verworfen. Danach kann ein neuer $t(appConfig.domainEntityTypes.REQUEST) erstellt werden.',
        cancelConfirm: '$t(appConfig.domainEntityTypes.REQUEST) zurückziehen',
        tabRestrictionRuleRequests: '$t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUESTS)',
        noRestrictionRuleRequestApprovals: 'Keine ausstehenden $t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUEST_APPROVALS).',
        requestChange: 'Änderung beantragen',
        requestActivation: 'Aktivierung beantragen',
        requestDeactivation: 'Deaktivierung beantragen',
        wizard: {
            stepBasics: 'Grunddaten',
            stepCondition: 'Bedingung',
            stepTest: 'Test',
            stepProfiles: 'Verwehrte Profile',
            stepReview: 'Überprüfung',
            stepBasicsDesc: 'Name, Eigentümer und Übergangsfrist für diesen $t(appConfig.domainEntityTypes.RESTRICTION_RULE_REQUEST).',
            stepConditionDesc: 'Identitätsbedingungsausdruck für diese Regel definieren.',
            stepTestDesc: 'Bedingungsausdruck optional gegen aktuelle $t(appConfig.domainEntityTypes.IDENTITIES) testen.',
            stepProfilesDesc: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) auswählen, die durch diese Regel verwehrt werden.',
            stepReviewDesc: 'Alle Einstellungen vor der Einreichung überprüfen.',
            nameLabel: 'Name',
            updateModeNote: 'Sie aktualisieren eine bestehende $t(appConfig.domainEntityTypes.RESTRICTION_RULE). Die aktuelle Regelkonfiguration ist vorausgefüllt.',
            hideHelp: 'Hilfe ausblenden',
            showHelp: 'Hilfe anzeigen',
            conditionRequired: 'Ein Bedingungsausdruck ist erforderlich, bevor Sie fortfahren können.',
            expressionValidating: 'Ausdruck wird geprüft...',
            expressionValid: 'Ausdruckssyntax ist gültig.',
            expressionInvalid: 'Ausdruck enthält Syntaxfehler.',
            expressionParseError: 'Zeile {{line}}, Spalte {{column}}: {{message}}',
            expressionNetworkError: 'Ausdruck konnte nicht geprüft werden – Verbindung prüfen.',
            testDescription: 'Führen Sie den Bedingungsausdruck gegen aktuelle $t(appConfig.domainEntityTypes.IDENTITIES) aus, um eine Vorschau zu erhalten.',
            runTest: 'Test ausführen',
            testCompleted: 'Test abgeschlossen',
            testCompletedDesc: '{{total}} $t(appConfig.domainEntityTypes.IDENTITIES) ausgewertet — {{matched}} Treffer, {{violations}} Verstöße.',
            viewAffected: '{{count}} Treffer anzeigen',
            statEvaluated: 'Ausgewertete $t(appConfig.domainEntityTypes.IDENTITIES)',
            statMatched: 'Treffer der Bedingung',
            statViolations: 'Verstöße',
            searchIdentities: '$t(appConfig.domainEntityTypes.IDENTITIES) suchen...',
            noIdentitiesMatch: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) entsprechen der Suche.',
            expressionBeingTested: 'Getesteter Ausdruck',
            noDeniedProfiles: 'Noch keine Profile ausgewählt. Bitte oben suchen und auswählen.',
            testResultSummary: 'Testergebnis',
            notTested: 'Die Bedingung wurde nicht getestet. Sie können ohne Test fortfahren.',
            skipTest: 'Test überspringen',
            next: 'Weiter',
            updateTitle: 'Regel aktualisieren: {{name}}',
            editTitle: '$t(appConfig.domainEntityTypes.REQUEST) für Restriktionsregel bearbeiten: {{name}}',
            defaultName: '$t(appConfig.domainEntityTypes.REQUEST) für Restriktionsregel',
            abandonTitle: 'Assistenten verlassen?',
            abandonDesc: 'Sie haben nicht gespeicherte Änderungen. Wenn Sie jetzt die Seite verlassen, gehen Ihre Eingaben verloren.',
            abandonStay: 'Bleiben',
            abandonLeave: 'Verlassen',
        },
    },
    delegations: {
        title: 'Stellvertretungen',
        pageTitle: 'Stellvertretungen',
        allDelegations: 'Alle Stellvertretungen',
        delegationsCount: '{{count}} Stellvertretungen',
        searchPlaceholder: 'Nach Delegierendem oder Stellvertreter suchen...',
        myDelegations: 'Meine Stellvertretungen',
        myDelegationsDesc: 'Verwalten Sie Ihre ausgehenden und eingehenden Stellvertretungen',
        outgoing: 'Ausgehende Stellvertretungen',
        incoming: 'Eingehende Stellvertretungen',
        createDelegation: 'Stellvertretung erstellen',
        editDelegation: 'Stellvertretung bearbeiten',
        revokeDelegation: 'Stellvertretung widerrufen',
        revokeConfirmation: 'Möchten Sie diese Stellvertretung wirklich widerrufen?',
        createSuccess: 'Stellvertretung erfolgreich erstellt',
        createErrorForDeputy: 'Fehlgeschlagen für {{deputy}}: {{error}}',
        updateSuccess: 'Stellvertretung erfolgreich aktualisiert',
        revokeSuccess: 'Stellvertretung erfolgreich widerrufen',
        noDelegations: 'Keine Stellvertretungen gefunden.',
        noOutgoing: 'Sie haben keine Stellvertretungen eingerichtet.',
        noIncoming: 'Niemand hat an Sie delegiert.',
        columns: {
            delegator: 'Delegierender',
            deputy: 'Stellvertreter',
            workflowStep: 'Workflow-Schritt',
            status: 'Status',
            startAt: 'Beginn',
            endAt: 'Ende',
            reason: 'Grund',
            createdAt: 'Erstellt',
        },
        permanent: 'Dauerhaft',
        form: {
            deputy: 'Stellvertreter',
            deputyPlaceholder: 'Stellvertreter suchen...',
            noDeputiesSelected: 'Noch keine Stellvertreter ausgewählt.',
            workflowStep: 'Workflow-Schritt',
            permanent: 'Dauerhafte Stellvertretung',
            permanentDescription: 'Kein Start-/Enddatum — aktiv bis zum Widerruf',
            startAt: 'Startdatum',
            endAt: 'Enddatum',
            reason: 'Grund',
            reasonPlaceholder: 'z.B. Urlaub, Elternzeit',
        },
        statuses: {
            SCHEDULED: 'Geplant',
            ACTIVE: 'Aktiv',
            EXPIRED: 'Abgelaufen',
            REVOKED: 'Widerrufen',
        },
        onBehalfOf: 'im $t(appConfig.domainEntityTypes.JOB) von {{delegator}}',
    },
    functionGroupAssignments: {
        title: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
        byAssignment: 'Nach Zuweisung',
        functionGroup: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP)',
        sources: 'Quellen',
        expiresAt: 'Läuft ab',
        assignmentHistory: 'Zuweisungsverlauf',
        noAssignments: 'Keine $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuweisungen.',
        noHistoryEvents: 'Keine Verlaufsereignisse.',
        activeAssignmentCount: '{{count}} aktive Zuweisung(en)',
        activeSources: '{{count}} aktive Quelle(n)',
        request: '$t(appConfig.domainEntityTypes.REQUEST)',
        rule: 'Regel',
        api: 'API',
        import: 'Import',
        unknownSource: 'Unbekannte Quelle',
        revoke: 'Widerrufen',
        revoking: 'Widerrufe...',
        revokeAssignment: 'Zuweisung widerrufen',
        revokeAssignmentConfirm: 'Sind Sie sicher, dass Sie diese $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuweisung widerrufen möchten? Diese Aktion kann innerhalb des Wiederherstellungsfensters rückgängig gemacht werden.',
        assignmentRevoked: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuweisung widerrufen.',
        restore: 'Wiederherstellen',
        restoring: 'Wiederherstellen...',
        restoreAssignment: 'Zuweisung wiederherstellen',
        restoreAssignmentConfirm: 'Sind Sie sicher, dass Sie diese widerrufene $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuweisung wiederherstellen möchten?',
        assignmentRestored: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuweisung wiederhergestellt.',
        extend: 'Verlängern',
        extending: 'Verlängere...',
        extendAssignment: 'Zuweisung verlängern',
        newExpiresAt: 'Neues Ablaufdatum',
        assignmentExtended: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuweisung verlängert.',
        statusActive: 'Aktiv',
        statusPending: 'Ausstehend',
        statusExpired: 'Abgelaufen',
        statusRevoked: 'Widerrufen',
        eventCreated: 'Erstellt',
        eventExtended: 'Verlängert',
        eventShortened: 'Verkürzt',
        eventRevoked: 'Widerrufen',
        eventRestored: 'Wiederhergestellt',
        eventSourceAdded: 'Quelle hinzugefügt',
        eventSourceRemoved: 'Quelle entfernt',
        eventSourceRestored: 'Quelle wiederhergestellt',
        identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        startAt: 'Start',
    },
    functionGroupDetail: {
        pageTitle: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Details',
        loading: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP) wird geladen...',
        detailsDescription: 'Konfiguration und Metadaten der $t(appConfig.domainEntityTypes.FUNCTION_GROUP)',
        externalId: 'Externe ID',
        parent: 'Übergeordnete $t(appConfig.domainEntityTypes.FUNCTION_GROUP)',
        owner: 'Eigentümer',
        autoAssignable: 'Automatisch zuweisbar',
        requestableLabel: 'Beantragbar',
        requestable: 'Beantragbar',
        notRequestable: 'Nicht beantragbar',
        expiryRequired: 'Ablaufdatum erforderlich',
        maxDurationDays: 'Maximale Dauer (Tage)',
        accessProfiles: {
            card: {
                title: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
                description: '{{count}} $t(appConfig.domainEntityTypes.ACCESS_PROFILE)',
                description_other: '{{count}} $t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
            },
            empty: 'Dieser $t(appConfig.domainEntityTypes.FUNCTION_GROUP) sind keine $t(appConfig.domainEntityTypes.ACCESS_PROFILES) zugeordnet.',
            error: 'Zugeordnete $t(appConfig.domainEntityTypes.ACCESS_PROFILES) konnten nicht geladen werden',
            warning100: 'Es werden die ersten 100 zugeordneten $t(appConfig.domainEntityTypes.ACCESS_PROFILES) angezeigt',
            columns: {
                name: 'Name',
                code: 'Code',
                resource: '$t(appConfig.domainEntityTypes.RESOURCE)',
                environment: 'Umgebung',
                riskLevel: 'Risikostufe',
                status: 'Status',
            },
        },
    },
    accessProfileDetail: {
        functionGroups: {
            card: {
                title: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
                description: '{{count}} $t(appConfig.domainEntityTypes.FUNCTION_GROUP)(n) gewähren dieses $t(appConfig.domainEntityTypes.ACCESS_PROFILE) $t(appConfig.domainEntityTypes.IDENTITIES)',
                description_other: '{{count}} $t(appConfig.domainEntityTypes.FUNCTION_GROUP)(n) gewähren dieses $t(appConfig.domainEntityTypes.ACCESS_PROFILE) $t(appConfig.domainEntityTypes.IDENTITIES)',
            },
            empty: 'Keine $t(appConfig.domainEntityTypes.FUNCTION_GROUP) gewährt dieses $t(appConfig.domainEntityTypes.ACCESS_PROFILE) $t(appConfig.domainEntityTypes.IDENTITIES)',
            error: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuordnungen konnten nicht geladen werden',
            columns: {
                name: 'Name',
                type: '$t(appConfig.domainEntityTypes.TYPE)',
            },
        },
    },
    identityInheritedAssignments: {
        sourceLabel: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP)',
        tooltip: 'Geerbt von $t(appConfig.domainEntityTypes.FUNCTION_GROUP) \u2014 Verwaltung über die $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuweisung',
        errorBanner: 'Geerbte Zuweisungen konnten nicht geladen werden',
        viaPrefix: 'über',
    },
    requestWizardLinkedAccessProfiles: {
        grantsCount: 'Gewährt {{count}} $t(appConfig.domainEntityTypes.ACCESS_PROFILE)',
        grantsCount_other: 'Gewährt {{count}} $t(appConfig.domainEntityTypes.ACCESS_PROFILES)',
        noAccessProfiles: 'Keine $t(appConfig.domainEntityTypes.ACCESS_PROFILES) zugeordnet',
        moreText: '+ {{count}} weitere',
        errorText: 'Zugeordnete $t(appConfig.domainEntityTypes.ACCESS_PROFILES) konnten nicht geladen werden',
        notAvailable: 'Zugeordnete $t(appConfig.domainEntityTypes.ACCESS_PROFILES) nicht verfügbar',
        retry: 'Erneut versuchen',
    },
    requestDetailLinkedAccessProfiles: {
        sectionTitle: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) ({{count}})',
        errorText: 'Zugeordnete $t(appConfig.domainEntityTypes.ACCESS_PROFILES) konnten nicht geladen werden',
        retry: 'Erneut versuchen',
    },
    functionGroups: {
        title: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
        subtitle: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS) bündeln $t(appConfig.domainEntityTypes.ACCESS_PROFILES) zur Zuweisung',
        createFunctionGroup: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP) anlegen',
        createSuccess: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP) angelegt.',
        owner: 'Eigentümer',
        noFunctionGroupsFound: 'Keine $t(appConfig.domainEntityTypes.FUNCTION_GROUPS) gefunden.',
        noFunctionGroupsMatch: 'Keine $t(appConfig.domainEntityTypes.FUNCTION_GROUPS) entsprechen dem Filter.',
    },
    functionGroupRequests: {
        title: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        pageTitle: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        subtitle: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zuweisungsanträge verwalten',
        createRequest: 'Neuer $t(appConfig.domainEntityTypes.REQUEST)',
        loadingRequests: 'Lade $t(appConfig.domainEntityTypes.REQUESTS)...',
        noRequestsFound: 'Keine $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS) gefunden.',
        requester: 'Antragsteller',
        beneficiary: 'Begünstigter',
        justification: 'Begründung',
        items: 'Positionen',
        searchByBeneficiary: 'Nach Begünstigtem suchen...',
        statusSubmitted: 'Eingereicht',
        statusInProgress: 'In Bearbeitung',
        statusCompleted: 'Abgeschlossen',
        statusCancelled: 'Storniert',
        detailPageTitle: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Antragsdetails',
        requestDetails: 'Antragsdetails',
        requestItems: '{{count}} Position(en)',
        untilDate: '(bis {{date}})',
        cancelRequest: '$t(appConfig.domainEntityTypes.REQUEST) stornieren',
        cancelEntireRequest: 'Gesamten $t(appConfig.domainEntityTypes.REQUEST) stornieren',
        cancelItem: 'Position stornieren',
        cancelReason: 'Stornierungsgrund',
        cancelReasonPlaceholder: 'Geben Sie einen Grund ein...',
        cancelled: 'Storniert:',
        cancelling: 'Storniere...',
        requestCancelled: '$t(appConfig.domainEntityTypes.REQUEST) storniert.',
        itemCancelled: 'Position storniert.',
        approveItem: 'Position genehmigen',
        approving: 'Genehmige...',
        itemApproved: 'Position genehmigt.',
        rejectItem: 'Position ablehnen',
        rejecting: 'Lehne ab...',
        itemRejected: 'Position abgelehnt.',
        commentOptional: 'Kommentar (optional)',
        commentPlaceholder: 'Optionalen Kommentar hinzufügen...',
        reasonRequired: 'Grund (erforderlich)',
        rejectReasonPlaceholder: 'Ablehnungsgrund eingeben...',
        statusPendingApproval: '$t(appConfig.domainEntityTypes.APPROVAL) ausstehend',
        statusApproved: 'Genehmigt',
        statusFulfilled: 'Erfüllt',
        statusRejected: 'Abgelehnt',
        approvers: 'Genehmiger',
        wizardTitle: 'Neuer $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUEST)',
        newPageTitle: 'Neuer $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUEST)',
        wizardSelectFunctionGroups: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS) auswählen',
        wizardSelectedFunctionGroups: 'Ausgewählte $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
        wizardReviewSubmit: 'Prüfen & Absenden',
        whoNeedsAccess: 'Wer benötigt $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zugriff?',
        myself: 'Ich selbst',
        someoneElse: 'Jemand anderes',
        searchForIdentity: '$t(appConfig.domainEntityTypes.IDENTITY) suchen',
        searchByName: 'Nach Namen suchen...',
        selected: 'Ausgewählt:',
        allFunctionGroups: 'Alle $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)',
        selectFunctionGroups: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS) auswählen',
        searchFunctionGroups: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS) suchen...',
        noFunctionGroupsFound: 'Keine $t(appConfig.domainEntityTypes.FUNCTION_GROUPS) gefunden.',
        noFunctionGroupsSelected: 'Noch keine $t(appConfig.domainEntityTypes.FUNCTION_GROUPS) ausgewählt.',
        selectedCount: '{{count}} ausgewählt',
        expiryRequired: 'Ablauf erforderlich',
        expirationDate: 'Ablaufdatum',
        setExpiration: 'Ablauf festlegen',
        maxDurationHint: 'Max. {{days}} Tage',
        reviewAndSubmit: 'Prüfen & Absenden',
        reviewBeneficiary: 'Begünstigter',
        reviewFunctionGroups: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS) ({{count}})',
        expandAll: 'Alle ausklappen',
        collapseAll: 'Alle einklappen',
        justificationPlaceholder: 'Warum wird dieser $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Zugriff benötigt?',
        submitRequest: '$t(appConfig.domainEntityTypes.REQUEST) absenden',
        submitting: 'Sende ab...',
        requestSubmitted: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUEST) eingereicht.',
        myFunctionGroupRequests: 'Meine $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        myFunctionGroupRequestsSubmitted: 'Von Ihnen eingereichte $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        newRequest: 'Neuer $t(appConfig.domainEntityTypes.REQUEST)',
        noFunctionGroupRequestsFound: 'Keine $t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS) gefunden.',
        tabFunctionGroupRequests: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP_REQUESTS)',
        noFunctionGroupRequestApprovals: 'Keine ausstehenden $t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-$t(appConfig.domainEntityTypes.APPROVALS)',
        functionGroupRequestApproved: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Antragsposition genehmigt.',
        functionGroupRequestRejected: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Antragsposition abgelehnt.',
        approveFunctionGroupRequest: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Antragsposition genehmigen',
        rejectFunctionGroupRequest: '$t(appConfig.domainEntityTypes.FUNCTION_GROUPS)-Antragsposition ablehnen',
    },
    errorLogs: {
        pageTitle: '$t(appConfig.domainEntityTypes.ERROR_LOG)',
        title: '$t(appConfig.domainEntityTypes.ERROR_LOG)',
        description: 'Systemfehler und Fehlermuster',
        sidebarTitle: '$t(appConfig.domainEntityTypes.ERROR_LOG)',
        sidebarDescription: 'Fehlermuster anzeigen',
        tabPatterns: 'Muster',
        tabAllRecords: 'Alle Einträge',
        totalFailures: 'Gesamt',
        patterns: 'Muster',
        occurrences: 'Vorkommen',
        allModules: 'Alle Module',
        allSourceTypes: 'Alle Quelltypen',
        allContextKeys: 'Alle Kontextschlüssel',
        contextValuePlaceholder: 'Nach Wert filtern...',
        filterModule: 'Modul',
        filterSourceType: 'Quelltyp',
        filterDateRange: 'Zeitraum',
        filterSearch: 'Fehler suchen...',
        last24h: 'Letzte 24h',
        last7d: 'Letzte 7 Tage',
        last30d: 'Letzte 30 Tage',
        columns: {
            count: 'Anzahl',
            module: 'Modul',
            exception: 'Ausnahme',
            message: 'Nachricht',
            lastSeen: 'Zuletzt gesehen',
            time: 'Zeit',
            sourceType: 'Quelltyp',
            source: 'Quelle',
            type: '$t(appConfig.domainEntityTypes.TYPE)',
            errorCode: 'Fehlercode',
            context: 'Kontext',
            sourceEntity: 'Quell-Entität',
            sessionId: 'Sitzung',
        },
        badgePattern: 'Muster',
        badgeOccurrence: 'Vorkommen',
        noFailures: 'Keine Systemfehler aufgezeichnet.',
        noFailuresMatch: 'Keine Fehler entsprechen den aktuellen Filtern.',
        noPatterns: 'Keine Fehlermuster gefunden.',
        noPatternsHint: 'Wechseln Sie zu Alle Einträge, um einzelne Fehler zu sehen.',
        noOccurrences: 'Keine einzelnen Vorkommen aufgezeichnet.',
        failedToLoad: 'Fehler beim Laden der Fehlereinträge.',
        patternDetail: {
            title: 'Fehlermuster-Detail',
            breadcrumb: 'Muster-Detail',
            patternInfo: 'Muster-Information',
            exceptionType: 'Ausnahme',
            errorCode: 'Fehlercode',
            module: 'Modul',
            firstSeen: 'Erstmals gesehen',
            lastSeen: 'Zuletzt gesehen',
            totalOccurrences: 'Gesamtvorkommen',
            stackTrace: 'Vorlage-Stack-Trace',
            showStackTrace: 'Stack-Trace anzeigen',
            hideStackTrace: 'Stack-Trace ausblenden',
            moreFrames: '... ({{count}} weitere Frames)',
            copyTrace: 'Kopieren',
            copiedTrace: 'Stack-Trace in Zwischenablage kopiert.',
            occurrencesTitle: 'Vorkommen',
            occurrencesCount: '{{count}} insgesamt',
            notFound: 'Dieses Fehlermuster existiert nicht mehr. Es wurde möglicherweise durch die Aufbewahrungsrichtlinie entfernt.',
        },
        occurrenceDetail: {
            title: 'Vorkommens-Detail',
            time: 'Zeit',
            source: 'Quelle',
            message: 'Nachricht',
            viewSource: 'Anzeigen',
            context: 'Kontext',
            noContext: 'Kein Kontext',
            stackTrace: 'Stack-Trace',
            stackTraceReconstructed: 'Stack-Trace (aus Muster rekonstruiert)',
            identicalToTemplate: 'Identisch mit der Mustervorlage.',
            noStackTrace: 'Dieser Fehler wurde ohne Stack-Trace aufgezeichnet.',
            diffNote: 'Hervorgehobene Zeichen unterscheiden sich von der Mustervorlage.',
        },
        requestContext: {
            title: 'Anfrage-Kontext',
            source: 'Quelle',
            appRequest: 'App-Anfrage',
            externalRequest: 'Externe Anfrage',
            method: 'Methode & URL',
            userAgent: 'User-Agent',
            correlationId: 'Korrelations-ID',
            authUser: 'Angemeldeter Benutzer',
            headers: 'Header',
            headersExpand: 'Header anzeigen',
            headersCollapse: 'Header ausblenden',
            copiedCorrelationId: 'Korrelations-ID in Zwischenablage kopiert.',
        },
        detail: {
            sessionId: 'Sitzungs-ID',
            actionId: 'Aktions-ID',
            e2eRunId: 'E2E-Lauf-ID',
            e2eTestClass: 'E2E-Testklasse',
            e2eTestMethod: 'E2E-Testmethode',
            sessionLink: 'Im Request Inspector anzeigen',
        },
        refresh: 'Aktualisieren',
        failedToLoadStats: 'Fehler beim Laden der Fehlerstatistiken.',
        retry: 'Wiederholen',
        patternCount: '{{count}} Muster',
        emptyState: 'Es wurden noch keine Fehler aufgezeichnet.',
        emptyStateHint: 'Das $t(appConfig.domainEntityTypes.ERROR_LOG) erfasst Ausnahmen von Hintergrund-Jobs, Konnektoren und anderen Systemprozessen.',
        generateTestData: 'Testdaten generieren',
        generatingTestData: 'Wird generiert...',
        testDataGenerated: '{{count}} Test-Fehlereinträge generiert',
        others: '{{count}} weitere',
        clearAll: 'Alle löschen',
        clearAllConfirm: 'Alle Fehler löschen',
        clearAllDescription: 'Sind Sie sicher? Alle Fehlereinträge werden unwiderruflich gelöscht.',
        clearAllSuccess: 'Alle Fehlereinträge wurden gelöscht.',
        minQHint: 'Bitte mindestens 3 Zeichen eingeben, um zu suchen.',
        searchScopeHint: 'Sucht ausschließlich in der Fehlermeldung – Stack-Traces werden nicht durchsucht.',
    },
    inlineAttributeEditor: {
        required: 'Pflichtfelder',
        optional: 'Optional',
        save: 'Speichern',
        reset: 'Zurücksetzen',
        remove: 'Entfernen',
        noDefinitions: 'Keine Attribute für diese Entität verfügbar.',
        noDefinitionsAdmin: 'Keine $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) für diesen $t(appConfig.domainEntityTypes.TYPE) konfiguriert.',
        saving: 'Speichern...',
        saveSuccess: 'Attribut gespeichert',
        removeSuccess: 'Attribut entfernt',
        removeConfirm: 'Attribut entfernen?',
        requiredHint: 'Dieses Attribut ist erforderlich',
        enterToAdd: 'Eingeben und Enter drücken',
        searchParty: 'Nach Name suchen...',
        source: 'Verwaltet von {{name}}',
    },
    scriptExecuteLog: {
        pageTitle: 'Skript-Ausführungsprotokoll | Administration',
        title: 'Skript-Ausführungsprotokoll',
        description: 'DDL-Audit-Spur aus sql.execute()-Aufrufen',
        emptyMessage: 'Keine Einträge erfasst.',
        emptyMatchMessage: 'Keine Einträge entsprechen den Filtern.',
        rowsBadge: '{{count}} Eintrag',
        rowsBadge_other: '{{count}} Einträge',
        filters: {
            actor: 'Akteur',
            actorPlaceholder: 'Benutzername...',
            mode: 'Modus',
            modeAll: 'Alle Modi',
            modePreview: 'Vorschau',
            modeRuntime: '$t(appConfig.domainEntityTypes.EXECUTION)',
            outcome: 'Ergebnis',
            outcomeAll: 'Alle Ergebnisse',
            outcomeSuccess: 'Erfolg',
            outcomeFailure: 'Fehler',
            occurredFrom: 'Von',
            occurredTo: 'Bis',
            clear: 'Filter löschen',
        },
        columns: {
            occurredAt: 'Zeit',
            mode: 'Modus',
            actor: 'Akteur',
            sqlText: 'SQL',
            durationMs: 'Dauer (ms)',
            success: 'Ergebnis',
            errorCode: 'Fehler',
        },
        badges: {
            preview: 'Vorschau',
            runtime: '$t(appConfig.domainEntityTypes.EXECUTION)',
            success: 'Erfolg',
            failure: 'Fehler',
        },
        detail: {
            title: 'Audit-Eintrag',
            close: 'Schließen',
            occurredAt: 'Zeitpunkt',
            mode: 'Modus',
            actor: 'Akteur',
            actorUserId: 'Akteur-ID',
            jobExecutionId: 'Job-Ausführungs-ID',
            duration: 'Dauer (ms)',
            outcome: 'Ergebnis',
            errorCode: 'Fehlercode',
            errorMessage: 'Fehlermeldung',
            sqlText: 'SQL',
        },
    },
    caches: {
        pageTitle: 'Caches | Administration',
        title: 'Caches',
        subtitle: 'In-Process-Caches aus allen Backend-Modulen — Status einsehen und manuell neu laden.',
        emptyState: 'Keine Caches registriert.',
        loadError: 'Caches konnten nicht geladen werden.',
        evictSuccess: 'Cache geleert.',
        evictError: 'Cache konnte nicht geleert werden.',
        reloadSuccess: 'Cache neu geladen.',
        reloadError: 'Cache konnte nicht neu geladen werden.',
        neverLoaded: 'Nie',
        expired: 'abgelaufen (nächste Anfrage lädt neu)',
        columns: {
            name: 'Name',
            description: 'Was gecacht wird',
            entries: 'Einträge',
            lastLoad: 'Letztes Laden',
            ttl: 'TTL',
            nextExpiry: 'Nächste Verfall',
            reloadTrigger: 'Neuladen ausgelöst durch',
            actions: 'Aktionen',
        },
        actions: {
            evict: 'Leeren',
            reload: 'Jetzt neu laden',
        },
    },
    llmPrompts: {
        pageTitle: 'LLM-Prompts | Administration',
        title: 'LLM-Prompt-Vorlagen',
        subtitle: 'KI-Prompt-Vorlagen fuer LLM-gestuetzte Funktionen konfigurieren',
        searchPlaceholder: 'Nach Schlüssel, Name oder Beschreibung suchen...',
        noMatchingPrompts: 'Keine Prompt-Vorlagen entsprechen Ihrer Suche.',
        emptyState: 'Keine Prompt-Vorlagen konfiguriert. Vorlagen werden waehrend der Systemeinrichtung erstellt.',
        columns: {
            key: 'Schluessel',
            displayName: 'Anzeigename',
            description: 'Beschreibung',
            lastUpdated: 'Zuletzt aktualisiert',
            updatedBy: 'Aktualisiert von',
        },
        detail: {
            title: 'Prompt-Vorlage bearbeiten',
            metadata: 'Metadaten',
            promptEditor: 'Prompt-Editor',
            variables: 'Verfuegbare Variablen',
            variableDescription: 'Verwenden Sie die Doppelklammer-Syntax in Ihrem Prompt, um diese Variablen zu referenzieren.',
            noVariables: 'Diese Vorlage hat keine Variablen.',
        },
        actions: {
            save: 'Speichern',
            cancel: 'Abbrechen',
            restoreDefault: 'Standard wiederherstellen',
            testPrompt: 'Prompt testen',
            renderPreview: 'Vorschau rendern',
            sendToLlm: 'An LLM senden',
        },
        messages: {
            saveSuccess: 'Prompt-Vorlage erfolgreich gespeichert',
            restoreSuccess: 'Prompt-Vorlage auf Standard zurueckgesetzt',
            restoreConfirm: 'Standard-Prompt wiederherstellen?',
            restoreConfirmDescription: 'Dadurch wird der aktuelle Prompt durch den urspruenglichen Standard ersetzt. Alle benutzerdefinierten Aenderungen gehen verloren.',
            unsavedChanges: 'Sie haben ungespeicherte Aenderungen. Sind Sie sicher, dass Sie die Seite verlassen moechten?',
            versionConflict: 'Die Vorlage wurde von einem anderen Benutzer geaendert. Wird neu geladen...',
            llmNotConfigured: 'LLM ist nicht konfiguriert. Testanfragen koennen nicht gesendet werden.',
        },
        testPanel: {
            title: 'Prompt testen',
            sampleInput: 'Beispiel-Benutzereingabe',
            sampleInputPlaceholder: 'Geben Sie eine Beispiel-Benutzeranfrage ein, um den Prompt zu testen...',
            renderedPrompt: 'Gerenderter Prompt',
            llmResponse: 'LLM-Antwort',
        },
    },
    notificationTemplates: {
        pageTitle: 'Benachrichtigungsvorlagen | Administration',
        title: 'Benachrichtigungsvorlagen',
        searchPlaceholder: 'Nach Schlüssel oder Betreff suchen...',
        noMatching: 'Keine Benachrichtigungsvorlagen entsprechen Ihrer Suche.',
        emptyState: 'Keine Benachrichtigungsvorlagen verfügbar.',
        columns: {
            key: 'Schlüssel',
            subject: 'Betreff',
            state: 'Status',
            active: 'Aktiv',
            lastModified: 'Zuletzt geändert',
        },
        badges: {
            customised: 'Angepasst',
            default: 'Standard',
            active: 'Aktiv',
            inactive: 'Inaktiv',
        },
        fields: {
            subject: 'Betreff',
            bodyHtml: 'Inhalt (HTML)',
            title: 'Titel',
            message: 'Nachricht',
        },
        detail: {
            title: 'Benachrichtigungsvorlage bearbeiten',
            metadata: 'Metadaten',
            editor: 'Vorlagen-Editor',
            variables: 'Verfügbare Variablen',
            variableHint: 'Klicken Sie auf eine Variable, um sie an der Cursorposition im Inhalt einzufügen.',
            noVariables: 'Diese Vorlage hat keine Variablen.',
        },
        actions: {
            restoreDefault: 'Standard wiederherstellen',
            testSend: 'Testnachricht senden',
        },
        messages: {
            saveSuccess: 'Benachrichtigungsvorlage erfolgreich gespeichert',
            restoreSuccess: 'Benachrichtigungsvorlage auf Standard zurückgesetzt',
            restoreConfirm: 'Standardvorlage wiederherstellen?',
            restoreConfirmDescription: 'Dadurch wird die Anpassung gelöscht und die Vorlage auf den ausgelieferten Standard zurückgesetzt. Alle Anpassungen gehen verloren.',
            versionConflict: 'Die Vorlage wurde von einem anderen Benutzer geändert. Wird neu geladen...',
            testSendSent: 'Testnachricht an {{email}} gesendet — eine Beispiel-$t(appConfig.domainEntityTypes.NOTIFICATION) wurde Ihrem Postfach hinzugefügt.',
            testSendSkipped: 'Für Ihr Konto ist keine E-Mail-Adresse hinterlegt — Testnachricht übersprungen, aber eine Beispiel-$t(appConfig.domainEntityTypes.NOTIFICATION) wurde Ihrem Postfach hinzugefügt.',
            testSendDirtyHint: 'Speichern Sie zuerst Ihre Änderungen — die Testnachricht verwendet die gespeicherte Vorlage, nicht Ihre ungespeicherten Bearbeitungen.',
        },
    },
    onboarding: {
        title: 'Onboarding',
        pageTitle: 'Onboarding | Identitätsverwaltung',
        menuDescription: 'Person mit $t(appConfig.domainEntityTypes.PARTY), $t(appConfig.domainEntityTypes.IDENTITY) und Kennungen anlegen',
        subtitle: '$t(appConfig.domainEntityTypes.PARTY) und $t(appConfig.domainEntityTypes.IDENTITY) mit allen erforderlichen Informationen in einem geführten Ablauf erstellen.',
        steps: {
            person: 'Person',
            organization: 'Organisation',
            identity: '$t(appConfig.domainEntityTypes.IDENTITY)',
            review: 'Überprüfung',
        },
        stepStatus: {
            active: 'aktiv',
            complete: 'abgeschlossen',
            upcoming: 'ausstehend',
        },
        stepAriaLabel: 'Schritt {{number}}: {{name}} — {{status}}',
        mode: {
            newPerson: 'Neue $t(appConfig.domainEntityTypes.PARTY)',
            existingPerson: '$t(appConfig.domainEntityTypes.IDENTITY) zu bestehender $t(appConfig.domainEntityTypes.PARTY) hinzufügen',
        },
        templates: {
            title: 'Vorlage auswählen',
            employee: 'Mitarbeiter',
            employeeDesc: 'Standard-Mitarbeiteridentität',
            contractor: 'Auftragnehmer',
            contractorDesc: 'Externe Partneridentität',
            service: 'Serviceidentität',
            serviceDesc: 'Nicht-menschliches $t(appConfig.domainEntityTypes.SERVICE_ACCOUNT)',
            custom: 'Benutzerdefiniert',
            customDesc: 'Identitätstyp manuell wählen',
        },
        person: {
            title: 'Personendetails',
            basicInfo: 'Grundinformationen',
            displayName: 'Anzeigename',
            displayNamePlaceholder: 'Vollständigen Namen eingeben',
            externalId: 'Externe ID',
            externalIdPlaceholder: 'Optionaler externer Bezeichner',
            duplicateWarning: 'Eine $t(appConfig.domainEntityTypes.PARTY) mit diesem Namen existiert bereits. Verwenden Sie \'$t(appConfig.domainEntityTypes.IDENTITY) zu bestehender $t(appConfig.domainEntityTypes.PARTY) hinzufügen\', um sie auszuwählen.',
            templateSwitchInfo: 'Identitätsattribute wurden zurückgesetzt, da die Vorlage geändert wurde. Felder auf Parteiebene (Name, Abteilung, Manager) wurden beibehalten.',
        },
        existingParty: {
            searchPlaceholder: 'Nach bestehender $t(appConfig.domainEntityTypes.PARTY) suchen...',
            partyType: 'Parteityp',
            loading: 'Lade Parteidetails...',
        },
        organization: {
            title: 'Organisation',
            relationships: 'Beziehungen',
            relationshipSearchPlaceholder: 'Nach {{label}} suchen...',
            additionalDetails: 'Zusätzliche Details',
            managerSection: 'Vorgesetzte:r',
            managerLabel: 'Vorgesetzte:r',
            managerSearchPlaceholder: 'Nach Name der vorgesetzten Person suchen (mindestens 2 Zeichen)...',
            managerEmptyResults: 'Keine $t(appConfig.domainEntityTypes.IDENTITIES) gefunden',
            managerInactiveAdvisory: 'Diese $t(appConfig.domainEntityTypes.IDENTITY) ist nicht aktiv — bitte bestätigen Sie, dass Sie wirklich eine inaktive Vorgesetzte:n zuweisen wollen.',
            managerSecondaryLabel: '{{primary}} · {{secondary}} (Hinweis)',
        },
        identity: {
            title: '$t(appConfig.domainEntityTypes.IDENTITY)',
            identityType: 'Identitätstyp',
            identityTypePlaceholder: 'Identitätstyp auswählen',
            entryDate: 'Eintrittsdatum',
            entryDateHelper: 'Heute = Sofort aktiv, Zukunft = Gesperrt bis zum Eintrittsdatum',
            entryDatePastError: 'Eintrittsdatum muss heute oder in der Zukunft liegen',
            exitDate: 'Austrittsdatum',
            exitDateHelper: 'Optionales Enddatum für diese $t(appConfig.domainEntityTypes.IDENTITY)',
            identifiers: 'Kennungen',
            addIdentifier: 'Kennung hinzufügen',
            emailLabel: 'E-Mail',
            emailPlaceholder: 'max.mustermann@example.com',
            identifierType: '$t(appConfig.domainEntityTypes.TYPE)',
            identifierValue: 'Wert',
            identifierValuePlaceholder: 'Wert eingeben',
            placeholderEMAIL: 'max.mustermann@example.com',
            placeholderUPN: 'max.mustermann@corp.local',
            placeholderEMPLOYEE_NO: 'MA-12345',
            placeholderCUSTOM: 'Benutzerdefinierter Identifikatorwert',
            primary: 'Primär',
            duplicateError: 'Diese(r) {{type}} wird bereits verwendet.',
            existingIdentities: 'Bestehende $t(appConfig.domainEntityTypes.IDENTITIES)',
            existingIdentifiers: 'Bestehende Kennungen',
            additionalDetails: 'Zusätzliche Details',
        },
        review: {
            title: 'Überprüfung & Absenden',
            personSection: 'Person',
            organizationSection: 'Organisation',
            identitySection: '$t(appConfig.domainEntityTypes.IDENTITY)',
            attributesSection: 'Attribute',
            newLabel: '(neu)',
            editLink: 'Bearbeiten',
            identityTypeLabel: 'Identitätstyp',
            entryDateLabel: 'Eintrittsdatum',
            exitDateLabel: 'Austrittsdatum',
        },
        actions: {
            next: 'Weiter',
            previous: 'Zurück',
            submit: 'Absenden',
            submitting: 'Wird gesendet...',
            cancel: 'Abbrechen',
            newUser: 'Onboarding',
        },
        messages: {
            success: 'Onboarding erfolgreich abgeschlossen',
            successAwaitingEntry: '$t(appConfig.domainEntityTypes.IDENTITY) wird am {{entryDate}} aktiviert',
            submitError: 'Onboarding fehlgeschlagen. Bitte überprüfen Sie die Fehler und versuchen Sie es erneut.',
        },
        cancel: {
            title: 'Änderungen verwerfen?',
            description: 'Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?',
            discard: 'Verwerfen',
            keepEditing: 'Weiter bearbeiten',
        },
        validation: {
            required: 'Dieses Feld ist erforderlich.',
            minLength: 'Muss mindestens {{min}} Zeichen lang sein.',
            maxLength: 'Darf höchstens {{max}} Zeichen lang sein.',
            pattern: 'Der Wert entspricht nicht dem erforderlichen Muster.',
            minValue: 'Muss mindestens {{min}} sein.',
            maxValue: 'Darf höchstens {{max}} sein.',
            invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
            unsafeChars: 'Nur Buchstaben, Ziffern, @, Punkte, Unterstriche und Bindestriche sind erlaubt.',
            exitBeforeEntry: 'Das Austrittsdatum muss nach dem Eintrittsdatum liegen.',
            displayNameMaxLength: 'Der Anzeigename darf maximal 255 Zeichen lang sein.',
            externalIdMaxLength: 'Die externe ID darf maximal 255 Zeichen lang sein.',
            identifierMaxLength: 'Der Identifikatorwert darf maximal 500 Zeichen lang sein.',
        },
    },
    formLayouts: {
        pageTitle: '$t(appConfig.domainEntityTypes.FORM_LAYOUTS) | Admin',
        designerPageTitle: '$t(appConfig.domainEntityTypes.FORM_LAYOUT)-Designer | Admin',
        title: '$t(appConfig.domainEntityTypes.FORM_LAYOUTS)',
        subtitle: 'Onboarding-$t(appConfig.domainEntityTypes.FORM_LAYOUTS) pro Anwendungsfall konfigurieren',
        noPermission: 'Sie haben keine Berechtigung zur Verwaltung von $t(appConfig.domainEntityTypes.FORM_LAYOUTS).',
        emptyCallout: 'Keine benutzerdefinierten Layouts konfiguriert. Alle Formulare verwenden die Standard-Attributsortierung. Klicken Sie auf Bearbeiten bei einem Anwendungsfall, um mit dem Gestalten zu beginnen.',
        statusActive: 'Aktiv',
        statusInactive: 'Inaktiv',
        statusDefault: 'Standard',
        deleteDialogTitle: 'Layout für {{displayName}} löschen?',
        deleteDialogBody: 'Das benutzerdefinierte Layout wird dauerhaft entfernt. Das Onboarding-Formular verwendet sofort wieder die Standard-Attributsortierung.',
        deleteSuccess: 'Layout erfolgreich gelöscht.',
        fieldCount: '{{count}} (von {{total}})',
        fieldCountSuffix: '(von {{total}})',
        columns: {
            useCase: 'Anwendungsfall',
            key: 'Schlüssel',
            formFields: 'Verwendete Formularfelder',
            status: 'Status',
        },
        wizardStepPerson: 'Onboarding → Schritt 1: Person',
        wizardStepOrgRelationships: 'Onboarding → Schritt 2: Organisation (Beziehungen)',
        wizardStepOrgAttributes: 'Onboarding → Schritt 2: Organisation (Zusätzliche Details)',
        wizardStepIdentity: 'Onboarding → Schritt 3: $t(appConfig.domainEntityTypes.IDENTITY)',
        wizardStepIdentityAttributes: 'Onboarding → Schritt 3: $t(appConfig.domainEntityTypes.IDENTITY) (Zusätzliche Details)',
        usedOnPage: 'Verwendet auf:',
        openPage: 'Seite öffnen',
        layoutActiveIndicator: 'Benutzerdefiniertes Layout',
        layoutActiveIndicatorTooltip: 'Für diesen Abschnitt ist ein benutzerdefiniertes $t(appConfig.domainEntityTypes.FORM_LAYOUT) aktiv. Klicken Sie, um den Designer zu öffnen.',
        keyBadgeTooltip: 'Dieser Schlüssel identifiziert, auf welchen Onboarding-Schritt dieses Layout angewendet wird. Er wird vom System vergeben und kann nicht geändert werden.',
        activeTooltip: 'Wenn inaktiv, ignoriert das Onboarding-Formular dieses Layout und verwendet die Standard-Feldreihenfolge.',
        preview: 'Vorschau',
        history: 'Verlauf',
        resetDialogTitle: 'Alle Änderungen zurücksetzen?',
        resetDialogBody: 'Ihre nicht gespeicherten Änderungen gehen verloren und das Layout wird auf die zuletzt gespeicherte Version zurückgesetzt.',
        saveSuccess: 'Layout erfolgreich gespeichert.',
        validationEmptySections: 'Fügen Sie mindestens einen Abschnitt hinzu, bevor Sie speichern.',
        validationEmptySectionLabel: 'Alle Abschnitte müssen vor dem Speichern eine Bezeichnung haben.',
        canvasEmpty: 'Noch keine Abschnitte',
        canvasEmptySubtext: "Klicken Sie unten auf 'Abschnitt hinzufügen' oder ziehen Sie ein Feld aus der Palette auf die Arbeitsfläche, um automatisch den ersten Abschnitt zu erstellen.",
        addSection: 'Abschnitt hinzufügen',
        sectionEmptyState: 'Felder hier aus der Palette ablegen.',
        unnamedSection: 'Unbenannter Abschnitt',
        deleteSectionTitle: "Abschnitt '{{label}}' löschen?",
        deleteSectionBody: 'Alle Felder in diesem Abschnitt werden aus dem Layout entfernt.',
        deleteSectionConfirm: 'Abschnitt löschen',
        columns1: '1 Spalte',
        columns2: '2 Spalten',
        columns3: '3 Spalten',
        paletteEntityFields: 'Entitätsfelder',
        paletteIamDefs: 'IAM-verwaltete Attribute',
        paletteReadOnly: 'Schreibgeschützt (HR-verwaltet)',
        paletteRelationships: 'Beziehungen',
        paletteError: 'Verfügbare Felder konnten nicht geladen werden',
        orphanedFieldTooltip: 'Die $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) dieses Feldes ist nicht mehr aktiv. Es wird beim Rendern des Formulars übersprungen. Entfernen Sie es oder stellen Sie die $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) wieder her.',
        colSpanOverflow: 'Überlauf',
        colSpanOverflowTooltip: 'Spaltenbreite überschreitet Zeilenbreite',
        duplicateFieldToast: "'{{label}}' ist bereits im Layout. Ein Feld kann nur einmal erscheinen.",
        fieldRemovedToast: 'Feld entfernt. Ziehen Sie es aus der Palette, um es wieder hinzuzufügen.',
        fieldProperties: 'Feldeigenschaften',
        sectionProperties: 'Abschnittseigenschaften',
        sectionLabel: 'Bezeichnung',
        sectionLabelPlaceholder: 'Abschnittsbezeichnung...',
        sectionLabelRequired: 'Abschnittsbezeichnung ist erforderlich.',
        sectionColumns: 'Spalten',
        sectionCollapsible: 'Einklappbarer Abschnitt',
        fieldLabel: 'Bezeichnung überschreiben',
        fieldLabelPlaceholder: 'Leer lassen für Standardbezeichnung',
        fieldPlaceholder: 'Platzhalter',
        fieldDefaultValue: 'Standardwert',
        fieldTemplateExpression: 'Vorlagenausdruck',
        templatePreview: 'Vorschau: {{value}}',
        templateUnknownToken: "Unbekannter Token '{{token}}' — wird als leer gerendert.",
        fieldColSpan: 'Spaltenbreite',
        colSpanFull: 'Voll',
        colSpanHalf: 'Halb',
        colSpanThird: 'Drittel',
        colSpanQuarter: 'Viertel',
        colSpanCustom: 'Benutzerdefiniert',
        fieldRequiredOverride: 'Pflichtfeld überschreiben',
        requiredInherit: 'Vererben',
        requiredRequired: 'Pflichtfeld',
        requiredOptional: 'Optional',
        requiredOptionalDisabledTooltip: 'Dieses Feld ist gemäß seiner $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITION) erforderlich und kann im Layout nicht als optional markiert werden.',
        conditionalVisibility: 'Bedingte Sichtbarkeit',
        visibilityShowWhen: 'Feld nur anzeigen wenn',
        visibilityFieldKeyPlaceholder: 'Feld auswählen...',
        visibilityValuePlaceholder: 'Gleichheitswert...',
        visibilityHint: 'Dieses Feld wird ausgeblendet, sofern die ausgewählte Bedingung nicht erfüllt ist.',
        fieldDisabled: 'Feld ist schreibgeschützt (nur Anzeige)',
        fieldHidden: 'Aus dem gerenderten Formular ausblenden',
        previewBanner: 'Vorschaumodus — So erscheint das Formular für Benutzer. Änderungen werden nicht gespeichert.',
        exitPreview: 'Vorschau beenden',
        templateEmployee: 'Mitarbeiter',
        templateContractor: 'Auftragnehmer',
        templateService: 'Dienst',
        templateCustom: 'Benutzerdefiniert',
        previewEmpty: 'Keine Abschnitte zur Vorschau.',
        historyTitle: 'Layout-Verlauf',
        historyEmpty: 'Kein Verlauf verfügbar.',
        historyRestore: 'Diese Version wiederherstellen',
        historyLoadMore: 'Mehr laden',
        historyRestoreToast: 'Historische Version als Entwurf geladen. Änderungen überprüfen und auf Speichern klicken.',
        cancelDialogTitle: 'Layout-Designer verlassen?',
        cancelDialogBody: 'Möchten Sie wirklich zur Layoutliste zurückkehren?',
        cancelDialogBodyDirty: 'Sie haben nicht gespeicherte Änderungen. Wenn Sie jetzt verlassen, gehen Ihre Änderungen verloren.',
        unsavedChangesTitle: 'Ohne Speichern verlassen?',
        unsavedChangesBody: 'Sie haben nicht gespeicherte Änderungen an diesem Layout. Wenn Sie jetzt verlassen, gehen Ihre Änderungen verloren.',
        unsavedChangesStay: 'Bleiben und weiter bearbeiten',
        unsavedChangesLeave: 'Ohne Speichern verlassen',
        conflictTitle: 'Layout wurde von einem anderen Benutzer geändert',
        conflictBody: 'Ihre Änderungen konnten nicht gespeichert werden, da das Layout von {{updatedBy}} am {{updatedAt}} aktualisiert wurde. Sie können Ihre Änderungen verwerfen und die neueste Version laden oder Ihre Änderungen manuell kopieren.',
        conflictKeepEditing: 'Weiter bearbeiten',
        conflictDiscard: 'Änderungen verwerfen und neu laden',
    },
    inboundConnectors: {
        pageTitle: '$t(appConfig.domainEntityTypes.INBOUND_CONNECTORS) | Administration',
        title: '$t(appConfig.domainEntityTypes.INBOUND_CONNECTORS)',
        subtitle: 'Eingehende Datenimport-Konnektoren für Identitätsdaten verwalten',
        allConnectors: 'Alle eingehenden Konnektoren',
        connectorCount: '{{count}} Konnektor(en)',
        createConnector: 'Eingehenden Konnektor erstellen',
        createDescription: 'Erstellen Sie einen neuen eingehenden Konnektor, um Identitätsdaten aus einer externen Quelle zu importieren.',
        displayName: 'Anzeigename',
        displayNamePlaceholder: 'z.B. SAP SuccessFactors HR Import',
        targetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
        selectSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM) auswählen...',
        connectorType: 'Konnektortyp',
        selectType: 'Konnektortyp auswählen',
        schedule: 'Zeitplan',
        schedulePlaceholder: 'Cron-Ausdruck (z.B. 0 0 */4 * * *)',
        schedulePreview: 'Zeitplan: {{preview}}',
        syncTypeFull: 'Vollsynchronisation',
        enabledLabel: 'Aktiviert',
        enabledDescription: 'Diesen Konnektor für geplante Synchronisation aktivieren',
        columns: {
            name: 'Name',
            targetSystem: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
            type: '$t(appConfig.domainEntityTypes.TYPE)',
            status: 'Status',
            lastSync: 'Letzte Synchronisation',
            records: 'Datensätze',
        },
        filterPlaceholder: 'Konnektoren filtern...',
        noConnectorsFound: 'Keine eingehenden Konnektoren konfiguriert. Erstellen Sie einen, um Identitätsdaten aus einem HR-System zu importieren.',
        noConnectorsMatch: 'Keine Konnektoren entsprechen Ihrem Filter.',
        loadingConnectors: 'Konnektoren werden geladen...',
        createSuccess: '$t(appConfig.domainEntityTypes.INBOUND_CONNECTOR) erfolgreich erstellt.',
        allSystemsHaveConnectors: 'Alle Systeme haben bereits $t(appConfig.domainEntityTypes.INBOUND_CONNECTORS) konfiguriert.',
        invalidCronExpression: 'Ungültiger Cron-Ausdruck',
        displayNameRequired: 'Anzeigename ist erforderlich',
        targetSystemRequired: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM) ist erforderlich',
        connectorTypeRequired: 'Konnektortyp ist erforderlich',
        typeRest: 'REST API',
        typeScim: 'SCIM 2.0',
        typeScript: 'Skript',
        typeSapHcm: 'SAP HCM',
        typeSapSfEc: 'SAP SuccessFactors EC',
        sapHcm: {
            connectionSection: 'SAP-HCM-Verbindung',
            connectionDescription: 'OData-V2-Verbindung zu SAP HCM. Wire-Feldnamen (Mitarbeiter-Schlüssel, Gültigkeitsband-Start/-Ende) werden pro Konnektor konfiguriert, sodass nicht-kanonische Hüllen (z. B. eine deutsche HR-Hülle mit mitarbeiterNummer / gültigVon / gültigBis anstelle von PERNR / BEGDA / ENDDA) ohne Code-Änderung unterstützt werden.',
            employeeKeyField: 'Mitarbeiter-Schlüsselfeld',
            validityStartField: 'Gültigkeitsband-Start',
            validityEndField: 'Gültigkeitsband-Ende',
            validityResolutionStrategy: 'Gültigkeitsauflösung',
            terminationAttribute: 'Beendigungsattribut',
            terminationValuesCsv: 'Beendigungswerte',
            enabledInfotypes: 'Aktivierte Infotypen',
            noInfotypes: 'Keine Infotypen aktiviert — Synchronisation liefert keine Datensätze.',
            editDialogTitle: 'SAP-HCM-Konfiguration bearbeiten',
            editDialogDescription: 'Aktualisieren Sie Verbindung, Wire-Feldnamen, Authentifizierung, Pagination, Delta- und Beendigungsoptionen für diesen SAP-HCM-Konnektor. Infotyp- und Attributzuordnungs-Editor werden separat im Tab Abgleich verwaltet.',
            sectionWireFields: 'Wire-Felder & Gültigkeitsauflösung',
            sectionTermination: 'Beendigungserkennung',
            saveSuccess: 'SAP-HCM-Konfiguration gespeichert.',
        },
        sapSfEc: {
            connectionSection: 'SAP-SuccessFactors-EC-Verbindung',
            connectionDescription: 'OData-V2-Verbindung zu SAP SuccessFactors Employee Central. Authentifizierung über OAuth2 Client Credentials oder OAuth2 SAML 2.0 Bearer Assertion.',
            entitySet: 'Entitätsmenge',
            datetimeFormat: 'Datums-/Zeitformat',
            selectFields: '$select-Felder',
            expandFields: '$expand-Felder',
            samlIssuer: 'SAML-Aussteller',
            samlAudience: 'SAML-Audience',
            samlSubject: 'SAML-Subjekt',
            noMappings: 'Keine Attribut-Mappings konfiguriert.',
            editDialogTitle: 'SAP-SuccessFactors-EC-Konfiguration bearbeiten',
            editDialogDescription: 'Aktualisieren Sie Verbindung, Authentifizierung und Pagination für diesen SAP-SuccessFactors-EC-Konnektor. Attributzuordnungen und Antwortfilter werden separat im Tab Abgleich verwaltet.',
            samlSigningKeyRef: 'Referenz auf SAML-Signaturschlüssel',
            samlSigningCertificateRef: 'Referenz auf SAML-Signaturzertifikat',
            samlAssertionTemplate: 'SAML-Assertion-Vorlage',
            samlBearerNote: 'OAuth2 SAML Bearer ist für IAS-vorgeschaltete Mandanten erforderlich. Der IAM-Mandant signiert die SAML-Assertion mit dem konfigurierten privaten Schlüssel und tauscht sie am Token-Endpunkt gegen ein Access Token (RFC 7522).',
            saveSuccess: 'SAP-SuccessFactors-EC-Konfiguration gespeichert.',
        },
        syncStatusRunning: 'Wird ausgeführt',
        syncStatusCompleted: 'Abgeschlossen',
        syncStatusCompletedWithErrors: 'Abgeschlossen mit Fehlern',
        syncStatusFailed: 'Fehlgeschlagen',
        syncStatusCancelled: 'Abgebrochen',
        syncStatusPaused: 'Pausiert',
        never: 'Nie',
        // Detail page
        detailPageTitle: '$t(appConfig.domainEntityTypes.INBOUND_CONNECTOR) Detail | Administration',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
        description: 'Beschreibung',
        noDescription: 'Keine Beschreibung vorhanden.',
        createdAt: 'Erstellt',
        updatedAt: 'Zuletzt geändert',
        // Overview tab
        tabOverview: 'Übersicht',
        tabConfiguration: 'Konfiguration',
        tabSyncRuns: 'Synchronisationsläufe',
        connectorInfo: 'Konnektor-Informationen',
        scheduleSection: 'Zeitplan',
        cronExpression: 'Cron-Ausdruck',
        cronPreview: 'Läuft: {{preview}}',
        nextRun: 'Nächster geplanter Lauf',
        lastSyncSection: 'Letzte Synchronisation',
        lastFullSync: 'Letzte Vollsynchronisation',
        neverSynced: 'Noch nie synchronisiert',
        quickStats: 'Schnellstatistik',
        lastRunStatus: 'Letzter Laufstatus',
        totalRecordsImported: 'Importierte Datensätze',
        manualSync: 'Manuelle Synchronisation',
        runFullSync: 'Vollsynchronisation starten',
        runDeltaSync: 'Delta-Synchronisation starten',
        runPreview: 'Vorschau starten',
        syncFullConfirmation: 'Dies startet eine Vollsynchronisation und importiert alle Datensätze aus dem Quellsystem. Fortfahren?',
        syncDeltaConfirmation: 'Dies startet eine Delta-Synchronisation und importiert nur geänderte Datensätze seit der letzten Synchronisation. Fortfahren?',
        syncPreviewConfirmation: 'Dies führt eine Vorschau-Synchronisation durch, ohne Änderungen anzuwenden. Fortfahren?',
        syncStarted: 'Synchronisation erfolgreich gestartet.',
        syncAlreadyRunning: 'Eine Synchronisation läuft bereits',
        enableFirst: 'Aktivieren Sie zuerst den Konnektor',
        confirmSync: 'Synchronisation bestätigen',
        // Vorschau-Ergebnis-Dialog
        previewResultTitle: 'Vorschau-Ergebnis',
        previewRunning: 'Lade von Quelle…',
        previewWaitingForRecords: 'Lade von Quelle…',
        previewNoRecords: 'Leere Antwort.',
        previewFailed: 'Vorschau fehlgeschlagen.',
        previewStatusLine: 'HTTP {{status}} • {{contentType}}',
        downloadResponse: 'Antwort herunterladen',
        responseFiltersSection: 'Antwort-Filter',
        responseFiltersHint: 'Nur Datensätze behalten, bei denen jedes (Feld = Wert) übereinstimmt (String-Vergleich am Quellwert, z. B. enabled = true). Leer lassen, um alle Datensätze zu behalten.',
        responseFilterFieldPlaceholder: 'enabled',
        responseFilterValuePlaceholder: 'true',
        addResponseFilter: 'Filter hinzufügen',
        // Delete
        deleteConnector: 'Konnektor löschen',
        deleteConfirmation: 'Dies löscht den eingehenden Konnektor und deaktiviert seinen Synchronisationsjob. Die Synchronisationshistorie wird beibehalten. Dies kann nicht rückgängig gemacht werden.',
        deleteSuccess: '$t(appConfig.domainEntityTypes.INBOUND_CONNECTOR) erfolgreich gelöscht.',
        dangerZone: 'Gefahrenzone',
        // Enable/Disable
        enable: 'Aktivieren',
        disable: 'Deaktivieren',
        enableDisable: 'Aktivieren / Deaktivieren',
        enableSuccess: 'Konnektor erfolgreich aktiviert.',
        disableSuccess: 'Konnektor erfolgreich deaktiviert.',
        // Update
        updateSuccess: 'Konnektor erfolgreich aktualisiert.',
        // Configuration tab
        connectionSection: 'REST-Konfiguration',
        connectionDescription: 'Verbindung, Authentifizierung und Synchronisierungseinstellungen.',
        baseUrl: 'Basis-URL',
        itemsEndpoint: 'Elemente-Endpunkt',
        itemsJsonPath: 'Elemente JSON-Pfad',
        responseFormat: 'Antwortformat',
        responseFormatJson: 'JSON',
        responseFormatXml: 'XML',
        responseFormatCsv: 'CSV',
        responseFormatText: 'TEXT',
        itemsPathHelpJson: 'JSON-Pfad zum Elemente-Array, z. B. data.users',
        itemsPathHelpXml: 'XML-Elementpfad zu den Elementen, z. B. users.user',
        itemsPathHelpCsv: '(nicht verwendet — CSV-Kopfzeile definiert die Felder)',
        itemsPathHelpText: '(nicht verwendet — Body wird als einzelner Datensatz zurückgegeben)',
        totalCountJsonPath: 'Gesamtanzahl JSON-Pfad',
        authSection: 'Authentifizierung',
        authType: 'Auth-$t(appConfig.domainEntityTypes.TYPE)',
        authBearer: 'Bearer Token',
        authOAuth2: 'OAuth2 Client Credentials',
        authBasic: 'Basic Auth',
        authApiKey: 'API-Schlüssel',
        authMutualTls: 'Mutual TLS',
        authAwsSigV4: 'AWS SigV4',
        authOAuth2SamlBearer: 'OAuth2 SAML Bearer',
        authNone: 'Keine',
        clientCertSecretRef: 'Referenz auf Client-Zertifikat',
        clientCertSecretRefPlaceholder: 'vault:certs/inbound/client.crt oder env:CLIENT_CERT_PEM',
        clientKeySecretRef: 'Referenz auf Client-Schlüssel',
        clientKeySecretRefPlaceholder: 'vault:certs/inbound/client.key oder env:CLIENT_KEY_PEM',
        truststoreSecretRef: 'Truststore-Referenz (optional)',
        truststoreSecretRefHelp: '(leer = JVM-Standard-CA-Bundle)',
        mtlsSectionHelp: 'Mutual TLS verwendet das vom Betreiber bereitgestellte Client-Zertifikat und den privaten Schlüssel für den TLS-Handshake. Der Truststore ist optional und greift standardmäßig auf das JVM-CA-Bundle zurück. Aktivieren Sie kein Trust-All — Server-Zertifikate werden immer validiert.',
        awsAccessKeySecretRef: 'AWS-Access-Key-Referenz (optional)',
        awsAccessKeySecretRefPlaceholder: 'vault:aws/inbound/access oder env:AWS_ACCESS_KEY',
        awsAccessKeySecretRefHelp: 'Leer lassen für [[IAM-Rolle]] / IRSA / Instance-Profile-Anmeldedaten (in Produktion empfohlen).',
        awsSecretKeySecretRef: 'AWS-Secret-Key-Referenz (optional)',
        awsSecretKeySecretRefPlaceholder: 'vault:aws/inbound/secret oder env:AWS_SECRET_KEY',
        awsRegion: 'AWS-Region',
        awsRegionPlaceholder: 'us-east-1',
        awsService: 'AWS-Service',
        awsServicePlaceholder: 'execute-api',
        sigV4SectionHelp: 'AWS SigV4 signiert jede Anfrage mit Ihren AWS-Anmeldedaten. Lassen Sie in Produktion beide Schlüsselfelder leer und nutzen Sie die [[IAM-Rolle]], die dem laufenden Pod oder der EC2-Instanz zugeordnet ist.',
        authSignedRequest: 'Signierte Anfrage',
        signingAlgorithm: 'Signaturalgorithmus',
        signingKeySecretRef: 'Signaturschlüssel-Referenz',
        signingKeySecretRefPlaceholder: 'vault:signing/keys/inbound oder env:LUMON_TEST_SIGNING_KEY',
        signingHeaderTemplate: 'Signatur-Header-Vorlage',
        signingHeaderTemplatePlaceholder: 'Authorization: Bearer {{signature}}',
        signingHeaderTemplateHelp: 'Verfügbare Platzhalter: {{timestamp}}, {{nonce}}, {{signature}}. Format „Header-Name: Wert" oder nur ein Wert (Standard: Authorization).',
        signingHeaderTemplateNewlineError: 'Zeilenumbrüche sind nicht erlaubt (Schutz vor HTTP-Response-Splitting)',
        signedRequestSectionHelp: 'Signierte Anfragen werden mit HS256, RS256 oder HMAC_SHA256 signiert. Jeder Konnektor sollte einen eigenen Signaturschlüssel verwenden — gemeinsam genutzte Schlüssel schwächen das Sicherheitsmodell.',
        authNtlmKerberos: 'NTLM/Kerberos',
        kerberosPrincipal: 'Kerberos-Principal',
        kerberosPrincipalPlaceholder: 'service@REALM.EXAMPLE.COM',
        kerberosKeytabSecretRef: 'Keytab-Referenz',
        kerberosKeytabSecretRefPlaceholder: 'vault:kerberos/keytab oder env:KERBEROS_KEYTAB',
        kerberosRealm: 'Kerberos-Realm (optional)',
        kerberosRealmHelp: '(leer = aus Principal ableiten)',
        kerberosSectionHelp: 'Kerberos- / NTLM-SSO. Empfohlen: Statt prozessinterner JAAS-Anmeldung einen Kerberos-Sidecar bereitstellen — siehe Betriebsleitfaden in docs/architecture/kerberos-deployment.md.',
        authGoogleSaJwt: 'Google Workspace (JWT-Bearer)',
        googleSaSectionHelp: 'Google-Workspace-JWT-Bearer-Verfahren (RFC 7523). Der Dienstkonto-Schlüssel signiert ein JWT mit seinem privaten RSA-Schlüssel und tauscht es bei https://oauth2.googleapis.com/token gegen ein Access-Token, das auf den delegierten Benutzer beschränkt ist.',
        googleDelegatedUser: 'E-Mail des delegierten Benutzers',
        googleDelegatedUserPlaceholder: 'iam-sync@ihre-domain.com',
        googleDelegatedUserHelp: 'Das Google-Workspace-Administratorkonto, dessen $t(appConfig.domainEntityTypes.IDENTITY) diese Integration übernimmt. Verwenden Sie ein dediziertes nicht-personales Admin-Konto (z. B. iam-sync@ihre-domain.com) — ein persönliches Konto funktioniert nicht mehr, sobald die Person ausscheidet.',
        googleSaEmail: 'Dienstkonto-E-Mail',
        googleSaEmailPlaceholder: 'sync@my-project.iam.gserviceaccount.com',
        googleSaEmailHelp: 'Die E-Mail-Adresse des Dienstkontos (zu finden in der Google Cloud Console unter IAM → Dienstkonten).',
        googleSaKeySecretRef: 'Dienstkonto-Schlüssel-Referenz',
        googleSaKeySecretRefPlaceholder: 'env:GOOGLE_SA_KEY oder vault:secret/iam/google-sa#private_key',
        googleSaKeySecretRefHelp: 'Secret-Referenz auf den privaten RSA-Schlüssel (PKCS#8-PEM). Der aufgelöste Schlüssel wird nie angezeigt — nur der Referenzname.',
        googleTokenScope: 'OAuth-Token-Scope',
        googleTokenScopePlaceholder: 'https://www.googleapis.com/auth/admin.directory.user.readonly',
        googleTokenScopeHelp: 'Leerzeichen-getrennte OAuth-Scopes. Für eine lesende Benutzer-Synchronisation: https://www.googleapis.com/auth/admin.directory.user.readonly',
        googleFieldRequiredError: 'Pflichtfeld, wenn Google Workspace (JWT-Bearer) ausgewählt ist.',
        googleEmailFormatError: 'Muss eine gültige E-Mail-Adresse sein.',
        googleSaKeySecretRefPrefixError: 'Muss mit vault:, env: oder plain: beginnen.',
        googleNewlineError: 'Zeilenumbrüche sind nicht erlaubt.',
        googleSecretMasked: '••••••',
        authTypeChangeWarning: 'Beim Speichern werden die bisherigen Secret-Referenzen des vorigen Auth-Modus gelöscht, wenn Sie den Auth-$t(appConfig.domainEntityTypes.TYPE) ändern.',
        tokenUrl: 'Token-URL',
        clientId: 'Client-ID',
        clientSecretRef: 'Client-Secret-Referenz',
        oauthScope: 'Scope',
        username: 'Benutzername',
        passwordRef: 'Passwort-Referenz',
        tokenRef: 'Token-Referenz',
        apiKeyHeader: 'API-Schlüssel-Header',
        apiKeyRef: 'API-Schlüssel-Referenz',
        paginationSection: 'Paginierung',
        paginationStyle: 'Paginierungsstil',
        pageSize: 'Seitengröße',
        paginationOffset: 'Offset',
        paginationPage: 'Seitennummer',
        paginationCursor: 'Cursor',
        paginationNone: 'Keine',
        timeoutSection: 'Zeitüberschreitungen',
        connectTimeout: 'Verbindungstimeout (ms)',
        readTimeout: 'Lesetimeout (ms)',
        maxRetries: 'Maximale Wiederholungen',
        entityOperationsSection: 'Entitätsoperationen',
        entityOperationsHelp: 'Wählen Sie, welche Operationen dieser Konnektor pro Entitätstyp ausführen darf.',
        operationCreate: 'Erstellen',
        operationUpdate: 'Aktualisieren',
        operationDelete: 'Löschen',
        safeguardsSection: 'Schutzmaßnahmen',
        safeguardsHelp: 'Schutzmaßnahmen pausieren die Synchronisation, wenn Schwellenwerte überschritten werden, und erfordern eine Admin-$t(appConfig.domainEntityTypes.APPROVAL).',
        maxDeletePercent: 'Max. Lösch-%',
        maxDeleteAbsolute: 'Max. Löschungen absolut',
        maxUpdatePercent: 'Max. Aktualisierungs-%',
        maxCreatePercent: 'Max. Erstellungs-%',
        emptySourceProtection: 'Leere-Quelle-Schutz',
        safeguardsEnabled: 'Schutzmaßnahmen aktiviert',
        rehirePolicySection: 'Wiedereinstellungs-Regel',
        rehirePolicyHelp: 'Steuert, wie der Abgleich reagiert, wenn ein eingehender Datensatz auf eine zuvor ausgeschiedene $t(appConfig.domainEntityTypes.IDENTITY) trifft.',
        rehirePolicyLabel: 'Wiedereinstellungs-Regel',
        rehirePolicyHumanReview: 'Manuelle Prüfung erforderlich',
        rehirePolicyAutoResurrect: 'Automatische Wiederherstellung bei Übereinstimmung',
        rehirePolicyIgnore: 'Ignorieren (Rehire-Prüfung überspringen)',
        rehirePolicyHelper: 'Die manuelle Prüfung legt einen Kandidaten an, der von einer Administratorin oder einem Administrator freigegeben werden muss. Die automatische Wiederherstellung reaktiviert die getroffene ausgeschiedene $t(appConfig.domainEntityTypes.IDENTITY) selbständig; der Konnektor wird als Entscheider protokolliert. Ignorieren überspringt die Rehire-Prüfung vollständig und legt eine neue $t(appConfig.domainEntityTypes.IDENTITY) an — nur für Quellen verwenden, die nicht autoritativ für den Identitätslebenszyklus sind.',
        rehirePolicyIgnoreAuthoritativeWarning: 'Dieses $t(appConfig.domainEntityTypes.TARGET_SYSTEM) ist autoritativ für den Identitätslebenszyklus. Das Überspringen der Rehire-Prüfung kann die Audit-Verknüpfung zwischen ausgeschiedenen und wiedereingestellten $t(appConfig.domainEntityTypes.IDENTITIES) brechen. Für Compliance-Prüfungen erforderlich.',
        editRehirePolicy: 'Wiedereinstellungs-Regel bearbeiten',
        editRehirePolicyDescription: 'Legt fest, wie Übereinstimmungen mit ausgeschiedenen $t(appConfig.domainEntityTypes.IDENTITIES) behandelt werden.',
        decidedByConnector: 'durch Konnektor {{name}}',
        validationSection: 'Validierung',
        validationHelp: 'Steuert, wie streng importierte Daten validiert werden. WARN protokolliert Verstöße, importiert den Datensatz aber. OFF überspringt die Validierung vollständig.',
        attributeValidation: 'Attribut-Validierung',
        relationshipSchema: 'Beziehungsschema',
        identifierUniqueness: 'Identifikator-Eindeutigkeit',
        enforcementStrict: 'Streng',
        enforcementWarn: 'Warnung',
        enforcementOff: 'Aus',
        attributeMappingsSection: 'Attribut-Zuordnungen',
        attributeMappingsHelp: 'JSON-Zuordnung von Quellfeldern zu IAM-$t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS).',
        invalidJson: 'Ungültiges JSON',
        scimSection: 'SCIM-Konfiguration',
        scimFilter: 'SCIM-Filter',
        enterpriseExtension: 'Enterprise-Erweiterung',
        testConnection: 'Verbindung testen',
        testConnectionSuccess: 'Verbindung erfolgreich hergestellt',
        testConnectionFailed: 'Verbindung fehlgeschlagen',
        testConnectionTime: '{{ms}}ms',
        noConfig: 'Konfigurieren Sie die Verbindung, um mit der Synchronisation zu beginnen. Setzen Sie die Basis-URL und die Authentifizierung und testen Sie die Verbindung.',
        saveConfig: 'Konfiguration speichern',
        // Edit dialogs
        editRestConfig: 'REST-Konfiguration bearbeiten',
        editRestConfigDescription: 'Verbindungs-, Authentifizierungs- und Synchronisationseinstellungen aktualisieren.',
        editScimConfig: 'SCIM-Konfiguration bearbeiten',
        editScimConfigDescription: 'SCIM-Filter und Enterprise-Erweiterungseinstellungen aktualisieren.',
        editSafeguards: 'Sicherheitsmechanismen bearbeiten',
        editSafeguardsDescription: 'Schwellenwerte und Schutzeinstellungen aktualisieren.',
        editValidation: 'Validierung bearbeiten',
        editValidationDescription: 'Validierungs- und Stapelverarbeitungseinstellungen aktualisieren.',
        editEntityOperations: 'Entitätsoperationen bearbeiten',
        editEntityOperationsDescription: 'Erlaubte Operationen pro Entitätstyp aktualisieren.',
        restConfigSaveSuccess: 'REST-Konfiguration erfolgreich gespeichert.',
        scimConfigSaveSuccess: 'SCIM-Konfiguration erfolgreich gespeichert.',
        settingsSaveSuccess: 'Einstellungen erfolgreich gespeichert.',
        sectionConnection: 'Verbindung',
        sectionAuthentication: 'Authentifizierung',
        sectionPagination: 'Paginierung',
        sectionTimeouts: 'Timeouts',
        unsavedChangesTitle: 'Ungespeicherte Änderungen',
        unsavedChangesMessage: 'Sie haben ungespeicherte Änderungen. Wenn Sie die Seite verlassen, gehen Ihre Änderungen verloren.',
        unsavedChangesLeave: 'Verlassen',
        unsavedChangesStay: 'Bleiben',
        queryFilter: 'Abfragefilter',
        queryParams: 'Query-Parameter',
        queryParamsPlaceholder: 'enabled=true&emailVerified=true',
        fullUrl: 'Vollständige URL',
        batchSize: 'Batch-Größe',
        secretRefPlaceholder: 'Geheimnis-Referenz (leer lassen, um bestehenden zu behalten)',
        correlationRulesSection: 'Korrelationsregeln',
        correlationRulesHelp: 'Regeln, die eingehende Datensätze mit bestehenden IAM-Entitäten abgleichen.',
        correlationRulesEmpty: 'Keine Korrelationsregeln konfiguriert. Datensätze werden nach externer ID abgeglichen.',
        // Sync Runs tab
        syncRunsEmpty: 'Noch keine Synchronisationsläufe. Starten Sie eine Synchronisation auf der Übersichtsseite.',
        syncRunType: '$t(appConfig.domainEntityTypes.TYPE)',
        syncRunStatus: 'Status',
        syncRunStarted: 'Gestartet',
        syncRunDuration: 'Dauer',
        syncRunDurationValue: '{{seconds}}s',
        syncRunCreated: 'Erstellt',
        syncRunUpdated: 'Aktualisiert',
        syncRunSkipped: 'Übersprungen',
        syncRunErrored: 'Fehlerhaft',
        syncRunTriggeredBy: 'Ausgelöst von',
        syncRunErrorMessage: 'Fehlermeldung',
        syncTypePreview: 'Vorschau',
        cancelSync: 'Abbrechen',
        activeRun: 'Aktiver Lauf',
        pausedTooltip: 'Diese Synchronisation ist pausiert. Überprüfen Sie die Staging-Datensätze und genehmigen Sie die Änderungen oder lehnen Sie den Lauf ab.',
        // Staging-Datensätze (Issue 145)
        syncRunRecordsTitle: 'Staging-Datensätze',
        syncRunRecordsFilterAll: 'Alle Aktionen',
        syncRunRecordsEmpty: 'Noch keine Staging-Datensätze.',
        syncRecordExternalId: 'Externe ID',
        syncRecordEntityType: 'Entitätstyp',
        syncRecordAction: 'Aktion',
        syncRecordCorrelatedIdentity: 'Zugeordnete $t(appConfig.domainEntityTypes.IDENTITY)',
        syncRecordProcessedAt: 'Verarbeitet am',
        syncRecordErrorMessage: 'Fehlermeldung',
        syncRecordRawData: 'Rohdaten',
        syncRecordMappedData: 'Gemappte Daten',
        syncRecordPayloadCleared: '(Payload nach erfolgreicher Verarbeitung gelöscht)',
        syncRecordPayloadPreProcessing: '(Payload ausstehend — Datensatz noch nicht verarbeitet)',
        syncRecordShowPayload: 'Payload anzeigen',
        syncRecordHidePayload: 'Payload ausblenden',
        syncRunErrorLogsTitle: '$t(appConfig.domainEntityTypes.ERROR_LOG)-Einträge je Datensatz',
        syncRunErrorLogsHint: 'Jeder Eintrag ist eine Zeile in der Tabelle error_logs. Über die IDs unten können die vollständige Ausnahme, der Stacktrace und der Kontext nachgeschlagen werden.',
        syncRunErrorLogsCountLabel: '{{count}} Einträge',
        syncRunErrorLogsCountLabel_one: '{{count}} Eintrag',
        syncRunErrorLogsCountLabel_other: '{{count}} Einträge',
        syncRunErrorLogsEmpty: 'Keine $t(appConfig.domainEntityTypes.ERROR_LOG)-Einträge je Datensatz — jeder Datensatz wurde sauber angewendet oder übersprungen.',
        syncRunErrorLogIdHeader: '$t(appConfig.domainEntityTypes.ERROR_LOG)-ID',
        syncRunErrorLogCreatedAtHeader: 'Protokolliert am',
        // Strukturierte Reconciler-Fehlercodes (Issue 338.01 — Rehire-Sicherheitsnetz)
        errorCode: {
            TERMINATED_MATCH_NEEDS_REVIEW: 'Beendet – Überprüfung erforderlich',
        },
        syncRunApprove: 'Genehmigen',
        syncRunReject: 'Ablehnen',
        syncRunApproveTitle: 'Pausierte Synchronisation genehmigen',
        syncRunApproveBody: 'Die in diesem Synchronisationslauf bereitgestellten Änderungen werden auf die Produktionsdaten angewendet. Dies kann nicht rückgängig gemacht werden.',
        syncRunRejectTitle: 'Pausierte Synchronisation ablehnen',
        syncRunRejectBody: 'Die Synchronisation wird abgebrochen und keine Änderungen werden angewendet. Die Staging-Datensätze bleiben zu Prüfzwecken erhalten.',
        syncRunApproveSuccess: 'Synchronisationslauf genehmigt. Bereitgestellte Änderungen werden angewendet.',
        syncRunRejectSuccess: 'Synchronisationslauf abgelehnt. Staging-Datensätze bleiben zu Prüfzwecken erhalten.',
        // Konfigurations-Unterseiten (Issue 547.04)
        configNavConnection: 'Verbindung',
        configNavConnectionDescription: 'Basis-URL, Authentifizierung, Antwortformat, Pagination, Zeitlimits.',
        configNavReconciliation: 'Abgleich',
        configNavReconciliationDescription: 'Wiedereinstellungsrichtlinie, Korrelationsregeln und Attributzuordnungen.',
        configNavOperations: 'Operationen',
        configNavOperationsDescription: 'Entitätsoperationen, Validierung und Schutzmaßnahmen.',
        configNavSelectorAria: 'Konfigurations-Unterseite',
        editRehirePolicyInline: 'Wiedereinstellungsrichtlinie bearbeiten',
        editValidationLevelInline: 'Validierungsstufe bearbeiten',
        editSafeguardsValueInline: 'Schutzmaßnahmen-Wert bearbeiten',
        editEntityOperationInline: 'Entitätsoperation umschalten',
        addCorrelationRule: 'Korrelationsregel hinzufügen',
        correlationRulesNotConfigured: 'Keine Korrelationsregeln definiert. Der Reconciler verwendet den Standardabgleich über die externe ID.',
        connectionEmptyState: 'Verbindung konfigurieren, um die Synchronisation zu starten.',
        inlineEditError: 'Speichern fehlgeschlagen: {{message}}',
        inlineEditConflictTitle: 'Aktualisierungskonflikt',
        inlineEditConflictDescription: 'Der Konnektor wurde durch eine andere Sitzung aktualisiert. Die aktuellsten Werte werden geladen.',
    },
    transformParams: {
        title: 'Parameter',
        zone: 'Zeitzone',
        zonePlaceholder: 'UTC',
        value: 'Wert',
        search: 'Suchen',
        replacement: 'Ersetzen durch',
        delimiter: 'Trennzeichen',
        index: 'Index',
        sources: 'Quellfelder',
        sourcesPlaceholder: 'firstName, lastName',
        pattern: 'Muster',
        group: 'Erfassungsgruppe',
        equals: 'Gleich',
        then: 'Dann',
        elseValue: 'Sonst',
        requiredField: '{{field}} ist erforderlich',
        notInteger: '{{field}} muss eine Ganzzahl sein',
        invalidRegex: 'Ungültiger regulärer Ausdruck',
        descriptions: {
            toAdGeneralizedTime: 'Formatiert ein Datum/eine Uhrzeit als Active-Directory-GeneralizedTime (yyyyMMddHHmmss.0Z). Eine optionale Zeitzone verschiebt den Wert vor der Formatierung.',
            toWindowsFiletime: 'Konvertiert ein Datum/eine Uhrzeit in eine Windows-FILETIME (100-Nanosekunden-Ticks seit 1601). Eine optionale Zeitzone verschiebt den Wert vor der Konvertierung.',
            prefix: 'Stellt dem Quellwert eine feste Zeichenkette voran. z. B. macht der Wert `EMP-` aus `1024` den Wert `EMP-1024`.',
            suffix: 'Hängt eine feste Zeichenkette an den Quellwert an. z. B. macht der Wert `@corp.com` aus `jdoe` den Wert `jdoe@corp.com`.',
            replace: 'Ersetzt jedes Vorkommen einer Teilzeichenkette durch eine andere. z. B. macht Suchen `_` Ersetzen `-` aus `a_b_c` den Wert `a-b-c`.',
            split: 'Teilt den Quellwert an einem Trennzeichen und gibt das Element am 0-basierten Index zurück. z. B. macht Trennzeichen `,` Index `1` aus `a,b,c` den Wert `b`.',
            join: 'Fügt mehrere Quellfelder zu einem Wert zusammen, getrennt durch ein Trennzeichen. z. B. ergeben die Felder `firstName, lastName` mit einem Leerzeichen als Trennzeichen `Jane Doe`.',
            regexExtract: 'Extrahiert den ersten Treffer eines regulären Ausdrucks, optional eine Erfassungsgruppe. z. B. ergibt das Muster `(\\d+)` bei `id-42` den Wert `42`.',
            conditional: 'Wenn der Quellwert einem Wert entspricht, wird ein Ergebnis ausgegeben, andernfalls ein anderes. z. B. Gleich `active` Dann `1` Sonst `0`.',
            lookupOrgUnit: 'Löst einen Organisationseinheits-Code während des Provisionings in seinen Anzeigenamen auf.',
            resolveManager: 'Löst eine Vorgesetzten-Referenz in die Kennung des Vorgesetzten im $t(appConfig.domainEntityTypes.TARGET_SYSTEM) auf.',
            toDate: 'Interpretiert den Quellwert als Datum und formatiert ihn als Datumswert neu.',
            toUppercase: 'Wandelt den Quellwert in Großbuchstaben um. z. B. wird aus `jdoe` der Wert `JDOE`.',
            toLowercase: 'Wandelt den Quellwert in Kleinbuchstaben um. z. B. wird aus `JDOE` der Wert `jdoe`.',
        },
    },
    inboundAttributeMappings: {
        title: 'Attributzuordnungen',
        description: 'Legen Sie fest, wie Felder des Quellsystems während der eingehenden Synchronisation IAM-Entitätsattributen zugeordnet werden.',
        descriptionDetail: 'Jede Zeile ordnet einen Quellfeldpfad (z.B. name.givenName) einem IAM-Attribut, einem Entitätstyp und einer optionalen Transformation zu.',
        source: 'Quelle',
        sourceHint: 'Externer Feldpfad (z.B. name.givenName, emails[type=work])',
        target: 'Ziel',
        targetHint: 'IAM-Attributname',
        type: '$t(appConfig.domainEntityTypes.TYPE)',
        typeDirect: 'Direkt',
        typeComputed: 'Berechnet',
        typeStatic: 'Statisch',
        targetEntityType: 'Entitätstyp',
        entityTypeParty: '$t(appConfig.domainEntityTypes.PARTY)',
        entityTypeIdentity: '$t(appConfig.domainEntityTypes.IDENTITY)',
        entityTypeResource: '$t(appConfig.domainEntityTypes.RESOURCE)',
        entityTypeFunctionGroup: '$t(appConfig.domainEntityTypes.FUNCTION_GROUP)',
        identifierType: 'Bezeichnertyp',
        identifierTypePlaceholder: 'z.B. EMAIL',
        transform: 'Transformation',
        transformNone: 'Keine',
        transformLookupOrgUnit: 'Organisationseinheit nachschlagen',
        transformResolveManager: 'Vorgesetzten auflösen',
        transformToDate: 'In Datum umwandeln',
        transformToUppercase: 'In Großbuchstaben',
        transformToLowercase: 'In Kleinbuchstaben',
        transformToAdGeneralizedTime: 'In AD GeneralizedTime',
        transformToWindowsFiletime: 'In Windows FILETIME',
        transformPrefix: 'Präfix hinzufügen',
        transformSuffix: 'Suffix hinzufügen',
        transformReplace: 'Ersetzen',
        transformSplit: 'Aufteilen',
        transformJoin: 'Zusammenführen',
        transformRegexExtract: 'Regex-Extraktion',
        transformConditional: 'Bedingt',
        required: 'Pflichtfeld',
        addMappingAction: '+ Hinzufügen',
        confirmDelete: 'Diese Zuordnung entfernen?',
        noMappings: 'Keine Attributzuordnungen konfiguriert',
        noMappingsWarning: 'Identitätsattribute werden nicht importiert, bis Attributzuordnungen konfiguriert sind.',
        sourceRequired: 'Quelle ist erforderlich',
        sourceExceedsMaxLength: 'Quelle überschreitet 500 Zeichen',
        targetRequired: 'Ziel ist erforderlich',
        targetExceedsMaxLength: 'Ziel überschreitet 100 Zeichen',
        targetNotInSchema: 'Nicht im Attribut-Schema von {{typeCode}} — Wert wird beim Sync stillschweigend verworfen',
        createPartyToggle: '$t(appConfig.domainEntityTypes.PARTY) erstellen ({{typeCode}})',
        createPartyToggleHeader: '$t(appConfig.domainEntityTypes.PARTY) erstellen',
        createPartyHint: 'Pro importiertem Datensatz einen $t(appConfig.domainEntityTypes.PARTY)-Eintrag anlegen.',
        createIdentityToggle: '$t(appConfig.domainEntityTypes.IDENTITY) erstellen ({{typeCode}})',
        createIdentityToggleHeader: '$t(appConfig.domainEntityTypes.IDENTITY) erstellen',
        createIdentityHint: 'Eine $t(appConfig.domainEntityTypes.IDENTITY) anlegen, die mit der $t(appConfig.domainEntityTypes.PARTY) verknüpft ist.',
        createAccountToggle: 'Konto erstellen',
        createAccountHint: 'Pro Datensatz ein Konto auf dem $t(appConfig.domainEntityTypes.TARGET_SYSTEM) dieses Connectors anlegen, verknüpft mit der $t(appConfig.domainEntityTypes.IDENTITY). Die externe ID stammt aus dem id-Feld der Quelle.',
        addPartyMapping: '$t(appConfig.domainEntityTypes.PARTY)-Mapping hinzufügen',
        addIdentityAttribute: 'Identitäts-Attribut hinzufügen',
        addIdentityIdentifier: 'Identitäts-Identifier hinzufügen',
        noPartyMappings: 'Noch keine $t(appConfig.domainEntityTypes.PARTY)-Mappings.',
        noIdentityMappings: 'Noch keine Identitäts-Mappings.',
        externalIdFieldLabel: 'Quellfeld für externe ID',
        externalIdFieldPlaceholder: 'id',
        externalIdFieldHint: 'Quellfeld, dessen Wert zur externen ID des Staging-Datensatzes und des Kontos wird. Standard: "id".',
        lifecycleSourceFieldLabel: 'Quellfeld für Lebenszyklus',
        lifecycleSourceFieldPlaceholder: 'enabled',
        lifecycleSourceFieldHint: 'Quellfeld, das Konto AKTIV / DEAKTIVIERT steuert. $t(appConfig.domainEntityTypes.IDENTITY) wird automatisch suspendiert, wenn alle Konten deaktiviert sind. Leer lassen zum Überspringen.',
        lifecycleEnabledValueLabel: 'AKTIV-Werte',
        lifecycleEnabledValuePlaceholder: 'true,1,ACTIVE,ENABLED',
        lifecycleEnabledValueHint: 'Komma-getrennte Liste von Quellwerten, die ENABLED bedeuten — String-Vergleich, Groß-/Kleinschreibung egal. Jeder Treffer → ENABLED, alles andere → DISABLED.',
        duplicateTarget: 'Doppeltes Ziel + Entitätstyp-Kombination: {{name}}',
        invalidTemplateSyntax: 'Ungültige Vorlagensyntax (nicht geschlossene oder verschachtelte geschweifte Klammern)',
        maxMappingsTooltip: 'Maximal 50 Attributzuordnungen erreicht',
        saved: 'Attributzuordnungen gespeichert',
        cleared: 'Attributzuordnungen geleert',
        sourceHintComputed: '{firstName} {lastName}',
        sourceHintStatic: 'Literalwert',
    },
    valueLists: {
        pageTitle: '$t(appConfig.domainEntityTypes.VALUE_LISTS) | Administration',
        title: '$t(appConfig.domainEntityTypes.VALUE_LISTS)',
        subtitle: 'Benutzerdefinierte $t(appConfig.domainEntityTypes.VALUE_LISTS) für $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) verwalten',
        detailPageTitle: '$t(appConfig.domainEntityTypes.VALUE_LIST) | Administration',
        columns: {
            name: 'Name',
            displayName: 'Anzeigename',
            description: 'Beschreibung',
            entryCount: 'Einträge',
            active: 'Aktiv',
        },
        entriesTable: {
            title: 'Einträge',
            code: 'Code',
            label: 'Bezeichnung',
            description: 'Beschreibung',
            sortOrder: 'Reihenfolge',
            active: 'Aktiv',
            empty: 'Noch keine Einträge. Fügen Sie den ersten Eintrag hinzu.',
            dragToReorder: 'Zum Umsortieren ziehen',
        },
        actions: {
            createList: 'Neue $t(appConfig.domainEntityTypes.VALUE_LIST)',
            editList: 'Liste bearbeiten',
            deleteList: 'Liste löschen',
            addEntry: 'Eintrag hinzufügen',
            editEntry: 'Eintrag bearbeiten',
            deleteEntry: 'Eintrag löschen',
        },
        form: {
            createTitle: '$t(appConfig.domainEntityTypes.VALUE_LIST) erstellen',
            createDescription: 'Eine neue benutzerdefinierte $t(appConfig.domainEntityTypes.VALUE_LIST) für $t(appConfig.domainEntityTypes.ATTRIBUTE_DEFINITIONS) erstellen.',
            editTitle: '$t(appConfig.domainEntityTypes.VALUE_LIST) bearbeiten',
            editDescription: 'Metadaten der $t(appConfig.domainEntityTypes.VALUE_LIST) aktualisieren.',
            namePlaceholder: 'z.B. clearance_levels',
            nameHelp: 'Nur Kleinbuchstaben, Zahlen und Unterstriche. Kann nach der Erstellung nicht mehr geändert werden.',
            displayNamePlaceholder: 'z.B. Sicherheitsstufen',
            descriptionPlaceholder: 'Optionale Beschreibung',
            entryCodePlaceholder: 'z.B. HIGH',
            entryCodeHelp: 'Nur Großbuchstaben, Zahlen und Unterstriche.',
            entryLabelPlaceholder: 'z.B. Hoch',
            entryDescriptionPlaceholder: 'Optionale Beschreibung',
            addEntryTitle: 'Eintrag hinzufügen',
            addEntryDescription: 'Einen neuen Eintrag zu dieser $t(appConfig.domainEntityTypes.VALUE_LIST) hinzufügen.',
            editEntryTitle: 'Eintrag bearbeiten',
            editEntryDescription: 'Den Wert dieses Eintrags aktualisieren.',
        },
        messages: {
            createSuccess: '$t(appConfig.domainEntityTypes.VALUE_LIST) erfolgreich erstellt.',
            updateSuccess: '$t(appConfig.domainEntityTypes.VALUE_LIST) erfolgreich aktualisiert.',
            deleteSuccess: '$t(appConfig.domainEntityTypes.VALUE_LIST) gelöscht.',
            addEntrySuccess: 'Eintrag erfolgreich hinzugefügt.',
            updateEntrySuccess: 'Eintrag erfolgreich aktualisiert.',
            deleteEntrySuccess: 'Eintrag gelöscht.',
            reorderSuccess: 'Einträge umsortiert.',
            confirmDeleteList: 'Möchten Sie diese $t(appConfig.domainEntityTypes.VALUE_LIST) wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
            confirmDeleteEntry: 'Möchten Sie diesen Eintrag wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        },
        noLists: 'Keine $t(appConfig.domainEntityTypes.VALUE_LISTS) gefunden.',
        selectList: '$t(appConfig.domainEntityTypes.VALUE_LIST) auswählen',
        customListLabel: 'Benutzerdefinierte Liste',
    },
    requestInspector: {
        pageTitle: 'Request Inspector',
        title: 'Request Inspector',
        description: 'HTTP-Traces und Session-Timelines inspizieren',
        searchPlaceholder: 'Suche nach Operations-Name oder HTTP-URL (mind. 3 Zeichen)...',
        minQHint: 'Bitte mindestens 3 Zeichen eingeben.',
        searchScopeHint: 'Die Suche durchsucht ausschließlich Operations-Namen und HTTP-URLs — diagnostische Spalten (SQL-Fingerprints, Fehlermeldungen, Trace-IDs) werden bewusst ausgeschlossen.',
        filterSession: 'Session-ID...',
        filterUser: 'Benutzer-ID...',
        filterErrorsOnly: 'Nur Fehler',
        filterSlowerThan: 'Langsamer als (ms)...',
        allSessions: 'Alle Sessions',
        clearFilters: 'Filter zurücksetzen',
        refresh: 'Aktualisieren',
        writerOffline: 'Der Span-Writer ist offline — neue Spans werden möglicherweise nicht aufgezeichnet.',
        columns: {
            sessionId: 'Session',
            spanCount: 'Spans',
            errorCount: 'Fehler',
            totalDuration: 'Dauer',
            earliestStartedAt: 'Gestartet',
            latestStartedAt: 'Letzter Span',
            e2eTestClass: 'E2E-Klasse',
        },
        noSessions: 'Noch keine Sessions aufgezeichnet.',
        noSessionsMatch: 'Keine Sessions entsprechen den aktuellen Filtern.',
        detail: {
            title: 'Session-Detail',
            back: 'Request Inspector',
            sessionId: 'Session-ID',
            spanCount: 'Spans',
            errorCount: 'Fehler',
            totalDuration: 'Gesamtdauer',
            startedAt: 'Gestartet',
            endedAt: 'Beendet',
            e2eRunId: 'E2E-Run-ID',
            e2eTestClass: 'E2E-Testklasse',
            e2eTestMethod: 'E2E-Testmethode',
            downloadTrace: 'Trace als JSON herunterladen',
            requestsTitle: '[[HTTP-Anfragen]]',
            noRequests: 'Keine [[HTTP-Anfragen]] in dieser Session aufgezeichnet.',
            columns: {
                method: 'Methode',
                url: 'URL',
                status: 'Status',
                duration: 'Dauer',
                sqlCount: 'SQL-Abfragen',
                sqlTime: 'SQL-Zeit',
            },
        },
        requestDetail: {
            title: 'Anfragen-Detail',
            back: 'Session',
            noSpans: 'Keine Spans für diese Anfrage gefunden.',
        },
        waterfall: {
            title: 'Span-Zeitleiste',
            colSpan: 'Span',
            colDuration: 'Dauer',
            colStatus: 'Status',
            sortByTime: 'Nach Zeit',
            sortByDuration: 'Nach Dauer',
            filterAll: 'Alle',
        },
        spanDetail: {
            title: 'Span-Detail',
            tabOverview: 'Übersicht',
            tabHttp: 'HTTP',
            tabSql: 'SQL',
            tabAttributes: 'Attribute',
            tabError: 'Fehler',
            spanId: 'Span-ID',
            traceId: 'Trace-ID',
            parentSpanId: 'Eltern-Span-ID',
            kind: '$t(appConfig.domainEntityTypes.TYPE)',
            operationName: 'Operation',
            status: 'Status',
            startedAt: 'Gestartet',
            endedAt: 'Beendet',
            durationMs: 'Dauer',
            sessionId: 'Session-ID',
            actionId: 'Aktions-ID',
            correlationId: 'Korrelations-ID',
            authUserId: 'Auth-Benutzer-ID',
            identityId: 'Identitäts-ID',
            httpMethod: 'Methode',
            httpUrl: 'URL',
            httpStatusCode: 'HTTP-Status',
            httpResponseBytes: 'Antwortgröße',
            sqlFingerprint: 'Abfrage-Schlüssel',
            sqlStatement: 'SQL-Anweisung',
            sqlRowsAffected: 'Betroffene Zeilen',
            sqlPoolWaitMs: 'Pool-Wartezeit',
            errorCode: 'Fehlercode',
            errorMessage: 'Fehlermeldung',
            errorLogId: '$t(appConfig.domainEntityTypes.ERROR_LOG)-ID',
            viewErrorLog: '$t(appConfig.domainEntityTypes.ERROR_LOG) anzeigen',
        },
    },
    help: {
        toggleHelp: 'Hilfe ein-/ausschalten',
        learnMore: 'Mehr erfahren',
    },
    associationEditor: {
        searchPlaceholder: 'Zum Hinzufügen suchen...',
        emptyMessage: 'Keine Einträge ausgewählt.',
        removeAriaLabel: '{{label}} entfernen',
        conflictToast: 'Dieser Datensatz wurde von einem anderen Benutzer geändert. Die Liste wurde mit den aktuellen Daten aktualisiert.',
    },
    scriptConnector: {
        title: 'Skript-Konfiguration',
        description: 'Groovy-Skript-Konfiguration für benutzerdefinierte Bereitstellungsoperationen.',
        baseUrl: 'Basis-URL',
        baseUrlPlaceholder: 'https://api.beispiel.de',
        apiKeyHeaderPlaceholder: 'X-Api-Key',
        authType: 'Authentifizierungstyp',
        connectTimeoutMs: 'Verbindungs-Timeout (ms)',
        readTimeoutMs: 'Lese-Timeout (ms)',
        operations: 'Operationen',
        script: 'Connector-Skript',
        scriptDescription: 'Ein Groovy-Blob mit allen Operationsmethoden. Gemeinsame Hilfsfunktionen können am Anfang definiert und von jeder Methode aufgerufen werden.',
        enabled: 'Aktiviert',
        createConfig: 'Skript-Connector konfigurieren',
        editConfig: 'Skript-Konfiguration bearbeiten',
        validateScript: 'Skript validieren',
        validationSuccess: 'Skript ist gültig.',
        validationError: 'Skript-Validierung fehlgeschlagen.',
        validationWarning: '{{count}} Warnung(en)',
        errorAtLine: 'Zeile {{line}}, Spalte {{column}}: {{message}}',
        noBaseUrl: 'Keine Basis-URL',
        configured: 'Konfiguriert',
        notConfigured: 'Nicht konfiguriert',
        badgeSupported: 'Methode vorhanden',
        badgeUnsupported: 'Methode fehlt',
        badgeDisabled: 'Deaktiviert',
        unsavedChanges: 'Sie haben ungespeicherte Änderungen. Trotzdem verlassen?',
        testConnection: 'Verbindung testen',
        testConnectionTesting: 'Teste...',
        testConnectionSuccess: 'Verbunden',
        testConnectionFailure: 'Verbindung fehlgeschlagen',
        noConfig: 'Keine Skript-Konfiguration. Klicken Sie auf "Skript-Connector konfigurieren", um Skripte für diesen Connector einzurichten.',
        noConfigFound: 'Keine Skript-Konfiguration gefunden. Konfigurieren Sie den Connector zuerst.',
        createSuccess: 'Skript-Konfiguration erfolgreich erstellt.',
        updateSuccess: 'Skript-Konfiguration erfolgreich aktualisiert.',
        createDialogTitle: 'Skript-Konfiguration erstellen',
        createDialogDescription: 'Authentifizierung, Skript und Timeouts für diesen Skript-Connector konfigurieren.',
        editDialogTitle: 'Skript-Konfiguration bearbeiten',
        editDialogDescription: 'Authentifizierung, Skript und Timeouts für diesen Skript-Connector aktualisieren.',
        sectionAuthentication: 'Authentifizierung',
        sectionBaseUrl: 'Basis-URL',
        sectionScript: 'Connector-Skript',
        sectionOperations: 'Operationen',
        sectionTimeouts: 'Timeouts',
        typeScript: 'Skript',
        timeoutValidation: 'Muss zwischen {{min}} und {{max}} ms liegen',
        operationLabels: {
            createAccount: 'Konto erstellen',
            updateAccount: 'Konto aktualisieren',
            disableAccount: 'Konto deaktivieren',
            enableAccount: 'Konto aktivieren',
            deleteAccount: 'Konto löschen',
            grant: 'Zuweisen',
            revoke: 'Entziehen',
            testConnection: 'Verbindungstest',
            fullSync: 'Vollsynchronisation',
            createOp: 'Anlegen',
            updateOp: 'Aktualisieren',
            deleteOp: 'Löschen',
            queryOp: 'Abfragen',
        },
    },
    unifiedSearch: {
        bar: {
            placeholder: 'Suchen...',
            clearSearch: 'Suchtext löschen',
            openFilters: 'Filter öffnen',
            activeFiltersIndicator: 'Aktive Filter',
        },
        panel: {
            title: 'Filter',
            apply: 'Anwenden',
            clearAll: 'Alle löschen',
            notSet: 'Nicht gesetzt',
            any: 'Alle',
            yes: 'Ja',
            no: 'Nein',
            from: 'Von',
            to: 'Bis',
            pickDate: 'Datum wählen',
            pickDateTime: 'Datum und Uhrzeit wählen',
            time: 'Uhrzeit',
            uuidPlaceholder: 'UUID eingeben (Entity-Picker folgt)',
        },
        calendar: {
            prevMonth: 'Vorheriger Monat',
            nextMonth: 'Nächster Monat',
            prevYear: 'Vorheriges Jahr',
            nextYear: 'Nächstes Jahr',
            pickYear: 'Jahr wählen',
            backToDays: 'Zurück zur Monatsansicht',
            prevDecade: 'Vorheriges Jahrzehnt',
            nextDecade: 'Nächstes Jahrzehnt',
            weekdayHeader: 'Kalendertage',
            weekdayShort: {
                sun: 'So',
                mon: 'Mo',
                tue: 'Di',
                wed: 'Mi',
                thu: 'Do',
                fri: 'Fr',
                sat: 'Sa',
            },
        },
        chip: {
            removeLabel: 'Filter entfernen: {{name}} {{values}}',
            moreSuffix: '+{{count}} weitere',
        },
        announce: {
            filterApplied: 'Filter angewendet: {{filters}}',
            noFiltersActive: 'keine Filter aktiv',
            filterRemoved: 'Filter entfernt: {{label}}',
            filtersCleared: 'Alle Filter gelöscht',
            searchCleared: 'Suche zurückgesetzt',
            search: 'Suche: {{query}}',
            resultsCount: '{{count}} Ergebnis',
            resultsCount_other: '{{count}} Ergebnisse',
            noResults: 'Keine Ergebnisse',
            valueSelected: '{{section}}: {{value}} ausgewählt',
            valueDeselected: '{{section}}: {{value}} abgewählt',
        },
        empty: {
            withFilters: 'Keine Ergebnisse für die aktuellen Filter.',
            clearAllFilters: 'Alle Filter löschen',
        },
        error: {
            toast: 'Suche fehlgeschlagen. Bitte erneut versuchen.',
        },
    },
    authority: {
        ownedBy: 'Verwaltet von {{systemName}}',
        unclaimed: 'Nicht beansprucht',
        historical: '(historisch)',
        editDisabledTooltip: 'Verwaltet von {{systemName}} — geben Sie zuerst die Autorität frei, um manuell zu bearbeiten',
        actionsMenu: 'Autoritäts-Aktionen',
        release: 'Autorität freigeben',
        releaseTitle: 'Autorität für {{attributeName}} freigeben?',
        releaseBody: 'Durch das Freigeben der Autorität darf jede Quelle in {{attributeName}} auf diesem Datensatz schreiben. Die nächste Inbound-Synchronisation, die dieses Attribut berührt, beansprucht die Autorität automatisch. Aktuell verwaltet von {{systemName}}.',
        releaseConfirm: 'Freigeben',
        releaseSuccess: 'Autorität freigegeben',
        releaseError: 'Autorität konnte nicht freigegeben werden. Bitte erneut versuchen.',
        transfer: 'Autorität übertragen...',
        transferTitle: 'Autorität für {{attributeName}} übertragen',
        transferBody: 'Wählen Sie das System, das {{attributeName}} auf diesem Datensatz besitzen soll. Es können nur Systeme gewählt werden, die aktuell als Quelle verknüpft sind. Schreibvorgänge anderer Systeme werden weiterhin abgelehnt.',
        transferTargetLabel: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM)',
        transferTargetPlaceholder: '$t(appConfig.domainEntityTypes.TARGET_SYSTEM) wählen',
        transferConfirm: 'Übertragen',
        transferSuccess: 'Autorität an {{systemName}} übertragen',
        transferError: 'Autorität konnte nicht übertragen werden. Bitte erneut versuchen.',
        transferNoEligibleSources: 'Keine aktiven Quellen für diesen Datensatz — verknüpfen Sie zuerst eine Quelle, um die Autorität zu übertragen.',
        violations: {
            title: 'Autoritätsverletzungen',
            count: '{{count}} Attribut-Schreibvorgänge übersprungen — gehört einem anderen System',
            truncated: 'Es werden nur die ersten 100 Verletzungen angezeigt. Filtern Sie Attribute auf den betroffenen Entitäten nach Autorität, um alle Verletzungen zu prüfen.',
            rowLabel: '{{entityType}} {{entityName}} — {{attributeName}} — verwaltet von {{ownerSystem}}, versucht von {{syncSystem}}',
            viewEntity: '{{entityType}} öffnen',
        },
    },
    owners: {
        title: 'Eigentümer',
        empty: 'Keine Eigentümer zugewiesen.',
        addOwner: 'Eigentümer hinzufügen',
        removeOwner: 'Entfernen',
        removeConfirm: '{{partyName}} als Eigentümer entfernen?',
        responsibility: 'Verantwortlichkeit',
        validFrom: 'Gültig ab',
        validTo: 'Gültig bis',
        party: '$t(appConfig.domainEntityTypes.PARTY)',
        searchParty: '$t(appConfig.domainEntityTypes.PARTY) suchen…',
        addOwnerTitle: 'Eigentümer hinzufügen',
        addOwnerDescription: 'Weisen Sie eine $t(appConfig.domainEntityTypes.PARTY) als Eigentümer dieser Entität zu.',
        addedSuccess: 'Eigentümer hinzugefügt.',
        removedSuccess: 'Eigentümer entfernt.',
        loading: 'Eigentümer werden geladen…',
        responsibilityLookupMissing: 'Die Verantwortlichkeitskonfiguration fehlt für diesen Entitätstyp. Eigentümerzuweisung ist deaktiviert, bis ein Administrator die Verantwortlichkeitsliste befüllt.',
    },
    sources: {
        title: 'Quellen',
        empty: 'Keine externen Quellen',
        emptySubtext: 'Dieser Datensatz wurde manuell erstellt und wird von keinem externen System synchronisiert.',
        loadError: 'Quellen konnten nicht geladen werden. Bitte Seite aktualisieren.',
        firstSeen: 'Zuerst verknüpft am {{date}}',
        lastSeen: 'Synchronisiert {{relativeTime}}',
        actionsMenu: 'Quellen-Aktionen',
        copyExternalId: 'Externe ID kopieren',
        externalIdCopied: 'Externe ID in die Zwischenablage kopiert',
        externalIdCopyFailed: 'Externe ID konnte nicht kopiert werden',
        detach: 'Quelle entfernen',
        detachTitle: 'Quelle entfernen?',
        detachBody: 'Wenn Sie {{systemName}} als Quelle entfernen, wird die externe ID {{externalId}} von diesem Datensatz getrennt. Die nächste Synchronisation aus {{systemName}} behandelt diesen Datensatz als neu und erstellt eine neue Quellverknüpfung. Schlägt die Korrelation fehl, kann ein Duplikat entstehen. Diese Aktion kann nicht rückgängig gemacht werden.',
        detachConfirm: 'Entfernen',
        detachSuccess: 'Quelle entfernt',
        detachSuccessWithCount: 'Quelle entfernt, {{count}} Attribute freigegeben',
        detachError: 'Quelle konnte nicht entfernt werden. Bitte erneut versuchen.',
        releaseAll: 'Alle Attribute dieses Systems freigeben',
        releaseAllTitle: 'Alle von {{systemName}} verwalteten Attribute freigeben?',
        releaseAllBody: 'Dadurch wird die Autorität für {{count}} Attribute auf diesem Datensatz freigegeben. Jedes Attribut wird wieder von jeder Quelle beschreibbar; die nächste Inbound-Synchronisation, die ein Attribut schreibt, beansprucht dessen Autorität automatisch.',
        releaseAllConfirm: '{{count}} Attribute freigeben',
        releaseAllSuccess: '{{count}} Attribute freigegeben',
        releaseAllError: 'Attribute konnten nicht freigegeben werden. Bitte erneut versuchen.',
    },
    rehireReview: {
        title: 'Wiedereinstellungs-Prüfung',
        pageTitle: 'Wiedereinstellungs-Prüfung | Administration',
        subtitle: 'Kandidaten, bei denen eine Inbound-Synchronisation eine TERMINATED-$t(appConfig.domainEntityTypes.IDENTITY) getroffen hat',
        list: {
            title: 'Prüfwarteschlange',
        },
        columns: {
            matchedIdentity: 'Abgeglichene $t(appConfig.domainEntityTypes.IDENTITY)',
            priorEntryDate: 'Früheres Eintrittsdatum',
            priorExitDate: 'Früheres Austrittsdatum',
            sourceConnector: 'Quell-Konnektor',
            syncRun: 'Synchronisationslauf',
            newEntryDate: 'Neues Eintrittsdatum',
            detectedAt: 'Erkannt am',
            status: 'Status',
            decidedBy: 'Entschieden von',
        },
        decidedByConnector: 'durch Konnektor {{name}}',
        status: {
            pending: 'Offen',
            resurrected: 'Reaktiviert',
            createdNew: 'Neu angelegt',
            rejected: 'Abgelehnt',
        },
        actorType: {
            user: 'Benutzer',
            connector: 'Konnektor',
        },
        filters: {
            status: 'Status',
            allStatuses: 'Alle Status',
            connector: 'Konnektor',
            allConnectors: 'Alle Konnektoren',
            from: 'Erkannt ab',
            to: 'Erkannt bis',
        },
        emptyState: {
            title: 'Keine Prüfkandidaten',
            description: 'Für die aktuellen Filter liegen keine Kandidaten vor. Eingehende Synchronisationen, die eine TERMINATED-$t(appConfig.domainEntityTypes.IDENTITY) treffen, erscheinen hier.',
        },
        detail: {
            pageTitle: 'Prüfkandidat | Administration',
            title: 'Kandidat prüfen',
            backToList: 'Zurück zur Warteschlange',
            matchedCard: {
                title: 'Abgeglichene $t(appConfig.domainEntityTypes.IDENTITY)',
                priorName: 'Früherer Anzeigename',
                employeeNumber: 'Personalnummer',
                entryDate: 'Eintrittsdatum',
                exitDate: 'Austrittsdatum',
                terminationReason: 'Letzter Austrittsgrund',
                lifecycleState: 'Lebenszyklus-Status',
            },
            incomingCard: {
                title: 'Eingehender Datensatz',
                newEntryDate: 'Neues Eintrittsdatum',
                sourceConnector: 'Quell-Konnektor',
                sourceSyncRun: 'Quell-Synchronisationslauf',
                detectedAt: 'Erkannt am',
                attributesSnapshot: 'Gemappte Attribute',
            },
            diff: {
                title: 'Attribut-Vergleich',
                description: 'Unterschiede zwischen gespeicherter $t(appConfig.domainEntityTypes.IDENTITY) und eingehendem Datensatz.',
                attribute: 'Attribut',
                oldValue: 'Gespeicherter Wert',
                newValue: 'Eingehender Wert',
                noChanges: 'Keine Attribut-Unterschiede festgestellt.',
            },
            actions: {
                title: 'Entscheidung',
                resurrect: 'Reaktivieren',
                createNew: 'Neu anlegen',
                reject: 'Ablehnen',
            },
            decisionInfo: {
                decidedBy: 'Entschieden von',
                decidedAt: 'Entschieden am',
                comment: 'Entscheidungs-Kommentar',
            },
        },
        dialogs: {
            resurrect: {
                title: '$t(appConfig.domainEntityTypes.IDENTITY) reaktivieren',
                description: 'Die abgeglichene $t(appConfig.domainEntityTypes.IDENTITY) mit dem neuen Eintrittsdatum aus dem eingehenden Datensatz reaktivieren.',
                reasonLabel: 'Begründung',
                reasonPlaceholder: 'Warum reaktivieren Sie diese $t(appConfig.domainEntityTypes.IDENTITY)?',
                submit: 'Reaktivieren',
            },
            createNew: {
                title: 'Neue $t(appConfig.domainEntityTypes.IDENTITY) anlegen',
                description: 'Eine separate neue $t(appConfig.domainEntityTypes.IDENTITY) für den eingehenden Datensatz anlegen. Die abgeglichene $t(appConfig.domainEntityTypes.IDENTITY) bleibt TERMINATED.',
                reasonLabel: 'Begründung',
                reasonPlaceholder: 'Warum legen Sie eine neue $t(appConfig.domainEntityTypes.IDENTITY) an?',
                submit: 'Neu anlegen',
            },
            reject: {
                title: 'Treffer ablehnen',
                description: 'Diesen Kandidaten verwerfen. Die abgeglichene $t(appConfig.domainEntityTypes.IDENTITY) und der eingehende Datensatz bleiben unverändert.',
                reasonLabel: 'Begründung',
                reasonPlaceholder: 'Warum lehnen Sie diesen Treffer ab?',
                submit: 'Ablehnen',
            },
            reasonRequired: 'Eine Begründung ist erforderlich.',
            entryDateLabel: 'Neues Eintrittsdatum',
            entryDateHint: 'Muss heute oder in der Zukunft liegen, innerhalb von 2 Jahren.',
            entryDateRequired: 'Ein neues Eintrittsdatum ist erforderlich.',
            entryDateInvalid: 'Das neue Eintrittsdatum muss heute oder in der Zukunft liegen, innerhalb von 2 Jahren.',
        },
        messages: {
            resurrectSuccess: '$t(appConfig.domainEntityTypes.IDENTITY) reaktiviert.',
            resurrectSuccessLink: '$t(appConfig.domainEntityTypes.IDENTITY) öffnen',
            createNewSuccess: 'Neue $t(appConfig.domainEntityTypes.IDENTITY) angelegt.',
            createNewSuccessLink: 'Neue $t(appConfig.domainEntityTypes.IDENTITY) öffnen',
            rejectSuccess: 'Kandidat abgelehnt.',
            readOnly: 'Sie haben nur Leserechte auf die Prüfwarteschlange.',
        },
        picker: {
            title: 'Vorher gehalten von {{name}}',
            description: '$t(appConfig.domainEntityTypes.ACCESS_PROFILES) auswählen, um sie für diese $t(appConfig.domainEntityTypes.IDENTITY) erneut anzufragen. Jede Anfrage durchläuft die normalen $t(appConfig.domainEntityTypes.APPROVAL_POLICIES).',
            selectionCount: '{{count}} ausgewählt',
            selectionCount_one: '{{count}} ausgewählt',
            selectionCount_other: '{{count}} ausgewählt',
            createRequests: 'Zugriffsanfragen erstellen',
            requestsCreated: '{{count}} Zugriffsanfrage(n) eingereicht.',
            requestsCreated_one: '{{count}} Zugriffsanfrage eingereicht.',
            requestsCreated_other: '{{count}} Zugriffsanfragen eingereicht.',
            viewRequests: 'Meine Anfragen öffnen',
            defaultJustification: 'Bisherigen Zugriff für wiedereingestellte $t(appConfig.domainEntityTypes.IDENTITY) wiederherstellen: {{name}}',
            requestsFailed: 'Erstellen der Zugriffsanfragen fehlgeschlagen.',
        },
    },
    serviceAccounts: {
        pageTitle: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNTS)',
        pageDescription: 'Nicht-menschliche Authentifizierungsidentitäten, die von Automatisierung, Skripten und Integrationen über API-Schlüssel verwendet werden.',
        listTitle: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNTS)',
        listCount: '{{count}} $t(appConfig.domainEntityTypes.SERVICE_ACCOUNT)',
        listCount_other: '{{count}} $t(appConfig.domainEntityTypes.SERVICE_ACCOUNTS)',
        matchingFilters: 'passend zu Filtern',
        createButton: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) anlegen',
        createTitle: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) anlegen',
        editButton: 'Bearbeiten',
        editTitle: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) bearbeiten',
        deactivateButton: 'Deaktivieren',
        reactivateButton: 'Reaktivieren',
        actions: 'Aktionen',
        nameLabel: 'Name',
        descriptionLabel: 'Beschreibung',
        descriptionPlaceholder: 'Optionale Beschreibung (max. 500 Zeichen)',
        nameRequired: 'Name ist erforderlich.',
        nameTooLong: 'Name darf höchstens 100 Zeichen lang sein.',
        descriptionTooLong: 'Beschreibung darf höchstens 500 Zeichen lang sein.',
        duplicateNameError: 'Ein $t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) mit diesem Namen existiert bereits.',
        createSuccess: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) angelegt.',
        editSuccess: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) aktualisiert.',
        deactivateSuccess: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) deaktiviert.',
        reactivateSuccess: '$t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) reaktiviert.',
        deactivateTitle: 'Dieses $t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) deaktivieren?',
        deactivateBody: 'Beim Deaktivieren werden alle aktiven API-Schlüssel sofort widerrufen. Automatisierungen, die diese Schlüssel verwenden, schlagen fehl.',
        deactivateConfirm: 'Deaktivieren',
        emptyTitle: 'Noch keine $t(appConfig.domainEntityTypes.SERVICE_ACCOUNTS)',
        emptyDescription: 'Legen Sie eines an, um programmatischen API-Zugriff zu ermöglichen.',
        emptyMatching: 'Keine $t(appConfig.domainEntityTypes.SERVICE_ACCOUNTS) passen zu den aktuellen Filtern.',
        clearFilters: 'Filter zurücksetzen',
        filterByName: 'Nach Name filtern',
        filterByStatus: 'Nach Status filtern',
        filterStatusAll: 'Alle',
        filterStatusActive: 'Nur aktive',
        filterStatusInactive: 'Nur inaktive',
        columns: {
            name: 'Name',
            activeKeys: 'Aktive Schlüssel',
            status: 'Status',
            created: 'Erstellt',
            createdBy: 'Erstellt von',
            description: 'Beschreibung',
        },
        statusActive: 'Aktiv',
        statusInactive: 'Inaktiv',
        overview: 'Übersicht',
        roles: '$t(appConfig.domainEntityTypes.ROLES)',
        rolesDescription: 'Autorisierungsrollen, die diesem $t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) zugewiesen sind.',
        rolesEmpty: 'Keine $t(appConfig.domainEntityTypes.ROLES) zugewiesen.',
        assignRoleButton: '$t(appConfig.domainEntityTypes.ROLE) zuweisen',
        assignRoleTitle: '$t(appConfig.domainEntityTypes.ROLE) zuweisen',
        assignRoleDescription: 'Wählen Sie eine $t(appConfig.domainEntityTypes.ROLE), die diesem $t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) zugewiesen werden soll.',
        assignButton: 'Zuweisen',
        roleLabel: '$t(appConfig.domainEntityTypes.ROLE)',
        selectRolePlaceholder: '$t(appConfig.domainEntityTypes.ROLES) suchen…',
        noRolesFound: 'Keine $t(appConfig.domainEntityTypes.ROLES) gefunden.',
        roleAlreadyAssignedError: 'Diese $t(appConfig.domainEntityTypes.ROLE) ist dem $t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) bereits zugewiesen.',
        removeRoleAction: 'Entfernen',
        removeRoleTitle: '$t(appConfig.domainEntityTypes.ROLE) entfernen?',
        removeRoleBody: '$t(appConfig.domainEntityTypes.ROLE) „{{role}}“ von „{{serviceAccount}}“ entfernen?',
        removeRoleConfirm: 'Entfernen',
        assignRoleSuccess: '$t(appConfig.domainEntityTypes.ROLE) zugewiesen.',
        removeRoleSuccess: '$t(appConfig.domainEntityTypes.ROLE) entfernt.',
        roleColumns: {
            name: '$t(appConfig.domainEntityTypes.ROLE)',
            description: 'Beschreibung',
            assignedBy: 'Zugewiesen von',
            assignedAt: 'Zugewiesen am',
            actions: 'Aktionen',
        },
    },
    apiKeys: {
        cardTitle: 'API-Schlüssel',
        cardCount: '{{count}} Schlüssel',
        cardCount_other: '{{count}} Schlüssel',
        emptyTitle: 'Noch keine API-Schlüssel',
        emptyDescription: 'Erzeugen Sie einen, um programmatischen Zugriff zu ermöglichen.',
        mintButton: 'API-Schlüssel erzeugen',
        revokeButton: 'Widerrufen',
        defaultRateLimit: 'Standard ({{value}})',
        never: 'Nie',
        columns: {
            name: 'Name',
            prefix: 'Präfix',
            lastUsed: 'Zuletzt verwendet',
            rateLimit: 'Rate-Limit',
            status: 'Status',
            actions: 'Aktionen',
        },
        status: {
            active: 'Aktiv',
            expired: 'Abgelaufen',
            revoked: 'Widerrufen',
            inactive: 'Inaktiv',
        },
        mintDialog: {
            title: 'API-Schlüssel erzeugen',
            description: 'Konfigurieren Sie den neuen Schlüssel. Der Klartextwert wird genau einmal nach dem Erzeugen angezeigt — kopieren Sie ihn vor dem Schließen.',
            nameLabel: 'Name',
            namePlaceholder: 'z. B. ci-deploy-bot',
            expiryLabel: 'Ablaufdatum',
            expiryHelp: 'Standard: heute + 365 Tage. Vergangene Daten werden abgelehnt.',
            rateLimitLabel: 'Rate-Limit (Anfragen pro Minute)',
            rateLimitPlaceholder: 'Standard ({{value}})',
            rateLimitHelp: 'Optional. Leer lassen, um den globalen Standardwert zu verwenden.',
            submit: 'Schlüssel erzeugen',
            submitting: 'Wird erzeugt…',
            disclosurePanelTitle: 'API-Schlüssel — jetzt sichern',
            warningBanner: 'Dies ist das einzige Mal, dass dieser Schlüssel angezeigt wird. Speichern Sie ihn jetzt an einem sicheren Ort — in Ihrem Passwort-Manager, Tresor oder CI-Secret-Store. Wir können diesen Schlüssel nicht erneut abrufen oder anzeigen. Wenn Sie ihn verlieren, widerrufen Sie ihn und erzeugen Sie einen neuen.',
            keyLabel: 'API-Schlüssel',
            copyButton: 'Kopieren',
            copyDone: 'Kopiert',
            copyDisabledMessage: 'Zwischenablage-Zugriff erfordert HTTPS. Bitte kopieren Sie den Schlüssel manuell.',
            closeButton: 'Ich habe ihn gespeichert — schließen',
            closeConfirm: 'Sie haben den Schlüssel noch nicht gespeichert. Trotzdem schließen?',
            nameRequired: 'Name ist erforderlich.',
            nameTooLong: 'Der Name darf höchstens 100 Zeichen lang sein.',
            expiresAtInPast: 'Das Ablaufdatum muss in der Zukunft liegen.',
            rateLimitInvalid: 'Das Rate-Limit muss eine positive ganze Zahl sein.',
            inactiveError: 'Dieses $t(appConfig.domainEntityTypes.SERVICE_ACCOUNT) ist inaktiv. Reaktivieren Sie es, bevor Sie Schlüssel erzeugen.',
        },
        revokeDialog: {
            title: 'Schlüssel „{{name}}“ widerrufen?',
            body: 'Aufrufe mit diesem Schlüssel schlagen sofort fehl. Dies kann nicht rückgängig gemacht werden.',
            confirm: 'Schlüssel widerrufen',
            successToast: 'Schlüssel widerrufen. Aufrufe mit diesem Schlüssel schlagen sofort fehl.',
        },
    },
    timeRange: {
        invalidUrlParam: 'Zeitraum-URL-Parameter ist ungültig: {{detail}}. Der ungültige Parameter wurde ignoriert.',
    },
    holdingStatus: {
        none: 'nicht zugewiesen',
        directBlocking: 'bereits zugewiesen',
        indirectRule: 'via [[Auto-Zuweisungsregel]]',
        indirectImport: 'via Inbound-Import',
        indirectFg: 'via [[Funktionsgruppe]]',
        indirectMixed: 'via mehrere Quellen',
        tooltipOriginsHeading: 'Zugewiesen via:',
        tooltipBlockingHint: 'Diese Zuweisung ist dauerhaft — eine neue Einreichung ist überflüssig.',
        tooltipIndirectHint: 'Diese Zuweisung ist temporär — eine neue Einreichung erzeugt eine dauerhafte Kopie.',
    },
    escalation: {
        timeline: {
            title: 'Eskalationsverlauf',
            empty: 'Bisher keine Eskalationsereignisse.',
            currentLevel: 'Aktuelle Stufe',
            nextDeadline: 'Nächste Frist',
            platformOwner: 'IAM-Fachstelle',
            unresolvableManager: 'Vorgesetzte:r nicht auflösbar — übersprungen',
            unknownRecipient: 'Unbekannte:r Empfänger:in',
            levels: {
                NONE: 'Nicht eskaliert',
                REMINDED: 'Erinnert',
                FINAL_REMINDED: 'Letzte Erinnerung',
                ESCALATED_TO_MANAGER: 'An Vorgesetzte:n eskaliert',
                ESCALATED_TO_PLATFORM_OWNER: 'An IAM-Fachstelle eskaliert',
                CHAIN_CLOSED: 'Kette geschlossen',
            },
            eventTypes: {
                REMINDED: 'Erinnerung versendet',
                FINAL_REMINDED: 'Letzte Erinnerung versendet',
                ESCALATED_TO_MANAGER: 'An Vorgesetzte:n eskaliert',
                ESCALATED_TO_PLATFORM_OWNER: 'An IAM-Fachstelle eskaliert',
                CHAIN_CLOSED: 'Kette geschlossen',
            },
        },
        thresholds: {
            pageTitle: 'Eskalationsschwellen',
            title: 'Eskalationsschwellen',
            description: 'Konfigurierbare Eskalationszeiten und Empfänger pro Antragstyp und Risikostufe.',
            count: '{{count}} Schwelle',
            count_other: '{{count}} Schwellen',
            defaultRiskLabel: 'Standard',
            columns: {
                requestType: 'Antragstyp',
                riskLevel: 'Risikostufe',
                reminderDays: 'Erinnerung (Tage)',
                finalReminderDays: 'Letzte Erinnerung (Tage)',
                managerDays: 'Eskalation an Vorgesetzte:n (Tage)',
                platformOwnerDays: 'Eskalation an Fachstelle (Tage)',
                managerTarget: 'Eskalationsziel',
                platformOwner: 'IAM-Fachstelle',
                active: 'Aktiv',
                activeSnapshots: 'Aktive Referenzen',
                actions: 'Aktionen',
            },
            actions: {
                edit: 'Schwelle bearbeiten',
            },
            edit: {
                title: 'Eskalationsschwelle bearbeiten',
                description: 'Änderungen wirken nur auf neu aktivierte Schritte. Laufende Schritte behalten die bei Aktivierung erfassten Werte.',
                reminderDays: 'Erinnerung nach (Tagen)',
                finalReminderDays: 'Letzte Erinnerung nach (Tagen)',
                managerDays: 'Eskalation an Vorgesetzte:n nach (Tagen)',
                platformOwnerDays: 'Eskalation an IAM-Fachstelle nach (Tagen)',
                managerTarget: 'Eskalationsziel',
                platformOwner: 'IAM-Fachstelle-Empfänger:in',
                platformOwnerPlaceholder: '[[Identitäten]] suchen…',
                active: 'Aktiv',
                save: 'Änderungen speichern',
                cancel: 'Abbrechen',
                saveSuccess: 'Schwelle aktualisiert.',
            },
            validation: {
                positive: 'Jeder Tageswert muss grösser als 0 sein.',
                monotonic: 'Werte müssen strikt aufsteigend sein: Erinnerung < letzte Erinnerung < Vorgesetzte:r < Fachstelle.',
                platformOwnerRequired: 'IAM-Fachstelle-Empfänger:in ist erforderlich, wenn die Schwelle aktiv ist.',
            },
            managerTarget: {
                APPROVER_MANAGER: 'Vorgesetzte:r des Genehmigenden',
                OBJECT_OWNER_MANAGER: 'Vorgesetzte:r des Objekteigners',
            },
        },
    },
} as const

export default translation
